import * as Io from "react";
import fe, { useEffect as te, forwardRef as Re, createElement as bi, useRef as q, useMemo as J, useContext as yt, createContext as xa, useState as re, Fragment as Ns, useCallback as ae, useLayoutEffect as js, cloneElement as Jg, Component as Xg, useReducer as Qg, useImperativeHandle as mr } from "react";
import eh from "react-dom";
const Ls = { themes: { default: { theme: { colors: { "secondary-text": "#555F6B", "secondary-100": "#F2F7FC", "secondary-200": "#EBF3FA", "secondary-300": "#E2EEF8", "secondary-400": "#DDEAF7", "secondary-500": "#D4E5F5", "secondary-600": "#C1D0DF", "secondary-700": "#97A3AE", "secondary-800": "#757E87", "secondary-900": "#596067", "info-text": "#FFFFFF", "info-100": "#EBF2FC", "info-200": "#8CB5EA", "info-300": "#5894E1", "info-400": "#377FDB", "info-500": "#055FD2", "info-600": "#0556BF", "info-700": "#044395", "info-800": "#033474", "info-900": "#022858", "greyscale-100": "#FAFAFB", "greyscale-200": "#F3F4F4", "greyscale-300": "#E7E8EA", "greyscale-400": "#C2C6CA", "greyscale-500": "#9EA3AA", "greyscale-600": "#79818A", "greyscale-700": "#555F6B", "greyscale-800": "#303C4B", "greyscale-900": "#0C1A2B", "greyscale-000": "#FFFFFF", "primary-100": "#EBF2FC", "primary-200": "#8CB5EA", "primary-300": "#5894E1", "primary-400": "#377FDB", "primary-500": "#055FD2", "primary-600": "#0556BF", "primary-700": "#044395", "primary-800": "#033474", "primary-900": "#022858", "success-100": "#EFFCD3", "success-200": "#DBFAA9", "success-300": "#BEF27C", "success-400": "#A0E659", "success-500": "#76D628", "success-600": "#5AB81D", "success-700": "#419A14", "success-800": "#2C7C0C", "success-900": "#1D6607", "warning-100": "#FFF8CD", "warning-200": "#FFEF9B", "warning-300": "#FFE469", "warning-400": "#FFDA43", "warning-500": "#FFC805", "warning-600": "#DBA603", "warning-700": "#B78702", "warning-800": "#936901", "warning-900": "#7A5400", "danger-100": "#F4B0B0", "danger-200": "#EE8A8A", "danger-300": "#E65454", "danger-400": "#E13333", "danger-500": "#DA0000", "danger-600": "#C60000", "danger-700": "#9B0000", "danger-800": "#780000", "danger-900": "#5C0000", "primary-text": "#FFFFFF", "success-text": "#FFFFFF", "warning-text": "#FFFFFF", "danger-text": "#FFFFFF" }, font: { sizes: { h1: "1.75rem", h2: "1.375rem", h3: "1.125rem", h4: "0.8125rem", h5: "0.625rem", h6: "0.5rem", l: "1rem", m: "0.8125rem", s: "0.6875rem" }, weights: { thin: 200, light: 300, regular: 400, medium: 500, bold: 600, extrabold: 700, black: 800 }, families: { base: '"Roboto Flex Variable", sans-serif', accent: '"Roboto Flex Variable", sans-serif' }, letterSpacings: { h1: "normal", h2: "normal", h3: "normal", h4: "normal", h5: "1px", h6: "normal", l: "normal", m: "normal", s: "normal" } }, spacings: { xl: "4rem", l: "3rem", b: "1.625rem", s: "1rem", t: "0.5rem", st: "0.25rem" }, transitions: { "ease-in": "cubic-bezier(0.32, 0, 0.67, 0)", "ease-out": "cubic-bezier(0.33, 1, 0.68, 1)", "ease-in-out": "cubic-bezier(0.65, 0, 0.35, 1)", duration: "250ms" }, breakpoints: { xs: 0, sm: "576px", md: "768px", lg: "992px", xl: "1200px", xxl: "1400px" } }, components: { tooltip: { "border-radius": "0.5rem", "background-color": "#0C1A2B", color: "#FFFFFF", "font-size": "0.6875rem", padding: "1rem", "max-width": "150px" }, toast: { "slide-in-duration": "1000ms", "slide-out-duration": "300ms", "background-color": "#FAFAFB", color: "#0C1A2B", "font-weight": 400, "icon-size": "19px", "progress-bar-height": "3px" }, modal: { "background-color": "#FFFFFF", "backdrop-color": "#0C1A2B99", "border-radius": "4px", "border-color": "#E7E8EA", "box-shadow": "0px 1px 2px 0px #0C1A2B4D", color: "#0C1A2B", "title-font-weight": 600, "content-font-size": "0.8125rem", "content-font-weight": 400, "content-color": "#303C4B", "width-small": "300px", "width-medium": "600px", "width-large": "800px", "width-extra-large": "75%" }, "forms-textarea": { "font-weight": 400, "font-size": "1rem", "border-radius": "8px", "border-radius--hover": "2px", "border-radius--focus": "2px", "border-width": "1px", "border-color": "#E7E8EA", "border-color--hover": "#9EA3AA", "border-color--focus": "#0556BF", "border-style": "solid", "label-color--focus": "#0556BF", "background-color": "#FFFFFF", "value-color": "#0C1A2B", "value-color--disabled": "#303C4B" }, "forms-switch": { "accent-color": "#419A14", "rail-background-color": "#9EA3AA", "rail-background-color--disabled": "#C2C6CA", "rail-border-radius": "50vw", "handle-background-color": "white", "handle-background-color--disabled": "#F3F4F4", "handle-border-radius": "50%" }, "forms-select": { "border-color": "#E7E8EA", "border-color--focus": "#0556BF", "border-color--hover": "#9EA3AA", "border-radius": "8px", "border-radius--focus": "2px", "border-radius--hover": "2px", "border-style": "solid", "border-width": "1px", "value-color": "#0C1A2B", "value-color--disabled": "#303C4B", "font-size": "1rem", height: "3.5rem", "item-background-color--hover": "#F3F4F4", "item-background-color--selected": "#EBF2FC", "item-color": "#303C4B", "item-color--disabled": "#9EA3AA", "item-font-size": "1rem", "background-color": "#FFFFFF", "menu-background-color": "#FFFFFF", "label-color--focus": "#0556BF", "multi-pill-background-color": "#F3F4F4", "multi-pill-border-radius": "2px", "multi-pill-max-width": "68%", "multi-pill-font-size": "0.8125rem" }, "forms-radio": { "border-color": "#E7E8EA", "accent-color": "#5AB81D", "background-color": "#FFFFFF" }, "forms-labelledbox": { "label-color--small": "#79818A", "label-color--big": "#0C1A2B", "label-color--small--disabled": "#79818A", "label-color--big--disabled": "#79818A" }, "forms-input": { "font-weight": 400, "font-size": "1rem", "border-radius": "8px", "border-radius--hover": "2px", "border-radius--focus": "2px", "border-width": "1px", "border-color": "#E7E8EA", "border-color--hover": "#9EA3AA", "border-color--focus": "#0556BF", "border-style": "solid", "label-color--focus": "#0556BF", "background-color": "#FFFFFF", "value-color": "#0C1A2B", "value-color--disabled": "#303C4B" }, "forms-fileuploader": { "background-color": "#FFFFFF", "border-color": "#E7E8EA", "border-radius": "0.5rem", "border-width": "2px", "border-style": "dotted", "background-color--active": "#EBF2FC", color: "#0C1A2B", padding: "1rem", "accent-color": "#0556BF", "text-color": "#79818A", "text-size": "0.6875rem", "file-text-size": "0.8125rem", "file-text-color": "#0C1A2B", "file-text-weight": 300, "file-border-color": "#E7E8EA", "file-border-width": "1px", "file-border-radius": "0.5rem", "file-background-color": "#FFFFFF", "file-specs-size": "0.6875rem", "file-specs-color": "#79818A" }, "forms-field": { width: "292px", "font-size": "0.6875rem", color: "#79818A" }, "forms-datepicker": { "border-color": "#E7E8EA", "border-color--disabled": "#F3F4F4", "border-color--focus": "#0556BF", "border-color--hover": "#9EA3AA", "border-radius": "8px", "border-radius--focus": "2px", "border-radius--hover": "2px", "border-style": "solid", "border-width": "1px", "value-color": "#0C1A2B", "value-color--disabled": "#303C4B", "font-size": "1rem", height: "3.5rem", "item-background-color--hover": "#F3F4F4", "item-background-color--selected": "#EBF2FC", "item-color": "#303C4B", "item-font-size": "1rem", "background-color": "#FFFFFF", "menu-background-color": "#FFFFFF", "range-selection-background-color": "#EBF2FC", "range-selection-background-color--disabled": "#FAFAFB", "grid-cell--border-color--today": "#0556BF", "grid-cell--color--today": "#0556BF", "label-color--focus": "#0556BF" }, "forms-checkbox": { "background-color--hover": "#F3F4F4", "background-color": "#FFFFFF", "font-size": "0.8125rem", "font-weight": 500, color: "#0C1A2B", "border-color": "#E7E8EA", "border-radius": "2px", "accent-color": "#5AB81D", size: "1.5rem" }, button: { "border-radius": "8px", "border-radius--active": "2px", "border-radius--focus": "8px", "medium-text-height": "36px", "medium-height": "48px", "small-height": "32px", "nano-height": "24px", "medium-font-size": "1rem", "medium-icon-font-size": "1.5rem", "small-font-size": "0.8125rem", "small-icon-font-size": "1rem", "nano-font-size": "0.8125rem", "nano-icon-font-size": "1rem", "font-weight": 400, "font-family": '"Roboto Flex Variable", sans-serif', "text-font-weight": 500 }, alert: { "background-color": "#FAFAFB", "border-radius": "4px", "font-weight": 500, color: "#0C1A2B", "icon-size": "19px", "additional-font-weight": 400, "additional-color": "#555F6B" } } }, dark: { theme: { colors: { "greyscale-100": "#182536", "greyscale-200": "#303C4B", "greyscale-300": "#555F6B", "greyscale-400": "#79818A", "greyscale-500": "#9EA3AA", "greyscale-600": "#C2C6CA", "greyscale-700": "#E7E8EA", "greyscale-800": "#F3F4F4", "greyscale-900": "#FAFAFB", "greyscale-000": "#0C1A2B", "primary-100": "#3B4C62", "primary-200": "#4D6481", "primary-300": "#6381A6", "primary-400": "#7FA5D5", "primary-500": "#8CB5EA", "primary-600": "#A3C4EE", "primary-700": "#C3D8F4", "primary-800": "#DDE9F8", "primary-900": "#F4F8FD", "success-100": "#EEF8D7", "success-200": "#D9F1B2", "success-300": "#BDE985", "success-400": "#A0E25D", "success-500": "#76D628", "success-600": "#5BB520", "success-700": "#43941A", "success-800": "#307414", "success-900": "#225D10", "warning-100": "#F7F3D5", "warning-200": "#F0E5AA", "warning-300": "#E8D680", "warning-400": "#E3C95F", "warning-500": "#D9B32B", "warning-600": "#BD9721", "warning-700": "#9D7B1C", "warning-800": "#7E6016", "warning-900": "#684D12", "danger-100": "#F8D0D0", "danger-200": "#F09898", "danger-300": "#F09898", "danger-400": "#ED8585", "danger-500": "#E96666", "danger-600": "#DD6666", "danger-700": "#C36666", "danger-800": "#AE6666", "danger-900": "#9D6666" } } } } };
function Di(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function th(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Po = { exports: {} }, Kn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tl;
function nh() {
  if (tl) return Kn;
  tl = 1;
  var e = fe, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(u, l, s) {
    var c, f = {}, p = null, d = null;
    s !== void 0 && (p = "" + s), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (d = l.ref);
    for (c in l) r.call(l, c) && !o.hasOwnProperty(c) && (f[c] = l[c]);
    if (u && u.defaultProps) for (c in l = u.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: t, type: u, key: p, ref: d, props: f, _owner: a.current };
  }
  return Kn.Fragment = n, Kn.jsx = i, Kn.jsxs = i, Kn;
}
var zn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nl;
function rh() {
  return nl || (nl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = fe, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), u = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g = Symbol.iterator, b = "@@iterator";
    function v(I) {
      if (I === null || typeof I != "object")
        return null;
      var G = g && I[g] || I[b];
      return typeof G == "function" ? G : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(I) {
      {
        for (var G = arguments.length, ne = new Array(G > 1 ? G - 1 : 0), ce = 1; ce < G; ce++)
          ne[ce - 1] = arguments[ce];
        D("error", I, ne);
      }
    }
    function D(I, G, ne) {
      {
        var ce = C.ReactDebugCurrentFrame, ye = ce.getStackAddendum();
        ye !== "" && (G += "%s", ne = ne.concat([ye]));
        var Ee = ne.map(function(pe) {
          return String(pe);
        });
        Ee.unshift("Warning: " + G), Function.prototype.apply.call(console[I], console, Ee);
      }
    }
    var x = !1, _ = !1, O = !1, L = !1, y = !1, F;
    F = Symbol.for("react.module.reference");
    function T(I) {
      return !!(typeof I == "string" || typeof I == "function" || I === r || I === o || y || I === a || I === s || I === c || L || I === d || x || _ || O || typeof I == "object" && I !== null && (I.$$typeof === p || I.$$typeof === f || I.$$typeof === i || I.$$typeof === u || I.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      I.$$typeof === F || I.getModuleId !== void 0));
    }
    function $(I, G, ne) {
      var ce = I.displayName;
      if (ce)
        return ce;
      var ye = G.displayName || G.name || "";
      return ye !== "" ? ne + "(" + ye + ")" : ne;
    }
    function R(I) {
      return I.displayName || "Context";
    }
    function P(I) {
      if (I == null)
        return null;
      if (typeof I.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof I == "function")
        return I.displayName || I.name || null;
      if (typeof I == "string")
        return I;
      switch (I) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case s:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case u:
            var G = I;
            return R(G) + ".Consumer";
          case i:
            var ne = I;
            return R(ne._context) + ".Provider";
          case l:
            return $(I, I.render, "ForwardRef");
          case f:
            var ce = I.displayName || null;
            return ce !== null ? ce : P(I.type) || "Memo";
          case p: {
            var ye = I, Ee = ye._payload, pe = ye._init;
            try {
              return P(pe(Ee));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var S = Object.assign, V = 0, k, w, A, K, E, B, j;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function H() {
      {
        if (V === 0) {
          k = console.log, w = console.info, A = console.warn, K = console.error, E = console.group, B = console.groupCollapsed, j = console.groupEnd;
          var I = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: I,
            log: I,
            warn: I,
            error: I,
            group: I,
            groupCollapsed: I,
            groupEnd: I
          });
        }
        V++;
      }
    }
    function W() {
      {
        if (V--, V === 0) {
          var I = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: S({}, I, {
              value: k
            }),
            info: S({}, I, {
              value: w
            }),
            warn: S({}, I, {
              value: A
            }),
            error: S({}, I, {
              value: K
            }),
            group: S({}, I, {
              value: E
            }),
            groupCollapsed: S({}, I, {
              value: B
            }),
            groupEnd: S({}, I, {
              value: j
            })
          });
        }
        V < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Z = C.ReactCurrentDispatcher, M;
    function U(I, G, ne) {
      {
        if (M === void 0)
          try {
            throw Error();
          } catch (ye) {
            var ce = ye.stack.trim().match(/\n( *(at )?)/);
            M = ce && ce[1] || "";
          }
        return `
` + M + I;
      }
    }
    var X = !1, Q;
    {
      var oe = typeof WeakMap == "function" ? WeakMap : Map;
      Q = new oe();
    }
    function z(I, G) {
      if (!I || X)
        return "";
      {
        var ne = Q.get(I);
        if (ne !== void 0)
          return ne;
      }
      var ce;
      X = !0;
      var ye = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ee;
      Ee = Z.current, Z.current = null, H();
      try {
        if (G) {
          var pe = function() {
            throw Error();
          };
          if (Object.defineProperty(pe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(pe, []);
            } catch (Xe) {
              ce = Xe;
            }
            Reflect.construct(I, [], pe);
          } else {
            try {
              pe.call();
            } catch (Xe) {
              ce = Xe;
            }
            I.call(pe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Xe) {
            ce = Xe;
          }
          I();
        }
      } catch (Xe) {
        if (Xe && ce && typeof Xe.stack == "string") {
          for (var me = Xe.stack.split(`
`), Ue = ce.stack.split(`
`), Ie = me.length - 1, Fe = Ue.length - 1; Ie >= 1 && Fe >= 0 && me[Ie] !== Ue[Fe]; )
            Fe--;
          for (; Ie >= 1 && Fe >= 0; Ie--, Fe--)
            if (me[Ie] !== Ue[Fe]) {
              if (Ie !== 1 || Fe !== 1)
                do
                  if (Ie--, Fe--, Fe < 0 || me[Ie] !== Ue[Fe]) {
                    var rt = `
` + me[Ie].replace(" at new ", " at ");
                    return I.displayName && rt.includes("<anonymous>") && (rt = rt.replace("<anonymous>", I.displayName)), typeof I == "function" && Q.set(I, rt), rt;
                  }
                while (Ie >= 1 && Fe >= 0);
              break;
            }
        }
      } finally {
        X = !1, Z.current = Ee, W(), Error.prepareStackTrace = ye;
      }
      var yn = I ? I.displayName || I.name : "", qt = yn ? U(yn) : "";
      return typeof I == "function" && Q.set(I, qt), qt;
    }
    function xe(I, G, ne) {
      return z(I, !1);
    }
    function ee(I) {
      var G = I.prototype;
      return !!(G && G.isReactComponent);
    }
    function we(I, G, ne) {
      if (I == null)
        return "";
      if (typeof I == "function")
        return z(I, ee(I));
      if (typeof I == "string")
        return U(I);
      switch (I) {
        case s:
          return U("Suspense");
        case c:
          return U("SuspenseList");
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case l:
            return xe(I.render);
          case f:
            return we(I.type, G, ne);
          case p: {
            var ce = I, ye = ce._payload, Ee = ce._init;
            try {
              return we(Ee(ye), G, ne);
            } catch {
            }
          }
        }
      return "";
    }
    var ve = Object.prototype.hasOwnProperty, Te = {}, ke = C.ReactDebugCurrentFrame;
    function Ve(I) {
      if (I) {
        var G = I._owner, ne = we(I.type, I._source, G ? G.type : null);
        ke.setExtraStackFrame(ne);
      } else
        ke.setExtraStackFrame(null);
    }
    function Gt(I, G, ne, ce, ye) {
      {
        var Ee = Function.call.bind(ve);
        for (var pe in I)
          if (Ee(I, pe)) {
            var me = void 0;
            try {
              if (typeof I[pe] != "function") {
                var Ue = Error((ce || "React class") + ": " + ne + " type `" + pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof I[pe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ue.name = "Invariant Violation", Ue;
              }
              me = I[pe](G, pe, ce, ne, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ie) {
              me = Ie;
            }
            me && !(me instanceof Error) && (Ve(ye), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ce || "React class", ne, pe, typeof me), Ve(null)), me instanceof Error && !(me.message in Te) && (Te[me.message] = !0, Ve(ye), h("Failed %s type: %s", ne, me.message), Ve(null));
          }
      }
    }
    var Ne = Array.isArray;
    function ze(I) {
      return Ne(I);
    }
    function Yt(I) {
      {
        var G = typeof Symbol == "function" && Symbol.toStringTag, ne = G && I[Symbol.toStringTag] || I.constructor.name || "Object";
        return ne;
      }
    }
    function hn(I) {
      try {
        return ct(I), !1;
      } catch {
        return !0;
      }
    }
    function ct(I) {
      return "" + I;
    }
    function $t(I) {
      if (hn(I))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Yt(I)), ct(I);
    }
    var Je = C.ReactCurrentOwner, et = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Cr, Gu, Ha;
    Ha = {};
    function Og(I) {
      if (ve.call(I, "ref")) {
        var G = Object.getOwnPropertyDescriptor(I, "ref").get;
        if (G && G.isReactWarning)
          return !1;
      }
      return I.ref !== void 0;
    }
    function Bg(I) {
      if (ve.call(I, "key")) {
        var G = Object.getOwnPropertyDescriptor(I, "key").get;
        if (G && G.isReactWarning)
          return !1;
      }
      return I.key !== void 0;
    }
    function Mg(I, G) {
      if (typeof I.ref == "string" && Je.current && G && Je.current.stateNode !== G) {
        var ne = P(Je.current.type);
        Ha[ne] || (h('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', P(Je.current.type), I.ref), Ha[ne] = !0);
      }
    }
    function kg(I, G) {
      {
        var ne = function() {
          Cr || (Cr = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
        };
        ne.isReactWarning = !0, Object.defineProperty(I, "key", {
          get: ne,
          configurable: !0
        });
      }
    }
    function Vg(I, G) {
      {
        var ne = function() {
          Gu || (Gu = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
        };
        ne.isReactWarning = !0, Object.defineProperty(I, "ref", {
          get: ne,
          configurable: !0
        });
      }
    }
    var Ng = function(I, G, ne, ce, ye, Ee, pe) {
      var me = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: I,
        key: G,
        ref: ne,
        props: pe,
        // Record the component responsible for creating this element.
        _owner: Ee
      };
      return me._store = {}, Object.defineProperty(me._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(me, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.defineProperty(me, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ye
      }), Object.freeze && (Object.freeze(me.props), Object.freeze(me)), me;
    };
    function jg(I, G, ne, ce, ye) {
      {
        var Ee, pe = {}, me = null, Ue = null;
        ne !== void 0 && ($t(ne), me = "" + ne), Bg(G) && ($t(G.key), me = "" + G.key), Og(G) && (Ue = G.ref, Mg(G, ye));
        for (Ee in G)
          ve.call(G, Ee) && !et.hasOwnProperty(Ee) && (pe[Ee] = G[Ee]);
        if (I && I.defaultProps) {
          var Ie = I.defaultProps;
          for (Ee in Ie)
            pe[Ee] === void 0 && (pe[Ee] = Ie[Ee]);
        }
        if (me || Ue) {
          var Fe = typeof I == "function" ? I.displayName || I.name || "Unknown" : I;
          me && kg(pe, Fe), Ue && Vg(pe, Fe);
        }
        return Ng(I, me, Ue, ye, ce, Je.current, pe);
      }
    }
    var Ka = C.ReactCurrentOwner, Yu = C.ReactDebugCurrentFrame;
    function vn(I) {
      if (I) {
        var G = I._owner, ne = we(I.type, I._source, G ? G.type : null);
        Yu.setExtraStackFrame(ne);
      } else
        Yu.setExtraStackFrame(null);
    }
    var za;
    za = !1;
    function Ua(I) {
      return typeof I == "object" && I !== null && I.$$typeof === t;
    }
    function qu() {
      {
        if (Ka.current) {
          var I = P(Ka.current.type);
          if (I)
            return `

Check the render method of \`` + I + "`.";
        }
        return "";
      }
    }
    function Lg(I) {
      return "";
    }
    var Zu = {};
    function Hg(I) {
      {
        var G = qu();
        if (!G) {
          var ne = typeof I == "string" ? I : I.displayName || I.name;
          ne && (G = `

Check the top-level render call using <` + ne + ">.");
        }
        return G;
      }
    }
    function Ju(I, G) {
      {
        if (!I._store || I._store.validated || I.key != null)
          return;
        I._store.validated = !0;
        var ne = Hg(G);
        if (Zu[ne])
          return;
        Zu[ne] = !0;
        var ce = "";
        I && I._owner && I._owner !== Ka.current && (ce = " It was passed a child from " + P(I._owner.type) + "."), vn(I), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ne, ce), vn(null);
      }
    }
    function Xu(I, G) {
      {
        if (typeof I != "object")
          return;
        if (ze(I))
          for (var ne = 0; ne < I.length; ne++) {
            var ce = I[ne];
            Ua(ce) && Ju(ce, G);
          }
        else if (Ua(I))
          I._store && (I._store.validated = !0);
        else if (I) {
          var ye = v(I);
          if (typeof ye == "function" && ye !== I.entries)
            for (var Ee = ye.call(I), pe; !(pe = Ee.next()).done; )
              Ua(pe.value) && Ju(pe.value, G);
        }
      }
    }
    function Kg(I) {
      {
        var G = I.type;
        if (G == null || typeof G == "string")
          return;
        var ne;
        if (typeof G == "function")
          ne = G.propTypes;
        else if (typeof G == "object" && (G.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        G.$$typeof === f))
          ne = G.propTypes;
        else
          return;
        if (ne) {
          var ce = P(G);
          Gt(ne, I.props, "prop", ce, I);
        } else if (G.PropTypes !== void 0 && !za) {
          za = !0;
          var ye = P(G);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ye || "Unknown");
        }
        typeof G.getDefaultProps == "function" && !G.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zg(I) {
      {
        for (var G = Object.keys(I.props), ne = 0; ne < G.length; ne++) {
          var ce = G[ne];
          if (ce !== "children" && ce !== "key") {
            vn(I), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ce), vn(null);
            break;
          }
        }
        I.ref !== null && (vn(I), h("Invalid attribute `ref` supplied to `React.Fragment`."), vn(null));
      }
    }
    var Qu = {};
    function el(I, G, ne, ce, ye, Ee) {
      {
        var pe = T(I);
        if (!pe) {
          var me = "";
          (I === void 0 || typeof I == "object" && I !== null && Object.keys(I).length === 0) && (me += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ue = Lg();
          Ue ? me += Ue : me += qu();
          var Ie;
          I === null ? Ie = "null" : ze(I) ? Ie = "array" : I !== void 0 && I.$$typeof === t ? (Ie = "<" + (P(I.type) || "Unknown") + " />", me = " Did you accidentally export a JSX literal instead of a component?") : Ie = typeof I, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ie, me);
        }
        var Fe = jg(I, G, ne, ye, Ee);
        if (Fe == null)
          return Fe;
        if (pe) {
          var rt = G.children;
          if (rt !== void 0)
            if (ce)
              if (ze(rt)) {
                for (var yn = 0; yn < rt.length; yn++)
                  Xu(rt[yn], I);
                Object.freeze && Object.freeze(rt);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xu(rt, I);
        }
        if (ve.call(G, "key")) {
          var qt = P(I), Xe = Object.keys(G).filter(function(Zg) {
            return Zg !== "key";
          }), Wa = Xe.length > 0 ? "{key: someKey, " + Xe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Qu[qt + Wa]) {
            var qg = Xe.length > 0 ? "{" + Xe.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Wa, qt, qg, qt), Qu[qt + Wa] = !0;
          }
        }
        return I === r ? zg(Fe) : Kg(Fe), Fe;
      }
    }
    function Ug(I, G, ne) {
      return el(I, G, ne, !0);
    }
    function Wg(I, G, ne) {
      return el(I, G, ne, !1);
    }
    var Gg = Wg, Yg = Ug;
    zn.Fragment = r, zn.jsx = Gg, zn.jsxs = Yg;
  }()), zn;
}
process.env.NODE_ENV === "production" ? Po.exports = nh() : Po.exports = rh();
var m = Po.exports;
const Hs = (e, t, n) => {
  const [r, a] = fe.useState(
    typeof t > "u" ? e : t
  ), o = (i) => {
    n ? n(i) : a(i);
  };
  return te(() => {
    n && typeof t < "u" && t !== r && a(t);
  }, [t]), [r, o];
}, ge = Re(
  ({
    children: e,
    color: t = "primary",
    size: n = "medium",
    iconPosition: r = "left",
    icon: a,
    active: o,
    className: i,
    fullWidth: u,
    ...l
  }, s) => {
    const c = [
      "c__button",
      "c__button--" + t,
      "c__button--" + n,
      i
    ];
    a && e && c.push("c__button--with-icon--" + r), a && !e && c.push("c__button--icon-only"), o && c.push("c__button--active"), u && c.push("c__button--full-width"), ["primary-text", "tertiary-text"].includes(t) && c.push("c__button--text");
    const f = /* @__PURE__ */ m.jsx("span", { className: "c__button__icon", children: a }), p = l.href ? "a" : "button";
    return bi(
      p,
      {
        className: c.join(" "),
        ...l,
        ref: s
      },
      /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
        !!a && r === "left" && f,
        e,
        !!a && r === "right" && f
      ] })
    );
  }
);
var Ks = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", i = 0; i < arguments.length; i++) {
        var u = arguments[i];
        u && (o = a(o, r(u)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var i = "";
      for (var u in o)
        t.call(o, u) && o[u] && (i = a(i, u));
      return i;
    }
    function a(o, i) {
      return i ? o ? o + " " + i : o + i : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Ks);
var ah = Ks.exports;
const se = /* @__PURE__ */ Di(ah), zs = {
  alert: {
    close_aria_label: "Delete alert",
    expand_aria_label: "Expand alert",
    shrink_aria_label: "Shrink alert"
  },
  pagination: {
    goto_label: "Go to page",
    goto_label_aria: "Go to any page",
    next_aria: "Go to next page",
    previous_aria: "Go to previous page",
    goto_page_aria: "Go to page {page}",
    current_page_aria: "You are currently on page {page}"
  },
  datagrid: {
    empty: "This table is empty",
    empty_alt: "Illustration of an empty table",
    loader_aria: "Loading data",
    rows_selection_aria: "All rows selection",
    row_selection_aria: "Row selection"
  },
  provider: {
    test: "This is a test: {name}"
  },
  forms: {
    input: {
      password: {
        show_password: "Show password",
        hide_password: "Hide password"
      }
    },
    select: {
      toggle_button_aria_label: "Toggle dropdown",
      clear_button_aria_label: "Clear selection",
      clear_all_button_aria_label: "Clear all selections",
      menu_empty_placeholder: "No options available"
    },
    file_uploader: {
      delete_file_name: "Delete file {name}",
      delete_file: "Delete file",
      uploading: "Uploading...",
      caption: "Drag and drop or ",
      browse_files: "Browse files"
    },
    date_picker: {
      toggle_button_aria_label_open: "Open calendar",
      toggle_button_aria_label_close: "Close calendar",
      clear_button_aria_label: "Clear date",
      next_month_button_aria_label: "Next month",
      next_year_button_aria_label: "Next year",
      previous_month_button_aria_label: "Previous month",
      previous_year_button_aria_label: "Previous year",
      year_select_button_aria_label: "Select a year",
      month_select_button_aria_label: "Select a month"
    }
  },
  modals: {
    helpers: {
      delete_confirmation: {
        title: "Are you sure?",
        children: "Are you sure to delete this item?",
        cancel: "Cancel",
        delete: "Delete"
      },
      confirmation: {
        title: "Are you sure?",
        children: "Are you sure you want to do that?",
        cancel: "Cancel",
        yes: "Yes"
      },
      disclaimer: {
        title: "Disclaimer",
        children: "This is a disclaimer",
        ok: "Ok"
      }
    }
  }
}, oh = {
  components: zs
}, ih = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  components: zs,
  default: oh
}, Symbol.toStringTag, { value: "Module" })), Us = {
  alert: {
    close_aria_label: "Supprimer l'alerte",
    expand_aria_label: "Ouvrir l'alerte",
    shrink_aria_label: "Fermer l'alerte"
  },
  pagination: {
    goto_label: "Aller à",
    goto_label_aria: "Aller à la page",
    next_aria: "Aller à la page suivante",
    previous_aria: "Aller à la page précédente",
    goto_page_aria: "Aller à la page {page}",
    current_page_aria: "Vous êtes actuellement sur la page {page}"
  },
  datagrid: {
    empty: "Ce tableau est vide",
    empty_alt: "Illustration d'un tableau vide",
    loader_aria: "Loading data"
  },
  provider: {
    test: "Ceci est un test : {name}"
  },
  forms: {
    select: {
      toggle_button_aria_label: "Ouvrir le menu",
      clear_button_aria_label: "Effacer la sélection",
      clear_all_button_aria_label: "Effacer toutes les sélections",
      menu_empty_placeholder: "Aucun choix disponible"
    },
    file_uploader: {
      delete_file_name: "Supprimer le fichier {name}",
      delete_file: "Supprimer le fichier",
      uploading: "Upload en cours ...",
      caption: "Glisser-déposer ou ",
      browse_files: "Parcourir"
    },
    date_picker: {
      toggle_button_aria_label_open: "Ouvrir le calendrier",
      toggle_button_aria_label_close: "Fermer le calendrier",
      clear_button_aria_label: "Effacer la date",
      next_month_button_aria_label: "Mois suivant",
      next_year_button_aria_label: "Année suivante",
      previous_month_button_aria_label: "Mois précédent",
      previous_year_button_aria_label: "Année précédente",
      year_select_button_aria_label: "Sélectionner une année",
      month_select_button_aria_label: "Sélectionner un mois"
    }
  }
}, uh = {
  components: Us
}, lh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  components: Us,
  default: uh
}, Symbol.toStringTag, { value: "Module" }));
var _i = /* @__PURE__ */ ((e) => (e.enUS = "en-US", e.frFR = "fr-FR", e))(_i || {});
function Ws(e) {
  const t = typeof window < "u" && window;
  return !!(t && (t.navigator.userAgent.match(/Chromatic/) || t.location.href.match(/chromatic=true/)));
}
var Ea = /* @__PURE__ */ ((e) => (e.INFO = "info", e.SUCCESS = "success", e.WARNING = "warning", e.ERROR = "error", e.NEUTRAL = "neutral", e))(Ea || {});
const sh = (e) => {
  switch (e) {
    case "info":
      return "info";
    case "success":
      return "success";
    case "warning":
      return "warning";
    case "error":
      return "danger";
    default:
      return "neutral";
  }
}, $i = (e) => {
  switch (e) {
    case "info":
      return "info";
    case "success":
      return "check_circle";
    case "warning":
      return "error_outline";
    case "error":
      return "cancel";
    default:
      return "";
  }
}, ch = (e) => {
  const [t, n] = fe.useState(!1), r = q(null), a = q();
  te(() => {
    if (!e.disableAnimate)
      return a.current = setTimeout(async () => {
        n(!0), a.current = void 0;
      }, e.duration), () => {
        a.current && clearTimeout(a.current);
      };
  }, []);
  const o = async () => {
    var i;
    await Promise.allSettled(
      r.current.getAnimations().map((u) => u.finished)
    ), (i = e.onDelete) == null || i.call(e);
  };
  return te(() => {
    t && o();
  }, [t]), /* @__PURE__ */ m.jsxs(
    "div",
    {
      ref: r,
      className: se("c__toast", "c__toast--" + e.type, {
        "c__toast--disappear": t,
        "c__toast--no-animate": e.disableAnimate
      }),
      role: "alert",
      children: [
        /* @__PURE__ */ m.jsx(fh, { duration: e.duration }),
        /* @__PURE__ */ m.jsxs("div", { className: "c__toast__content", children: [
          e.primaryLabel && /* @__PURE__ */ m.jsx("div", { className: "c__toast__content__buttons", children: /* @__PURE__ */ m.jsx(
            ge,
            {
              color: "primary-text",
              onClick: e.primaryOnClick,
              ...e.primaryProps,
              children: e.primaryLabel
            }
          ) }),
          e.actions,
          /* @__PURE__ */ m.jsx("div", { className: "c__toast__content__children", children: e.children }),
          /* @__PURE__ */ m.jsx(dh, { ...e })
        ] })
      ]
    }
  );
}, dh = ({ type: e, ...t }) => {
  const n = J(() => $i(e), [e]);
  return t.icon ? t.icon : n ? /* @__PURE__ */ m.jsx("div", { className: "c__toast__icon", children: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: n }) }) : null;
}, fh = ({ duration: e }) => {
  const t = q(null);
  return te(() => {
    Ws() || t.current.animate([{ width: "0%" }, { width: "100%" }], {
      duration: e,
      easing: "linear"
    });
  }, []), /* @__PURE__ */ m.jsx("div", { className: "c__progress-bar", children: /* @__PURE__ */ m.jsx("div", { className: "c__progress-bar__content", ref: t }) });
};
class mh {
  push(t) {
    const n = async () => (this.lastJob && await this.lastJob, t());
    return this.lastJob = n(), this.lastJob;
  }
}
const Gs = fe.createContext(
  void 0
), zb = () => {
  const e = yt(Gs);
  if (e === void 0)
    throw new Error("useToastProvider must be used within a ToastProvider.");
  return e;
};
let Ga = 1;
const ph = 6e3, rl = () => parseInt(
  Ls.themes.default.components.toast["slide-in-duration"].replace(
    "ms",
    ""
  ),
  10
), gh = ({ children: e }) => {
  const t = q(null), n = q(0), [r, a] = fe.useState([]), o = q(new mh()), i = J(
    () => ({
      toast: (l, s = Ea.NEUTRAL, c = {}) => {
        var f;
        (f = o.current) == null || f.push(
          () => new Promise((p) => {
            const d = Ga;
            Ga += 1, n.current = t.current.offsetHeight, a((g) => [
              ...g,
              {
                ...c,
                message: l,
                i: d,
                type: s,
                duration: (c == null ? void 0 : c.duration) ?? ph
              }
            ]), setTimeout(() => {
              p();
            }, rl());
          })
        );
      }
    }),
    [t, n, r]
  ), u = async () => {
    if (!t.current)
      return;
    const l = n.current, c = t.current.offsetHeight - l;
    typeof t.current.animate == "function" && !Ws() && t.current.animate(
      [
        { transform: `translateY(${c}px)` },
        { transform: "translateY(0)" }
      ],
      {
        duration: rl(),
        easing: "ease"
      }
    );
  };
  return fe.useEffect(() => {
    u();
  }, [Ga]), /* @__PURE__ */ m.jsxs(Gs.Provider, { value: i, children: [
    e,
    /* @__PURE__ */ m.jsx("div", { className: "c__toast__container", ref: t, children: r.map((l) => /* @__PURE__ */ m.jsx(
      ch,
      {
        onDelete: () => {
          a((s) => s.filter((c) => c.i !== l.i));
        },
        ...l,
        children: l.message
      },
      l.i
    )) })
  ] });
};
var Ro = { exports: {} }, sn = {}, Fo = { exports: {} }, wr = { exports: {} }, be = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var al;
function hh() {
  if (al) return be;
  al = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, h = e ? Symbol.for("react.scope") : 60119;
  function D(_) {
    if (typeof _ == "object" && _ !== null) {
      var O = _.$$typeof;
      switch (O) {
        case t:
          switch (_ = _.type, _) {
            case l:
            case s:
            case r:
            case o:
            case a:
            case f:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case u:
                case c:
                case g:
                case d:
                case i:
                  return _;
                default:
                  return O;
              }
          }
        case n:
          return O;
      }
    }
  }
  function x(_) {
    return D(_) === s;
  }
  return be.AsyncMode = l, be.ConcurrentMode = s, be.ContextConsumer = u, be.ContextProvider = i, be.Element = t, be.ForwardRef = c, be.Fragment = r, be.Lazy = g, be.Memo = d, be.Portal = n, be.Profiler = o, be.StrictMode = a, be.Suspense = f, be.isAsyncMode = function(_) {
    return x(_) || D(_) === l;
  }, be.isConcurrentMode = x, be.isContextConsumer = function(_) {
    return D(_) === u;
  }, be.isContextProvider = function(_) {
    return D(_) === i;
  }, be.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === t;
  }, be.isForwardRef = function(_) {
    return D(_) === c;
  }, be.isFragment = function(_) {
    return D(_) === r;
  }, be.isLazy = function(_) {
    return D(_) === g;
  }, be.isMemo = function(_) {
    return D(_) === d;
  }, be.isPortal = function(_) {
    return D(_) === n;
  }, be.isProfiler = function(_) {
    return D(_) === o;
  }, be.isStrictMode = function(_) {
    return D(_) === a;
  }, be.isSuspense = function(_) {
    return D(_) === f;
  }, be.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === r || _ === s || _ === o || _ === a || _ === f || _ === p || typeof _ == "object" && _ !== null && (_.$$typeof === g || _.$$typeof === d || _.$$typeof === i || _.$$typeof === u || _.$$typeof === c || _.$$typeof === v || _.$$typeof === C || _.$$typeof === h || _.$$typeof === b);
  }, be.typeOf = D, be;
}
var De = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ol;
function vh() {
  return ol || (ol = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, h = e ? Symbol.for("react.scope") : 60119;
    function D(z) {
      return typeof z == "string" || typeof z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      z === r || z === s || z === o || z === a || z === f || z === p || typeof z == "object" && z !== null && (z.$$typeof === g || z.$$typeof === d || z.$$typeof === i || z.$$typeof === u || z.$$typeof === c || z.$$typeof === v || z.$$typeof === C || z.$$typeof === h || z.$$typeof === b);
    }
    function x(z) {
      if (typeof z == "object" && z !== null) {
        var xe = z.$$typeof;
        switch (xe) {
          case t:
            var ee = z.type;
            switch (ee) {
              case l:
              case s:
              case r:
              case o:
              case a:
              case f:
                return ee;
              default:
                var we = ee && ee.$$typeof;
                switch (we) {
                  case u:
                  case c:
                  case g:
                  case d:
                  case i:
                    return we;
                  default:
                    return xe;
                }
            }
          case n:
            return xe;
        }
      }
    }
    var _ = l, O = s, L = u, y = i, F = t, T = c, $ = r, R = g, P = d, S = n, V = o, k = a, w = f, A = !1;
    function K(z) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), E(z) || x(z) === l;
    }
    function E(z) {
      return x(z) === s;
    }
    function B(z) {
      return x(z) === u;
    }
    function j(z) {
      return x(z) === i;
    }
    function N(z) {
      return typeof z == "object" && z !== null && z.$$typeof === t;
    }
    function H(z) {
      return x(z) === c;
    }
    function W(z) {
      return x(z) === r;
    }
    function Z(z) {
      return x(z) === g;
    }
    function M(z) {
      return x(z) === d;
    }
    function U(z) {
      return x(z) === n;
    }
    function X(z) {
      return x(z) === o;
    }
    function Q(z) {
      return x(z) === a;
    }
    function oe(z) {
      return x(z) === f;
    }
    De.AsyncMode = _, De.ConcurrentMode = O, De.ContextConsumer = L, De.ContextProvider = y, De.Element = F, De.ForwardRef = T, De.Fragment = $, De.Lazy = R, De.Memo = P, De.Portal = S, De.Profiler = V, De.StrictMode = k, De.Suspense = w, De.isAsyncMode = K, De.isConcurrentMode = E, De.isContextConsumer = B, De.isContextProvider = j, De.isElement = N, De.isForwardRef = H, De.isFragment = W, De.isLazy = Z, De.isMemo = M, De.isPortal = U, De.isProfiler = X, De.isStrictMode = Q, De.isSuspense = oe, De.isValidElementType = D, De.typeOf = x;
  }()), De;
}
var il;
function Ys() {
  return il || (il = 1, process.env.NODE_ENV === "production" ? wr.exports = hh() : wr.exports = vh()), wr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ya, ul;
function yh() {
  if (ul) return Ya;
  ul = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var i = {}, u = 0; u < 10; u++)
        i["_" + String.fromCharCode(u)] = u;
      var l = Object.getOwnPropertyNames(i).map(function(c) {
        return i[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var s = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        s[c] = c;
      }), Object.keys(Object.assign({}, s)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ya = a() ? Object.assign : function(o, i) {
    for (var u, l = r(o), s, c = 1; c < arguments.length; c++) {
      u = Object(arguments[c]);
      for (var f in u)
        t.call(u, f) && (l[f] = u[f]);
      if (e) {
        s = e(u);
        for (var p = 0; p < s.length; p++)
          n.call(u, s[p]) && (l[s[p]] = u[s[p]]);
      }
    }
    return l;
  }, Ya;
}
var qa, ll;
function xi() {
  if (ll) return qa;
  ll = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return qa = e, qa;
}
var Za, sl;
function qs() {
  return sl || (sl = 1, Za = Function.call.bind(Object.prototype.hasOwnProperty)), Za;
}
var Ja, cl;
function bh() {
  if (cl) return Ja;
  cl = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = xi(), n = {}, r = qs();
    e = function(o) {
      var i = "Warning: " + o;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function a(o, i, u, l, s) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var f;
          try {
            if (typeof o[c] != "function") {
              var p = Error(
                (l || "React class") + ": " + u + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = o[c](i, c, l, u, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + u + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var d = s ? s() : "";
            e(
              "Failed " + u + " type: " + f.message + (d ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ja = a, Ja;
}
var Xa, dl;
function Dh() {
  if (dl) return Xa;
  dl = 1;
  var e = Ys(), t = yh(), n = xi(), r = qs(), a = bh(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(u) {
    var l = "Warning: " + u;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Xa = function(u, l) {
    var s = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(E) {
      var B = E && (s && E[s] || E[c]);
      if (typeof B == "function")
        return B;
    }
    var p = "<<anonymous>>", d = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: h(),
      arrayOf: D,
      element: x(),
      elementType: _(),
      instanceOf: O,
      node: T(),
      objectOf: y,
      oneOf: L,
      oneOfType: F,
      shape: R,
      exact: P
    };
    function g(E, B) {
      return E === B ? E !== 0 || 1 / E === 1 / B : E !== E && B !== B;
    }
    function b(E, B) {
      this.message = E, this.data = B && typeof B == "object" ? B : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function v(E) {
      if (process.env.NODE_ENV !== "production")
        var B = {}, j = 0;
      function N(W, Z, M, U, X, Q, oe) {
        if (U = U || p, Q = Q || M, oe !== n) {
          if (l) {
            var z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw z.name = "Invariant Violation", z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var xe = U + ":" + M;
            !B[xe] && // Avoid spamming the console because they are often not actionable except for lib authors
            j < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Q + "` prop on `" + U + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), B[xe] = !0, j++);
          }
        }
        return Z[M] == null ? W ? Z[M] === null ? new b("The " + X + " `" + Q + "` is marked as required " + ("in `" + U + "`, but its value is `null`.")) : new b("The " + X + " `" + Q + "` is marked as required in " + ("`" + U + "`, but its value is `undefined`.")) : null : E(Z, M, U, X, Q);
      }
      var H = N.bind(null, !1);
      return H.isRequired = N.bind(null, !0), H;
    }
    function C(E) {
      function B(j, N, H, W, Z, M) {
        var U = j[N], X = k(U);
        if (X !== E) {
          var Q = w(U);
          return new b(
            "Invalid " + W + " `" + Z + "` of type " + ("`" + Q + "` supplied to `" + H + "`, expected ") + ("`" + E + "`."),
            { expectedType: E }
          );
        }
        return null;
      }
      return v(B);
    }
    function h() {
      return v(i);
    }
    function D(E) {
      function B(j, N, H, W, Z) {
        if (typeof E != "function")
          return new b("Property `" + Z + "` of component `" + H + "` has invalid PropType notation inside arrayOf.");
        var M = j[N];
        if (!Array.isArray(M)) {
          var U = k(M);
          return new b("Invalid " + W + " `" + Z + "` of type " + ("`" + U + "` supplied to `" + H + "`, expected an array."));
        }
        for (var X = 0; X < M.length; X++) {
          var Q = E(M, X, H, W, Z + "[" + X + "]", n);
          if (Q instanceof Error)
            return Q;
        }
        return null;
      }
      return v(B);
    }
    function x() {
      function E(B, j, N, H, W) {
        var Z = B[j];
        if (!u(Z)) {
          var M = k(Z);
          return new b("Invalid " + H + " `" + W + "` of type " + ("`" + M + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(E);
    }
    function _() {
      function E(B, j, N, H, W) {
        var Z = B[j];
        if (!e.isValidElementType(Z)) {
          var M = k(Z);
          return new b("Invalid " + H + " `" + W + "` of type " + ("`" + M + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(E);
    }
    function O(E) {
      function B(j, N, H, W, Z) {
        if (!(j[N] instanceof E)) {
          var M = E.name || p, U = K(j[N]);
          return new b("Invalid " + W + " `" + Z + "` of type " + ("`" + U + "` supplied to `" + H + "`, expected ") + ("instance of `" + M + "`."));
        }
        return null;
      }
      return v(B);
    }
    function L(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), i;
      function B(j, N, H, W, Z) {
        for (var M = j[N], U = 0; U < E.length; U++)
          if (g(M, E[U]))
            return null;
        var X = JSON.stringify(E, function(oe, z) {
          var xe = w(z);
          return xe === "symbol" ? String(z) : z;
        });
        return new b("Invalid " + W + " `" + Z + "` of value `" + String(M) + "` " + ("supplied to `" + H + "`, expected one of " + X + "."));
      }
      return v(B);
    }
    function y(E) {
      function B(j, N, H, W, Z) {
        if (typeof E != "function")
          return new b("Property `" + Z + "` of component `" + H + "` has invalid PropType notation inside objectOf.");
        var M = j[N], U = k(M);
        if (U !== "object")
          return new b("Invalid " + W + " `" + Z + "` of type " + ("`" + U + "` supplied to `" + H + "`, expected an object."));
        for (var X in M)
          if (r(M, X)) {
            var Q = E(M, X, H, W, Z + "." + X, n);
            if (Q instanceof Error)
              return Q;
          }
        return null;
      }
      return v(B);
    }
    function F(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var B = 0; B < E.length; B++) {
        var j = E[B];
        if (typeof j != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + A(j) + " at index " + B + "."
          ), i;
      }
      function N(H, W, Z, M, U) {
        for (var X = [], Q = 0; Q < E.length; Q++) {
          var oe = E[Q], z = oe(H, W, Z, M, U, n);
          if (z == null)
            return null;
          z.data && r(z.data, "expectedType") && X.push(z.data.expectedType);
        }
        var xe = X.length > 0 ? ", expected one of type [" + X.join(", ") + "]" : "";
        return new b("Invalid " + M + " `" + U + "` supplied to " + ("`" + Z + "`" + xe + "."));
      }
      return v(N);
    }
    function T() {
      function E(B, j, N, H, W) {
        return S(B[j]) ? null : new b("Invalid " + H + " `" + W + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return v(E);
    }
    function $(E, B, j, N, H) {
      return new b(
        (E || "React class") + ": " + B + " type `" + j + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + H + "`."
      );
    }
    function R(E) {
      function B(j, N, H, W, Z) {
        var M = j[N], U = k(M);
        if (U !== "object")
          return new b("Invalid " + W + " `" + Z + "` of type `" + U + "` " + ("supplied to `" + H + "`, expected `object`."));
        for (var X in E) {
          var Q = E[X];
          if (typeof Q != "function")
            return $(H, W, Z, X, w(Q));
          var oe = Q(M, X, H, W, Z + "." + X, n);
          if (oe)
            return oe;
        }
        return null;
      }
      return v(B);
    }
    function P(E) {
      function B(j, N, H, W, Z) {
        var M = j[N], U = k(M);
        if (U !== "object")
          return new b("Invalid " + W + " `" + Z + "` of type `" + U + "` " + ("supplied to `" + H + "`, expected `object`."));
        var X = t({}, j[N], E);
        for (var Q in X) {
          var oe = E[Q];
          if (r(E, Q) && typeof oe != "function")
            return $(H, W, Z, Q, w(oe));
          if (!oe)
            return new b(
              "Invalid " + W + " `" + Z + "` key `" + Q + "` supplied to `" + H + "`.\nBad object: " + JSON.stringify(j[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(E), null, "  ")
            );
          var z = oe(M, Q, H, W, Z + "." + Q, n);
          if (z)
            return z;
        }
        return null;
      }
      return v(B);
    }
    function S(E) {
      switch (typeof E) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !E;
        case "object":
          if (Array.isArray(E))
            return E.every(S);
          if (E === null || u(E))
            return !0;
          var B = f(E);
          if (B) {
            var j = B.call(E), N;
            if (B !== E.entries) {
              for (; !(N = j.next()).done; )
                if (!S(N.value))
                  return !1;
            } else
              for (; !(N = j.next()).done; ) {
                var H = N.value;
                if (H && !S(H[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function V(E, B) {
      return E === "symbol" ? !0 : B ? B["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && B instanceof Symbol : !1;
    }
    function k(E) {
      var B = typeof E;
      return Array.isArray(E) ? "array" : E instanceof RegExp ? "object" : V(B, E) ? "symbol" : B;
    }
    function w(E) {
      if (typeof E > "u" || E === null)
        return "" + E;
      var B = k(E);
      if (B === "object") {
        if (E instanceof Date)
          return "date";
        if (E instanceof RegExp)
          return "regexp";
      }
      return B;
    }
    function A(E) {
      var B = w(E);
      switch (B) {
        case "array":
        case "object":
          return "an " + B;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + B;
        default:
          return B;
      }
    }
    function K(E) {
      return !E.constructor || !E.constructor.name ? p : E.constructor.name;
    }
    return d.checkPropTypes = a, d.resetWarningCache = a.resetWarningCache, d.PropTypes = d, d;
  }, Xa;
}
var Qa, fl;
function _h() {
  if (fl) return Qa;
  fl = 1;
  var e = xi();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Qa = function() {
    function r(i, u, l, s, c, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Qa;
}
if (process.env.NODE_ENV !== "production") {
  var $h = Ys(), xh = !0;
  Fo.exports = Dh()($h.isElement, xh);
} else
  Fo.exports = _h()();
var Ei = Fo.exports;
const Y = /* @__PURE__ */ Di(Ei);
var Ao = { exports: {} }, bt = {}, To = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var n = "none", r = "contents", a = /input|select|textarea|button|object|iframe/;
  function o(f, p) {
    return p.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    f.scrollWidth <= 0 && f.scrollHeight <= 0;
  }
  function i(f) {
    var p = f.offsetWidth <= 0 && f.offsetHeight <= 0;
    if (p && !f.innerHTML) return !0;
    try {
      var d = window.getComputedStyle(f), g = d.getPropertyValue("display");
      return p ? g !== r && o(f, d) : g === n;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function u(f) {
    for (var p = f, d = f.getRootNode && f.getRootNode(); p && p !== document.body; ) {
      if (d && p === d && (p = d.host.parentNode), i(p)) return !1;
      p = p.parentNode;
    }
    return !0;
  }
  function l(f, p) {
    var d = f.nodeName.toLowerCase(), g = a.test(d) && !f.disabled || d === "a" && f.href || p;
    return g && u(f);
  }
  function s(f) {
    var p = f.getAttribute("tabindex");
    p === null && (p = void 0);
    var d = isNaN(p);
    return (d || p >= 0) && l(f, !d);
  }
  function c(f) {
    var p = [].slice.call(f.querySelectorAll("*"), 0).reduce(function(d, g) {
      return d.concat(g.shadowRoot ? c(g.shadowRoot) : [g]);
    }, []);
    return p.filter(s);
  }
  e.exports = t.default;
})(To, To.exports);
var Zs = To.exports;
Object.defineProperty(bt, "__esModule", {
  value: !0
});
bt.resetState = Sh;
bt.log = Ih;
bt.handleBlur = or;
bt.handleFocus = ir;
bt.markForFocusLater = Ph;
bt.returnFocus = Rh;
bt.popWithoutFocus = Fh;
bt.setupScopedFocus = Ah;
bt.teardownScopedFocus = Th;
var Eh = Zs, Ch = wh(Eh);
function wh(e) {
  return e && e.__esModule ? e : { default: e };
}
var cn = [], xn = null, Oo = !1;
function Sh() {
  cn = [];
}
function Ih() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), cn.forEach(function(e) {
    var t = e || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function or() {
  Oo = !0;
}
function ir() {
  if (Oo) {
    if (Oo = !1, !xn)
      return;
    setTimeout(function() {
      if (!xn.contains(document.activeElement)) {
        var e = (0, Ch.default)(xn)[0] || xn;
        e.focus();
      }
    }, 0);
  }
}
function Ph() {
  cn.push(document.activeElement);
}
function Rh() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    cn.length !== 0 && (t = cn.pop(), t.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function Fh() {
  cn.length > 0 && cn.pop();
}
function Ah(e) {
  xn = e, window.addEventListener ? (window.addEventListener("blur", or, !1), document.addEventListener("focus", ir, !0)) : (window.attachEvent("onBlur", or), document.attachEvent("onFocus", ir));
}
function Th() {
  xn = null, window.addEventListener ? (window.removeEventListener("blur", or), document.removeEventListener("focus", ir)) : (window.detachEvent("onBlur", or), document.detachEvent("onFocus", ir));
}
var Bo = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = Zs, r = a(n);
  function a(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function o() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return u.activeElement.shadowRoot ? o(u.activeElement.shadowRoot) : u.activeElement;
  }
  function i(u, l) {
    var s = (0, r.default)(u);
    if (!s.length) {
      l.preventDefault();
      return;
    }
    var c = void 0, f = l.shiftKey, p = s[0], d = s[s.length - 1], g = o();
    if (u === g) {
      if (!f) return;
      c = d;
    }
    if (d === g && !f && (c = p), p === g && f && (c = d), c) {
      l.preventDefault(), c.focus();
      return;
    }
    var b = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), v = b != null && b[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (v) {
      var C = s.indexOf(g);
      if (C > -1 && (C += f ? -1 : 1), c = s[C], typeof c > "u") {
        l.preventDefault(), c = f ? d : p, c.focus();
        return;
      }
      l.preventDefault(), c.focus();
    }
  }
  e.exports = t.default;
})(Bo, Bo.exports);
var Oh = Bo.exports, Dt = {}, Bh = process.env.NODE_ENV !== "production", Js = function() {
};
if (Bh) {
  var Mh = function(t, n) {
    var r = arguments.length;
    n = new Array(r > 1 ? r - 1 : 0);
    for (var a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    var o = 0, i = "Warning: " + t.replace(/%s/g, function() {
      return n[o++];
    });
    typeof console < "u" && console.error(i);
    try {
      throw new Error(i);
    } catch {
    }
  };
  Js = function(e, t, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var a = 2; a < r; a++)
      n[a - 2] = arguments[a];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || Mh.apply(null, [t].concat(n));
  };
}
var kh = Js, gt = {}, Xs = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), n = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    e.exports ? e.exports = n : window.ExecutionEnvironment = n;
  })();
})(Xs);
var Vh = Xs.exports;
Object.defineProperty(gt, "__esModule", {
  value: !0
});
gt.canUseDOM = gt.SafeNodeList = gt.SafeHTMLCollection = void 0;
var Nh = Vh, jh = Lh(Nh);
function Lh(e) {
  return e && e.__esModule ? e : { default: e };
}
var Ca = jh.default, Hh = Ca.canUseDOM ? window.HTMLElement : {};
gt.SafeHTMLCollection = Ca.canUseDOM ? window.HTMLCollection : {};
gt.SafeNodeList = Ca.canUseDOM ? window.NodeList : {};
gt.canUseDOM = Ca.canUseDOM;
gt.default = Hh;
Object.defineProperty(Dt, "__esModule", {
  value: !0
});
Dt.resetState = Gh;
Dt.log = Yh;
Dt.assertNodeList = Qs;
Dt.setElement = qh;
Dt.validateElement = Ci;
Dt.hide = Zh;
Dt.show = Jh;
Dt.documentNotReadyOrSSRTesting = Xh;
var Kh = kh, zh = Wh(Kh), Uh = gt;
function Wh(e) {
  return e && e.__esModule ? e : { default: e };
}
var tt = null;
function Gh() {
  tt && (tt.removeAttribute ? tt.removeAttribute("aria-hidden") : tt.length != null ? tt.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(tt).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), tt = null;
}
function Yh() {
  if (process.env.NODE_ENV !== "production") {
    var e = tt || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function Qs(e, t) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function qh(e) {
  var t = e;
  if (typeof t == "string" && Uh.canUseDOM) {
    var n = document.querySelectorAll(t);
    Qs(n, t), t = n;
  }
  return tt = t || tt, tt;
}
function Ci(e) {
  var t = e || tt;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, zh.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function Zh(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var a = Ci(e)[Symbol.iterator](), o; !(t = (o = a.next()).done); t = !0) {
      var i = o.value;
      i.setAttribute("aria-hidden", "true");
    }
  } catch (u) {
    n = !0, r = u;
  } finally {
    try {
      !t && a.return && a.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function Jh(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var a = Ci(e)[Symbol.iterator](), o; !(t = (o = a.next()).done); t = !0) {
      var i = o.value;
      i.removeAttribute("aria-hidden");
    }
  } catch (u) {
    n = !0, r = u;
  } finally {
    try {
      !t && a.return && a.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function Xh() {
  tt = null;
}
var jn = {};
Object.defineProperty(jn, "__esModule", {
  value: !0
});
jn.resetState = Qh;
jn.log = e0;
var rn = {}, an = {};
function ml(e, t) {
  e.classList.remove(t);
}
function Qh() {
  var e = document.getElementsByTagName("html")[0];
  for (var t in rn)
    ml(e, rn[t]);
  var n = document.body;
  for (var r in an)
    ml(n, an[r]);
  rn = {}, an = {};
}
function e0() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + e + `):
  `;
    for (var n in rn)
      t += "  " + n + " " + rn[n] + `
  `;
    e = document.body.className, t += `

doc.body (` + e + `):
  `;
    for (var r in an)
      t += "  " + r + " " + an[r] + `
  `;
    t += `
`, console.log(t);
  }
}
var t0 = function(t, n) {
  return t[n] || (t[n] = 0), t[n] += 1, n;
}, n0 = function(t, n) {
  return t[n] && (t[n] -= 1), n;
}, r0 = function(t, n, r) {
  r.forEach(function(a) {
    t0(n, a), t.add(a);
  });
}, a0 = function(t, n, r) {
  r.forEach(function(a) {
    n0(n, a), n[a] === 0 && t.remove(a);
  });
};
jn.add = function(t, n) {
  return r0(t.classList, t.nodeName.toLowerCase() == "html" ? rn : an, n.split(" "));
};
jn.remove = function(t, n) {
  return a0(t.classList, t.nodeName.toLowerCase() == "html" ? rn : an, n.split(" "));
};
var Ln = {};
Object.defineProperty(Ln, "__esModule", {
  value: !0
});
Ln.log = i0;
Ln.resetState = u0;
function o0(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var ec = function e() {
  var t = this;
  o0(this, e), this.register = function(n) {
    if (t.openInstances.indexOf(n) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(n), t.emit("register");
  }, this.deregister = function(n) {
    var r = t.openInstances.indexOf(n);
    if (r === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + n + " as it was never registered");
      return;
    }
    t.openInstances.splice(r, 1), t.emit("deregister");
  }, this.subscribe = function(n) {
    t.subscribers.push(n);
  }, this.emit = function(n) {
    t.subscribers.forEach(function(r) {
      return r(
        n,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, Xr = new ec();
function i0() {
  console.log("portalOpenInstances ----------"), console.log(Xr.openInstances.length), Xr.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function u0() {
  Xr = new ec();
}
Ln.default = Xr;
var wi = {};
Object.defineProperty(wi, "__esModule", {
  value: !0
});
wi.resetState = d0;
wi.log = f0;
var l0 = Ln, s0 = c0(l0);
function c0(e) {
  return e && e.__esModule ? e : { default: e };
}
var Le = void 0, dt = void 0, on = [];
function d0() {
  for (var e = [Le, dt], t = 0; t < e.length; t++) {
    var n = e[t];
    n && n.parentNode && n.parentNode.removeChild(n);
  }
  Le = dt = null, on = [];
}
function f0() {
  console.log("bodyTrap ----------"), console.log(on.length);
  for (var e = [Le, dt], t = 0; t < e.length; t++) {
    var n = e[t], r = n || {};
    console.log(r.nodeName, r.className, r.id);
  }
  console.log("edn bodyTrap ----------");
}
function pl() {
  if (on.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  on[on.length - 1].focusContent();
}
function m0(e, t) {
  !Le && !dt && (Le = document.createElement("div"), Le.setAttribute("data-react-modal-body-trap", ""), Le.style.position = "absolute", Le.style.opacity = "0", Le.setAttribute("tabindex", "0"), Le.addEventListener("focus", pl), dt = Le.cloneNode(), dt.addEventListener("focus", pl)), on = t, on.length > 0 ? (document.body.firstChild !== Le && document.body.insertBefore(Le, document.body.firstChild), document.body.lastChild !== dt && document.body.appendChild(dt)) : (Le.parentElement && Le.parentElement.removeChild(Le), dt.parentElement && dt.parentElement.removeChild(dt));
}
s0.default.subscribe(m0);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(S) {
    for (var V = 1; V < arguments.length; V++) {
      var k = arguments[V];
      for (var w in k)
        Object.prototype.hasOwnProperty.call(k, w) && (S[w] = k[w]);
    }
    return S;
  }, r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(S) {
    return typeof S;
  } : function(S) {
    return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
  }, a = /* @__PURE__ */ function() {
    function S(V, k) {
      for (var w = 0; w < k.length; w++) {
        var A = k[w];
        A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(V, A.key, A);
      }
    }
    return function(V, k, w) {
      return k && S(V.prototype, k), w && S(V, w), V;
    };
  }(), o = fe, i = Ei, u = _(i), l = bt, s = x(l), c = Oh, f = _(c), p = Dt, d = x(p), g = jn, b = x(g), v = gt, C = _(v), h = Ln, D = _(h);
  function x(S) {
    if (S && S.__esModule)
      return S;
    var V = {};
    if (S != null)
      for (var k in S)
        Object.prototype.hasOwnProperty.call(S, k) && (V[k] = S[k]);
    return V.default = S, V;
  }
  function _(S) {
    return S && S.__esModule ? S : { default: S };
  }
  function O(S, V) {
    if (!(S instanceof V))
      throw new TypeError("Cannot call a class as a function");
  }
  function L(S, V) {
    if (!S)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return V && (typeof V == "object" || typeof V == "function") ? V : S;
  }
  function y(S, V) {
    if (typeof V != "function" && V !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof V);
    S.prototype = Object.create(V && V.prototype, { constructor: { value: S, enumerable: !1, writable: !0, configurable: !0 } }), V && (Object.setPrototypeOf ? Object.setPrototypeOf(S, V) : S.__proto__ = V);
  }
  var F = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, T = function(V) {
    return V.code === "Tab" || V.keyCode === 9;
  }, $ = function(V) {
    return V.code === "Escape" || V.keyCode === 27;
  }, R = 0, P = function(S) {
    y(V, S);
    function V(k) {
      O(this, V);
      var w = L(this, (V.__proto__ || Object.getPrototypeOf(V)).call(this, k));
      return w.setOverlayRef = function(A) {
        w.overlay = A, w.props.overlayRef && w.props.overlayRef(A);
      }, w.setContentRef = function(A) {
        w.content = A, w.props.contentRef && w.props.contentRef(A);
      }, w.afterClose = function() {
        var A = w.props, K = A.appElement, E = A.ariaHideApp, B = A.htmlOpenClassName, j = A.bodyOpenClassName, N = A.parentSelector, H = N && N().ownerDocument || document;
        j && b.remove(H.body, j), B && b.remove(H.getElementsByTagName("html")[0], B), E && R > 0 && (R -= 1, R === 0 && d.show(K)), w.props.shouldFocusAfterRender && (w.props.shouldReturnFocusAfterClose ? (s.returnFocus(w.props.preventScroll), s.teardownScopedFocus()) : s.popWithoutFocus()), w.props.onAfterClose && w.props.onAfterClose(), D.default.deregister(w);
      }, w.open = function() {
        w.beforeOpen(), w.state.afterOpen && w.state.beforeClose ? (clearTimeout(w.closeTimer), w.setState({ beforeClose: !1 })) : (w.props.shouldFocusAfterRender && (s.setupScopedFocus(w.node), s.markForFocusLater()), w.setState({ isOpen: !0 }, function() {
          w.openAnimationFrame = requestAnimationFrame(function() {
            w.setState({ afterOpen: !0 }), w.props.isOpen && w.props.onAfterOpen && w.props.onAfterOpen({
              overlayEl: w.overlay,
              contentEl: w.content
            });
          });
        }));
      }, w.close = function() {
        w.props.closeTimeoutMS > 0 ? w.closeWithTimeout() : w.closeWithoutTimeout();
      }, w.focusContent = function() {
        return w.content && !w.contentHasFocus() && w.content.focus({ preventScroll: !0 });
      }, w.closeWithTimeout = function() {
        var A = Date.now() + w.props.closeTimeoutMS;
        w.setState({ beforeClose: !0, closesAt: A }, function() {
          w.closeTimer = setTimeout(w.closeWithoutTimeout, w.state.closesAt - Date.now());
        });
      }, w.closeWithoutTimeout = function() {
        w.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, w.afterClose);
      }, w.handleKeyDown = function(A) {
        T(A) && (0, f.default)(w.content, A), w.props.shouldCloseOnEsc && $(A) && (A.stopPropagation(), w.requestClose(A));
      }, w.handleOverlayOnClick = function(A) {
        w.shouldClose === null && (w.shouldClose = !0), w.shouldClose && w.props.shouldCloseOnOverlayClick && (w.ownerHandlesClose() ? w.requestClose(A) : w.focusContent()), w.shouldClose = null;
      }, w.handleContentOnMouseUp = function() {
        w.shouldClose = !1;
      }, w.handleOverlayOnMouseDown = function(A) {
        !w.props.shouldCloseOnOverlayClick && A.target == w.overlay && A.preventDefault();
      }, w.handleContentOnClick = function() {
        w.shouldClose = !1;
      }, w.handleContentOnMouseDown = function() {
        w.shouldClose = !1;
      }, w.requestClose = function(A) {
        return w.ownerHandlesClose() && w.props.onRequestClose(A);
      }, w.ownerHandlesClose = function() {
        return w.props.onRequestClose;
      }, w.shouldBeClosed = function() {
        return !w.state.isOpen && !w.state.beforeClose;
      }, w.contentHasFocus = function() {
        return document.activeElement === w.content || w.content.contains(document.activeElement);
      }, w.buildClassName = function(A, K) {
        var E = (typeof K > "u" ? "undefined" : r(K)) === "object" ? K : {
          base: F[A],
          afterOpen: F[A] + "--after-open",
          beforeClose: F[A] + "--before-close"
        }, B = E.base;
        return w.state.afterOpen && (B = B + " " + E.afterOpen), w.state.beforeClose && (B = B + " " + E.beforeClose), typeof K == "string" && K ? B + " " + K : B;
      }, w.attributesFromObject = function(A, K) {
        return Object.keys(K).reduce(function(E, B) {
          return E[A + "-" + B] = K[B], E;
        }, {});
      }, w.state = {
        afterOpen: !1,
        beforeClose: !1
      }, w.shouldClose = null, w.moveFromContentToOverlay = null, w;
    }
    return a(V, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(w, A) {
        process.env.NODE_ENV !== "production" && (w.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), w.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !w.isOpen ? this.open() : !this.props.isOpen && w.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !A.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var w = this.props, A = w.appElement, K = w.ariaHideApp, E = w.htmlOpenClassName, B = w.bodyOpenClassName, j = w.parentSelector, N = j && j().ownerDocument || document;
        B && b.add(N.body, B), E && b.add(N.getElementsByTagName("html")[0], E), K && (R += 1, d.hide(A)), D.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var w = this.props, A = w.id, K = w.className, E = w.overlayClassName, B = w.defaultStyles, j = w.children, N = K ? {} : B.content, H = E ? {} : B.overlay;
        if (this.shouldBeClosed())
          return null;
        var W = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", E),
          style: n({}, H, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, Z = n({
          id: A,
          ref: this.setContentRef,
          style: n({}, N, this.props.style.content),
          className: this.buildClassName("content", K),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", n({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), M = this.props.contentElement(Z, j);
        return this.props.overlayElement(W, M);
      }
    }]), V;
  }(o.Component);
  P.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, P.propTypes = {
    isOpen: u.default.bool.isRequired,
    defaultStyles: u.default.shape({
      content: u.default.object,
      overlay: u.default.object
    }),
    style: u.default.shape({
      content: u.default.object,
      overlay: u.default.object
    }),
    className: u.default.oneOfType([u.default.string, u.default.object]),
    overlayClassName: u.default.oneOfType([u.default.string, u.default.object]),
    parentSelector: u.default.func,
    bodyOpenClassName: u.default.string,
    htmlOpenClassName: u.default.string,
    ariaHideApp: u.default.bool,
    appElement: u.default.oneOfType([u.default.instanceOf(C.default), u.default.instanceOf(v.SafeHTMLCollection), u.default.instanceOf(v.SafeNodeList), u.default.arrayOf(u.default.instanceOf(C.default))]),
    onAfterOpen: u.default.func,
    onAfterClose: u.default.func,
    onRequestClose: u.default.func,
    closeTimeoutMS: u.default.number,
    shouldFocusAfterRender: u.default.bool,
    shouldCloseOnOverlayClick: u.default.bool,
    shouldReturnFocusAfterClose: u.default.bool,
    preventScroll: u.default.bool,
    role: u.default.string,
    contentLabel: u.default.string,
    aria: u.default.object,
    data: u.default.object,
    children: u.default.node,
    shouldCloseOnEsc: u.default.bool,
    overlayRef: u.default.func,
    contentRef: u.default.func,
    id: u.default.string,
    overlayElement: u.default.func,
    contentElement: u.default.func,
    testId: u.default.string
  }, t.default = P, e.exports = t.default;
})(Ao, Ao.exports);
var p0 = Ao.exports;
function tc() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function nc(e) {
  function t(n) {
    var r = this.constructor.getDerivedStateFromProps(e, n);
    return r ?? null;
  }
  this.setState(t.bind(this));
}
function rc(e, t) {
  try {
    var n = this.props, r = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      r
    );
  } finally {
    this.props = n, this.state = r;
  }
}
tc.__suppressDeprecationWarning = !0;
nc.__suppressDeprecationWarning = !0;
rc.__suppressDeprecationWarning = !0;
function g0(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var n = null, r = null, a = null;
  if (typeof t.componentWillMount == "function" ? n = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? r = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (r = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? a = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (a = "UNSAFE_componentWillUpdate"), n !== null || r !== null || a !== null) {
    var o = e.displayName || e.name, i = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + o + " uses " + i + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + (a !== null ? `
  ` + a : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = tc, t.componentWillReceiveProps = nc), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = rc;
    var u = t.componentDidUpdate;
    t.componentDidUpdate = function(s, c, f) {
      var p = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : f;
      u.call(this, s, c, p);
    };
  }
  return e;
}
const h0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: g0
}, Symbol.toStringTag, { value: "Module" })), v0 = /* @__PURE__ */ th(h0);
Object.defineProperty(sn, "__esModule", {
  value: !0
});
sn.bodyOpenClassName = sn.portalClassName = void 0;
var gl = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, y0 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var a = n[r];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}(), ac = fe, Qr = pr(ac), b0 = eh, ea = pr(b0), D0 = Ei, de = pr(D0), _0 = p0, hl = pr(_0), $0 = Dt, x0 = C0($0), Vt = gt, vl = pr(Vt), E0 = v0;
function C0(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t.default = e, t;
}
function pr(e) {
  return e && e.__esModule ? e : { default: e };
}
function w0(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yl(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function S0(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var I0 = sn.portalClassName = "ReactModalPortal", P0 = sn.bodyOpenClassName = "ReactModal__Body--open", Xt = Vt.canUseDOM && ea.default.createPortal !== void 0, Mo = function(t) {
  return document.createElement(t);
}, bl = function() {
  return Xt ? ea.default.createPortal : ea.default.unstable_renderSubtreeIntoContainer;
};
function Sr(e) {
  return e();
}
var Hn = function(e) {
  S0(t, e);
  function t() {
    var n, r, a, o;
    w0(this, t);
    for (var i = arguments.length, u = Array(i), l = 0; l < i; l++)
      u[l] = arguments[l];
    return o = (r = (a = yl(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(u))), a), a.removePortal = function() {
      !Xt && ea.default.unmountComponentAtNode(a.node);
      var s = Sr(a.props.parentSelector);
      s && s.contains(a.node) ? s.removeChild(a.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, a.portalRef = function(s) {
      a.portal = s;
    }, a.renderPortal = function(s) {
      var c = bl(), f = c(a, Qr.default.createElement(hl.default, gl({ defaultStyles: t.defaultStyles }, s)), a.node);
      a.portalRef(f);
    }, r), yl(a, o);
  }
  return y0(t, [{
    key: "componentDidMount",
    value: function() {
      if (Vt.canUseDOM) {
        Xt || (this.node = Mo("div")), this.node.className = this.props.portalClassName;
        var r = Sr(this.props.parentSelector);
        r.appendChild(this.node), !Xt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(r) {
      var a = Sr(r.parentSelector), o = Sr(this.props.parentSelector);
      return { prevParent: a, nextParent: o };
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, a, o) {
      if (Vt.canUseDOM) {
        var i = this.props, u = i.isOpen, l = i.portalClassName;
        r.portalClassName !== l && (this.node.className = l);
        var s = o.prevParent, c = o.nextParent;
        c !== s && (s.removeChild(this.node), c.appendChild(this.node)), !(!r.isOpen && !u) && !Xt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!Vt.canUseDOM || !this.node || !this.portal)) {
        var r = this.portal.state, a = Date.now(), o = r.isOpen && this.props.closeTimeoutMS && (r.closesAt || a + this.props.closeTimeoutMS);
        o ? (r.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, o - a)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!Vt.canUseDOM || !Xt)
        return null;
      !this.node && Xt && (this.node = Mo("div"));
      var r = bl();
      return r(Qr.default.createElement(hl.default, gl({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(r) {
      x0.setElement(r);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(ac.Component);
Hn.propTypes = {
  isOpen: de.default.bool.isRequired,
  style: de.default.shape({
    content: de.default.object,
    overlay: de.default.object
  }),
  portalClassName: de.default.string,
  bodyOpenClassName: de.default.string,
  htmlOpenClassName: de.default.string,
  className: de.default.oneOfType([de.default.string, de.default.shape({
    base: de.default.string.isRequired,
    afterOpen: de.default.string.isRequired,
    beforeClose: de.default.string.isRequired
  })]),
  overlayClassName: de.default.oneOfType([de.default.string, de.default.shape({
    base: de.default.string.isRequired,
    afterOpen: de.default.string.isRequired,
    beforeClose: de.default.string.isRequired
  })]),
  appElement: de.default.oneOfType([de.default.instanceOf(vl.default), de.default.instanceOf(Vt.SafeHTMLCollection), de.default.instanceOf(Vt.SafeNodeList), de.default.arrayOf(de.default.instanceOf(vl.default))]),
  onAfterOpen: de.default.func,
  onRequestClose: de.default.func,
  closeTimeoutMS: de.default.number,
  ariaHideApp: de.default.bool,
  shouldFocusAfterRender: de.default.bool,
  shouldCloseOnOverlayClick: de.default.bool,
  shouldReturnFocusAfterClose: de.default.bool,
  preventScroll: de.default.bool,
  parentSelector: de.default.func,
  aria: de.default.object,
  data: de.default.object,
  role: de.default.string,
  contentLabel: de.default.string,
  shouldCloseOnEsc: de.default.bool,
  overlayRef: de.default.func,
  contentRef: de.default.func,
  id: de.default.string,
  overlayElement: de.default.func,
  contentElement: de.default.func
};
Hn.defaultProps = {
  isOpen: !1,
  portalClassName: I0,
  bodyOpenClassName: P0,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, n) {
    return Qr.default.createElement(
      "div",
      t,
      n
    );
  },
  contentElement: function(t, n) {
    return Qr.default.createElement(
      "div",
      t,
      n
    );
  }
};
Hn.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, E0.polyfill)(Hn);
process.env.NODE_ENV !== "production" && (Hn.setCreateHTMLElement = function(e) {
  return Mo = e;
});
sn.default = Hn;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = sn, r = a(n);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  t.default = r.default, e.exports = t.default;
})(Ro, Ro.exports);
var R0 = Ro.exports;
const oc = /* @__PURE__ */ Di(R0), Dl = "c__modal";
var wa = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.EXTRA_LARGE = "extra-large", e.FULL = "full", e))(wa || {});
const F0 = ({
  isOpenDefault: e
} = {}) => {
  const [t, n] = fe.useState(!!e), r = () => {
    n(!1);
  };
  return {
    isOpen: t,
    onClose: r,
    open: () => {
      n(!0);
    },
    close: () => {
      r();
    }
  };
}, Si = (e) => {
  const [t, n] = fe.useState(!0);
  return te(() => {
    n(!1);
  }, []), t ? null : /* @__PURE__ */ m.jsx(A0, { ...e });
}, A0 = ({ closeOnEsc: e = !0, ...t }) => {
  const { modalParentSelector: n } = V0();
  return t.isOpen ? /* @__PURE__ */ m.jsx(
    oc,
    {
      isOpen: t.isOpen,
      onRequestClose: () => {
        t.preventClose || t.onClose();
      },
      parentSelector: n,
      overlayClassName: "c__modal__backdrop",
      className: se(Dl, `${Dl}--${t.size}`),
      shouldCloseOnOverlayClick: !!t.closeOnClickOutside,
      shouldCloseOnEsc: e,
      bodyOpenClassName: se("c__modals--opened", k0),
      children: /* @__PURE__ */ m.jsxs("div", { className: "c__modal__scroller", children: [
        !t.hideCloseButton && !t.preventClose && /* @__PURE__ */ m.jsx("div", { className: "c__modal__close", children: /* @__PURE__ */ m.jsx(
          ge,
          {
            icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "close" }),
            color: "tertiary-text",
            size: "small",
            onClick: t.onClose
          }
        ) }),
        t.titleIcon && /* @__PURE__ */ m.jsx("div", { className: "c__modal__title-icon", children: t.titleIcon }),
        t.title && /* @__PURE__ */ m.jsx("div", { className: "c__modal__title", children: t.title }),
        /* @__PURE__ */ m.jsx("div", { className: "c__modal__content", tabIndex: 0, children: t.children }),
        /* @__PURE__ */ m.jsx(T0, { ...t })
      ] })
    }
  ) : null;
}, T0 = ({
  leftActions: e,
  rightActions: t,
  actions: n
}) => {
  if ((e || t) && n)
    throw new Error("Cannot use leftActions or rightActions with actions");
  return !e && !t && !n ? null : /* @__PURE__ */ m.jsx(
    "div",
    {
      className: se("c__modal__footer", {
        "c__modal__footer--sided": e || t
      }),
      children: n || /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
        /* @__PURE__ */ m.jsx("div", { className: "c__modal__footer__left", children: e }),
        /* @__PURE__ */ m.jsx("div", { className: "c__modal__footer__right", children: t })
      ] })
    }
  );
}, O0 = ({
  title: e,
  children: t,
  onDecide: n,
  ...r
}) => {
  const { t: a } = Oe();
  return /* @__PURE__ */ m.jsx(
    Si,
    {
      title: e ?? a("components.modals.helpers.delete_confirmation.title"),
      titleIcon: /* @__PURE__ */ m.jsx("span", { className: "material-icons clr-danger-600", children: "delete" }),
      size: wa.SMALL,
      actions: /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
        /* @__PURE__ */ m.jsx(
          ge,
          {
            color: "secondary",
            fullWidth: !0,
            onClick: () => n(null),
            children: a("components.modals.helpers.delete_confirmation.cancel")
          }
        ),
        /* @__PURE__ */ m.jsx(
          ge,
          {
            fullWidth: !0,
            onClick: () => n("delete"),
            color: "danger",
            children: a("components.modals.helpers.delete_confirmation.delete")
          }
        )
      ] }),
      ...r,
      children: /* @__PURE__ */ m.jsx("div", { className: "c__modal__content__text", children: t ?? a("components.modals.helpers.delete_confirmation.children") })
    }
  );
};
function Ii(e = 8) {
  const t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let n = "";
  for (let r = e; r > 0; --r)
    n += t[Math.floor(Math.random() * t.length)];
  return n;
}
function ta(e, t) {
  if (t < e)
    throw new Error("`min` arg must be inferior to `max` arg.");
  return Array.from({ length: t - e + 1 }, (n, r) => r + e);
}
const B0 = ({
  title: e,
  children: t,
  onDecide: n,
  ...r
}) => {
  const { t: a } = Oe();
  return /* @__PURE__ */ m.jsx(
    Si,
    {
      title: e ?? a("components.modals.helpers.confirmation.title"),
      size: wa.SMALL,
      actions: /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
        /* @__PURE__ */ m.jsx(
          ge,
          {
            color: "secondary",
            fullWidth: !0,
            onClick: () => n(null),
            children: a("components.modals.helpers.confirmation.cancel")
          }
        ),
        /* @__PURE__ */ m.jsx(ge, { fullWidth: !0, onClick: () => n("yes"), children: a("components.modals.helpers.confirmation.yes") })
      ] }),
      ...r,
      children: /* @__PURE__ */ m.jsx("div", { className: "c__modal__content__text", children: t ?? a("components.modals.helpers.confirmation.children") })
    }
  );
}, M0 = ({
  title: e,
  children: t,
  onDecide: n,
  messageType: r,
  ...a
}) => {
  const { t: o } = Oe();
  return /* @__PURE__ */ m.jsx(
    Si,
    {
      title: e ?? o("components.modals.helpers.disclaimer.title"),
      titleIcon: r !== Ea.NEUTRAL && /* @__PURE__ */ m.jsx(
        "span",
        {
          className: se(
            "material-icons",
            `clr-${sh(r)}-600`
          ),
          children: $i(r)
        }
      ),
      size: wa.SMALL,
      actions: /* @__PURE__ */ m.jsx(ge, { fullWidth: !0, onClick: () => n("ok"), children: o("components.modals.helpers.disclaimer.ok") }),
      ...a,
      children: /* @__PURE__ */ m.jsx("div", { className: "c__modal__content__text", children: t ?? o("components.modals.helpers.disclaimer.children") })
    }
  );
}, k0 = "c__noscroll", ic = xa(void 0), V0 = () => {
  const e = yt(ic);
  if (e === void 0)
    throw new Error("useModals must be used within a ModalProvider.");
  return e;
}, N0 = ({
  component: e,
  onClose: t,
  props: n
}) => {
  const r = F0({ isOpenDefault: !0 }), a = () => {
    r.onClose(), t();
  };
  return bi(e, {
    ...r,
    ...n,
    onClose: () => {
      var u;
      a(), (u = n.onDecide) == null || u.call(n);
    },
    onDecide: (u) => {
      var l;
      a(), (l = n.onDecide) == null || l.call(n, u);
    }
  });
}, j0 = ({
  children: e,
  modalParentSelector: t
}) => {
  const [n, r] = re({});
  te(() => {
    oc.setAppElement(".c__app");
  }, []);
  const a = (u, l) => {
    const s = Ii(32), c = /* @__PURE__ */ m.jsx(
      N0,
      {
        component: u,
        props: l,
        onClose: () => {
          r((f) => (delete f[s], f));
        }
      }
    );
    r((f) => ({
      ...f,
      [s]: c
    }));
  }, o = (u) => (l = {}) => new Promise((s) => {
    a(u, {
      onDecide: (c) => {
        s(c);
      },
      ...l
    });
  }), i = J(
    () => ({
      deleteConfirmationModal: o(O0),
      confirmationModal: o(B0),
      messageModal: o(M0),
      modalParentSelector: () => t ? t() : document.getElementById("c__modals-portal")
    }),
    []
  );
  return /* @__PURE__ */ m.jsxs(ic.Provider, { value: i, children: [
    e,
    /* @__PURE__ */ m.jsx("div", { id: "c__modals-portal" }),
    Object.entries(n).map(([u, l]) => /* @__PURE__ */ m.jsx(Ns, { children: l }, u))
  ] });
}, uc = xa(void 0), Oe = () => {
  const e = yt(uc);
  if (e === void 0)
    throw new Error("useCunningham must be used within a CunninghamProvider.");
  return e;
}, Ir = _i.enUS, L0 = "default", Ub = Object.values(_i), _l = "cunningham-theme--", $l = (e, t) => {
  const [n, ...r] = e.split(".");
  return r.reduce((a, o) => a[o], t[n]);
}, Wb = ({
  currentLocale: e = Ir,
  customLocales: t,
  theme: n = L0,
  modalParentSelector: r,
  children: a
}) => {
  const o = J(
    () => ({
      [Ir]: ih,
      "fr-FR": lh,
      ...t
    }),
    [t]
  ), i = J(() => o[e] && e || Ir, [e, o]), u = J(
    () => ({
      t: (l, s) => {
        let c = $l(l, o[i]) ?? $l(l, o[Ir]) ?? l;
        return s && Object.keys(s).forEach((f) => {
          c = c == null ? void 0 : c.replace(`{${f}}`, "" + s[f]);
        }), c;
      },
      currentLocale: i
    }),
    [e, o]
  );
  return te(() => {
    const l = document.querySelector(":root");
    l.classList.forEach((s) => {
      s.startsWith(_l) && l.classList.remove(s);
    }), l.classList.add(_l + n);
  }, [n]), /* @__PURE__ */ m.jsx(uc.Provider, { value: u, children: /* @__PURE__ */ m.jsx(j0, { modalParentSelector: r, children: /* @__PURE__ */ m.jsx("div", { className: "c__app", children: /* @__PURE__ */ m.jsx(gh, { children: a }) }) }) });
}, lc = (e) => /* @__PURE__ */ m.jsx(
  "div",
  {
    className: se(
      "c__alert",
      "c__alert--" + e.type,
      e.className,
      {
        "c__alert--hide": e.hide
      }
    ),
    children: e.children
  }
), sc = ({ type: e, ...t }) => {
  const n = J(() => $i(e), [e]);
  return t.icon ? t.icon : n ? /* @__PURE__ */ m.jsx("div", { className: "c__alert__icon", children: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: n }) }) : null;
}, cc = (e) => {
  const { t } = Oe();
  return e.canClose && /* @__PURE__ */ m.jsx(
    ge,
    {
      color: "tertiary",
      size: "small",
      icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "close" }),
      "aria-label": t("components.alert.close_aria_label"),
      onClick: () => {
        var n;
        (n = e.onClose) == null || n.call(e, !0);
      }
    }
  );
}, dc = (e) => /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
  e.tertiaryLabel && /* @__PURE__ */ m.jsx(
    ge,
    {
      color: "tertiary-text",
      onClick: e.tertiaryOnClick,
      ...e.tertiaryProps,
      children: e.tertiaryLabel
    }
  ),
  e.primaryLabel && /* @__PURE__ */ m.jsx(
    ge,
    {
      color: "primary-text",
      onClick: e.primaryOnClick,
      ...e.primaryProps,
      children: e.primaryLabel
    }
  ),
  e.buttons
] }), fc = (e) => /* @__PURE__ */ m.jsxs(lc, { ...e, children: [
  /* @__PURE__ */ m.jsxs("div", { className: "c__alert__content", children: [
    /* @__PURE__ */ m.jsxs("div", { className: "c__alert__content__left", children: [
      e.children,
      /* @__PURE__ */ m.jsx(sc, { ...e })
    ] }),
    /* @__PURE__ */ m.jsx(cc, { ...e })
  ] }),
  /* @__PURE__ */ m.jsx("div", { className: "c__alert__additional", children: e.additional }),
  /* @__PURE__ */ m.jsx("div", { className: "c__alert-additional__buttons", children: /* @__PURE__ */ m.jsx(dc, { ...e }) })
] }), mc = (e) => {
  const t = e.canClose || e.primaryLabel || e.tertiaryLabel || e.buttons;
  return /* @__PURE__ */ m.jsx(lc, { ...e, children: /* @__PURE__ */ m.jsxs("div", { className: "c__alert__content", children: [
    /* @__PURE__ */ m.jsxs("div", { className: "c__alert__content__left", children: [
      e.children,
      /* @__PURE__ */ m.jsx(sc, { ...e })
    ] }),
    t && /* @__PURE__ */ m.jsxs("div", { className: "c__alert__actions", children: [
      /* @__PURE__ */ m.jsx(dc, { ...e }),
      /* @__PURE__ */ m.jsx(cc, { ...e })
    ] })
  ] }) });
}, H0 = (e) => {
  const { t } = Oe(), [n, r] = Hs(
    !1,
    e.expanded,
    e.onExpand
  ), a = /* @__PURE__ */ m.jsx(
    ge,
    {
      color: "tertiary",
      size: "nano",
      "aria-label": t(n ? "components.alert.shrink_aria_label" : "components.alert.expand_aria_label"),
      icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: n ? "remove" : "add" }),
      onClick: () => {
        r(!n);
      }
    }
  ), o = {
    ...e,
    icon: a,
    className: "c__alert--expandable"
  };
  return n ? /* @__PURE__ */ m.jsx(fc, { ...o }) : /* @__PURE__ */ m.jsx(mc, { ...o });
}, Gb = (e) => {
  const [t, n] = Hs(
    !1,
    e.closed,
    e.onClose
  ), r = {
    type: Ea.INFO,
    ...e,
    onClose: n
  };
  return t ? null : e.additional ? e.expandable ? /* @__PURE__ */ m.jsx(H0, { ...r }) : /* @__PURE__ */ m.jsx(fc, { ...r }) : /* @__PURE__ */ m.jsx(mc, { ...r });
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function K0() {
  return {
    accessor: (e, t) => typeof e == "function" ? {
      ...t,
      accessorFn: e
    } : {
      ...t,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function Nt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function nt(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: Nt(n, r[e])
    }));
  };
}
function Sa(e) {
  return e instanceof Function;
}
function z0(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function U0(e, t) {
  const n = [], r = (a) => {
    a.forEach((o) => {
      n.push(o);
      const i = t(o);
      i != null && i.length && r(i);
    });
  };
  return r(e), n;
}
function ue(e, t, n) {
  let r = [], a;
  return (o) => {
    let i;
    n.key && n.debug && (i = Date.now());
    const u = e(o);
    if (!(u.length !== r.length || u.some((c, f) => r[f] !== c)))
      return a;
    r = u;
    let s;
    if (n.key && n.debug && (s = Date.now()), a = t(...u), n == null || n.onChange == null || n.onChange(a), n.key && n.debug && n != null && n.debug()) {
      const c = Math.round((Date.now() - i) * 100) / 100, f = Math.round((Date.now() - s) * 100) / 100, p = f / 16, d = (g, b) => {
        for (g = String(g); g.length < b; )
          g = " " + g;
        return g;
      };
      console.info(`%c⏱ ${d(f, 5)} /${d(c, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * p, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return a;
  };
}
function le(e, t, n, r) {
  return {
    debug: () => {
      var a;
      return (a = e == null ? void 0 : e.debugAll) != null ? a : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function W0(e, t, n, r) {
  const a = () => {
    var i;
    return (i = o.getValue()) != null ? i : e.options.renderFallbackValue;
  }, o = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: a,
    getContext: ue(() => [e, n, t, o], (i, u, l, s) => ({
      table: i,
      column: u,
      row: l,
      cell: s,
      getValue: s.getValue,
      renderValue: s.renderValue
    }), le(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((i) => {
    i.createCell == null || i.createCell(o, n, t, e);
  }, {}), o;
}
function G0(e, t, n, r) {
  var a, o;
  const u = {
    ...e._getDefaultColumnDef(),
    ...t
  }, l = u.accessorKey;
  let s = (a = (o = u.id) != null ? o : l ? typeof String.prototype.replaceAll == "function" ? l.replaceAll(".", "_") : l.replace(/\./g, "_") : void 0) != null ? a : typeof u.header == "string" ? u.header : void 0, c;
  if (u.accessorFn ? c = u.accessorFn : l && (l.includes(".") ? c = (p) => {
    let d = p;
    for (const b of l.split(".")) {
      var g;
      d = (g = d) == null ? void 0 : g[b], process.env.NODE_ENV !== "production" && d === void 0 && console.warn(`"${b}" in deeply nested key "${l}" returned undefined.`);
    }
    return d;
  } : c = (p) => p[u.accessorKey]), !s)
    throw process.env.NODE_ENV !== "production" ? new Error(u.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(s)}`,
    accessorFn: c,
    parent: r,
    depth: n,
    columnDef: u,
    columns: [],
    getFlatColumns: ue(() => [!0], () => {
      var p;
      return [f, ...(p = f.columns) == null ? void 0 : p.flatMap((d) => d.getFlatColumns())];
    }, le(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ue(() => [e._getOrderColumnsFn()], (p) => {
      var d;
      if ((d = f.columns) != null && d.length) {
        let g = f.columns.flatMap((b) => b.getLeafColumns());
        return p(g);
      }
      return [f];
    }, le(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const p of e._features)
    p.createColumn == null || p.createColumn(f, e);
  return f;
}
const je = "debugHeaders";
function xl(e, t, n) {
  var r;
  let o = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const i = [], u = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(u), i.push(l);
      };
      return u(o), i;
    },
    getContext: () => ({
      table: e,
      header: o,
      column: t
    })
  };
  return e._features.forEach((i) => {
    i.createHeader == null || i.createHeader(o, e);
  }), o;
}
const Y0 = {
  createTable: (e) => {
    e.getHeaderGroups = ue(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, a) => {
      var o, i;
      const u = (o = r == null ? void 0 : r.map((f) => n.find((p) => p.id === f)).filter(Boolean)) != null ? o : [], l = (i = a == null ? void 0 : a.map((f) => n.find((p) => p.id === f)).filter(Boolean)) != null ? i : [], s = n.filter((f) => !(r != null && r.includes(f.id)) && !(a != null && a.includes(f.id)));
      return Pr(t, [...u, ...s, ...l], e);
    }, le(e.options, je, "getHeaderGroups")), e.getCenterHeaderGroups = ue(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, a) => (n = n.filter((o) => !(r != null && r.includes(o.id)) && !(a != null && a.includes(o.id))), Pr(t, n, e, "center")), le(e.options, je, "getCenterHeaderGroups")), e.getLeftHeaderGroups = ue(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var a;
      const o = (a = r == null ? void 0 : r.map((i) => n.find((u) => u.id === i)).filter(Boolean)) != null ? a : [];
      return Pr(t, o, e, "left");
    }, le(e.options, je, "getLeftHeaderGroups")), e.getRightHeaderGroups = ue(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var a;
      const o = (a = r == null ? void 0 : r.map((i) => n.find((u) => u.id === i)).filter(Boolean)) != null ? a : [];
      return Pr(t, o, e, "right");
    }, le(e.options, je, "getRightHeaderGroups")), e.getFooterGroups = ue(() => [e.getHeaderGroups()], (t) => [...t].reverse(), le(e.options, je, "getFooterGroups")), e.getLeftFooterGroups = ue(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), le(e.options, je, "getLeftFooterGroups")), e.getCenterFooterGroups = ue(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), le(e.options, je, "getCenterFooterGroups")), e.getRightFooterGroups = ue(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), le(e.options, je, "getRightFooterGroups")), e.getFlatHeaders = ue(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), le(e.options, je, "getFlatHeaders")), e.getLeftFlatHeaders = ue(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), le(e.options, je, "getLeftFlatHeaders")), e.getCenterFlatHeaders = ue(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), le(e.options, je, "getCenterFlatHeaders")), e.getRightFlatHeaders = ue(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), le(e.options, je, "getRightFlatHeaders")), e.getCenterLeafHeaders = ue(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), le(e.options, je, "getCenterLeafHeaders")), e.getLeftLeafHeaders = ue(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), le(e.options, je, "getLeftLeafHeaders")), e.getRightLeafHeaders = ue(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), le(e.options, je, "getRightLeafHeaders")), e.getLeafHeaders = ue(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var a, o, i, u, l, s;
      return [...(a = (o = t[0]) == null ? void 0 : o.headers) != null ? a : [], ...(i = (u = n[0]) == null ? void 0 : u.headers) != null ? i : [], ...(l = (s = r[0]) == null ? void 0 : s.headers) != null ? l : []].map((c) => c.getLeafHeaders()).flat();
    }, le(e.options, je, "getLeafHeaders"));
  }
};
function Pr(e, t, n, r) {
  var a, o;
  let i = 0;
  const u = function(p, d) {
    d === void 0 && (d = 1), i = Math.max(i, d), p.filter((g) => g.getIsVisible()).forEach((g) => {
      var b;
      (b = g.columns) != null && b.length && u(g.columns, d + 1);
    }, 0);
  };
  u(e);
  let l = [];
  const s = (p, d) => {
    const g = {
      depth: d,
      id: [r, `${d}`].filter(Boolean).join("_"),
      headers: []
    }, b = [];
    p.forEach((v) => {
      const C = [...b].reverse()[0], h = v.column.depth === g.depth;
      let D, x = !1;
      if (h && v.column.parent ? D = v.column.parent : (D = v.column, x = !0), C && (C == null ? void 0 : C.column) === D)
        C.subHeaders.push(v);
      else {
        const _ = xl(n, D, {
          id: [r, d, D.id, v == null ? void 0 : v.id].filter(Boolean).join("_"),
          isPlaceholder: x,
          placeholderId: x ? `${b.filter((O) => O.column === D).length}` : void 0,
          depth: d,
          index: b.length
        });
        _.subHeaders.push(v), b.push(_);
      }
      g.headers.push(v), v.headerGroup = g;
    }), l.push(g), d > 0 && s(b, d - 1);
  }, c = t.map((p, d) => xl(n, p, {
    depth: i,
    index: d
  }));
  s(c, i - 1), l.reverse();
  const f = (p) => p.filter((g) => g.column.getIsVisible()).map((g) => {
    let b = 0, v = 0, C = [0];
    g.subHeaders && g.subHeaders.length ? (C = [], f(g.subHeaders).forEach((D) => {
      let {
        colSpan: x,
        rowSpan: _
      } = D;
      b += x, C.push(_);
    })) : b = 1;
    const h = Math.min(...C);
    return v = v + h, g.colSpan = b, g.rowSpan = v, {
      colSpan: b,
      rowSpan: v
    };
  });
  return f((a = (o = l[0]) == null ? void 0 : o.headers) != null ? a : []), l;
}
const q0 = (e, t, n, r, a, o, i) => {
  let u = {
    id: t,
    index: r,
    original: n,
    depth: a,
    parentId: i,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (u._valuesCache.hasOwnProperty(l))
        return u._valuesCache[l];
      const s = e.getColumn(l);
      if (s != null && s.accessorFn)
        return u._valuesCache[l] = s.accessorFn(u.original, r), u._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (u._uniqueValuesCache.hasOwnProperty(l))
        return u._uniqueValuesCache[l];
      const s = e.getColumn(l);
      if (s != null && s.accessorFn)
        return s.columnDef.getUniqueValues ? (u._uniqueValuesCache[l] = s.columnDef.getUniqueValues(u.original, r), u._uniqueValuesCache[l]) : (u._uniqueValuesCache[l] = [u.getValue(l)], u._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var s;
      return (s = u.getValue(l)) != null ? s : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => U0(u.subRows, (l) => l.subRows),
    getParentRow: () => u.parentId ? e.getRow(u.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], s = u;
      for (; ; ) {
        const c = s.getParentRow();
        if (!c) break;
        l.push(c), s = c;
      }
      return l.reverse();
    },
    getAllCells: ue(() => [e.getAllLeafColumns()], (l) => l.map((s) => W0(e, u, s, s.id)), le(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ue(() => [u.getAllCells()], (l) => l.reduce((s, c) => (s[c.column.id] = c, s), {}), le(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < e._features.length; l++) {
    const s = e._features[l];
    s == null || s.createRow == null || s.createRow(u, e);
  }
  return u;
}, Z0 = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, pc = (e, t, n) => {
  var r;
  const a = n.toLowerCase();
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(a));
};
pc.autoRemove = (e) => ht(e);
const gc = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
gc.autoRemove = (e) => ht(e);
const hc = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
hc.autoRemove = (e) => ht(e);
const vc = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
vc.autoRemove = (e) => ht(e) || !(e != null && e.length);
const yc = (e, t, n) => !n.some((r) => {
  var a;
  return !((a = e.getValue(t)) != null && a.includes(r));
});
yc.autoRemove = (e) => ht(e) || !(e != null && e.length);
const bc = (e, t, n) => n.some((r) => {
  var a;
  return (a = e.getValue(t)) == null ? void 0 : a.includes(r);
});
bc.autoRemove = (e) => ht(e) || !(e != null && e.length);
const Dc = (e, t, n) => e.getValue(t) === n;
Dc.autoRemove = (e) => ht(e);
const _c = (e, t, n) => e.getValue(t) == n;
_c.autoRemove = (e) => ht(e);
const Pi = (e, t, n) => {
  let [r, a] = n;
  const o = e.getValue(t);
  return o >= r && o <= a;
};
Pi.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, a = typeof n != "number" ? parseFloat(n) : n, o = t === null || Number.isNaN(r) ? -1 / 0 : r, i = n === null || Number.isNaN(a) ? 1 / 0 : a;
  if (o > i) {
    const u = o;
    o = i, i = u;
  }
  return [o, i];
};
Pi.autoRemove = (e) => ht(e) || ht(e[0]) && ht(e[1]);
const Rt = {
  includesString: pc,
  includesStringSensitive: gc,
  equalsString: hc,
  arrIncludes: vc,
  arrIncludesAll: yc,
  arrIncludesSome: bc,
  equals: Dc,
  weakEquals: _c,
  inNumberRange: Pi
};
function ht(e) {
  return e == null || e === "";
}
const J0 = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: nt("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? Rt.includesString : typeof r == "number" ? Rt.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? Rt.equals : Array.isArray(r) ? Rt.arrIncludes : Rt.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return Sa(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : Rt[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, a;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((a = t.options.enableFilters) != null ? a : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((a) => a.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const a = e.getFilterFn(), o = r == null ? void 0 : r.find((c) => c.id === e.id), i = Nt(n, o ? o.value : void 0);
        if (El(a, i, e)) {
          var u;
          return (u = r == null ? void 0 : r.filter((c) => c.id !== e.id)) != null ? u : [];
        }
        const l = {
          id: e.id,
          value: i
        };
        if (o) {
          var s;
          return (s = r == null ? void 0 : r.map((c) => c.id === e.id ? l : c)) != null ? s : [];
        }
        return r != null && r.length ? [...r, l] : [l];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (a) => {
        var o;
        return (o = Nt(t, a)) == null ? void 0 : o.filter((i) => {
          const u = n.find((l) => l.id === i.id);
          if (u) {
            const l = u.getFilterFn();
            if (El(l, i.value, u))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function El(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const X0 = (e, t, n) => n.reduce((r, a) => {
  const o = a.getValue(e);
  return r + (typeof o == "number" ? o : 0);
}, 0), Q0 = (e, t, n) => {
  let r;
  return n.forEach((a) => {
    const o = a.getValue(e);
    o != null && (r > o || r === void 0 && o >= o) && (r = o);
  }), r;
}, ev = (e, t, n) => {
  let r;
  return n.forEach((a) => {
    const o = a.getValue(e);
    o != null && (r < o || r === void 0 && o >= o) && (r = o);
  }), r;
}, tv = (e, t, n) => {
  let r, a;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r === void 0 ? i >= i && (r = a = i) : (r > i && (r = i), a < i && (a = i)));
  }), [r, a];
}, nv = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((a) => {
    let o = a.getValue(e);
    o != null && (o = +o) >= o && (++n, r += o);
  }), n) return r / n;
}, rv = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((o) => o.getValue(e));
  if (!z0(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), a = n.sort((o, i) => o - i);
  return n.length % 2 !== 0 ? a[r] : (a[r - 1] + a[r]) / 2;
}, av = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), ov = (e, t) => new Set(t.map((n) => n.getValue(e))).size, iv = (e, t) => t.length, eo = {
  sum: X0,
  min: Q0,
  max: ev,
  extent: tv,
  mean: nv,
  median: rv,
  unique: av,
  uniqueCount: ov,
  count: iv
}, uv = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: nt("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return eo.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return eo.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Sa(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : eo[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var a;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((a = n.subRows) != null && a.length);
    };
  }
};
function lv(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((o) => !t.includes(o.id));
  return n === "remove" ? r : [...t.map((o) => e.find((i) => i.id === o)).filter(Boolean), ...r];
}
const sv = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: nt("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = ue((n) => [Qn(t, n)], (n) => n.findIndex((r) => r.id === e.id), le(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = Qn(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const a = Qn(t, n);
      return ((r = a[a.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = ue(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (a) => {
      let o = [];
      if (!(t != null && t.length))
        o = a;
      else {
        const i = [...t], u = [...a];
        for (; u.length && i.length; ) {
          const l = i.shift(), s = u.findIndex((c) => c.id === l);
          s > -1 && o.push(u.splice(s, 1)[0]);
        }
        o = [...o, ...u];
      }
      return lv(o, n, r);
    }, le(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, to = () => ({
  left: [],
  right: []
}), cv = {
  getInitialState: (e) => ({
    columnPinning: to(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: nt("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((a) => a.id).filter(Boolean);
      t.setColumnPinning((a) => {
        var o, i;
        if (n === "right") {
          var u, l;
          return {
            left: ((u = a == null ? void 0 : a.left) != null ? u : []).filter((f) => !(r != null && r.includes(f))),
            right: [...((l = a == null ? void 0 : a.right) != null ? l : []).filter((f) => !(r != null && r.includes(f))), ...r]
          };
        }
        if (n === "left") {
          var s, c;
          return {
            left: [...((s = a == null ? void 0 : a.left) != null ? s : []).filter((f) => !(r != null && r.includes(f))), ...r],
            right: ((c = a == null ? void 0 : a.right) != null ? c : []).filter((f) => !(r != null && r.includes(f)))
          };
        }
        return {
          left: ((o = a == null ? void 0 : a.left) != null ? o : []).filter((f) => !(r != null && r.includes(f))),
          right: ((i = a == null ? void 0 : a.right) != null ? i : []).filter((f) => !(r != null && r.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var a, o, i;
      return ((a = r.columnDef.enablePinning) != null ? a : !0) && ((o = (i = t.options.enableColumnPinning) != null ? i : t.options.enablePinning) != null ? o : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((u) => u.id), {
        left: r,
        right: a
      } = t.getState().columnPinning, o = n.some((u) => r == null ? void 0 : r.includes(u)), i = n.some((u) => a == null ? void 0 : a.includes(u));
      return o ? "left" : i ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const a = e.getIsPinned();
      return a ? (n = (r = t.getState().columnPinning) == null || (r = r[a]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = ue(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, a) => {
      const o = [...r ?? [], ...a ?? []];
      return n.filter((i) => !o.includes(i.column.id));
    }, le(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = ue(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((o) => n.find((i) => i.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "left"
    })), le(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = ue(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((o) => n.find((i) => i.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "right"
    })), le(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? to() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : to());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var a, o;
        return !!((a = r.left) != null && a.length || (o = r.right) != null && o.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = ue(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((a) => a.id === r)).filter(Boolean), le(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = ue(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((a) => a.id === r)).filter(Boolean), le(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = ue(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const a = [...n ?? [], ...r ?? []];
      return t.filter((o) => !a.includes(o.id));
    }, le(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, Rr = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, no = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), dv = {
  getDefaultColumnDef: () => Rr,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: no(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: nt("columnSizing", e),
    onColumnSizingInfoChange: nt("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, a;
      const o = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : Rr.minSize, (r = o ?? e.columnDef.size) != null ? r : Rr.size), (a = e.columnDef.maxSize) != null ? a : Rr.maxSize);
    }, e.getStart = ue((n) => [n, Qn(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((a, o) => a + o.getSize(), 0), le(t.options, "debugColumns", "getStart")), e.getAfter = ue((n) => [n, Qn(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((a, o) => a + o.getSize(), 0), le(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...a
        } = n;
        return a;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (a) => {
        if (a.subHeaders.length)
          a.subHeaders.forEach(r);
        else {
          var o;
          n += (o = a.column.getSize()) != null ? o : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), a = r == null ? void 0 : r.getCanResize();
      return (o) => {
        if (!r || !a || (o.persist == null || o.persist(), ro(o) && o.touches && o.touches.length > 1))
          return;
        const i = e.getSize(), u = e ? e.getLeafHeaders().map((C) => [C.column.id, C.column.getSize()]) : [[r.id, r.getSize()]], l = ro(o) ? Math.round(o.touches[0].clientX) : o.clientX, s = {}, c = (C, h) => {
          typeof h == "number" && (t.setColumnSizingInfo((D) => {
            var x, _;
            const O = t.options.columnResizeDirection === "rtl" ? -1 : 1, L = (h - ((x = D == null ? void 0 : D.startOffset) != null ? x : 0)) * O, y = Math.max(L / ((_ = D == null ? void 0 : D.startSize) != null ? _ : 0), -0.999999);
            return D.columnSizingStart.forEach((F) => {
              let [T, $] = F;
              s[T] = Math.round(Math.max($ + $ * y, 0) * 100) / 100;
            }), {
              ...D,
              deltaOffset: L,
              deltaPercentage: y
            };
          }), (t.options.columnResizeMode === "onChange" || C === "end") && t.setColumnSizing((D) => ({
            ...D,
            ...s
          })));
        }, f = (C) => c("move", C), p = (C) => {
          c("end", C), t.setColumnSizingInfo((h) => ({
            ...h,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, d = n || typeof document < "u" ? document : null, g = {
          moveHandler: (C) => f(C.clientX),
          upHandler: (C) => {
            d == null || d.removeEventListener("mousemove", g.moveHandler), d == null || d.removeEventListener("mouseup", g.upHandler), p(C.clientX);
          }
        }, b = {
          moveHandler: (C) => (C.cancelable && (C.preventDefault(), C.stopPropagation()), f(C.touches[0].clientX), !1),
          upHandler: (C) => {
            var h;
            d == null || d.removeEventListener("touchmove", b.moveHandler), d == null || d.removeEventListener("touchend", b.upHandler), C.cancelable && (C.preventDefault(), C.stopPropagation()), p((h = C.touches[0]) == null ? void 0 : h.clientX);
          }
        }, v = fv() ? {
          passive: !1
        } : !1;
        ro(o) ? (d == null || d.addEventListener("touchmove", b.moveHandler, v), d == null || d.addEventListener("touchend", b.upHandler, v)) : (d == null || d.addEventListener("mousemove", g.moveHandler, v), d == null || d.addEventListener("mouseup", g.upHandler, v)), t.setColumnSizingInfo((C) => ({
          ...C,
          startOffset: l,
          startSize: i,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: u,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? no() : (n = e.initialState.columnSizingInfo) != null ? n : no());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, a) => r + a.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, a) => r + a.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, a) => r + a.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, a) => r + a.getSize(), 0)) != null ? t : 0;
    };
  }
};
let Fr = null;
function fv() {
  if (typeof Fr == "boolean") return Fr;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return Fr = e, Fr;
}
function ro(e) {
  return e.type === "touchstart";
}
const mv = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: nt("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const a = e.columns;
      return (n = a.length ? a.some((o) => o.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = ue(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), le(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = ue(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, a) => [...n, ...r, ...a], le(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => ue(() => [r(), r().filter((a) => a.getIsVisible()).map((a) => a.id).join("_")], (a) => a.filter((o) => o.getIsVisible == null ? void 0 : o.getIsVisible()), le(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((a, o) => ({
        ...a,
        [o.id]: n || !(o.getCanHide != null && o.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function Qn(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const pv = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, gv = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: nt("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, a, o;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((a = t.options.enableFilters) != null ? a : !0) && ((o = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? o : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Rt.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return Sa(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : Rt[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, hv = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: nt("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, a;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (a = e.options.autoResetAll) != null ? a : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var a, o;
      e.setExpanded(r ? {} : (a = (o = e.initialState) == null ? void 0 : o.expanded) != null ? a : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((a) => !a.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((o) => {
        const i = o.split(".");
        r = Math.max(r, i.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var a;
        const o = r === !0 ? !0 : !!(r != null && r[e.id]);
        let i = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((u) => {
          i[u] = !0;
        }) : i = r, n = (a = n) != null ? a : !o, !o && n)
          return {
            ...i,
            [e.id]: !0
          };
        if (o && !n) {
          const {
            [e.id]: u,
            ...l
          } = i;
          return l;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, a;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((a = e.subRows) != null && a.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, ko = 0, Vo = 10, ao = () => ({
  pageIndex: ko,
  pageSize: Vo
}), vv = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...ao(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: nt("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, a;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (a = e.options.autoResetAll) != null ? a : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const a = (o) => Nt(r, o);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(a);
    }, e.resetPagination = (r) => {
      var a;
      e.setPagination(r ? ao() : (a = e.initialState.pagination) != null ? a : ao());
    }, e.setPageIndex = (r) => {
      e.setPagination((a) => {
        let o = Nt(r, a.pageIndex);
        const i = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return o = Math.max(0, Math.min(o, i)), {
          ...a,
          pageIndex: o
        };
      });
    }, e.resetPageIndex = (r) => {
      var a, o;
      e.setPageIndex(r ? ko : (a = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageIndex) != null ? a : ko);
    }, e.resetPageSize = (r) => {
      var a, o;
      e.setPageSize(r ? Vo : (a = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageSize) != null ? a : Vo);
    }, e.setPageSize = (r) => {
      e.setPagination((a) => {
        const o = Math.max(1, Nt(r, a.pageSize)), i = a.pageSize * a.pageIndex, u = Math.floor(i / o);
        return {
          ...a,
          pageIndex: u,
          pageSize: o
        };
      });
    }, e.setPageCount = (r) => e.setPagination((a) => {
      var o;
      let i = Nt(r, (o = e.options.pageCount) != null ? o : -1);
      return typeof i == "number" && (i = Math.max(-1, i)), {
        ...a,
        pageCount: i
      };
    }), e.getPageOptions = ue(() => [e.getPageCount()], (r) => {
      let a = [];
      return r && r > 0 && (a = [...new Array(r)].fill(null).map((o, i) => i)), a;
    }, le(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, a = e.getPageCount();
      return a === -1 ? !0 : a === 0 ? !1 : r < a - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, oo = () => ({
  top: [],
  bottom: []
}), yv = {
  getInitialState: (e) => ({
    rowPinning: oo(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: nt("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, a) => {
      const o = r ? e.getLeafRows().map((l) => {
        let {
          id: s
        } = l;
        return s;
      }) : [], i = a ? e.getParentRows().map((l) => {
        let {
          id: s
        } = l;
        return s;
      }) : [], u = /* @__PURE__ */ new Set([...i, e.id, ...o]);
      t.setRowPinning((l) => {
        var s, c;
        if (n === "bottom") {
          var f, p;
          return {
            top: ((f = l == null ? void 0 : l.top) != null ? f : []).filter((b) => !(u != null && u.has(b))),
            bottom: [...((p = l == null ? void 0 : l.bottom) != null ? p : []).filter((b) => !(u != null && u.has(b))), ...Array.from(u)]
          };
        }
        if (n === "top") {
          var d, g;
          return {
            top: [...((d = l == null ? void 0 : l.top) != null ? d : []).filter((b) => !(u != null && u.has(b))), ...Array.from(u)],
            bottom: ((g = l == null ? void 0 : l.bottom) != null ? g : []).filter((b) => !(u != null && u.has(b)))
          };
        }
        return {
          top: ((s = l == null ? void 0 : l.top) != null ? s : []).filter((b) => !(u != null && u.has(b))),
          bottom: ((c = l == null ? void 0 : l.bottom) != null ? c : []).filter((b) => !(u != null && u.has(b)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: a
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? a) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: a
      } = t.getState().rowPinning, o = n.some((u) => r == null ? void 0 : r.includes(u)), i = n.some((u) => a == null ? void 0 : a.includes(u));
      return o ? "top" : i ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const a = e.getIsPinned();
      if (!a) return -1;
      const o = (n = a === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((i) => {
        let {
          id: u
        } = i;
        return u;
      });
      return (r = o == null ? void 0 : o.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? oo() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : oo());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var a, o;
        return !!((a = r.top) != null && a.length || (o = r.bottom) != null && o.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var a;
      return ((a = e.options.keepPinnedRows) == null || a ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((i) => {
          const u = e.getRow(i, !0);
          return u.getIsAllParentsExpanded() ? u : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((i) => t.find((u) => u.id === i))
      )).filter(Boolean).map((i) => ({
        ...i,
        position: r
      }));
    }, e.getTopRows = ue(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), le(e.options, "debugRows", "getTopRows")), e.getBottomRows = ue(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), le(e.options, "debugRows", "getBottomRows")), e.getCenterRows = ue(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const a = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((o) => !a.has(o.id));
    }, le(e.options, "debugRows", "getCenterRows"));
  }
}, bv = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: nt("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, a = e.getPreGroupedRowModel().flatRows;
        return t ? a.forEach((o) => {
          o.getCanSelect() && (r[o.id] = !0);
        }) : a.forEach((o) => {
          delete r[o.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), a = {
        ...n
      };
      return e.getRowModel().rows.forEach((o) => {
        No(a, o.id, r, !0, e);
      }), a;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = ue(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? io(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, le(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = ue(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? io(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, le(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = ue(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? io(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, le(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((a) => a.getCanSelect() && !n[a.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((a) => a.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((a) => !n[a.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const a = e.getIsSelected();
      t.setRowSelection((o) => {
        var i;
        if (n = typeof n < "u" ? n : !a, e.getCanSelect() && a === n)
          return o;
        const u = {
          ...o
        };
        return No(u, e.id, n, (i = r == null ? void 0 : r.selectChildren) != null ? i : !0, t), u;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Ri(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return jo(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return jo(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var a;
        n && e.toggleSelected((a = r.target) == null ? void 0 : a.checked);
      };
    };
  }
}, No = (e, t, n, r, a) => {
  var o;
  const i = a.getRow(t, !0);
  n ? (i.getCanMultiSelect() || Object.keys(e).forEach((u) => delete e[u]), i.getCanSelect() && (e[t] = !0)) : delete e[t], r && (o = i.subRows) != null && o.length && i.getCanSelectSubRows() && i.subRows.forEach((u) => No(e, u.id, n, r, a));
};
function io(e, t) {
  const n = e.getState().rowSelection, r = [], a = {}, o = function(i, u) {
    return i.map((l) => {
      var s;
      const c = Ri(l, n);
      if (c && (r.push(l), a[l.id] = l), (s = l.subRows) != null && s.length && (l = {
        ...l,
        subRows: o(l.subRows)
      }), c)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: o(t.rows),
    flatRows: r,
    rowsById: a
  };
}
function Ri(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function jo(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let a = !0, o = !1;
  return e.subRows.forEach((i) => {
    if (!(o && !a) && (i.getCanSelect() && (Ri(i, t) ? o = !0 : a = !1), i.subRows && i.subRows.length)) {
      const u = jo(i, t);
      u === "all" ? o = !0 : (u === "some" && (o = !0), a = !1);
    }
  }), a ? "all" : o ? "some" : !1;
}
const Lo = /([0-9]+)/gm, Dv = (e, t, n) => $c(Ht(e.getValue(n)).toLowerCase(), Ht(t.getValue(n)).toLowerCase()), _v = (e, t, n) => $c(Ht(e.getValue(n)), Ht(t.getValue(n))), $v = (e, t, n) => Fi(Ht(e.getValue(n)).toLowerCase(), Ht(t.getValue(n)).toLowerCase()), xv = (e, t, n) => Fi(Ht(e.getValue(n)), Ht(t.getValue(n))), Ev = (e, t, n) => {
  const r = e.getValue(n), a = t.getValue(n);
  return r > a ? 1 : r < a ? -1 : 0;
}, Cv = (e, t, n) => Fi(e.getValue(n), t.getValue(n));
function Fi(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function Ht(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function $c(e, t) {
  const n = e.split(Lo).filter(Boolean), r = t.split(Lo).filter(Boolean);
  for (; n.length && r.length; ) {
    const a = n.shift(), o = r.shift(), i = parseInt(a, 10), u = parseInt(o, 10), l = [i, u].sort();
    if (isNaN(l[0])) {
      if (a > o)
        return 1;
      if (o > a)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(i) ? -1 : 1;
    if (i > u)
      return 1;
    if (u > i)
      return -1;
  }
  return n.length - r.length;
}
const Un = {
  alphanumeric: Dv,
  alphanumericCaseSensitive: _v,
  text: $v,
  textCaseSensitive: xv,
  datetime: Ev,
  basic: Cv
}, wv = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: nt("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const a of n) {
        const o = a == null ? void 0 : a.getValue(e.id);
        if (Object.prototype.toString.call(o) === "[object Date]")
          return Un.datetime;
        if (typeof o == "string" && (r = !0, o.split(Lo).length > 1))
          return Un.alphanumeric;
      }
      return r ? Un.text : Un.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Sa(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : Un[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const a = e.getNextSortingOrder(), o = typeof n < "u" && n !== null;
      t.setSorting((i) => {
        const u = i == null ? void 0 : i.find((d) => d.id === e.id), l = i == null ? void 0 : i.findIndex((d) => d.id === e.id);
        let s = [], c, f = o ? n : a === "desc";
        if (i != null && i.length && e.getCanMultiSort() && r ? u ? c = "toggle" : c = "add" : i != null && i.length && l !== i.length - 1 ? c = "replace" : u ? c = "toggle" : c = "replace", c === "toggle" && (o || a || (c = "remove")), c === "add") {
          var p;
          s = [...i, {
            id: e.id,
            desc: f
          }], s.splice(0, s.length - ((p = t.options.maxMultiSortColCount) != null ? p : Number.MAX_SAFE_INTEGER));
        } else c === "toggle" ? s = i.map((d) => d.id === e.id ? {
          ...d,
          desc: f
        } : d) : c === "remove" ? s = i.filter((d) => d.id !== e.id) : s = [{
          id: e.id,
          desc: f
        }];
        return s;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, a;
      const o = e.getFirstSortDir(), i = e.getIsSorted();
      return i ? i !== o && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (a = t.options.enableMultiRemove) != null) || a) ? !1 : i === "desc" ? "asc" : "desc" : o;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((a) => a.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((a) => a.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, Sv = [
  Y0,
  mv,
  sv,
  cv,
  Z0,
  J0,
  pv,
  //depends on ColumnFaceting
  gv,
  //depends on ColumnFiltering
  wv,
  uv,
  //depends on RowSorting
  hv,
  vv,
  yv,
  bv,
  dv
];
function Iv(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...Sv, ...(t = e._features) != null ? t : []];
  let a = {
    _features: r
  };
  const o = a._features.reduce((p, d) => Object.assign(p, d.getDefaultOptions == null ? void 0 : d.getDefaultOptions(a)), {}), i = (p) => a.options.mergeOptions ? a.options.mergeOptions(o, p) : {
    ...o,
    ...p
  };
  let l = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  a._features.forEach((p) => {
    var d;
    l = (d = p.getInitialState == null ? void 0 : p.getInitialState(l)) != null ? d : l;
  });
  const s = [];
  let c = !1;
  const f = {
    _features: r,
    options: {
      ...o,
      ...e
    },
    initialState: l,
    _queue: (p) => {
      s.push(p), c || (c = !0, Promise.resolve().then(() => {
        for (; s.length; )
          s.shift()();
        c = !1;
      }).catch((d) => setTimeout(() => {
        throw d;
      })));
    },
    reset: () => {
      a.setState(a.initialState);
    },
    setOptions: (p) => {
      const d = Nt(p, a.options);
      a.options = i(d);
    },
    getState: () => a.options.state,
    setState: (p) => {
      a.options.onStateChange == null || a.options.onStateChange(p);
    },
    _getRowId: (p, d, g) => {
      var b;
      return (b = a.options.getRowId == null ? void 0 : a.options.getRowId(p, d, g)) != null ? b : `${g ? [g.id, d].join(".") : d}`;
    },
    getCoreRowModel: () => (a._getCoreRowModel || (a._getCoreRowModel = a.options.getCoreRowModel(a)), a._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => a.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (p, d) => {
      let g = (d ? a.getPrePaginationRowModel() : a.getRowModel()).rowsById[p];
      if (!g && (g = a.getCoreRowModel().rowsById[p], !g))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${p}`) : new Error();
      return g;
    },
    _getDefaultColumnDef: ue(() => [a.options.defaultColumn], (p) => {
      var d;
      return p = (d = p) != null ? d : {}, {
        header: (g) => {
          const b = g.header.column.columnDef;
          return b.accessorKey ? b.accessorKey : b.accessorFn ? b.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (g) => {
          var b, v;
          return (b = (v = g.renderValue()) == null || v.toString == null ? void 0 : v.toString()) != null ? b : null;
        },
        ...a._features.reduce((g, b) => Object.assign(g, b.getDefaultColumnDef == null ? void 0 : b.getDefaultColumnDef()), {}),
        ...p
      };
    }, le(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => a.options.columns,
    getAllColumns: ue(() => [a._getColumnDefs()], (p) => {
      const d = function(g, b, v) {
        return v === void 0 && (v = 0), g.map((C) => {
          const h = G0(a, C, v, b), D = C;
          return h.columns = D.columns ? d(D.columns, h, v + 1) : [], h;
        });
      };
      return d(p);
    }, le(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ue(() => [a.getAllColumns()], (p) => p.flatMap((d) => d.getFlatColumns()), le(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ue(() => [a.getAllFlatColumns()], (p) => p.reduce((d, g) => (d[g.id] = g, d), {}), le(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ue(() => [a.getAllColumns(), a._getOrderColumnsFn()], (p, d) => {
      let g = p.flatMap((b) => b.getLeafColumns());
      return d(g);
    }, le(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (p) => {
      const d = a._getAllFlatColumnsById()[p];
      return process.env.NODE_ENV !== "production" && !d && console.error(`[Table] Column with id '${p}' does not exist.`), d;
    }
  };
  Object.assign(a, f);
  for (let p = 0; p < a._features.length; p++) {
    const d = a._features[p];
    d == null || d.createTable == null || d.createTable(a);
  }
  return a;
}
function Pv() {
  return (e) => ue(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(a, o, i) {
      o === void 0 && (o = 0);
      const u = [];
      for (let s = 0; s < a.length; s++) {
        const c = q0(e, e._getRowId(a[s], s, i), a[s], s, o, void 0, i == null ? void 0 : i.id);
        if (n.flatRows.push(c), n.rowsById[c.id] = c, u.push(c), e.options.getSubRows) {
          var l;
          c.originalSubRows = e.options.getSubRows(a[s], s), (l = c.originalSubRows) != null && l.length && (c.subRows = r(c.originalSubRows, o + 1, c));
        }
      }
      return u;
    };
    return n.rows = r(t), n;
  }, le(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function Rv() {
  return (e) => ue(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, a = [], o = r.filter((l) => {
      var s;
      return (s = e.getColumn(l.id)) == null ? void 0 : s.getCanSort();
    }), i = {};
    o.forEach((l) => {
      const s = e.getColumn(l.id);
      s && (i[l.id] = {
        sortUndefined: s.columnDef.sortUndefined,
        invertSorting: s.columnDef.invertSorting,
        sortingFn: s.getSortingFn()
      });
    });
    const u = (l) => {
      const s = l.map((c) => ({
        ...c
      }));
      return s.sort((c, f) => {
        for (let d = 0; d < o.length; d += 1) {
          var p;
          const g = o[d], b = i[g.id], v = b.sortUndefined, C = (p = g == null ? void 0 : g.desc) != null ? p : !1;
          let h = 0;
          if (v) {
            const D = c.getValue(g.id), x = f.getValue(g.id), _ = D === void 0, O = x === void 0;
            if (_ || O) {
              if (v === "first") return _ ? -1 : 1;
              if (v === "last") return _ ? 1 : -1;
              h = _ && O ? 0 : _ ? v : -v;
            }
          }
          if (h === 0 && (h = b.sortingFn(c, f, g.id)), h !== 0)
            return C && (h *= -1), b.invertSorting && (h *= -1), h;
        }
        return c.index - f.index;
      }), s.forEach((c) => {
        var f;
        a.push(c), (f = c.subRows) != null && f.length && (c.subRows = u(c.subRows));
      }), s;
    };
    return {
      rows: u(n.rows),
      flatRows: a,
      rowsById: n.rowsById
    };
  }, le(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Cl(e, t) {
  return e ? Fv(e) ? /* @__PURE__ */ Io.createElement(e, t) : e : null;
}
function Fv(e) {
  return Av(e) || typeof e == "function" || Tv(e);
}
function Av(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function Tv(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function Ov(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = Io.useState(() => ({
    current: Iv(t)
  })), [r, a] = Io.useState(() => n.current.initialState);
  return n.current.setOptions((o) => ({
    ...o,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (i) => {
      a(i), e.onStateChange == null || e.onStateChange(i);
    }
  })), n.current;
}
const _t = ({
  children: e,
  state: t = "default",
  text: n,
  textItems: r,
  rightText: a,
  fullWidth: o,
  compact: i,
  className: u
}) => /* @__PURE__ */ m.jsxs(
  "div",
  {
    className: se("c__field", "c__field--" + t, u, {
      "c__field--full-width": o,
      "c__field--compact": i && !o
    }),
    children: [
      e,
      (n || a || r) && /* @__PURE__ */ m.jsxs("div", { className: "c__field__footer", children: [
        (n || a) && /* @__PURE__ */ m.jsxs("div", { className: "c__field__footer__top", children: [
          /* @__PURE__ */ m.jsx("span", { className: "c__field__text", children: n }),
          /* @__PURE__ */ m.jsx("span", { className: "c__field__text__right", children: a })
        ] }),
        r && /* @__PURE__ */ m.jsx("ul", { className: "c__field__footer__items", children: r.map((l) => /* @__PURE__ */ m.jsx("li", { children: l }, l)) })
      ] })
    ]
  }
), gr = ({
  children: e,
  label: t,
  labelAsPlaceholder: n,
  htmlFor: r,
  labelId: a,
  hideLabel: o,
  horizontal: i,
  disabled: u
}) => /* @__PURE__ */ m.jsxs(
  "div",
  {
    className: se("labelled-box", {
      "labelled-box--no-label": o,
      "labelled-box--horizontal": i,
      "labelled-box--disabled": u
    }),
    children: [
      t && /* @__PURE__ */ m.jsx(
        "label",
        {
          className: se("labelled-box__label", {
            placeholder: n,
            c__offscreen: o
          }),
          htmlFor: r,
          id: a,
          children: /* @__PURE__ */ m.jsx("span", { children: t })
        }
      ),
      /* @__PURE__ */ m.jsx("div", { className: "labelled-box__children", children: e })
    ]
  }
), xc = Re(
  ({
    className: e,
    defaultValue: t,
    label: n,
    id: r,
    icon: a,
    rightIcon: o,
    charCounter: i,
    charCounterMax: u,
    ...l
  }, s) => {
    const c = ["c__input"], f = q(null), [p, d] = re(!1), [g, b] = re(t || l.value || ""), [v, C] = re(!g), h = q(r || Ii()), D = i ? `${g.toString().length}/${u}` : l.rightText, x = () => {
      if (p) {
        C(!1);
        return;
      }
      C(!g);
    };
    te(() => {
      x();
    }, [p, g]), te(() => {
      t === void 0 && b(l.value || "");
    }, [l.value]);
    const {
      compact: _,
      fullWidth: O,
      rightText: L,
      state: y,
      text: F,
      textItems: T,
      ...$
    } = l;
    return /* @__PURE__ */ m.jsx(_t, { ...l, rightText: D, className: e, children: /* @__PURE__ */ m.jsxs(
      "div",
      {
        className: se(
          "c__input__wrapper",
          l.state && "c__input__wrapper--" + l.state,
          {
            "c__input__wrapper--disabled": l.disabled
          }
        ),
        onClick: () => {
          var R;
          (R = f.current) == null || R.focus();
        },
        children: [
          !!a && /* @__PURE__ */ m.jsx("div", { className: "c__input__icon-left", children: a }),
          /* @__PURE__ */ m.jsx(
            gr,
            {
              label: n,
              htmlFor: h.current,
              labelAsPlaceholder: v,
              disabled: l.disabled,
              children: /* @__PURE__ */ m.jsx(
                "input",
                {
                  type: "text",
                  className: c.join(" "),
                  ...$,
                  id: h.current,
                  value: g,
                  onFocus: (R) => {
                    var P;
                    d(!0), (P = l.onFocus) == null || P.call(l, R);
                  },
                  onBlur: (R) => {
                    var P;
                    d(!1), (P = l.onBlur) == null || P.call(l, R);
                  },
                  onChange: (R) => {
                    var P;
                    b(R.target.value), (P = l.onChange) == null || P.call(l, R);
                  },
                  ref: (R) => {
                    s && (typeof s == "function" ? s(R) : s.current = R), f.current = R;
                  }
                }
              )
            }
          ),
          !!o && /* @__PURE__ */ m.jsx("div", { className: "c__input__icon-right", children: o })
        ]
      }
    ) });
  }
), Bv = ({
  defaultPage: e = 1,
  defaultPagesCount: t,
  pageSize: n = 10
}) => {
  const [r, a] = re(e), [o, i] = re(t);
  return {
    page: r,
    setPage: a,
    onPageChange: a,
    pagesCount: o,
    setPagesCount: i,
    pageSize: n
  };
}, Mv = ({
  page: e,
  onPageChange: t,
  pagesCount: n = 0,
  displayGoto: r = !0
}) => {
  const { t: a } = Oe(), [o, i] = re("");
  if (te(() => {
    i(e + "");
  }, [e]), n <= 1)
    return null;
  const u = [
    1,
    // If there is just one page between first page and currentPage - 2,
    // we can display this page number instead of "..."
    e - 2 === 3 ? e - 3 : -1,
    e - 2,
    e - 1,
    e,
    e + 1,
    e + 2,
    // If there is just one page between maxPage and currentPage + 2,
    // we can display this page number instead of "..."
    e + 3 === n - 1 ? e + 3 : -1,
    n
  ].filter((d) => d > 0).filter((d) => d <= n).filter((d, g, b) => d !== b[g - 1]), l = () => {
    t(Math.max(e - 1, 0));
  }, s = () => {
    t(Math.min(e + 1, n));
  }, c = () => {
    let d = +o;
    (d < 0 || !d) && (d = 1), d > n && (d = n), t(d);
  }, f = e > 1, p = e < n;
  return /* @__PURE__ */ m.jsxs("div", { className: "c__pagination", children: [
    /* @__PURE__ */ m.jsxs("div", { className: "c__pagination__list", children: [
      /* @__PURE__ */ m.jsx(
        ge,
        {
          color: "tertiary-text",
          "aria-label": a("components.pagination.previous_aria"),
          onClick: l,
          disabled: !f,
          icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "navigate_before" }),
          size: "small"
        }
      ),
      u.map((d, g) => /* @__PURE__ */ m.jsxs(Ns, { children: [
        d > (u[g - 1] || 0) + 1 && /* @__PURE__ */ m.jsx("span", { children: "..." }),
        d === e ? /* @__PURE__ */ m.jsx(
          ge,
          {
            color: "tertiary-text",
            active: !0,
            "aria-label": a("components.pagination.current_page_aria", {
              page: d
            }),
            size: "small",
            children: d
          }
        ) : /* @__PURE__ */ m.jsx(
          ge,
          {
            color: "tertiary-text",
            "aria-label": a("components.pagination.goto_page_aria", {
              page: d
            }),
            onClick: () => t(d),
            size: "small",
            children: d
          }
        )
      ] }, d)),
      /* @__PURE__ */ m.jsx(
        ge,
        {
          color: "tertiary-text",
          "aria-label": a("components.pagination.next_aria"),
          onClick: s,
          disabled: !p,
          icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "navigate_next" }),
          size: "small"
        }
      )
    ] }),
    r && /* @__PURE__ */ m.jsx("div", { className: "c__pagination__goto", children: /* @__PURE__ */ m.jsx(
      "form",
      {
        onSubmit: (d) => {
          d.preventDefault(), c();
        },
        children: /* @__PURE__ */ m.jsx(
          xc,
          {
            type: "number",
            label: a("components.pagination.goto_label"),
            "aria-label": a("components.pagination.goto_label_aria"),
            size: 2,
            value: o,
            onChange: (d) => i(d.target.value),
            min: 1,
            max: n,
            onBlur: () => c(),
            onFocus: (d) => d.target.select()
          }
        )
      }
    ) })
  ] });
}, Ec = ({ size: e = "medium", ...t }) => /* @__PURE__ */ m.jsx(
  "div",
  {
    className: se("c__loader", "c__loader--" + e),
    role: "status",
    ...t
  }
), Ai = Re(
  ({ indeterminate: e, className: t = "", checked: n, label: r, ...a }, o) => {
    const i = q(), [u, l] = re(!!n);
    te(() => {
      l(!!n);
    }, [n]), te(() => {
      i.current && (i.current.indeterminate = !!e);
    }, [e]);
    const {
      compact: s,
      fullWidth: c,
      rightText: f,
      state: p,
      text: d,
      textItems: g,
      ...b
    } = a;
    return /* @__PURE__ */ m.jsx(
      "label",
      {
        className: se("c__checkbox", t, {
          "c__checkbox--disabled": a.disabled,
          "c__checkbox--full-width": a.fullWidth
        }),
        children: /* @__PURE__ */ m.jsx(_t, { compact: !0, ...a, children: /* @__PURE__ */ m.jsxs("div", { className: "c__checkbox__container", children: [
          /* @__PURE__ */ m.jsxs("div", { className: "c__checkbox__wrapper", children: [
            /* @__PURE__ */ m.jsx(
              "input",
              {
                type: "checkbox",
                ...b,
                onChange: (v) => {
                  var C;
                  l(v.target.checked), (C = a.onChange) == null || C.call(a, v);
                },
                checked: u,
                ref: (v) => {
                  typeof o == "function" && o(v), i.current = v || void 0;
                }
              }
            ),
            /* @__PURE__ */ m.jsx(Vv, {}),
            /* @__PURE__ */ m.jsx(kv, {})
          ] }),
          r && /* @__PURE__ */ m.jsx("div", { className: "c__checkbox__label", children: r })
        ] }) })
      }
    );
  }
), Yb = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ m.jsx(_t, { className: se("c__checkbox__group", t), ...n, children: /* @__PURE__ */ m.jsx("div", { className: "c__checkbox__group__list", children: e }) }), kv = () => /* @__PURE__ */ m.jsx(
  "svg",
  {
    className: "checkmark",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: (e) => e.stopPropagation(),
    children: /* @__PURE__ */ m.jsx(
      "path",
      {
        d: "M17.5685 6.34318L9.8751 14.0366L7.07184 11.2333C6.84127 11.0106 6.53245 10.8874 6.21191 10.8902C5.89137 10.893 5.58474 11.0215 5.35807 11.2482C5.1314 11.4749 5.00283 11.7815 5.00005 12.102C4.99726 12.4226 5.12048 12.7314 5.34318 12.962L9.01077 16.6296C9.24003 16.8587 9.55093 16.9875 9.8751 16.9875C10.1993 16.9875 10.5102 16.8587 10.7394 16.6296L19.2972 8.07184C19.5198 7.84127 19.6431 7.53245 19.6403 7.21191C19.6375 6.89136 19.5089 6.58474 19.2823 6.35807C19.0556 6.1314 18.749 6.00283 18.4284 6.00005C18.1079 5.99726 17.7991 6.12048 17.5685 6.34318Z",
        fill: "currentColor"
      }
    )
  }
), Vv = () => /* @__PURE__ */ m.jsx(
  "svg",
  {
    className: "indeterminate",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: (e) => e.stopPropagation(),
    children: /* @__PURE__ */ m.jsx("rect", { x: "5", y: "10", width: "14", height: "3", rx: "1.5", fill: "currentColor" })
  }
), Ho = "cunningham-select", Nv = ({
  columns: e,
  enableRowSelection: t
}) => {
  const { t: n } = Oe(), r = K0();
  let a = e.map((o) => {
    const u = {
      id: o.id ?? o.field,
      enableSorting: o.enableSorting === void 0 ? !0 : o.enableSorting,
      header: o.headerName,
      size: o.size,
      cell: (l) => o.renderCell ? o.renderCell({ row: l.row.original }) : l.cell.getValue()
    };
    return o.field ? r.accessor(o.field, u) : r.display(u);
  });
  return t && (a = [
    r.display({
      id: Ho,
      size: 34,
      header: () => null,
      cell: ({ row: o }) => /* @__PURE__ */ m.jsx(
        Ai,
        {
          checked: o.getIsSelected(),
          disabled: !o.getCanSelect,
          indeterminate: o.getIsSomeSelected(),
          onChange: o.getToggleSelectedHandler(),
          "aria-label": n("components.datagrid.row_selection_aria")
        }
      )
    }),
    ...a
  ]), a;
}, jv = (e) => e ? e.filter((t) => !!t.sort).map((t) => ({
  id: t.field,
  desc: t.sort === "desc"
})) : [], Lv = (e) => e.map((t) => ({
  field: t.id,
  sort: t.desc ? "desc" : "asc"
})), Hv = (e) => {
  if (e)
    return {
      pageIndex: e.page ?? 0,
      pageSize: e.pageSize
    };
}, Kv = "data:image/svg+xml,%3csvg%20width='411'%20height='185'%20viewBox='0%200%20411%20185'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='409.009'%20height='15.3105'%20transform='translate(1)'%20fill='white'/%3e%3crect%20x='7.12402'%20y='4.59326'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='4.59326'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='199.702'%20y='4.59326'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='291.231'%20y='4.59326'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='382.761'%20y='4.59326'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='0.808618'%20y='15.1192'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='19.9038'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='19.9038'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='19.9038'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='19.9038'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='19.9038'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='15.1192'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='30.4297'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='35.2144'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='35.2144'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='35.2144'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='35.2144'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='35.2144'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='30.4297'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='45.7403'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='50.5249'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='50.5249'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='50.5249'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='50.5249'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='50.5249'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='45.7403'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='61.0508'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='65.8354'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='65.8354'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='65.8354'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='65.8354'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='65.8354'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='61.0508'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='76.3614'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='81.146'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='81.146'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='81.146'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='81.146'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='81.146'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='76.3614'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='91.6719'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='96.4565'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='96.4565'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='96.4565'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='96.4565'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='96.4565'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='91.6719'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='106.982'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='111.767'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='111.767'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='111.767'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='111.767'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='111.767'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='106.982'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='122.293'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='127.078'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='127.078'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='127.078'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='127.078'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='127.078'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='122.293'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='137.604'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='142.388'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='142.388'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='142.388'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='142.388'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='142.388'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='137.604'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='152.914'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='157.699'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='157.699'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='157.699'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='157.699'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='157.699'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='152.914'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3crect%20x='0.808618'%20y='168.224'%20width='409.392'%20height='15.6933'%20fill='white'/%3e%3crect%20x='7.12402'%20y='173.009'%20width='85.7389'%20height='6.12421'%20rx='0.765526'%20fill='%23C2C6CA'/%3e%3crect%20x='108.174'%20y='173.009'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='199.702'%20y='173.009'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='291.231'%20y='173.009'%20width='76.2184'%20height='6.12421'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='382.761'%20y='173.009'%20width='15'%20height='6'%20rx='0.765526'%20fill='%23E7E8EA'/%3e%3crect%20x='0.808618'%20y='168.224'%20width='409.392'%20height='15.6933'%20stroke='%23E8E9EB'%20stroke-width='0.382763'/%3e%3c/svg%3e", Cc = ({
  columns: e,
  rows: t,
  pagination: n,
  sortModel: r,
  onSortModelChange: a,
  isLoading: o,
  enableRowSelection: i,
  onRowSelectionChange: u,
  rowSelection: l,
  tableOptions: s,
  className: c,
  emptyPlaceholderLabel: f,
  emptyCta: p,
  hideEmptyPlaceholderImage: d,
  displayHeader: g = !0,
  enableSorting: b = !0
}) => {
  const { t: v } = Oe(), C = Nv({ columns: e, enableRowSelection: i });
  C.forEach((y) => {
    y.enableSorting && !a && console.warn(
      "You are using a column with sorting enabled, but you are not providing an `onSortModelChange` handler. The sorting will not work as expected."
    );
  });
  const h = J(
    () => Hv(n),
    [n]
  ), D = J(
    () => jv(r),
    [r]
  ), x = Ov({
    data: t,
    columns: C,
    state: {
      sorting: D,
      rowSelection: l,
      pagination: h
    },
    // Sorting
    enableSorting: b,
    getSortedRowModel: Rv(),
    manualSorting: !0,
    onSortingChange: (y) => {
      typeof y == "function" && (a == null || a(
        Lv(y(D))
      ));
    },
    // Pagination
    manualPagination: !0,
    pageCount: (n == null ? void 0 : n.pagesCount) ?? 0,
    onPaginationChange: (y) => {
      var F;
      h && typeof y == "function" && ((F = n == null ? void 0 : n.onPageChange) == null || F.call(n, y(h).pageIndex));
    },
    // Row selection
    getCoreRowModel: Pv(),
    enableRowSelection: i,
    onRowSelectionChange: (y) => {
      y && typeof y == "function" && (u == null || u(y(l)));
    },
    // Related to https://github.com/TanStack/table/issues/4555.
    getRowId: (y) => y.id,
    ...s
  }), _ = t.length === 0, O = !o && _, L = () => O ? /* @__PURE__ */ m.jsxs("div", { className: "c__datagrid__empty-placeholder fs-h3 clr-greyscale-900 fw-bold", children: [
    !d && /* @__PURE__ */ m.jsx("img", { src: Kv, alt: v("components.datagrid.empty_alt") }),
    f ?? v("components.datagrid.empty"),
    p
  ] }) : /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    o && /* @__PURE__ */ m.jsxs("div", { className: "c__datagrid__loader", children: [
      /* @__PURE__ */ m.jsx("div", { className: "c__datagrid__loader__background" }),
      /* @__PURE__ */ m.jsx(Ec, { "aria-label": v("components.datagrid.loader_aria") })
    ] }),
    !_ && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
      /* @__PURE__ */ m.jsx("div", { className: "c__datagrid__table__container", children: /* @__PURE__ */ m.jsxs("table", { children: [
        /* @__PURE__ */ m.jsx("thead", { children: g && x.getHeaderGroups().map((y) => /* @__PURE__ */ m.jsx("tr", { children: y.headers.map((F, T) => {
          const $ = {}, R = C[T];
          return R && typeof R.size < "u" && ($.width = `${R.size}px`), /* @__PURE__ */ m.jsx(
            "th",
            {
              colSpan: F.colSpan,
              className: se({
                "c__datagrid__header--select": F.id === Ho
              }),
              style: $,
              children: F.isPlaceholder ? null : /* @__PURE__ */ m.jsxs(
                "div",
                {
                  className: se(
                    "c__datagrid__header fs-h5",
                    {
                      "c__datagrid__header--sortable": F.column.getCanSort()
                    }
                  ),
                  ...F.column.getCanSort() ? {
                    role: "button",
                    tabIndex: 0,
                    onClick: F.column.getToggleSortingHandler()
                  } : {},
                  children: [
                    F.id === Ho ? /* @__PURE__ */ m.jsx(
                      Ai,
                      {
                        checked: x.getIsAllRowsSelected(),
                        indeterminate: x.getIsSomeRowsSelected(),
                        onChange: x.getToggleAllRowsSelectedHandler(),
                        "aria-label": v(
                          "components.datagrid.rows_selection_aria"
                        )
                      }
                    ) : Cl(
                      F.column.columnDef.header,
                      F.getContext()
                    ),
                    F.column.getIsSorted() === "asc" && /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "arrow_drop_up" }),
                    F.column.getIsSorted() === "desc" && /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "arrow_drop_down" }),
                    F.id !== "select" && !F.column.getIsSorted() && /* @__PURE__ */ m.jsx("span", { className: "c__datagrid__header__icon-placeholder" })
                  ]
                }
              )
            },
            F.id
          );
        }) }, y.id)) }),
        /* @__PURE__ */ m.jsx("tbody", { children: x.getRowModel().rows.map((y) => /* @__PURE__ */ m.jsx("tr", { "data-testid": y.id, children: y.getVisibleCells().map((F, T) => {
          let $ = !1;
          i && T > 0 ? $ = !!e[T - 1].highlight : $ = !!e[T].highlight;
          const R = {};
          if (g === !1) {
            const P = e[T];
            P && typeof P.size == "number" && (R.width = `${P.size}px`);
          }
          return /* @__PURE__ */ m.jsx(
            "td",
            {
              className: se({
                "c__datagrid__row__cell--highlight": $,
                "c__datagrid__row__cell--actions": F.column.id === "actions",
                "c__datagrid__row__cell--select": F.column.id === "select"
              }),
              style: R,
              children: Cl(
                F.column.columnDef.cell,
                F.getContext()
              )
            },
            F.id
          );
        }) }, y.id)) })
      ] }) }),
      !!n && /* @__PURE__ */ m.jsx(Mv, { ...n })
    ] })
  ] });
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      className: se("c__datagrid", c, {
        "c__datagrid--empty": _,
        "c__datagrid--loading": o
      }),
      children: L()
    }
  );
}, qb = ({ rows: e, ...t }) => /* @__PURE__ */ m.jsx(
  Cc,
  {
    ...t,
    displayHeader: !1,
    rows: e,
    columns: t.columns.map((n) => ({
      ...n
    })),
    enableSorting: !1
  }
), Zb = ({
  rows: e,
  defaultPaginationParams: t,
  defaultSortModel: n = [],
  ...r
}) => {
  const [a, o] = re([]), [i, u] = re(n), l = J(() => typeof t == "boolean" ? {} : t, [t]), s = l ? Bv(l) : void 0;
  return te(() => {
    s == null || s.setPagesCount(Math.ceil(e.length / s.pageSize));
  }, [e]), te(() => {
    const c = i.length > 0 ? i[0].field : "id", f = i.length > 0 && i[0].sort === "asc" ? 1 : -1, p = [...e].sort((d, g) => d[c] < g[c] ? -f : d[c] > g[c] ? f : 0);
    o(
      s ? p.slice(
        (s.page - 1) * s.pageSize,
        s.page * s.pageSize
      ) : p
    );
  }, [s == null ? void 0 : s.page, i, e]), /* @__PURE__ */ m.jsx(
    Cc,
    {
      ...r,
      pagination: s,
      rows: a,
      sortModel: i,
      onSortModelChange: u
    }
  );
};
var wc = {};
wc = {
  rangeOverflow: (e) => `يجب أن تكون القيمة ${e.maxValue} أو قبل ذلك.`,
  rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
  rangeUnderflow: (e) => `يجب أن تكون القيمة ${e.minValue} أو بعد ذلك.`,
  unavailableDate: "البيانات المحددة غير متاحة."
};
var Sc = {};
Sc = {
  rangeOverflow: (e) => `Стойността трябва да е ${e.maxValue} или по-ранна.`,
  rangeReversed: "Началната дата трябва да е преди крайната.",
  rangeUnderflow: (e) => `Стойността трябва да е ${e.minValue} или по-късно.`,
  unavailableDate: "Избраната дата не е налична."
};
var Ic = {};
Ic = {
  rangeOverflow: (e) => `Hodnota musí být ${e.maxValue} nebo dřívější.`,
  rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
  rangeUnderflow: (e) => `Hodnota musí být ${e.minValue} nebo pozdější.`,
  unavailableDate: "Vybrané datum není k dispozici."
};
var Pc = {};
Pc = {
  rangeOverflow: (e) => `Værdien skal være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen skal være før slutdatoen.",
  rangeUnderflow: (e) => `Værdien skal være ${e.minValue} eller nyere.`,
  unavailableDate: "Den valgte dato er ikke tilgængelig."
};
var Rc = {};
Rc = {
  rangeOverflow: (e) => `Der Wert muss ${e.maxValue} oder früher sein.`,
  rangeReversed: "Das Anfangsdatum muss vor dem Enddatum liegen.",
  rangeUnderflow: (e) => `Der Wert muss ${e.minValue} oder später sein.`,
  unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
};
var Fc = {};
Fc = {
  rangeOverflow: (e) => `Η τιμή πρέπει να είναι ${e.maxValue} ή παλαιότερη.`,
  rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
  rangeUnderflow: (e) => `Η τιμή πρέπει να είναι ${e.minValue} ή μεταγενέστερη.`,
  unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
};
var Ac = {};
Ac = {
  rangeUnderflow: (e) => `Value must be ${e.minValue} or later.`,
  rangeOverflow: (e) => `Value must be ${e.maxValue} or earlier.`,
  rangeReversed: "Start date must be before end date.",
  unavailableDate: "Selected date unavailable."
};
var Tc = {};
Tc = {
  rangeOverflow: (e) => `El valor debe ser ${e.maxValue} o anterior.`,
  rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
  rangeUnderflow: (e) => `El valor debe ser ${e.minValue} o posterior.`,
  unavailableDate: "Fecha seleccionada no disponible."
};
var Oc = {};
Oc = {
  rangeOverflow: (e) => `Väärtus peab olema ${e.maxValue} või varasem.`,
  rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
  rangeUnderflow: (e) => `Väärtus peab olema ${e.minValue} või hilisem.`,
  unavailableDate: "Valitud kuupäev pole saadaval."
};
var Bc = {};
Bc = {
  rangeOverflow: (e) => `Arvon on oltava ${e.maxValue} tai sitä aikaisempi.`,
  rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
  rangeUnderflow: (e) => `Arvon on oltava ${e.minValue} tai sitä myöhäisempi.`,
  unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
};
var Mc = {};
Mc = {
  rangeOverflow: (e) => `La valeur doit être ${e.maxValue} ou antérieure.`,
  rangeReversed: "La date de début doit être antérieure à la date de fin.",
  rangeUnderflow: (e) => `La valeur doit être ${e.minValue} ou ultérieure.`,
  unavailableDate: "La date sélectionnée n’est pas disponible."
};
var kc = {};
kc = {
  rangeOverflow: (e) => `הערך חייב להיות ${e.maxValue} או מוקדם יותר.`,
  rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
  rangeUnderflow: (e) => `הערך חייב להיות ${e.minValue} או מאוחר יותר.`,
  unavailableDate: "התאריך הנבחר אינו זמין."
};
var Vc = {};
Vc = {
  rangeOverflow: (e) => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
  rangeReversed: "Datum početka mora biti prije datuma završetka.",
  rangeUnderflow: (e) => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
  unavailableDate: "Odabrani datum nije dostupan."
};
var Nc = {};
Nc = {
  rangeOverflow: (e) => `Az értéknek ${e.maxValue} vagy korábbinak kell lennie.`,
  rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
  rangeUnderflow: (e) => `Az értéknek ${e.minValue} vagy későbbinek kell lennie.`,
  unavailableDate: "A kiválasztott dátum nem érhető el."
};
var jc = {};
jc = {
  rangeOverflow: (e) => `Il valore deve essere ${e.maxValue} o precedente.`,
  rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
  rangeUnderflow: (e) => `Il valore deve essere ${e.minValue} o successivo.`,
  unavailableDate: "Data selezionata non disponibile."
};
var Lc = {};
Lc = {
  rangeOverflow: (e) => `値は ${e.maxValue} 以下にする必要があります。`,
  rangeReversed: "開始日は終了日より前にする必要があります。",
  rangeUnderflow: (e) => `値は ${e.minValue} 以上にする必要があります。`,
  unavailableDate: "選択した日付は使用できません。"
};
var Hc = {};
Hc = {
  rangeOverflow: (e) => `값은 ${e.maxValue} 이전이어야 합니다.`,
  rangeReversed: "시작일은 종료일 이전이어야 합니다.",
  rangeUnderflow: (e) => `값은 ${e.minValue} 이상이어야 합니다.`,
  unavailableDate: "선택한 날짜를 사용할 수 없습니다."
};
var Kc = {};
Kc = {
  rangeOverflow: (e) => `Reikšmė turi būti ${e.maxValue} arba ankstesnė.`,
  rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
  rangeUnderflow: (e) => `Reikšmė turi būti ${e.minValue} arba naujesnė.`,
  unavailableDate: "Pasirinkta data nepasiekiama."
};
var zc = {};
zc = {
  rangeOverflow: (e) => `Vērtībai ir jābūt ${e.maxValue} vai agrākai.`,
  rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
  rangeUnderflow: (e) => `Vērtībai ir jābūt ${e.minValue} vai vēlākai.`,
  unavailableDate: "Atlasītais datums nav pieejams."
};
var Uc = {};
Uc = {
  rangeOverflow: (e) => `Verdien må være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen må være før sluttdatoen.",
  rangeUnderflow: (e) => `Verdien må være ${e.minValue} eller senere.`,
  unavailableDate: "Valgt dato utilgjengelig."
};
var Wc = {};
Wc = {
  rangeOverflow: (e) => `Waarde moet ${e.maxValue} of eerder zijn.`,
  rangeReversed: "De startdatum moet voor de einddatum liggen.",
  rangeUnderflow: (e) => `Waarde moet ${e.minValue} of later zijn.`,
  unavailableDate: "Geselecteerde datum niet beschikbaar."
};
var Gc = {};
Gc = {
  rangeOverflow: (e) => `Wartość musi mieć wartość ${e.maxValue} lub wcześniejszą.`,
  rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
  rangeUnderflow: (e) => `Wartość musi mieć wartość ${e.minValue} lub późniejszą.`,
  unavailableDate: "Wybrana data jest niedostępna."
};
var Yc = {};
Yc = {
  rangeOverflow: (e) => `O valor deve ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data inicial deve ser anterior à data final.",
  rangeUnderflow: (e) => `O valor deve ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var qc = {};
qc = {
  rangeOverflow: (e) => `O valor tem de ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data de início deve ser anterior à data de fim.",
  rangeUnderflow: (e) => `O valor tem de ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var Zc = {};
Zc = {
  rangeOverflow: (e) => `Valoarea trebuie să fie ${e.maxValue} sau anterioară.`,
  rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
  rangeUnderflow: (e) => `Valoarea trebuie să fie ${e.minValue} sau ulterioară.`,
  unavailableDate: "Data selectată nu este disponibilă."
};
var Jc = {};
Jc = {
  rangeOverflow: (e) => `Значение должно быть не позже ${e.maxValue}.`,
  rangeReversed: "Дата начала должна предшествовать дате окончания.",
  rangeUnderflow: (e) => `Значение должно быть не раньше ${e.minValue}.`,
  unavailableDate: "Выбранная дата недоступна."
};
var Xc = {};
Xc = {
  rangeOverflow: (e) => `Hodnota musí byť ${e.maxValue} alebo skoršia.`,
  rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
  rangeUnderflow: (e) => `Hodnota musí byť ${e.minValue} alebo neskoršia.`,
  unavailableDate: "Vybratý dátum je nedostupný."
};
var Qc = {};
Qc = {
  rangeOverflow: (e) => `Vrednost mora biti ${e.maxValue} ali starejša.`,
  rangeReversed: "Začetni datum mora biti pred končnim datumom.",
  rangeUnderflow: (e) => `Vrednost mora biti ${e.minValue} ali novejša.`,
  unavailableDate: "Izbrani datum ni na voljo."
};
var ed = {};
ed = {
  rangeOverflow: (e) => `Vrednost mora da bude ${e.maxValue} ili starija.`,
  rangeReversed: "Datum početka mora biti pre datuma završetka.",
  rangeUnderflow: (e) => `Vrednost mora da bude ${e.minValue} ili novija.`,
  unavailableDate: "Izabrani datum nije dostupan."
};
var td = {};
td = {
  rangeOverflow: (e) => `Värdet måste vara ${e.maxValue} eller tidigare.`,
  rangeReversed: "Startdatumet måste vara före slutdatumet.",
  rangeUnderflow: (e) => `Värdet måste vara ${e.minValue} eller senare.`,
  unavailableDate: "Det valda datumet är inte tillgängligt."
};
var nd = {};
nd = {
  rangeOverflow: (e) => `Değer, ${e.maxValue} veya öncesi olmalıdır.`,
  rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
  rangeUnderflow: (e) => `Değer, ${e.minValue} veya sonrası olmalıdır.`,
  unavailableDate: "Seçilen tarih kullanılamıyor."
};
var rd = {};
rd = {
  rangeOverflow: (e) => `Значення має бути не пізніше ${e.maxValue}.`,
  rangeReversed: "Дата початку має передувати даті завершення.",
  rangeUnderflow: (e) => `Значення має бути не раніше ${e.minValue}.`,
  unavailableDate: "Вибрана дата недоступна."
};
var ad = {};
ad = {
  rangeOverflow: (e) => `值必须是 ${e.maxValue} 或更早日期。`,
  rangeReversed: "开始日期必须早于结束日期。",
  rangeUnderflow: (e) => `值必须是 ${e.minValue} 或更晚日期。`,
  unavailableDate: "所选日期不可用。"
};
var od = {};
od = {
  rangeOverflow: (e) => `值必須是 ${e.maxValue} 或更早。`,
  rangeReversed: "開始日期必須在結束日期之前。",
  rangeUnderflow: (e) => `值必須是 ${e.minValue} 或更晚。`,
  unavailableDate: "所選日期無法使用。"
};
var id = {};
id = {
  "ar-AE": wc,
  "bg-BG": Sc,
  "cs-CZ": Ic,
  "da-DK": Pc,
  "de-DE": Rc,
  "el-GR": Fc,
  "en-US": Ac,
  "es-ES": Tc,
  "et-EE": Oc,
  "fi-FI": Bc,
  "fr-FR": Mc,
  "he-IL": kc,
  "hr-HR": Vc,
  "hu-HU": Nc,
  "it-IT": jc,
  "ja-JP": Lc,
  "ko-KR": Hc,
  "lt-LT": Kc,
  "lv-LV": zc,
  "nb-NO": Uc,
  "nl-NL": Wc,
  "pl-PL": Gc,
  "pt-BR": Yc,
  "pt-PT": qc,
  "ro-RO": Zc,
  "ru-RU": Jc,
  "sk-SK": Xc,
  "sl-SI": Qc,
  "sr-SP": ed,
  "sv-SE": td,
  "tr-TR": nd,
  "uk-UA": rd,
  "zh-CN": ad,
  "zh-TW": od
};
function wn(e, t) {
  return e - t * Math.floor(e / t);
}
const ud = 1721426;
function tn(e, t, n, r) {
  t = hr(e, t);
  let a = t - 1, o = -2;
  return n <= 2 ? o = 0 : jt(t) && (o = -1), ud - 1 + 365 * a + Math.floor(a / 4) - Math.floor(a / 100) + Math.floor(a / 400) + Math.floor((367 * n - 362) / 12 + o + r);
}
function jt(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function hr(e, t) {
  return e === "BC" ? 1 - t : t;
}
function Ia(e) {
  let t = "AD";
  return e <= 0 && (t = "BC", e = 1 - e), [
    t,
    e
  ];
}
const zv = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class Ke {
  fromJulianDay(t) {
    let n = t, r = n - ud, a = Math.floor(r / 146097), o = wn(r, 146097), i = Math.floor(o / 36524), u = wn(o, 36524), l = Math.floor(u / 1461), s = wn(u, 1461), c = Math.floor(s / 365), f = a * 400 + i * 100 + l * 4 + c + (i !== 4 && c !== 4 ? 1 : 0), [p, d] = Ia(f), g = n - tn(p, d, 1, 1), b = 2;
    n < tn(p, d, 3, 1) ? b = 0 : jt(d) && (b = 1);
    let v = Math.floor(((g + b) * 12 + 373) / 367), C = n - tn(p, d, v, 1) + 1;
    return new Se(p, d, v, C);
  }
  toJulianDay(t) {
    return tn(t.era, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    return zv[jt(t.year) ? "leapyear" : "standard"][t.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(t) {
    return 12;
  }
  getDaysInYear(t) {
    return jt(t.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(t) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(t) {
    return t.era === "BC";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BC" ? "AD" : "BC", t.year = 1 - t.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
const Uv = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Ae(e, t) {
  return t = Ce(t, e.calendar), e.era === t.era && e.year === t.year && e.month === t.month && e.day === t.day;
}
function Ko(e, t) {
  return e.calendar.identifier === t.calendar.identifier && e.era === t.era && e.year === t.year && e.month === t.month && e.day === t.day;
}
function ld(e, t) {
  return Ae(e, Pa(t));
}
function Ti(e, t) {
  let n = e.calendar.toJulianDay(e), r = Math.ceil(n + 1 - Jv(t)) % 7;
  return r < 0 && (r += 7), r;
}
function sd(e) {
  return At(Date.now(), e);
}
function Pa(e) {
  return qe(sd(e));
}
function cd(e, t) {
  return e.calendar.toJulianDay(e) - t.calendar.toJulianDay(t);
}
function dd(e, t) {
  return wl(e) - wl(t);
}
function wl(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let uo = null;
function vr() {
  return uo == null && (uo = new Intl.DateTimeFormat().resolvedOptions().timeZone), uo;
}
function yr(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function na(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
function Wv(e) {
  return yr(e.subtract({
    months: e.month - 1
  }));
}
function Gv(e) {
  return e.calendar.getMinimumMonthInYear ? e.calendar.getMinimumMonthInYear(e) : 1;
}
function Yv(e) {
  return e.calendar.getMinimumDayInMonth ? e.calendar.getMinimumDayInMonth(e) : 1;
}
function Tn(e, t) {
  let n = Ti(e, t);
  return e.subtract({
    days: n
  });
}
function qv(e, t) {
  return Tn(e, t).add({
    days: 6
  });
}
const Sl = /* @__PURE__ */ new Map();
function Zv(e) {
  if (Intl.Locale) {
    let n = Sl.get(e);
    return n || (n = new Intl.Locale(e).maximize().region, n && Sl.set(e, n)), n;
  }
  let t = e.split("-")[1];
  return t === "u" ? void 0 : t;
}
function Jv(e) {
  let t = Zv(e);
  return t && Uv[t] || 0;
}
function Xv(e, t) {
  let n = e.calendar.getDaysInMonth(e);
  return Math.ceil((Ti(yr(e), t) + n) / 7);
}
function Oi(e, t) {
  return e && t ? e.compare(t) <= 0 ? e : t : e || t;
}
function Bi(e, t) {
  return e && t ? e.compare(t) >= 0 ? e : t : e || t;
}
function On(e) {
  e = Ce(e, new Ke());
  let t = hr(e.era, e.year);
  return fd(t, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function fd(e, t, n, r, a, o, i) {
  let u = /* @__PURE__ */ new Date();
  return u.setUTCHours(r, a, o, i), u.setUTCFullYear(e, t - 1, n), u.getTime();
}
function zo(e, t) {
  if (t === "UTC") return 0;
  if (e > 0 && t === vr()) return new Date(e).getTimezoneOffset() * -6e4;
  let { year: n, month: r, day: a, hour: o, minute: i, second: u } = md(e, t);
  return fd(n, r, a, o, i, u, 0) - Math.floor(e / 1e3) * 1e3;
}
const Il = /* @__PURE__ */ new Map();
function md(e, t) {
  let n = Il.get(t);
  n || (n = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), Il.set(t, n));
  let r = n.formatToParts(new Date(e)), a = {};
  for (let o of r) o.type !== "literal" && (a[o.type] = o.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: a.era === "BC" || a.era === "B" ? -a.year + 1 : +a.year,
    month: +a.month,
    day: +a.day,
    hour: a.hour === "24" ? 0 : +a.hour,
    minute: +a.minute,
    second: +a.second
  };
}
const Pl = 864e5;
function Qv(e, t, n, r) {
  return (n === r ? [
    n
  ] : [
    n,
    r
  ]).filter((o) => e4(e, t, o));
}
function e4(e, t, n) {
  let r = md(n, t);
  return e.year === r.year && e.month === r.month && e.day === r.day && e.hour === r.hour && e.minute === r.minute && e.second === r.second;
}
function Ft(e, t, n = "compatible") {
  let r = wt(e);
  if (t === "UTC") return On(r);
  if (t === vr() && n === "compatible") {
    r = Ce(r, new Ke());
    let l = /* @__PURE__ */ new Date(), s = hr(r.era, r.year);
    return l.setFullYear(s, r.month - 1, r.day), l.setHours(r.hour, r.minute, r.second, r.millisecond), l.getTime();
  }
  let a = On(r), o = zo(a - Pl, t), i = zo(a + Pl, t), u = Qv(r, t, a - o, a - i);
  if (u.length === 1) return u[0];
  if (u.length > 1) switch (n) {
    case "compatible":
    case "earlier":
      return u[0];
    case "later":
      return u[u.length - 1];
    case "reject":
      throw new RangeError("Multiple possible absolute times found");
  }
  switch (n) {
    case "earlier":
      return Math.min(a - o, a - i);
    case "compatible":
    case "later":
      return Math.max(a - o, a - i);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function pd(e, t, n = "compatible") {
  return new Date(Ft(e, t, n));
}
function At(e, t) {
  let n = zo(e, t), r = new Date(e + n), a = r.getUTCFullYear(), o = r.getUTCMonth() + 1, i = r.getUTCDate(), u = r.getUTCHours(), l = r.getUTCMinutes(), s = r.getUTCSeconds(), c = r.getUTCMilliseconds();
  return new Bn(a, o, i, t, n, u, l, s, c);
}
function qe(e) {
  return new Se(e.calendar, e.era, e.year, e.month, e.day);
}
function wt(e, t) {
  let n = 0, r = 0, a = 0, o = 0;
  if ("timeZone" in e) ({ hour: n, minute: r, second: a, millisecond: o } = e);
  else if ("hour" in e && !t) return e;
  return t && ({ hour: n, minute: r, second: a, millisecond: o } = t), new ra(e.calendar, e.era, e.year, e.month, e.day, n, r, a, o);
}
function Ce(e, t) {
  if (e.calendar.identifier === t.identifier) return e;
  let n = t.fromJulianDay(e.calendar.toJulianDay(e)), r = e.copy();
  return r.calendar = t, r.era = n.era, r.year = n.year, r.month = n.month, r.day = n.day, dn(r), r;
}
function gd(e, t, n) {
  if (e instanceof Bn)
    return e.timeZone === t ? e : hd(e, t);
  let r = Ft(e, t, n);
  return At(r, t);
}
function t4(e) {
  let t = On(e) - e.offset;
  return new Date(t);
}
function hd(e, t) {
  let n = On(e) - e.offset;
  return Ce(At(n, t), e.calendar);
}
const Wn = 36e5;
function Ra(e, t) {
  let n = e.copy(), r = "hour" in n ? Dd(n, t) : 0;
  Uo(n, t.years || 0), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e), n.month += t.months || 0, Wo(n), vd(n), n.day += (t.weeks || 0) * 7, n.day += t.days || 0, n.day += r, n4(n), n.calendar.balanceDate && n.calendar.balanceDate(n), n.year < 1 && (n.year = 1, n.month = 1, n.day = 1);
  let a = n.calendar.getYearsInEra(n);
  if (n.year > a) {
    var o, i;
    let l = (o = (i = n.calendar).isInverseEra) === null || o === void 0 ? void 0 : o.call(i, n);
    n.year = a, n.month = l ? 1 : n.calendar.getMonthsInYear(n), n.day = l ? 1 : n.calendar.getDaysInMonth(n);
  }
  n.month < 1 && (n.month = 1, n.day = 1);
  let u = n.calendar.getMonthsInYear(n);
  return n.month > u && (n.month = u, n.day = n.calendar.getDaysInMonth(n)), n.day = Math.max(1, Math.min(n.calendar.getDaysInMonth(n), n.day)), n;
}
function Uo(e, t) {
  var n, r;
  !((n = (r = e.calendar).isInverseEra) === null || n === void 0) && n.call(r, e) && (t = -t), e.year += t;
}
function Wo(e) {
  for (; e.month < 1; )
    Uo(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let t = 0;
  for (; e.month > (t = e.calendar.getMonthsInYear(e)); )
    e.month -= t, Uo(e, 1);
}
function n4(e) {
  for (; e.day < 1; )
    e.month--, Wo(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, Wo(e);
}
function vd(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function dn(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), vd(e);
}
function Mi(e) {
  let t = {};
  for (let n in e) typeof e[n] == "number" && (t[n] = -e[n]);
  return t;
}
function yd(e, t) {
  return Ra(e, Mi(t));
}
function ki(e, t) {
  let n = e.copy();
  return t.era != null && (n.era = t.era), t.year != null && (n.year = t.year), t.month != null && (n.month = t.month), t.day != null && (n.day = t.day), dn(n), n;
}
function ur(e, t) {
  let n = e.copy();
  return t.hour != null && (n.hour = t.hour), t.minute != null && (n.minute = t.minute), t.second != null && (n.second = t.second), t.millisecond != null && (n.millisecond = t.millisecond), bd(n), n;
}
function r4(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Ar(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Ar(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Ar(e.minute, 60);
  let t = Math.floor(e.hour / 24);
  return e.hour = Ar(e.hour, 24), t;
}
function bd(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Ar(e, t) {
  let n = e % t;
  return n < 0 && (n += t), n;
}
function Dd(e, t) {
  return e.hour += t.hours || 0, e.minute += t.minutes || 0, e.second += t.seconds || 0, e.millisecond += t.milliseconds || 0, r4(e);
}
function _d(e, t) {
  let n = e.copy();
  return Dd(n, t), n;
}
function a4(e, t) {
  return _d(e, Mi(t));
}
function Vi(e, t, n, r) {
  let a = e.copy();
  switch (t) {
    case "era": {
      let u = e.calendar.getEras(), l = u.indexOf(e.era);
      if (l < 0) throw new Error("Invalid era: " + e.era);
      l = Tt(l, n, 0, u.length - 1, r == null ? void 0 : r.round), a.era = u[l], dn(a);
      break;
    }
    case "year":
      var o, i;
      !((o = (i = a.calendar).isInverseEra) === null || o === void 0) && o.call(i, a) && (n = -n), a.year = Tt(e.year, n, -1 / 0, 9999, r == null ? void 0 : r.round), a.year === -1 / 0 && (a.year = 1), a.calendar.balanceYearMonth && a.calendar.balanceYearMonth(a, e);
      break;
    case "month":
      a.month = Tt(e.month, n, 1, e.calendar.getMonthsInYear(e), r == null ? void 0 : r.round);
      break;
    case "day":
      a.day = Tt(e.day, n, 1, e.calendar.getDaysInMonth(e), r == null ? void 0 : r.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(a), dn(a), a;
}
function Ni(e, t, n, r) {
  let a = e.copy();
  switch (t) {
    case "hour": {
      let o = e.hour, i = 0, u = 23;
      if ((r == null ? void 0 : r.hourCycle) === 12) {
        let l = o >= 12;
        i = l ? 12 : 0, u = l ? 23 : 11;
      }
      a.hour = Tt(o, n, i, u, r == null ? void 0 : r.round);
      break;
    }
    case "minute":
      a.minute = Tt(e.minute, n, 0, 59, r == null ? void 0 : r.round);
      break;
    case "second":
      a.second = Tt(e.second, n, 0, 59, r == null ? void 0 : r.round);
      break;
    case "millisecond":
      a.millisecond = Tt(e.millisecond, n, 0, 999, r == null ? void 0 : r.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return a;
}
function Tt(e, t, n, r, a = !1) {
  if (a) {
    e += Math.sign(t), e < n && (e = r);
    let o = Math.abs(t);
    t > 0 ? e = Math.ceil(e / o) * o : e = Math.floor(e / o) * o, e > r && (e = n);
  } else
    e += t, e < n ? e = r - (n - e - 1) : e > r && (e = n + (e - r - 1));
  return e;
}
function $d(e, t) {
  let n;
  if (t.years != null && t.years !== 0 || t.months != null && t.months !== 0 || t.weeks != null && t.weeks !== 0 || t.days != null && t.days !== 0) {
    let a = Ra(wt(e), {
      years: t.years,
      months: t.months,
      weeks: t.weeks,
      days: t.days
    });
    n = Ft(a, e.timeZone);
  } else
    n = On(e) - e.offset;
  n += t.milliseconds || 0, n += (t.seconds || 0) * 1e3, n += (t.minutes || 0) * 6e4, n += (t.hours || 0) * 36e5;
  let r = At(n, e.timeZone);
  return Ce(r, e.calendar);
}
function o4(e, t) {
  return $d(e, Mi(t));
}
function i4(e, t, n, r) {
  switch (t) {
    case "hour": {
      let a = 0, o = 23;
      if ((r == null ? void 0 : r.hourCycle) === 12) {
        let g = e.hour >= 12;
        a = g ? 12 : 0, o = g ? 23 : 11;
      }
      let i = wt(e), u = Ce(ur(i, {
        hour: a
      }), new Ke()), l = [
        Ft(u, e.timeZone, "earlier"),
        Ft(u, e.timeZone, "later")
      ].filter((g) => At(g, e.timeZone).day === u.day)[0], s = Ce(ur(i, {
        hour: o
      }), new Ke()), c = [
        Ft(s, e.timeZone, "earlier"),
        Ft(s, e.timeZone, "later")
      ].filter((g) => At(g, e.timeZone).day === s.day).pop(), f = On(e) - e.offset, p = Math.floor(f / Wn), d = f % Wn;
      return f = Tt(p, n, Math.floor(l / Wn), Math.floor(c / Wn), r == null ? void 0 : r.round) * Wn + d, Ce(At(f, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return Ni(e, t, n, r);
    case "era":
    case "year":
    case "month":
    case "day": {
      let a = Vi(wt(e), t, n, r), o = Ft(a, e.timeZone);
      return Ce(At(o, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + t);
  }
}
function u4(e, t, n) {
  let r = wt(e), a = ur(ki(r, t), t);
  if (a.compare(r) === 0) return e;
  let o = Ft(a, e.timeZone, n);
  return Ce(At(o, e.timeZone), e.calendar);
}
const l4 = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
function xd(e, t) {
  let n = e.match(l4);
  if (!n) throw new Error("Invalid ISO 8601 date time string: " + e);
  let r = new Bn(St(n[1], 1, 9999), St(n[2], 1, 12), 1, t, 0, n[4] ? St(n[4], 0, 23) : 0, n[5] ? St(n[5], 0, 59) : 0, n[6] ? St(n[6], 0, 59) : 0, n[7] ? St(n[7], 0, 1 / 0) * 1e3 : 0);
  r.day = St(n[3], 0, r.calendar.getDaysInMonth(r));
  var a;
  return n[8] && (r.offset = St(n[8], -23, 23) * 36e5 + St((a = n[9]) !== null && a !== void 0 ? a : "0", 0, 59) * 6e4), hd(r, t);
}
function s4(e) {
  return xd(e, vr());
}
function St(e, t, n) {
  let r = Number(e);
  if (r < t || r > n) throw new RangeError(`Value out of range: ${t} <= ${r} <= ${n}`);
  return r;
}
function Ed(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function Cd(e) {
  let t = Ce(e, new Ke());
  return `${String(t.year).padStart(4, "0")}-${String(t.month).padStart(2, "0")}-${String(t.day).padStart(2, "0")}`;
}
function wd(e) {
  return `${Cd(e)}T${Ed(e)}`;
}
function c4(e) {
  let t = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let n = Math.floor(e / 36e5), r = e % 36e5 / 6e4;
  return `${t}${String(n).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}
function d4(e) {
  return `${wd(e)}${c4(e.offset)}[${e.timeZone}]`;
}
function f4(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function br(e, t, n) {
  f4(e, t), t.set(e, n);
}
function ji(e) {
  let t = typeof e[0] == "object" ? e.shift() : new Ke(), n;
  if (typeof e[0] == "string") n = e.shift();
  else {
    let i = t.getEras();
    n = i[i.length - 1];
  }
  let r = e.shift(), a = e.shift(), o = e.shift();
  return [
    t,
    n,
    r,
    a,
    o
  ];
}
var m4 = /* @__PURE__ */ new WeakMap();
class Se {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Se(this.calendar, this.era, this.year, this.month, this.day) : new Se(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(t) {
    return Ra(this, t);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(t) {
    return yd(this, t);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return ki(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return Vi(this, t, n, r);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(t) {
    return pd(this, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return Cd(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return cd(this, t);
  }
  constructor(...t) {
    br(this, m4, {
      writable: !0,
      value: void 0
    });
    let [n, r, a, o, i] = ji(t);
    this.calendar = n, this.era = r, this.year = a, this.month = o, this.day = i, dn(this);
  }
}
var p4 = /* @__PURE__ */ new WeakMap();
class Li {
  /** Returns a copy of this time. */
  copy() {
    return new Li(this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `Time` with the given duration added to it. */
  add(t) {
    return _d(this, t);
  }
  /** Returns a new `Time` with the given duration subtracted from it. */
  subtract(t) {
    return a4(this, t);
  }
  /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return ur(this, t);
  }
  /**
  * Returns a new `Time` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return Ni(this, t, n, r);
  }
  /** Converts the time to an ISO 8601 formatted string. */
  toString() {
    return Ed(this);
  }
  /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */
  compare(t) {
    return dd(this, t);
  }
  constructor(t = 0, n = 0, r = 0, a = 0) {
    br(this, p4, {
      writable: !0,
      value: void 0
    }), this.hour = t, this.minute = n, this.second = r, this.millisecond = a, bd(this);
  }
}
var g4 = /* @__PURE__ */ new WeakMap();
class ra {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ra(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new ra(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(t) {
    return Ra(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return yd(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return ki(ur(this, t), t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    switch (t) {
      case "era":
      case "year":
      case "month":
      case "day":
        return Vi(this, t, n, r);
      default:
        return Ni(this, t, n, r);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(t, n) {
    return pd(this, t, n);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return wd(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    let n = cd(this, t);
    return n === 0 ? dd(this, wt(t)) : n;
  }
  constructor(...t) {
    br(this, g4, {
      writable: !0,
      value: void 0
    });
    let [n, r, a, o, i] = ji(t);
    this.calendar = n, this.era = r, this.year = a, this.month = o, this.day = i, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, dn(this);
  }
}
var h4 = /* @__PURE__ */ new WeakMap();
class Bn {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Bn(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new Bn(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(t) {
    return $d(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return o4(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t, n) {
    return u4(this, t, n);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return i4(this, t, n, r);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return t4(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return d4(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return this.toDate().getTime() - gd(t, this.timeZone).toDate().getTime();
  }
  constructor(...t) {
    br(this, h4, {
      writable: !0,
      value: void 0
    });
    let [n, r, a, o, i] = ji(t), u = t.shift(), l = t.shift();
    this.calendar = n, this.era = r, this.year = a, this.month = o, this.day = i, this.timeZone = u, this.offset = l, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, dn(this);
  }
}
const Sn = [
  [
    1868,
    9,
    8
  ],
  [
    1912,
    7,
    30
  ],
  [
    1926,
    12,
    25
  ],
  [
    1989,
    1,
    8
  ],
  [
    2019,
    5,
    1
  ]
], v4 = [
  [
    1912,
    7,
    29
  ],
  [
    1926,
    12,
    24
  ],
  [
    1989,
    1,
    7
  ],
  [
    2019,
    4,
    30
  ]
], zr = [
  1867,
  1911,
  1925,
  1988,
  2018
], kt = [
  "meiji",
  "taisho",
  "showa",
  "heisei",
  "reiwa"
];
function Rl(e) {
  const t = Sn.findIndex(([n, r, a]) => e.year < n || e.year === n && e.month < r || e.year === n && e.month === r && e.day < a);
  return t === -1 ? Sn.length - 1 : t === 0 ? 0 : t - 1;
}
function lo(e) {
  let t = zr[kt.indexOf(e.era)];
  if (!t) throw new Error("Unknown era: " + e.era);
  return new Se(e.year + t, e.month, e.day);
}
class y4 extends Ke {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = Rl(n);
    return new Se(this, kt[r], n.year - zr[r], n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(lo(t));
  }
  balanceDate(t) {
    let n = lo(t), r = Rl(n);
    kt[r] !== t.era && (t.era = kt[r], t.year = n.year - zr[r]), this.constrainDate(t);
  }
  constrainDate(t) {
    let n = kt.indexOf(t.era), r = v4[n];
    if (r != null) {
      let [a, o, i] = r, u = a - zr[n];
      t.year = Math.max(1, Math.min(u, t.year)), t.year === u && (t.month = Math.min(o, t.month), t.month === o && (t.day = Math.min(i, t.day)));
    }
    if (t.year === 1 && n >= 0) {
      let [, a, o] = Sn[n];
      t.month = Math.max(a, t.month), t.month === a && (t.day = Math.max(o, t.day));
    }
  }
  getEras() {
    return kt;
  }
  getYearsInEra(t) {
    let n = kt.indexOf(t.era), r = Sn[n], a = Sn[n + 1];
    if (a == null)
      return 9999 - r[0] + 1;
    let o = a[0] - r[0];
    return (t.month < a[1] || t.month === a[1] && t.day < a[2]) && o++, o;
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(lo(t));
  }
  getMinimumMonthInYear(t) {
    let n = Fl(t);
    return n ? n[1] : 1;
  }
  getMinimumDayInMonth(t) {
    let n = Fl(t);
    return n && t.month === n[1] ? n[2] : 1;
  }
  constructor(...t) {
    super(...t), this.identifier = "japanese";
  }
}
function Fl(e) {
  if (e.year === 1) {
    let t = kt.indexOf(e.era);
    return Sn[t];
  }
}
const Sd = -543;
class b4 extends Ke {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = hr(n.era, n.year);
    return new Se(this, r - Sd, n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(Al(t));
  }
  getEras() {
    return [
      "BE"
    ];
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(Al(t));
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "buddhist";
  }
}
function Al(e) {
  let [t, n] = Ia(e.year + Sd);
  return new Se(t, n, e.month, e.day);
}
const aa = 1911;
function Id(e) {
  return e.era === "minguo" ? e.year + aa : 1 - e.year + aa;
}
function Tl(e) {
  let t = e - aa;
  return t > 0 ? [
    "minguo",
    t
  ] : [
    "before_minguo",
    1 - t
  ];
}
class D4 extends Ke {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = hr(n.era, n.year), [a, o] = Tl(r);
    return new Se(this, a, o, n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(Ol(t));
  }
  getEras() {
    return [
      "before_minguo",
      "minguo"
    ];
  }
  balanceDate(t) {
    let [n, r] = Tl(Id(t));
    t.era = n, t.year = r;
  }
  isInverseEra(t) {
    return t.era === "before_minguo";
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(Ol(t));
  }
  getYearsInEra(t) {
    return t.era === "before_minguo" ? 9999 : 9999 - aa;
  }
  constructor(...t) {
    super(...t), this.identifier = "roc";
  }
}
function Ol(e) {
  let [t, n] = Ia(Id(e));
  return new Se(t, n, e.month, e.day);
}
const Bl = 1948320, Ml = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
  // Esfand
];
class _4 {
  fromJulianDay(t) {
    let n = t - Bl, r = 1 + Math.floor((33 * n + 3) / 12053), a = 365 * (r - 1) + Math.floor((8 * r + 21) / 33), o = n - a, i = o < 216 ? Math.floor(o / 31) : Math.floor((o - 6) / 30), u = o - Ml[i] + 1;
    return new Se(this, r, i + 1, u);
  }
  toJulianDay(t) {
    let n = Bl - 1 + 365 * (t.year - 1) + Math.floor((8 * t.year + 21) / 33);
    return n += Ml[t.month - 1], n += t.day, n;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInMonth(t) {
    return t.month <= 6 ? 31 : t.month <= 11 || wn(25 * t.year + 11, 33) < 8 ? 30 : 29;
  }
  getEras() {
    return [
      "AP"
    ];
  }
  getYearsInEra() {
    return 9377;
  }
  constructor() {
    this.identifier = "persian";
  }
}
const so = 78, kl = 80;
class $4 extends Ke {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = n.year - so, a = t - tn(n.era, n.year, 1, 1), o;
    a < kl ? (r--, o = jt(n.year - 1) ? 31 : 30, a += o + 155 + 90 + 10) : (o = jt(n.year) ? 31 : 30, a -= kl);
    let i, u;
    if (a < o)
      i = 1, u = a + 1;
    else {
      let l = a - o;
      l < 155 ? (i = Math.floor(l / 31) + 2, u = l % 31 + 1) : (l -= 155, i = Math.floor(l / 30) + 7, u = l % 30 + 1);
    }
    return new Se(this, r, i, u);
  }
  toJulianDay(t) {
    let n = t.year + so, [r, a] = Ia(n), o, i;
    return jt(a) ? (o = 31, i = tn(r, a, 3, 21)) : (o = 30, i = tn(r, a, 3, 22)), t.month === 1 ? i + t.day - 1 : (i += o + Math.min(t.month - 2, 5) * 31, t.month >= 8 && (i += (t.month - 7) * 30), i += t.day - 1, i);
  }
  getDaysInMonth(t) {
    return t.month === 1 && jt(t.year + so) || t.month >= 2 && t.month <= 6 ? 31 : 30;
  }
  getYearsInEra() {
    return 9919;
  }
  getEras() {
    return [
      "saka"
    ];
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "indian";
  }
}
const oa = 1948440, Vl = 1948439, at = 1300, bn = 1600, x4 = 460322;
function ia(e, t, n, r) {
  return r + Math.ceil(29.5 * (n - 1)) + (t - 1) * 354 + Math.floor((3 + 11 * t) / 30) + e - 1;
}
function Pd(e, t, n) {
  let r = Math.floor((30 * (n - t) + 10646) / 10631), a = Math.min(12, Math.ceil((n - (29 + ia(t, r, 1, 1))) / 29.5) + 1), o = n - ia(t, r, a, 1) + 1;
  return new Se(e, r, a, o);
}
function Nl(e) {
  return (14 + 11 * e) % 30 < 11;
}
class Hi {
  fromJulianDay(t) {
    return Pd(this, oa, t);
  }
  toJulianDay(t) {
    return ia(oa, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    let n = 29 + t.month % 2;
    return t.month === 12 && Nl(t.year) && n++, n;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInYear(t) {
    return Nl(t.year) ? 355 : 354;
  }
  getYearsInEra() {
    return 9665;
  }
  getEras() {
    return [
      "AH"
    ];
  }
  constructor() {
    this.identifier = "islamic-civil";
  }
}
class E4 extends Hi {
  fromJulianDay(t) {
    return Pd(this, Vl, t);
  }
  toJulianDay(t) {
    return ia(Vl, t.year, t.month, t.day);
  }
  constructor(...t) {
    super(...t), this.identifier = "islamic-tbla";
  }
}
const C4 = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let Go, In;
function Ur(e) {
  return x4 + In[e - at];
}
function Zn(e, t) {
  let n = e - at, r = 1 << 11 - (t - 1);
  return Go[n] & r ? 30 : 29;
}
function jl(e, t) {
  let n = Ur(e);
  for (let r = 1; r < t; r++) n += Zn(e, r);
  return n;
}
function Ll(e) {
  return In[e + 1 - at] - In[e - at];
}
class w4 extends Hi {
  fromJulianDay(t) {
    let n = t - oa, r = Ur(at), a = Ur(bn);
    if (n < r || n > a) return super.fromJulianDay(t);
    {
      let o = at - 1, i = 1, u = 1;
      for (; u > 0; ) {
        o++, u = n - Ur(o) + 1;
        let l = Ll(o);
        if (u === l) {
          i = 12;
          break;
        } else if (u < l) {
          let s = Zn(o, i);
          for (i = 1; u > s; )
            u -= s, i++, s = Zn(o, i);
          break;
        }
      }
      return new Se(this, o, i, n - jl(o, i) + 1);
    }
  }
  toJulianDay(t) {
    return t.year < at || t.year > bn ? super.toJulianDay(t) : oa + jl(t.year, t.month) + (t.day - 1);
  }
  getDaysInMonth(t) {
    return t.year < at || t.year > bn ? super.getDaysInMonth(t) : Zn(t.year, t.month);
  }
  getDaysInYear(t) {
    return t.year < at || t.year > bn ? super.getDaysInYear(t) : Ll(t.year);
  }
  constructor() {
    if (super(), this.identifier = "islamic-umalqura", Go || (Go = new Uint16Array(Uint8Array.from(atob(C4), (t) => t.charCodeAt(0)).buffer)), !In) {
      In = new Uint32Array(bn - at + 1);
      let t = 0;
      for (let n = at; n <= bn; n++) {
        In[n - at] = t;
        for (let r = 1; r <= 12; r++) t += Zn(n, r);
      }
    }
  }
}
const Hl = 347997, Rd = 1080, Fd = 24 * Rd, S4 = 29, I4 = 12 * Rd + 793, P4 = S4 * Fd + I4;
function Qt(e) {
  return wn(e * 7 + 1, 19) < 7;
}
function Wr(e) {
  let t = Math.floor((235 * e - 234) / 19), n = 12084 + 13753 * t, r = t * 29 + Math.floor(n / 25920);
  return wn(3 * (r + 1), 7) < 3 && (r += 1), r;
}
function R4(e) {
  let t = Wr(e - 1), n = Wr(e);
  return Wr(e + 1) - n === 356 ? 2 : n - t === 382 ? 1 : 0;
}
function er(e) {
  return Wr(e) + R4(e);
}
function Ad(e) {
  return er(e + 1) - er(e);
}
function F4(e) {
  let t = Ad(e);
  switch (t > 380 && (t -= 30), t) {
    case 353:
      return 0;
    case 354:
      return 1;
    case 355:
      return 2;
  }
}
function Tr(e, t) {
  if (t >= 6 && !Qt(e) && t++, t === 4 || t === 7 || t === 9 || t === 11 || t === 13) return 29;
  let n = F4(e);
  return t === 2 ? n === 2 ? 30 : 29 : t === 3 ? n === 0 ? 29 : 30 : t === 6 ? Qt(e) ? 30 : 0 : 30;
}
class A4 {
  fromJulianDay(t) {
    let n = t - Hl, r = n * Fd / P4, a = Math.floor((19 * r + 234) / 235) + 1, o = er(a), i = Math.floor(n - o);
    for (; i < 1; )
      a--, o = er(a), i = Math.floor(n - o);
    let u = 1, l = 0;
    for (; l < i; )
      l += Tr(a, u), u++;
    u--, l -= Tr(a, u);
    let s = i - l;
    return new Se(this, a, u, s);
  }
  toJulianDay(t) {
    let n = er(t.year);
    for (let r = 1; r < t.month; r++) n += Tr(t.year, r);
    return n + t.day + Hl;
  }
  getDaysInMonth(t) {
    return Tr(t.year, t.month);
  }
  getMonthsInYear(t) {
    return Qt(t.year) ? 13 : 12;
  }
  getDaysInYear(t) {
    return Ad(t.year);
  }
  getYearsInEra() {
    return 9999;
  }
  getEras() {
    return [
      "AM"
    ];
  }
  balanceYearMonth(t, n) {
    n.year !== t.year && (Qt(n.year) && !Qt(t.year) && n.month > 6 ? t.month-- : !Qt(n.year) && Qt(t.year) && n.month > 6 && t.month++);
  }
  constructor() {
    this.identifier = "hebrew";
  }
}
const Yo = 1723856, Kl = 1824665, qo = 5500;
function ua(e, t, n, r) {
  return e + 365 * t + Math.floor(t / 4) + 30 * (n - 1) + r - 1;
}
function Ki(e, t) {
  let n = Math.floor(4 * (t - e) / 1461), r = 1 + Math.floor((t - ua(e, n, 1, 1)) / 30), a = t + 1 - ua(e, n, r, 1);
  return [
    n,
    r,
    a
  ];
}
function Td(e) {
  return Math.floor(e % 4 / 3);
}
function Od(e, t) {
  return t % 13 !== 0 ? 30 : Td(e) + 5;
}
class zi {
  fromJulianDay(t) {
    let [n, r, a] = Ki(Yo, t), o = "AM";
    return n <= 0 && (o = "AA", n += qo), new Se(this, o, n, r, a);
  }
  toJulianDay(t) {
    let n = t.year;
    return t.era === "AA" && (n -= qo), ua(Yo, n, t.month, t.day);
  }
  getDaysInMonth(t) {
    return Od(t.year, t.month);
  }
  getMonthsInYear() {
    return 13;
  }
  getDaysInYear(t) {
    return 365 + Td(t.year);
  }
  getYearsInEra(t) {
    return t.era === "AA" ? 9999 : 9991;
  }
  getEras() {
    return [
      "AA",
      "AM"
    ];
  }
  constructor() {
    this.identifier = "ethiopic";
  }
}
class T4 extends zi {
  fromJulianDay(t) {
    let [n, r, a] = Ki(Yo, t);
    return n += qo, new Se(this, "AA", n, r, a);
  }
  getEras() {
    return [
      "AA"
    ];
  }
  getYearsInEra() {
    return 9999;
  }
  constructor(...t) {
    super(...t), this.identifier = "ethioaa";
  }
}
class O4 extends zi {
  fromJulianDay(t) {
    let [n, r, a] = Ki(Kl, t), o = "CE";
    return n <= 0 && (o = "BCE", n = 1 - n), new Se(this, o, n, r, a);
  }
  toJulianDay(t) {
    let n = t.year;
    return t.era === "BCE" && (n = 1 - n), ua(Kl, n, t.month, t.day);
  }
  getDaysInMonth(t) {
    let n = t.year;
    return t.era === "BCE" && (n = 1 - n), Od(n, t.month);
  }
  isInverseEra(t) {
    return t.era === "BCE";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BCE" ? "CE" : "BCE", t.year = 1 - t.year);
  }
  getEras() {
    return [
      "BCE",
      "CE"
    ];
  }
  getYearsInEra(t) {
    return t.era === "BCE" ? 9999 : 9715;
  }
  constructor(...t) {
    super(...t), this.identifier = "coptic";
  }
}
function Fa(e) {
  switch (e) {
    case "buddhist":
      return new b4();
    case "ethiopic":
      return new zi();
    case "ethioaa":
      return new T4();
    case "coptic":
      return new O4();
    case "hebrew":
      return new A4();
    case "indian":
      return new $4();
    case "islamic-civil":
      return new Hi();
    case "islamic-tbla":
      return new E4();
    case "islamic-umalqura":
      return new w4();
    case "japanese":
      return new y4();
    case "persian":
      return new _4();
    case "roc":
      return new D4();
    case "gregory":
    default:
      return new Ke();
  }
}
let co = /* @__PURE__ */ new Map();
class ut {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(t) {
    return this.formatter.format(t);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(t) {
    return this.formatter.formatToParts(t);
  }
  /** Formats a date range as a string. */
  formatRange(t, n) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(t)} – ${this.formatter.format(n)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.formatter.formatToParts(t), a = this.formatter.formatToParts(n);
    return [
      ...r.map((o) => ({
        ...o,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((o) => ({
        ...o,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.formatter.resolvedOptions();
    return k4() && (this.resolvedHourCycle || (this.resolvedHourCycle = V4(t.locale, this.options)), t.hourCycle = this.resolvedHourCycle, t.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), t.calendar === "ethiopic-amete-alem" && (t.calendar = "ethioaa"), t;
  }
  constructor(t, n = {}) {
    this.formatter = Bd(t, n), this.options = n;
  }
}
const B4 = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function Bd(e, t = {}) {
  if (typeof t.hour12 == "boolean" && M4()) {
    t = {
      ...t
    };
    let a = B4[String(t.hour12)][e.split("-")[0]], o = t.hour12 ? "h12" : "h23";
    t.hourCycle = a ?? o, delete t.hour12;
  }
  let n = e + (t ? Object.entries(t).sort((a, o) => a[0] < o[0] ? -1 : 1).join() : "");
  if (co.has(n)) return co.get(n);
  let r = new Intl.DateTimeFormat(e, t);
  return co.set(n, r), r;
}
let fo = null;
function M4() {
  return fo == null && (fo = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), fo;
}
let mo = null;
function k4() {
  return mo == null && (mo = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), mo;
}
function V4(e, t) {
  if (!t.timeStyle && !t.hour) return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let n = Bd(e, {
    ...t,
    timeZone: void 0
    // use local timezone
  }), r = parseInt(n.formatToParts(new Date(2020, 2, 3, 0)).find((o) => o.type === "hour").value, 10), a = parseInt(n.formatToParts(new Date(2020, 2, 3, 23)).find((o) => o.type === "hour").value, 10);
  if (r === 0 && a === 23) return "h23";
  if (r === 24 && a === 23) return "h24";
  if (r === 0 && a === 11) return "h11";
  if (r === 12 && a === 11) return "h12";
  throw new Error("Unexpected hour cycle result");
}
const N4 = Symbol.for("react-aria.i18n.locale"), j4 = Symbol.for("react-aria.i18n.strings");
let Dn;
class zt {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let a = this.getStringsForLocale(n)[t];
    if (!a) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return a;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = L4(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[N4];
    if (Dn === void 0) {
      let a = window[j4];
      if (!a) return null;
      Dn = {};
      for (let o in a) Dn[o] = new zt({
        [n]: a[o]
      }, n);
    }
    let r = Dn == null ? void 0 : Dn[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
}
function L4(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = H4(e);
  if (t[r]) return t[r];
  for (let a in t)
    if (a.startsWith(r + "-")) return t[a];
  return t[n];
}
function H4(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const zl = /* @__PURE__ */ new Map(), Ul = /* @__PURE__ */ new Map();
class Md {
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let a = n["=" + t];
    if (a) return typeof a == "function" ? a() : a;
    let o = this.locale + ":" + r, i = zl.get(o);
    i || (i = new Intl.PluralRules(this.locale, {
      type: r
    }), zl.set(o, i));
    let u = i.select(t);
    return a = n[u] || n.other, typeof a == "function" ? a() : a;
  }
  number(t) {
    let n = Ul.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), Ul.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
}
const Aa = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, kd = {
  ...Aa,
  customError: !0,
  valid: !1
}, en = {
  isInvalid: !1,
  validationDetails: Aa,
  validationErrors: []
}, K4 = xa({}), lr = "__formValidationState" + Date.now();
function Ui(e) {
  if (e[lr]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: a, commitValidation: o } = e[lr];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: a,
      commitValidation: o
    };
  }
  return z4(e);
}
function z4(e) {
  let { isInvalid: t, validationState: n, name: r, value: a, builtinValidation: o, validate: i, validationBehavior: u = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let l = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: kd
  } : null, s = J(() => Wl(U4(i, a)), [
    i,
    a
  ]);
  o != null && o.validationDetails.valid && (o = null);
  let c = yt(K4), f = J(() => r ? Array.isArray(r) ? r.flatMap((T) => Zo(c[T])) : Zo(c[r]) : [], [
    c,
    r
  ]), [p, d] = re(c), [g, b] = re(!1);
  c !== p && (d(c), b(!1));
  let v = J(() => Wl(g ? [] : f), [
    g,
    f
  ]), C = q(en), [h, D] = re(en), x = q(en), _ = () => {
    if (!O) return;
    L(!1);
    let T = s || o || C.current;
    po(T, x.current) || (x.current = T, D(T));
  }, [O, L] = re(!1);
  return te(_), {
    realtimeValidation: l || v || s || o || en,
    displayValidation: u === "native" ? l || v || h : l || v || s || o || h,
    updateValidation(T) {
      u === "aria" && !po(h, T) ? D(T) : C.current = T;
    },
    resetValidation() {
      let T = en;
      po(T, x.current) || (x.current = T, D(T)), u === "native" && L(!1), b(!0);
    },
    commitValidation() {
      u === "native" && L(!0), b(!0);
    }
  };
}
function Zo(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function U4(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return Zo(n);
  }
  return [];
}
function Wl(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: kd
  } : null;
}
function po(e, t) {
  return e === t ? !0 : e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
function la(...e) {
  let t = /* @__PURE__ */ new Set(), n = !1, r = {
    ...Aa
  };
  for (let i of e) {
    var a, o;
    for (let u of i.validationErrors) t.add(u);
    n || (n = i.isInvalid);
    for (let u in r) (a = r)[o = u] || (a[o] = i.validationDetails[u]);
  }
  return r.valid = !n, {
    isInvalid: n,
    validationErrors: [
      ...t
    ],
    validationDetails: r
  };
}
function W4(e) {
  return e && e.__esModule ? e.default : e;
}
const Vd = new zt(W4(id));
function Nd() {
  return typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
}
function sa(e, t, n, r, a) {
  let o = e != null && n != null && e.compare(n) > 0, i = e != null && t != null && e.compare(t) < 0, u = e != null && (r == null ? void 0 : r(e)) || !1, l = o || i || u, s = [];
  if (l) {
    let c = Nd(), f = zt.getGlobalDictionaryForPackage("@react-stately/datepicker") || Vd, p = new Md(c, f), d = new ut(c, Ot({}, a)), g = d.resolvedOptions().timeZone;
    i && s.push(p.format("rangeUnderflow", {
      minValue: d.format(t.toDate(g))
    })), o && s.push(p.format("rangeOverflow", {
      maxValue: d.format(n.toDate(g))
    })), u && s.push(p.format("unavailableDate"));
  }
  return {
    isInvalid: l,
    validationErrors: s,
    validationDetails: {
      badInput: u,
      customError: !1,
      patternMismatch: !1,
      rangeOverflow: o,
      rangeUnderflow: i,
      stepMismatch: !1,
      tooLong: !1,
      tooShort: !1,
      typeMismatch: !1,
      valueMissing: !1,
      valid: !l
    }
  };
}
function G4(e, t, n, r, a) {
  let o = sa(e == null ? void 0 : e.start, t, n, r, a), i = sa(e == null ? void 0 : e.end, t, n, r, a), u = la(o, i);
  if (e.end != null && e.start != null && e.end.compare(e.start) < 0) {
    let l = zt.getGlobalDictionaryForPackage("@react-stately/datepicker") || Vd;
    u = la(u, {
      isInvalid: !0,
      validationErrors: [
        l.getStringForLocale("rangeReversed", Nd())
      ],
      validationDetails: {
        ...Aa,
        rangeUnderflow: !0,
        rangeOverflow: !0,
        valid: !1
      }
    });
  }
  return u;
}
const Y4 = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
}, q4 = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
};
function Ot(e, t) {
  e = {
    ...t.shouldForceLeadingZeros ? q4 : Y4,
    ...e
  };
  let r = t.granularity || "minute", a = Object.keys(e);
  var o;
  let i = a.indexOf((o = t.maxGranularity) !== null && o !== void 0 ? o : "year");
  i < 0 && (i = 0);
  let u = a.indexOf(r);
  if (u < 0 && (u = 2), i > u) throw new Error("maxGranularity must be greater than granularity");
  let l = a.slice(i, u + 1).reduce((c, f) => (c[f] = e[f], c), {});
  return t.hourCycle != null && (l.hour12 = t.hourCycle === 12), l.timeZone = t.timeZone || "UTC", (r === "hour" || r === "minute" || r === "second") && t.timeZone && !t.hideTimeZone && (l.timeZoneName = "short"), t.showEra && i === 0 && (l.era = "short"), l;
}
function En(e) {
  return e && "hour" in e ? e : new Li();
}
function jd(e, t) {
  if (e === null) return null;
  if (e)
    return Ce(e, t);
}
function Gn(e, t, n, r) {
  if (e) return jd(e, n);
  let a = Ce(sd(r).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }), n);
  return t === "year" || t === "month" || t === "day" ? qe(a) : r ? a : wt(a);
}
function Wi(e, t) {
  let n = e && "timeZone" in e ? e.timeZone : void 0, r = e && "minute" in e ? "minute" : "day";
  if (e && t && !(t in e)) throw new Error("Invalid granularity " + t + " for value " + e.toString());
  let [a, o] = re([
    r,
    n
  ]);
  e && (a[0] !== r || a[1] !== n) && o([
    r,
    n
  ]), t || (t = e ? r : a[0]);
  let i = e ? n : a[1];
  return [
    t,
    i
  ];
}
function fn(e, t, n) {
  let [r, a] = re(e || t), o = q(e !== void 0), i = e !== void 0;
  te(() => {
    let s = o.current;
    s !== i && console.warn(`WARN: A component changed from ${s ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}.`), o.current = i;
  }, [
    i
  ]);
  let u = i ? e : r, l = ae((s, ...c) => {
    let f = (p, ...d) => {
      n && (Object.is(u, p) || n(p, ...d)), i || (u = p);
    };
    typeof s == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), a((d, ...g) => {
      let b = s(i ? u : d, ...g);
      return f(b, ...c), i ? d : b;
    })) : (i || a(s), f(s, ...c));
  }, [
    i,
    u,
    n
  ]);
  return [
    u,
    l
  ];
}
function Jo(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
function Gi(e) {
  let [t, n] = fn(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = ae(() => {
    n(!0);
  }, [
    n
  ]), a = ae(() => {
    n(!1);
  }, [
    n
  ]), o = ae(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: a,
    toggle: o
  };
}
function Z4(e) {
  let t = Gi(e), [n, r] = fn(e.value, e.defaultValue || null, e.onChange), a = n || e.placeholderValue, [o, i] = Wi(a, e.granularity), u = n != null ? n.toDate(i ?? "UTC") : null, l = o === "hour" || o === "minute" || o === "second";
  var s;
  let c = (s = e.shouldCloseOnSelect) !== null && s !== void 0 ? s : !0, [f, p] = re(null), [d, g] = re(null);
  if (n && (f = n, "hour" in n && (d = n)), a && !(o in a)) throw new Error("Invalid granularity " + o + " for value " + a.toString());
  let b = (n == null ? void 0 : n.calendar.identifier) === "gregory" && n.era === "BC", v = J(() => ({
    granularity: o,
    timeZone: i,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    showEra: b
  }), [
    o,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    i,
    e.hideTimeZone,
    b
  ]), { minValue: C, maxValue: h, isDateUnavailable: D } = e, x = J(() => sa(n, C, h, D, v), [
    n,
    C,
    h,
    D,
    v
  ]), _ = Ui({
    ...e,
    value: n,
    builtinValidation: x
  }), O = _.displayValidation.isInvalid, L = e.validationState || (O ? "invalid" : null), y = ($, R) => {
    r("timeZone" in R ? R.set(qe($)) : wt($, R)), p(null), g(null), _.commitValidation();
  };
  return {
    ..._,
    value: n,
    setValue: r,
    dateValue: f,
    timeValue: d,
    setDateValue: ($) => {
      let R = typeof c == "function" ? c() : c;
      l ? d || R ? y($, d || En(e.placeholderValue)) : p($) : (r($), _.commitValidation()), R && t.setOpen(!1);
    },
    setTimeValue: ($) => {
      f && $ ? y(f, $) : g($);
    },
    granularity: o,
    hasTime: l,
    ...t,
    setOpen($) {
      !$ && !n && f && l && y(f, d || En(e.placeholderValue)), t.setOpen($);
    },
    validationState: L,
    isInvalid: O,
    formatValue($, R) {
      if (!u) return "";
      let P = Ot(R, v);
      return new ut($, P).format(u);
    },
    getDateFormatter($, R) {
      let P = {
        ...v,
        ...R
      }, S = Ot({}, P);
      return new ut($, S);
    }
  };
}
const J4 = new zt({
  ach: {
    year: "mwaka",
    month: "dwe",
    day: "nino"
  },
  af: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  am: {
    year: "ዓዓዓዓ",
    month: "ሚሜ",
    day: "ቀቀ"
  },
  an: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ar: {
    year: "سنة",
    month: "شهر",
    day: "يوم"
  },
  ast: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  az: {
    year: "iiii",
    month: "aa",
    day: "gg"
  },
  be: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bg: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bn: {
    year: "yyyy",
    month: "মিমি",
    day: "dd"
  },
  br: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  bs: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  ca: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  cak: {
    year: "jjjj",
    month: "ii",
    day: "q'q'"
  },
  ckb: {
    year: "ساڵ",
    month: "مانگ",
    day: "ڕۆژ"
  },
  cs: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  cy: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  da: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  de: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  dsb: {
    year: "llll",
    month: "mm",
    day: "źź"
  },
  el: {
    year: "εεεε",
    month: "μμ",
    day: "ηη"
  },
  en: {
    year: "yyyy",
    month: "mm",
    day: "dd"
  },
  eo: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  es: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  et: {
    year: "aaaa",
    month: "kk",
    day: "pp"
  },
  eu: {
    year: "uuuu",
    month: "hh",
    day: "ee"
  },
  fa: {
    year: "سال",
    month: "ماه",
    day: "روز"
  },
  ff: {
    year: "hhhh",
    month: "ll",
    day: "ññ"
  },
  fi: {
    year: "vvvv",
    month: "kk",
    day: "pp"
  },
  fr: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  fy: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  ga: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gd: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gl: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  he: {
    year: "שנה",
    month: "חודש",
    day: "יום"
  },
  hr: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  hsb: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  hu: {
    year: "éééé",
    month: "hh",
    day: "nn"
  },
  ia: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  id: {
    year: "tttt",
    month: "bb",
    day: "hh"
  },
  it: {
    year: "aaaa",
    month: "mm",
    day: "gg"
  },
  ja: {
    year: " 年 ",
    month: "月",
    day: "日"
  },
  ka: {
    year: "წწწწ",
    month: "თთ",
    day: "რრ"
  },
  kk: {
    year: "жжжж",
    month: "аа",
    day: "кк"
  },
  kn: {
    year: "ವವವವ",
    month: "ಮಿಮೀ",
    day: "ದಿದಿ"
  },
  ko: {
    year: "연도",
    month: "월",
    day: "일"
  },
  lb: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  lo: {
    year: "ປປປປ",
    month: "ດດ",
    day: "ວວ"
  },
  lt: {
    year: "mmmm",
    month: "mm",
    day: "dd"
  },
  lv: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  meh: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ml: {
    year: "വർഷം",
    month: "മാസം",
    day: "തീയതി"
  },
  ms: {
    year: "tttt",
    month: "mm",
    day: "hh"
  },
  nl: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  nn: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  no: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  oc: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  pl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  pt: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  rm: {
    year: "oooo",
    month: "mm",
    day: "dd"
  },
  ro: {
    year: "aaaa",
    month: "ll",
    day: "zz"
  },
  ru: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  sc: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  scn: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  sk: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  sl: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  sr: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  sv: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  szl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  tg: {
    year: "сссс",
    month: "мм",
    day: "рр"
  },
  th: {
    year: "ปปปป",
    month: "ดด",
    day: "วว"
  },
  tr: {
    year: "yyyy",
    month: "aa",
    day: "gg"
  },
  uk: {
    year: "рррр",
    month: "мм",
    day: "дд"
  },
  "zh-CN": {
    year: "年",
    month: "月",
    day: "日"
  },
  "zh-TW": {
    year: "年",
    month: "月",
    day: "日"
  }
}, "en");
function X4(e, t, n) {
  return e === "era" || e === "dayPeriod" ? t : e === "year" || e === "month" || e === "day" ? J4.getStringForLocale(e, n) : "––";
}
const Or = {
  year: !0,
  month: !0,
  day: !0,
  hour: !0,
  minute: !0,
  second: !0,
  dayPeriod: !0,
  era: !0
}, Gl = {
  year: 5,
  month: 2,
  day: 7,
  hour: 2,
  minute: 15,
  second: 15
}, Q4 = {
  dayperiod: "dayPeriod"
};
function e3(e) {
  let { locale: t, createCalendar: n, hideTimeZone: r, isDisabled: a, isReadOnly: o, isRequired: i, minValue: u, maxValue: l, isDateUnavailable: s } = e, c = e.value || e.defaultValue || e.placeholderValue, [f, p] = Wi(c, e.granularity), d = p || "UTC";
  if (c && !(f in c)) throw new Error("Invalid granularity " + f + " for value " + c.toString());
  let g = J(() => new ut(t), [
    t
  ]), b = J(() => n(g.resolvedOptions().calendar), [
    n,
    g
  ]), [v, C] = fn(e.value, e.defaultValue, e.onChange), h = J(() => jd(v, b), [
    v,
    b
  ]), [D, x] = re(() => Gn(e.placeholderValue, f, b, p)), _ = h || D, O = b.identifier === "gregory" && _.era === "BC", L = J(() => {
    var M;
    return {
      granularity: f,
      maxGranularity: (M = e.maxGranularity) !== null && M !== void 0 ? M : "year",
      timeZone: p,
      hideTimeZone: r,
      hourCycle: e.hourCycle,
      showEra: O,
      shouldForceLeadingZeros: e.shouldForceLeadingZeros
    };
  }, [
    e.maxGranularity,
    f,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    p,
    r,
    O
  ]), y = J(() => Ot({}, L), [
    L
  ]), F = J(() => new ut(t, y), [
    t,
    y
  ]), T = J(() => F.resolvedOptions(), [
    F
  ]), $ = J(() => F.formatToParts(/* @__PURE__ */ new Date()).filter((M) => Or[M.type]).reduce((M, U) => (M[U.type] = !0, M), {}), [
    F
  ]), [R, P] = re(() => e.value || e.defaultValue ? {
    ...$
  } : {}), S = q(void 0), V = q(b.identifier);
  te(() => {
    b.identifier !== V.current && (V.current = b.identifier, x((M) => Object.keys(R).length > 0 ? Ce(M, b) : Gn(e.placeholderValue, f, b, p)));
  }, [
    b,
    f,
    R,
    p,
    e.placeholderValue
  ]), v && Object.keys(R).length < Object.keys($).length && (R = {
    ...$
  }, P(R)), v == null && Object.keys(R).length === Object.keys($).length && (R = {}, P(R), x(Gn(e.placeholderValue, f, b, p)));
  let k = h && Object.keys(R).length >= Object.keys($).length ? h : D, w = (M) => {
    if (e.isDisabled || e.isReadOnly) return;
    let U = Object.keys(R), X = Object.keys($);
    M == null ? (C(null), x(Gn(e.placeholderValue, f, b, p)), P({})) : U.length >= X.length || U.length === X.length - 1 && $.dayPeriod && !R.dayPeriod && S.current !== "dayPeriod" ? (M = Ce(M, (c == null ? void 0 : c.calendar) || new Ke()), C(M)) : x(M), S.current = null;
  }, A = J(() => k.toDate(d), [
    k,
    d
  ]), K = J(() => F.formatToParts(A).map((M) => {
    let U = Or[M.type];
    M.type === "era" && b.getEras().length === 1 && (U = !1);
    let X = Or[M.type] && !R[M.type], Q = Or[M.type] ? X4(M.type, M.value, t) : null;
    return {
      type: Q4[M.type] || M.type,
      text: X ? Q : M.value,
      ...t3(k, M.type, T),
      isPlaceholder: X,
      placeholder: Q,
      isEditable: U
    };
  }), [
    A,
    R,
    F,
    T,
    k,
    b,
    t
  ]);
  $.era && R.year && !R.era ? (R.era = !0, P({
    ...R
  })) : !$.era && R.era && (delete R.era, P({
    ...R
  }));
  let E = (M) => {
    R[M] = !0, M === "year" && $.era && (R.era = !0), P({
      ...R
    });
  }, B = (M, U) => {
    if (R[M])
      w(n3(k, M, U, T));
    else {
      E(M);
      let X = Object.keys(R), Q = Object.keys($);
      (X.length >= Q.length || X.length === Q.length - 1 && $.dayPeriod && !R.dayPeriod) && w(k);
    }
  }, j = J(() => sa(v, u, l, s, L), [
    v,
    u,
    l,
    s,
    L
  ]), N = Ui({
    ...e,
    value: v,
    builtinValidation: j
  }), H = N.displayValidation.isInvalid, W = e.validationState || (H ? "invalid" : null);
  var Z;
  return {
    ...N,
    value: h,
    dateValue: A,
    calendar: b,
    setValue: w,
    segments: K,
    dateFormatter: F,
    validationState: W,
    isInvalid: H,
    granularity: f,
    maxGranularity: (Z = e.maxGranularity) !== null && Z !== void 0 ? Z : "year",
    isDisabled: a,
    isReadOnly: o,
    isRequired: i,
    increment(M) {
      B(M, 1);
    },
    decrement(M) {
      B(M, -1);
    },
    incrementPage(M) {
      B(M, Gl[M] || 1);
    },
    decrementPage(M) {
      B(M, -(Gl[M] || 1));
    },
    setSegment(M, U) {
      E(M), w(r3(k, M, U, T));
    },
    confirmPlaceholder() {
      if (e.isDisabled || e.isReadOnly) return;
      let M = Object.keys(R), U = Object.keys($);
      M.length === U.length - 1 && $.dayPeriod && !R.dayPeriod && (R = {
        ...$
      }, P(R), w(k.copy()));
    },
    clearSegment(M) {
      delete R[M], S.current = M, P({
        ...R
      });
      let U = Gn(e.placeholderValue, f, b, p), X = k;
      if (M === "dayPeriod" && "hour" in k && "hour" in U) {
        let Q = k.hour >= 12, oe = U.hour >= 12;
        Q && !oe ? X = k.set({
          hour: k.hour - 12
        }) : !Q && oe && (X = k.set({
          hour: k.hour + 12
        }));
      } else M in k && (X = k.set({
        [M]: U[M]
      }));
      C(null), w(X);
    },
    formatValue(M) {
      if (!h) return "";
      let U = Ot(M, L);
      return new ut(t, U).format(A);
    },
    getDateFormatter(M, U) {
      let X = {
        ...L,
        ...U
      }, Q = Ot({}, X);
      return new ut(M, Q);
    }
  };
}
function t3(e, t, n) {
  switch (t) {
    case "era": {
      let r = e.calendar.getEras();
      return {
        value: r.indexOf(e.era),
        minValue: 0,
        maxValue: r.length - 1
      };
    }
    case "year":
      return {
        value: e.year,
        minValue: 1,
        maxValue: e.calendar.getYearsInEra(e)
      };
    case "month":
      return {
        value: e.month,
        minValue: Gv(e),
        maxValue: e.calendar.getMonthsInYear(e)
      };
    case "day":
      return {
        value: e.day,
        minValue: Yv(e),
        maxValue: e.calendar.getDaysInMonth(e)
      };
  }
  if ("hour" in e) switch (t) {
    case "dayPeriod":
      return {
        value: e.hour >= 12 ? 12 : 0,
        minValue: 0,
        maxValue: 12
      };
    case "hour":
      if (n.hour12) {
        let r = e.hour >= 12;
        return {
          value: e.hour,
          minValue: r ? 12 : 0,
          maxValue: r ? 23 : 11
        };
      }
      return {
        value: e.hour,
        minValue: 0,
        maxValue: 23
      };
    case "minute":
      return {
        value: e.minute,
        minValue: 0,
        maxValue: 59
      };
    case "second":
      return {
        value: e.second,
        minValue: 0,
        maxValue: 59
      };
  }
  return {};
}
function n3(e, t, n, r) {
  switch (t) {
    case "era":
    case "year":
    case "month":
    case "day":
      return e.cycle(t, n, {
        round: t === "year"
      });
  }
  if ("hour" in e) switch (t) {
    case "dayPeriod": {
      let a = e.hour, o = a >= 12;
      return e.set({
        hour: o ? a - 12 : a + 12
      });
    }
    case "hour":
    case "minute":
    case "second":
      return e.cycle(t, n, {
        round: t !== "hour",
        hourCycle: r.hour12 ? 12 : 24
      });
  }
}
function r3(e, t, n, r) {
  switch (t) {
    case "day":
    case "month":
    case "year":
    case "era":
      return e.set({
        [t]: n
      });
  }
  if ("hour" in e) switch (t) {
    case "dayPeriod": {
      let a = e.hour, o = a >= 12;
      return n >= 12 === o ? e : e.set({
        hour: o ? a - 12 : a + 12
      });
    }
    case "hour":
      if (r.hour12) {
        let o = e.hour >= 12;
        !o && n === 12 && (n = 0), o && n < 12 && (n += 12);
      }
    case "minute":
    case "second":
      return e.set({
        [t]: n
      });
  }
}
function a3(e) {
  var t, n;
  let r = Gi(e), [a, o] = fn(e.value, e.defaultValue || null, e.onChange), [i, u] = re(() => a || {
    start: null,
    end: null
  });
  a == null && i.start && i.end && (i = {
    start: null,
    end: null
  }, u(i));
  let l = a || i, s = (k) => {
    u(k || {
      start: null,
      end: null
    }), k != null && k.start && k.end ? o(k) : o(null);
  }, c = (l == null ? void 0 : l.start) || (l == null ? void 0 : l.end) || e.placeholderValue, [f, p] = Wi(c, e.granularity), d = f === "hour" || f === "minute" || f === "second";
  var g;
  let b = (g = e.shouldCloseOnSelect) !== null && g !== void 0 ? g : !0, [v, C] = re(null), [h, D] = re(null);
  l && l.start && l.end && (v = l, "hour" in l.start && (h = l));
  let x = (k, w) => {
    s({
      start: "timeZone" in w.start ? w.start.set(qe(k.start)) : wt(k.start, w.start),
      end: "timeZone" in w.end ? w.end.set(qe(k.end)) : wt(k.end, w.end)
    }), C(null), D(null), P.commitValidation();
  }, _ = (k) => {
    let w = typeof b == "function" ? b() : b;
    d ? w || k.start && k.end && (h != null && h.start) && (h != null && h.end) ? x(k, {
      start: (h == null ? void 0 : h.start) || En(e.placeholderValue),
      end: (h == null ? void 0 : h.end) || En(e.placeholderValue)
    }) : C(k) : k.start && k.end ? (s(k), P.commitValidation()) : C(k), w && r.setOpen(!1);
  }, O = (k) => {
    v != null && v.start && (v != null && v.end) && k.start && k.end ? x(v, k) : D(k);
  }, L = (l == null || (t = l.start) === null || t === void 0 ? void 0 : t.calendar.identifier) === "gregory" && l.start.era === "BC" || (l == null || (n = l.end) === null || n === void 0 ? void 0 : n.calendar.identifier) === "gregory" && l.end.era === "BC", y = J(() => ({
    granularity: f,
    timeZone: p,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    showEra: L
  }), [
    f,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    p,
    e.hideTimeZone,
    L
  ]), { minValue: F, maxValue: T, isDateUnavailable: $ } = e, R = J(() => G4(l, F, T, $, y), [
    l,
    F,
    T,
    $,
    y
  ]), P = Ui({
    ...e,
    value: a,
    name: J(() => [
      e.startName,
      e.endName
    ], [
      e.startName,
      e.endName
    ]),
    builtinValidation: R
  }), S = P.displayValidation.isInvalid, V = e.validationState || (S ? "invalid" : null);
  return {
    ...P,
    value: l,
    setValue: s,
    dateRange: v,
    timeRange: h,
    granularity: f,
    hasTime: d,
    setDate(k, w) {
      _({
        ...v,
        [k]: w
      });
    },
    setTime(k, w) {
      O({
        ...h,
        [k]: w
      });
    },
    setDateTime(k, w) {
      s({
        ...l,
        [k]: w
      });
    },
    setDateRange: _,
    setTimeRange: O,
    ...r,
    setOpen(k) {
      !k && !(l != null && l.start && (l != null && l.end)) && (v != null && v.start) && (v != null && v.end) && d && x(v, {
        start: (h == null ? void 0 : h.start) || En(e.placeholderValue),
        end: (h == null ? void 0 : h.end) || En(e.placeholderValue)
      }), r.setOpen(k);
    },
    validationState: V,
    isInvalid: S,
    formatValue(k, w) {
      if (!l || !l.start || !l.end) return null;
      let A = "timeZone" in l.start ? l.start.timeZone : void 0, K = e.granularity || (l.start && "minute" in l.start ? "minute" : "day"), E = "timeZone" in l.end ? l.end.timeZone : void 0, B = e.granularity || (l.end && "minute" in l.end ? "minute" : "day"), j = Ot(w, {
        granularity: K,
        timeZone: A,
        hideTimeZone: e.hideTimeZone,
        hourCycle: e.hourCycle,
        showEra: l.start.calendar.identifier === "gregory" && l.start.era === "BC" || l.end.calendar.identifier === "gregory" && l.end.era === "BC"
      }), N = l.start.toDate(A || "UTC"), H = l.end.toDate(E || "UTC"), W = new ut(k, j), Z;
      if (A === E && K === B && l.start.compare(l.end) !== 0) {
        try {
          let M = W.formatRangeToParts(N, H), U = -1;
          for (let oe = 0; oe < M.length; oe++) {
            let z = M[oe];
            if (z.source === "shared" && z.type === "literal") U = oe;
            else if (z.source === "endRange") break;
          }
          let X = "", Q = "";
          for (let oe = 0; oe < M.length; oe++)
            oe < U ? X += M[oe].value : oe > U && (Q += M[oe].value);
          return {
            start: X,
            end: Q
          };
        } catch {
        }
        Z = W;
      } else {
        let M = Ot(w, {
          granularity: B,
          timeZone: E,
          hideTimeZone: e.hideTimeZone,
          hourCycle: e.hourCycle
        });
        Z = new ut(k, M);
      }
      return {
        start: W.format(N),
        end: Z.format(H)
      };
    },
    getDateFormatter(k, w) {
      let A = {
        ...y,
        ...w
      }, K = Ot({}, A);
      return new ut(k, K);
    }
  };
}
var Ld = {};
Ld = {
  calendar: "التقويم",
  day: "يوم",
  dayPeriod: "ص/م",
  endDate: "تاريخ الانتهاء",
  era: "العصر",
  hour: "الساعات",
  minute: "الدقائق",
  month: "الشهر",
  second: "الثواني",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.startDate} إلى ${e.endDate}`,
  selectedTimeDescription: (e) => `الوقت المحدد: ${e.time}`,
  startDate: "تاريخ البدء",
  timeZoneName: "التوقيت",
  weekday: "اليوم",
  year: "السنة"
};
var Hd = {};
Hd = {
  calendar: "Календар",
  day: "ден",
  dayPeriod: "пр.об./сл.об.",
  endDate: "Крайна дата",
  era: "ера",
  hour: "час",
  minute: "минута",
  month: "месец",
  second: "секунда",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.startDate} до ${e.endDate}`,
  selectedTimeDescription: (e) => `Избрано време: ${e.time}`,
  startDate: "Начална дата",
  timeZoneName: "часова зона",
  weekday: "ден от седмицата",
  year: "година"
};
var Kd = {};
Kd = {
  calendar: "Kalendář",
  day: "den",
  dayPeriod: "část dne",
  endDate: "Konečné datum",
  era: "letopočet",
  hour: "hodina",
  minute: "minuta",
  month: "měsíc",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.startDate} až ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybraný čas: ${e.time}`,
  startDate: "Počáteční datum",
  timeZoneName: "časové pásmo",
  weekday: "den v týdnu",
  year: "rok"
};
var zd = {};
zd = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "AM/PM",
  endDate: "Slutdato",
  era: "æra",
  hour: "time",
  minute: "minut",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tidspunkt: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidszone",
  weekday: "ugedag",
  year: "år"
};
var Ud = {};
Ud = {
  calendar: "Kalender",
  day: "Tag",
  dayPeriod: "Tageshälfte",
  endDate: "Enddatum",
  era: "Epoche",
  hour: "Stunde",
  minute: "Minute",
  month: "Monat",
  second: "Sekunde",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.startDate} bis ${e.endDate}`,
  selectedTimeDescription: (e) => `Ausgewählte Zeit: ${e.time}`,
  startDate: "Anfangsdatum",
  timeZoneName: "Zeitzone",
  weekday: "Wochentag",
  year: "Jahr"
};
var Wd = {};
Wd = {
  calendar: "Ημερολόγιο",
  day: "ημέρα",
  dayPeriod: "π.μ./μ.μ.",
  endDate: "Ημερομηνία λήξης",
  era: "περίοδος",
  hour: "ώρα",
  minute: "λεπτό",
  month: "μήνας",
  second: "δευτερόλεπτο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.startDate} έως ${e.endDate}`,
  selectedTimeDescription: (e) => `Επιλεγμένη ώρα: ${e.time}`,
  startDate: "Ημερομηνία έναρξης",
  timeZoneName: "ζώνη ώρας",
  weekday: "καθημερινή",
  year: "έτος"
};
var Gd = {};
Gd = {
  era: "era",
  year: "year",
  month: "month",
  day: "day",
  hour: "hour",
  minute: "minute",
  second: "second",
  dayPeriod: "AM/PM",
  calendar: "Calendar",
  startDate: "Start Date",
  endDate: "End Date",
  weekday: "day of the week",
  timeZoneName: "time zone",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.startDate} to ${e.endDate}`,
  selectedTimeDescription: (e) => `Selected Time: ${e.time}`
};
var Yd = {};
Yd = {
  calendar: "Calendario",
  day: "día",
  dayPeriod: "a. m./p. m.",
  endDate: "Fecha final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mes",
  second: "segundo",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Rango seleccionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora seleccionada: ${e.time}`,
  startDate: "Fecha de inicio",
  timeZoneName: "zona horaria",
  weekday: "día de la semana",
  year: "año"
};
var qd = {};
qd = {
  calendar: "Kalender",
  day: "päev",
  dayPeriod: "enne/pärast lõunat",
  endDate: "Lõppkuupäev",
  era: "ajastu",
  hour: "tund",
  minute: "minut",
  month: "kuu",
  second: "sekund",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.startDate} kuni ${e.endDate}`,
  selectedTimeDescription: (e) => `Valitud aeg: ${e.time}`,
  startDate: "Alguskuupäev",
  timeZoneName: "ajavöönd",
  weekday: "nädalapäev",
  year: "aasta"
};
var Zd = {};
Zd = {
  calendar: "Kalenteri",
  day: "päivä",
  dayPeriod: "vuorokaudenaika",
  endDate: "Päättymispäivä",
  era: "aikakausi",
  hour: "tunti",
  minute: "minuutti",
  month: "kuukausi",
  second: "sekunti",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.startDate} – ${e.endDate}`,
  selectedTimeDescription: (e) => `Valittu aika: ${e.time}`,
  startDate: "Alkamispäivä",
  timeZoneName: "aikavyöhyke",
  weekday: "viikonpäivä",
  year: "vuosi"
};
var Jd = {};
Jd = {
  calendar: "Calendrier",
  day: "jour",
  dayPeriod: "cadran",
  endDate: "Date de fin",
  era: "ère",
  hour: "heure",
  minute: "minute",
  month: "mois",
  second: "seconde",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.startDate} au ${e.endDate}`,
  selectedTimeDescription: (e) => `Heure choisie : ${e.time}`,
  startDate: "Date de début",
  timeZoneName: "fuseau horaire",
  weekday: "jour de la semaine",
  year: "année"
};
var Xd = {};
Xd = {
  calendar: "לוח שנה",
  day: "יום",
  dayPeriod: "לפנה״צ/אחה״צ",
  endDate: "תאריך סיום",
  era: "תקופה",
  hour: "שעה",
  minute: "דקה",
  month: "חודש",
  second: "שנייה",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.startDate} עד ${e.endDate}`,
  selectedTimeDescription: (e) => `זמן נבחר: ${e.time}`,
  startDate: "תאריך התחלה",
  timeZoneName: "אזור זמן",
  weekday: "יום בשבוע",
  year: "שנה"
};
var Qd = {};
Qd = {
  calendar: "Kalendar",
  day: "dan",
  dayPeriod: "AM/PM",
  endDate: "Datum završetka",
  era: "era",
  hour: "sat",
  minute: "minuta",
  month: "mjesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Odabrano vrijeme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "vremenska zona",
  weekday: "dan u tjednu",
  year: "godina"
};
var ef = {};
ef = {
  calendar: "Naptár",
  day: "nap",
  dayPeriod: "napszak",
  endDate: "Befejező dátum",
  era: "éra",
  hour: "óra",
  minute: "perc",
  month: "hónap",
  second: "másodperc",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.startDate}–${e.endDate}`,
  selectedTimeDescription: (e) => `Kijelölt idő: ${e.time}`,
  startDate: "Kezdő dátum",
  timeZoneName: "időzóna",
  weekday: "hét napja",
  year: "év"
};
var tf = {};
tf = {
  calendar: "Calendario",
  day: "giorno",
  dayPeriod: "AM/PM",
  endDate: "Data finale",
  era: "era",
  hour: "ora",
  minute: "minuto",
  month: "mese",
  second: "secondo",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: da ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selezionata: ${e.time}`,
  startDate: "Data iniziale",
  timeZoneName: "fuso orario",
  weekday: "giorno della settimana",
  year: "anno"
};
var nf = {};
nf = {
  calendar: "カレンダー",
  day: "日",
  dayPeriod: "午前/午後",
  endDate: "終了日",
  era: "時代",
  hour: "時",
  minute: "分",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.startDate} から ${e.endDate}`,
  selectedTimeDescription: (e) => `選択した時間 : ${e.time}`,
  startDate: "開始日",
  timeZoneName: "タイムゾーン",
  weekday: "曜日",
  year: "年"
};
var rf = {};
rf = {
  calendar: "달력",
  day: "일",
  dayPeriod: "오전/오후",
  endDate: "종료일",
  era: "연호",
  hour: "시",
  minute: "분",
  month: "월",
  second: "초",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.startDate} ~ ${e.endDate}`,
  selectedTimeDescription: (e) => `선택 시간: ${e.time}`,
  startDate: "시작일",
  timeZoneName: "시간대",
  weekday: "요일",
  year: "년"
};
var af = {};
af = {
  calendar: "Kalendorius",
  day: "diena",
  dayPeriod: "iki pietų / po pietų",
  endDate: "Pabaigos data",
  era: "era",
  hour: "valanda",
  minute: "minutė",
  month: "mėnuo",
  second: "sekundė",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: nuo ${e.startDate} iki ${e.endDate}`,
  selectedTimeDescription: (e) => `Pasirinktas laikas: ${e.time}`,
  startDate: "Pradžios data",
  timeZoneName: "laiko juosta",
  weekday: "savaitės diena",
  year: "metai"
};
var of = {};
of = {
  calendar: "Kalendārs",
  day: "diena",
  dayPeriod: "priekšpusdienā/pēcpusdienā",
  endDate: "Beigu datums",
  era: "ēra",
  hour: "stundas",
  minute: "minūtes",
  month: "mēnesis",
  second: "sekundes",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: no ${e.startDate} līdz ${e.endDate}`,
  selectedTimeDescription: (e) => `Atlasītais laiks: ${e.time}`,
  startDate: "Sākuma datums",
  timeZoneName: "laika josla",
  weekday: "nedēļas diena",
  year: "gads"
};
var uf = {};
uf = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Sluttdato",
  era: "tidsalder",
  hour: "time",
  minute: "minutt",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tid: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidssone",
  weekday: "ukedag",
  year: "år"
};
var lf = {};
lf = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Einddatum",
  era: "tijdperk",
  hour: "uur",
  minute: "minuut",
  month: "maand",
  second: "seconde",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.startDate} tot ${e.endDate}`,
  selectedTimeDescription: (e) => `Geselecteerde tijd: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tijdzone",
  weekday: "dag van de week",
  year: "jaar"
};
var sf = {};
sf = {
  calendar: "Kalendarz",
  day: "dzień",
  dayPeriod: "rano / po południu / wieczorem",
  endDate: "Data końcowa",
  era: "era",
  hour: "godzina",
  minute: "minuta",
  month: "miesiąc",
  second: "sekunda",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Wybrany czas: ${e.time}`,
  startDate: "Data początkowa",
  timeZoneName: "strefa czasowa",
  weekday: "dzień tygodnia",
  year: "rok"
};
var cf = {};
cf = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "AM/PM",
  endDate: "Data final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data inicial",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var df = {};
df = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "am/pm",
  endDate: "Data de Término",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data de Início",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var ff = {};
ff = {
  calendar: "Calendar",
  day: "zi",
  dayPeriod: "a.m/p.m.",
  endDate: "Dată final",
  era: "eră",
  hour: "oră",
  minute: "minut",
  month: "lună",
  second: "secundă",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: de la ${e.startDate} până la ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selectată: ${e.time}`,
  startDate: "Dată început",
  timeZoneName: "fus orar",
  weekday: "ziua din săptămână",
  year: "an"
};
var mf = {};
mf = {
  calendar: "Календарь",
  day: "день",
  dayPeriod: "AM/PM",
  endDate: "Дата окончания",
  era: "эра",
  hour: "час",
  minute: "минута",
  month: "месяц",
  second: "секунда",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: с ${e.startDate} по ${e.endDate}`,
  selectedTimeDescription: (e) => `Выбранное время: ${e.time}`,
  startDate: "Дата начала",
  timeZoneName: "часовой пояс",
  weekday: "день недели",
  year: "год"
};
var pf = {};
pf = {
  calendar: "Kalendár",
  day: "deň",
  dayPeriod: "AM/PM",
  endDate: "Dátum ukončenia",
  era: "letopočet",
  hour: "hodina",
  minute: "minúta",
  month: "mesiac",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybratý čas: ${e.time}`,
  startDate: "Dátum začatia",
  timeZoneName: "časové pásmo",
  weekday: "deň týždňa",
  year: "rok"
};
var gf = {};
gf = {
  calendar: "Koledar",
  day: "dan",
  dayPeriod: "dop/pop",
  endDate: "Datum konca",
  era: "doba",
  hour: "ura",
  minute: "minuta",
  month: "mesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izbrani čas: ${e.time}`,
  startDate: "Datum začetka",
  timeZoneName: "časovni pas",
  weekday: "dan v tednu",
  year: "leto"
};
var hf = {};
hf = {
  calendar: "Kalendar",
  day: "дан",
  dayPeriod: "пре подне/по подне",
  endDate: "Datum završetka",
  era: "ера",
  hour: "сат",
  minute: "минут",
  month: "месец",
  second: "секунд",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani opseg: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izabrano vreme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "временска зона",
  weekday: "дан у недељи",
  year: "година"
};
var vf = {};
vf = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "fm/em",
  endDate: "Slutdatum",
  era: "era",
  hour: "timme",
  minute: "minut",
  month: "månad",
  second: "sekund",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.startDate} till ${e.endDate}`,
  selectedTimeDescription: (e) => `Vald tid: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tidszon",
  weekday: "veckodag",
  year: "år"
};
var yf = {};
yf = {
  calendar: "Takvim",
  day: "gün",
  dayPeriod: "ÖÖ/ÖS",
  endDate: "Bitiş Tarihi",
  era: "çağ",
  hour: "saat",
  minute: "dakika",
  month: "ay",
  second: "saniye",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.startDate} - ${e.endDate}`,
  selectedTimeDescription: (e) => `Seçilen Zaman: ${e.time}`,
  startDate: "Başlangıç Tarihi",
  timeZoneName: "saat dilimi",
  weekday: "haftanın günü",
  year: "yıl"
};
var bf = {};
bf = {
  calendar: "Календар",
  day: "день",
  dayPeriod: "дп/пп",
  endDate: "Дата завершення",
  era: "ера",
  hour: "година",
  minute: "хвилина",
  month: "місяць",
  second: "секунда",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.startDate} — ${e.endDate}`,
  selectedTimeDescription: (e) => `Вибраний час: ${e.time}`,
  startDate: "Дата початку",
  timeZoneName: "часовий пояс",
  weekday: "день тижня",
  year: "рік"
};
var Df = {};
Df = {
  calendar: "日历",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "结束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `选定的时间：${e.time}`,
  startDate: "开始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var _f = {};
_f = {
  calendar: "日曆",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "結束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `選定的時間：${e.time}`,
  startDate: "開始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var Dr = {};
Dr = {
  "ar-AE": Ld,
  "bg-BG": Hd,
  "cs-CZ": Kd,
  "da-DK": zd,
  "de-DE": Ud,
  "el-GR": Wd,
  "en-US": Gd,
  "es-ES": Yd,
  "et-EE": qd,
  "fi-FI": Zd,
  "fr-FR": Jd,
  "he-IL": Xd,
  "hr-HR": Qd,
  "hu-HU": ef,
  "it-IT": tf,
  "ja-JP": nf,
  "ko-KR": rf,
  "lt-LT": af,
  "lv-LV": of,
  "nb-NO": uf,
  "nl-NL": lf,
  "pl-PL": sf,
  "pt-BR": cf,
  "pt-PT": df,
  "ro-RO": ff,
  "ru-RU": mf,
  "sk-SK": pf,
  "sl-SI": gf,
  "sr-SP": hf,
  "sv-SE": vf,
  "tr-TR": yf,
  "uk-UA": bf,
  "zh-CN": Df,
  "zh-TW": _f
};
const st = typeof document < "u" ? fe.useLayoutEffect : () => {
};
function Ge(e) {
  const t = q(null);
  return st(() => {
    t.current = e;
  }, [
    e
  ]), ae((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
function o3(e) {
  let [t, n] = re(e), r = q(null), a = Ge(() => {
    if (!r.current) return;
    let i = r.current.next();
    if (i.done) {
      r.current = null;
      return;
    }
    t === i.value ? a() : n(i.value);
  });
  st(() => {
    r.current && a();
  });
  let o = Ge((i) => {
    r.current = i(t), a();
  });
  return [
    t,
    o
  ];
}
const ca = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, $f = /* @__PURE__ */ fe.createContext(ca), i3 = /* @__PURE__ */ fe.createContext(!1);
let u3 = !!(typeof window < "u" && window.document && window.document.createElement), go = /* @__PURE__ */ new WeakMap();
function l3(e = !1) {
  let t = yt($f), n = q(null);
  if (n.current === null && !e) {
    var r, a;
    let o = (a = fe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (r = a.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (o) {
      let i = go.get(o);
      i == null ? go.set(o, {
        id: t.current,
        state: o.memoizedState
      }) : o.memoizedState !== i.state && (t.current = i.id, go.delete(o));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function s3(e) {
  let t = yt($f);
  t === ca && !u3 && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = l3(!!e), r = t === ca && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function c3(e) {
  let t = fe.useId(), [n] = re(xf()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ca.prefix}`;
  return e || `${r}-${t}`;
}
const d3 = typeof fe.useId == "function" ? c3 : s3;
function f3() {
  return !1;
}
function m3() {
  return !0;
}
function p3(e) {
  return () => {
  };
}
function xf() {
  return typeof fe.useSyncExternalStore == "function" ? fe.useSyncExternalStore(p3, f3, m3) : yt(i3);
}
let g3 = !!(typeof window < "u" && window.document && window.document.createElement), da = /* @__PURE__ */ new Map();
function vt(e) {
  let [t, n] = re(e), r = q(null), a = d3(t), o = ae((i) => {
    r.current = i;
  }, []);
  return g3 && da.set(a, o), st(() => {
    let i = a;
    return () => {
      da.delete(i);
    };
  }, [
    a
  ]), te(() => {
    let i = r.current;
    i && (r.current = null, n(i));
  }), a;
}
function h3(e, t) {
  if (e === t) return e;
  let n = da.get(e);
  if (n)
    return n(t), t;
  let r = da.get(t);
  return r ? (r(e), e) : t;
}
function Xo(e = []) {
  let t = vt(), [n, r] = o3(t), a = ae(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return st(a, [
    t,
    a,
    ...e
  ]), n;
}
function Ef(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const He = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, mn = (e) => e && "window" in e && e.window === e ? e : He(e).defaultView || window;
function Cf(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Cf(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function v3() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Cf(e)) && (r && (r += " "), r += t);
  return r;
}
function Me(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let a in r) {
      let o = t[a], i = r[a];
      typeof o == "function" && typeof i == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = Ef(o, i) : (a === "className" || a === "UNSAFE_className") && typeof o == "string" && typeof i == "string" ? t[a] = v3(o, i) : a === "id" && o && i ? t.id = h3(o, i) : t[a] = i !== void 0 ? i : o;
    }
  }
  return t;
}
function y3(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    for (let n of e)
      typeof n == "function" ? n(t) : n != null && (n.current = t);
  };
}
const b3 = /* @__PURE__ */ new Set([
  "id"
]), D3 = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), _3 = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), $3 = /^(data-.*)$/;
function _r(e, t = {}) {
  let { labelable: n, isLink: r, propNames: a } = t, o = {};
  for (const i in e) Object.prototype.hasOwnProperty.call(e, i) && (b3.has(i) || n && D3.has(i) || r && _3.has(i) || a != null && a.has(i) || $3.test(i)) && (o[i] = e[i]);
  return o;
}
function Lt(e) {
  if (x3()) e.focus({
    preventScroll: !0
  });
  else {
    let t = E3(e);
    e.focus(), C3(t);
  }
}
let Br = null;
function x3() {
  if (Br == null) {
    Br = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Br = !0, !0;
        }
      });
    } catch {
    }
  }
  return Br;
}
function E3(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function C3(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function Ta(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function Yi(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Ut(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Mn = Ut(function() {
  return Yi(/^Mac/i);
}), w3 = Ut(function() {
  return Yi(/^iPhone/i);
}), wf = Ut(function() {
  return Yi(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Mn() && navigator.maxTouchPoints > 1;
}), qi = Ut(function() {
  return w3() || wf();
}), Sf = Ut(function() {
  return Ta(/AppleWebKit/i) && !S3();
}), S3 = Ut(function() {
  return Ta(/Chrome/i);
}), If = Ut(function() {
  return Ta(/Android/i);
}), I3 = Ut(function() {
  return Ta(/Firefox/i);
});
function sr(e, t, n = !0) {
  var r, a;
  let { metaKey: o, ctrlKey: i, altKey: u, shiftKey: l } = t;
  I3() && (!((a = window.event) === null || a === void 0 || (r = a.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (Mn() ? o = !0 : i = !0);
  let s = Sf() && Mn() && !wf() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: o,
    ctrlKey: i,
    altKey: u,
    shiftKey: l
  }) : new MouseEvent("click", {
    metaKey: o,
    ctrlKey: i,
    altKey: u,
    shiftKey: l,
    bubbles: !0,
    cancelable: !0
  });
  sr.isOpening = n, Lt(e), e.dispatchEvent(s), sr.isOpening = !1;
}
sr.isOpening = !1;
let $n = /* @__PURE__ */ new Map(), Qo = /* @__PURE__ */ new Set();
function Yl() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target) return;
    let a = $n.get(r.target);
    a || (a = /* @__PURE__ */ new Set(), $n.set(r.target, a), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), a.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target) return;
    let a = $n.get(r.target);
    if (a && (a.delete(r.propertyName), a.size === 0 && (r.target.removeEventListener("transitioncancel", n), $n.delete(r.target)), $n.size === 0)) {
      for (let o of Qo) o();
      Qo.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? Yl() : document.addEventListener("DOMContentLoaded", Yl));
function Pf(e) {
  requestAnimationFrame(() => {
    $n.size === 0 ? e() : Qo.add(e);
  });
}
function Rf() {
  let e = q(/* @__PURE__ */ new Map()), t = ae((a, o, i, u) => {
    let l = u != null && u.once ? (...s) => {
      e.current.delete(i), i(...s);
    } : i;
    e.current.set(i, {
      type: o,
      eventTarget: a,
      fn: l,
      options: u
    }), a.addEventListener(o, i, u);
  }, []), n = ae((a, o, i, u) => {
    var l;
    let s = ((l = e.current.get(i)) === null || l === void 0 ? void 0 : l.fn) || i;
    a.removeEventListener(o, s, u), e.current.delete(i);
  }, []), r = ae(() => {
    e.current.forEach((a, o) => {
      n(a.eventTarget, a.type, o, a.options);
    });
  }, [
    n
  ]);
  return te(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function Oa(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": a } = e;
  return n = vt(n), a && r ? a = [
    .../* @__PURE__ */ new Set([
      n,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !r && !a && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": a
  };
}
function P3(e) {
  const t = q(null);
  return J(() => ({
    get current() {
      return t.current;
    },
    set current(n) {
      t.current = n, typeof e == "function" ? e(n) : e && (e.current = n);
    }
  }), [
    e
  ]);
}
function ql(e, t) {
  const n = q(!0), r = q(null);
  te(() => (n.current = !0, () => {
    n.current = !1;
  }), []), te(() => {
    n.current ? n.current = !1 : (!r.current || t.some((a, o) => !Object.is(a, r[o]))) && e(), r.current = t;
  }, t);
}
function R3() {
  return typeof window.ResizeObserver < "u";
}
function Zl(e) {
  const { ref: t, box: n, onResize: r } = e;
  te(() => {
    let a = t == null ? void 0 : t.current;
    if (a)
      if (R3()) {
        const o = new window.ResizeObserver((i) => {
          i.length && r();
        });
        return o.observe(a, {
          box: n
        }), () => {
          a && o.unobserve(a);
        };
      } else
        return window.addEventListener("resize", r, !1), () => {
          window.removeEventListener("resize", r, !1);
        };
  }, [
    r,
    t,
    n
  ]);
}
function Ff(e, t) {
  st(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function ei(e, t) {
  let n = window.getComputedStyle(e), r = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return r && t && (r = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), r;
}
function Af(e, t) {
  let n = e;
  for (ei(n, t) && (n = n.parentElement); n && !ei(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function F3(e, t) {
  const n = [];
  for (; e && e !== document.documentElement; )
    ei(e, t) && n.push(e), e = e.parentElement;
  return n;
}
let A3 = 0;
const ho = /* @__PURE__ */ new Map();
function Ba(e) {
  let [t, n] = re();
  return st(() => {
    if (!e) return;
    let r = ho.get(e);
    if (r)
      n(r.element.id);
    else {
      let a = `react-aria-description-${A3++}`;
      n(a);
      let o = document.createElement("div");
      o.id = a, o.style.display = "none", o.textContent = e, document.body.appendChild(o), r = {
        refCount: 0,
        element: o
      }, ho.set(e, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), ho.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
function Pn(e, t, n, r) {
  let a = Ge(n), o = n == null;
  te(() => {
    if (o || !e.current) return;
    let i = e.current;
    return i.addEventListener(t, a, r), () => {
      i.removeEventListener(t, a, r);
    };
  }, [
    e,
    t,
    r,
    o,
    a
  ]);
}
function T3(e, t) {
  let n = Jl(e, t, "left"), r = Jl(e, t, "top"), a = t.offsetWidth, o = t.offsetHeight, i = e.scrollLeft, u = e.scrollTop, { borderTopWidth: l, borderLeftWidth: s } = getComputedStyle(e), c = e.scrollLeft + parseInt(s, 10), f = e.scrollTop + parseInt(l, 10), p = c + e.clientWidth, d = f + e.clientHeight;
  n <= i ? i = n - parseInt(s, 10) : n + a > p && (i += n + a - p), r <= f ? u = r - parseInt(l, 10) : r + o > d && (u += r + o - d), e.scrollLeft = i, e.scrollTop = u;
}
function Jl(e, t, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let a = 0;
  for (; t.offsetParent && (a += t[r], t.offsetParent !== e); ) {
    if (t.offsetParent.contains(e)) {
      a -= e[r];
      break;
    }
    t = t.offsetParent;
  }
  return a;
}
function Tf(e, t) {
  if (document.contains(e)) {
    let i = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(i).overflow === "hidden") {
      let l = F3(e);
      for (let s of l) T3(s, e);
    } else {
      var n;
      let { left: l, top: s } = e.getBoundingClientRect();
      e == null || (n = e.scrollIntoView) === null || n === void 0 || n.call(e, {
        block: "nearest"
      });
      let { left: c, top: f } = e.getBoundingClientRect();
      if (Math.abs(l - c) > 1 || Math.abs(s - f) > 1) {
        var r, a, o;
        t == null || (a = t.containingElement) === null || a === void 0 || (r = a.scrollIntoView) === null || r === void 0 || r.call(a, {
          block: "center",
          inline: "center"
        }), (o = e.scrollIntoView) === null || o === void 0 || o.call(e, {
          block: "nearest"
        });
      }
    }
  }
}
function ti(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : If() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function O3(e) {
  return !If() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function Of(e, t) {
  let n = q(null);
  return e && n.current && t(e, n.current) && (e = n.current), n.current = e, e;
}
function B3(e, t, n) {
  let r = q(t), a = Ge(() => {
    n && n(r.current);
  });
  te(() => {
    var o;
    let i = e == null || (o = e.current) === null || o === void 0 ? void 0 : o.form;
    return i == null || i.addEventListener("reset", a), () => {
      i == null || i.removeEventListener("reset", a);
    };
  }, [
    e,
    a
  ]);
}
let Cn = "default", ni = "", Gr = /* @__PURE__ */ new WeakMap();
function Xl(e) {
  if (qi()) {
    if (Cn === "default") {
      const t = He(e);
      ni = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    Cn = "disabled";
  } else (e instanceof HTMLElement || e instanceof SVGElement) && (Gr.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function Mr(e) {
  if (qi()) {
    if (Cn !== "disabled") return;
    Cn = "restoring", setTimeout(() => {
      Pf(() => {
        if (Cn === "restoring") {
          const t = He(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = ni || ""), ni = "", Cn = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Gr.has(e)) {
    let t = Gr.get(e);
    e.style.userSelect === "none" && (e.style.userSelect = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Gr.delete(e);
  }
}
const Bf = fe.createContext({
  register: () => {
  }
});
Bf.displayName = "PressResponderContext";
function M3(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function Mf(e, t, n) {
  if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function k3(e, t) {
  var n = Mf(e, t, "get");
  return M3(e, n);
}
function V3(e, t, n) {
  if (t.set) t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function Ql(e, t, n) {
  var r = Mf(e, t, "set");
  return V3(e, r, n), n;
}
function N3(e) {
  let t = yt(Bf);
  if (t) {
    let { register: n, ...r } = t;
    e = Me(r, e), n();
  }
  return Ff(t, e.ref), e;
}
var kr = /* @__PURE__ */ new WeakMap();
class Vr {
  continuePropagation() {
    Ql(this, kr, !1);
  }
  get shouldStopPropagation() {
    return k3(this, kr);
  }
  constructor(t, n, r, a) {
    br(this, kr, {
      writable: !0,
      value: void 0
    }), Ql(this, kr, !0);
    var o;
    let i = (o = a == null ? void 0 : a.target) !== null && o !== void 0 ? o : r.currentTarget;
    const u = i == null ? void 0 : i.getBoundingClientRect();
    let l, s = 0, c, f = null;
    r.clientX != null && r.clientY != null && (c = r.clientX, f = r.clientY), u && (c != null && f != null ? (l = c - u.left, s = f - u.top) : (l = u.width / 2, s = u.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = l, this.y = s;
  }
}
const es = Symbol("linkClicked");
function kf(e) {
  let {
    onPress: t,
    onPressChange: n,
    onPressStart: r,
    onPressEnd: a,
    onPressUp: o,
    isDisabled: i,
    isPressed: u,
    preventFocusOnPress: l,
    shouldCancelOnPointerExit: s,
    allowTextSelectionOnPress: c,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: f,
    ...p
  } = N3(e), [d, g] = re(!1), b = q({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: v, removeAllGlobalListeners: C } = Rf(), h = Ge((y, F) => {
    let T = b.current;
    if (i || T.didFirePressStart) return !1;
    let $ = !0;
    if (T.isTriggeringEvent = !0, r) {
      let R = new Vr("pressstart", F, y);
      r(R), $ = R.shouldStopPropagation;
    }
    return n && n(!0), T.isTriggeringEvent = !1, T.didFirePressStart = !0, g(!0), $;
  }), D = Ge((y, F, T = !0) => {
    let $ = b.current;
    if (!$.didFirePressStart) return !1;
    $.ignoreClickAfterPress = !0, $.didFirePressStart = !1, $.isTriggeringEvent = !0;
    let R = !0;
    if (a) {
      let P = new Vr("pressend", F, y);
      a(P), R = P.shouldStopPropagation;
    }
    if (n && n(!1), g(!1), t && T && !i) {
      let P = new Vr("press", F, y);
      t(P), R && (R = P.shouldStopPropagation);
    }
    return $.isTriggeringEvent = !1, R;
  }), x = Ge((y, F) => {
    let T = b.current;
    if (i) return !1;
    if (o) {
      T.isTriggeringEvent = !0;
      let $ = new Vr("pressup", F, y);
      return o($), T.isTriggeringEvent = !1, $.shouldStopPropagation;
    }
    return !0;
  }), _ = Ge((y) => {
    let F = b.current;
    F.isPressed && F.target && (F.isOverTarget && F.pointerType != null && D(It(F.target, y), F.pointerType, !1), F.isPressed = !1, F.isOverTarget = !1, F.activePointerId = null, F.pointerType = null, C(), c || Mr(F.target));
  }), O = Ge((y) => {
    s && _(y);
  }), L = J(() => {
    let y = b.current, F = {
      onKeyDown($) {
        if (vo($.nativeEvent, $.currentTarget) && $.currentTarget.contains($.target)) {
          var R;
          ns($.target, $.key) && $.preventDefault();
          let P = !0;
          if (!y.isPressed && !$.repeat) {
            y.target = $.currentTarget, y.isPressed = !0, P = h($, "keyboard");
            let S = $.currentTarget, V = (k) => {
              vo(k, S) && !k.repeat && S.contains(k.target) && y.target && x(It(y.target, k), "keyboard");
            };
            v(He($.currentTarget), "keyup", Ef(V, T), !0);
          }
          P && $.stopPropagation(), $.metaKey && Mn() && ((R = y.metaKeyEvents) === null || R === void 0 || R.set($.key, $.nativeEvent));
        } else $.key === "Meta" && (y.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick($) {
        if (!($ && !$.currentTarget.contains($.target)) && $ && $.button === 0 && !y.isTriggeringEvent && !sr.isOpening) {
          let R = !0;
          if (i && $.preventDefault(), !y.ignoreClickAfterPress && !y.ignoreEmulatedMouseEvents && !y.isPressed && (y.pointerType === "virtual" || ti($.nativeEvent))) {
            !i && !l && Lt($.currentTarget);
            let P = h($, "virtual"), S = x($, "virtual"), V = D($, "virtual");
            R = P && S && V;
          }
          y.ignoreEmulatedMouseEvents = !1, y.ignoreClickAfterPress = !1, R && $.stopPropagation();
        }
      }
    }, T = ($) => {
      var R;
      if (y.isPressed && y.target && vo($, y.target)) {
        var P;
        ns($.target, $.key) && $.preventDefault();
        let V = $.target;
        D(It(y.target, $), "keyboard", y.target.contains(V)), C(), $.key !== "Enter" && Zi(y.target) && y.target.contains(V) && !$[es] && ($[es] = !0, sr(y.target, $, !1)), y.isPressed = !1, (P = y.metaKeyEvents) === null || P === void 0 || P.delete($.key);
      } else if ($.key === "Meta" && (!((R = y.metaKeyEvents) === null || R === void 0) && R.size)) {
        var S;
        let V = y.metaKeyEvents;
        y.metaKeyEvents = void 0;
        for (let k of V.values()) (S = y.target) === null || S === void 0 || S.dispatchEvent(new KeyboardEvent("keyup", k));
      }
    };
    if (typeof PointerEvent < "u") {
      F.onPointerDown = (S) => {
        if (S.button !== 0 || !S.currentTarget.contains(S.target)) return;
        if (O3(S.nativeEvent)) {
          y.pointerType = "virtual";
          return;
        }
        yo(S.currentTarget) && S.preventDefault(), y.pointerType = S.pointerType;
        let V = !0;
        y.isPressed || (y.isPressed = !0, y.isOverTarget = !0, y.activePointerId = S.pointerId, y.target = S.currentTarget, !i && !l && Lt(S.currentTarget), c || Xl(y.target), V = h(S, y.pointerType), v(He(S.currentTarget), "pointermove", $, !1), v(He(S.currentTarget), "pointerup", R, !1), v(He(S.currentTarget), "pointercancel", P, !1)), V && S.stopPropagation();
      }, F.onMouseDown = (S) => {
        S.currentTarget.contains(S.target) && S.button === 0 && (yo(S.currentTarget) && S.preventDefault(), S.stopPropagation());
      }, F.onPointerUp = (S) => {
        !S.currentTarget.contains(S.target) || y.pointerType === "virtual" || S.button === 0 && _n(S, S.currentTarget) && x(S, y.pointerType || S.pointerType);
      };
      let $ = (S) => {
        S.pointerId === y.activePointerId && (y.target && _n(S, y.target) ? !y.isOverTarget && y.pointerType != null && (y.isOverTarget = !0, h(It(y.target, S), y.pointerType)) : y.target && y.isOverTarget && y.pointerType != null && (y.isOverTarget = !1, D(It(y.target, S), y.pointerType, !1), O(S)));
      }, R = (S) => {
        S.pointerId === y.activePointerId && y.isPressed && S.button === 0 && y.target && (_n(S, y.target) && y.pointerType != null ? D(It(y.target, S), y.pointerType) : y.isOverTarget && y.pointerType != null && D(It(y.target, S), y.pointerType, !1), y.isPressed = !1, y.isOverTarget = !1, y.activePointerId = null, y.pointerType = null, C(), c || Mr(y.target));
      }, P = (S) => {
        _(S);
      };
      F.onDragStart = (S) => {
        S.currentTarget.contains(S.target) && _(S);
      };
    } else {
      F.onMouseDown = (P) => {
        if (P.button !== 0 || !P.currentTarget.contains(P.target)) return;
        if (yo(P.currentTarget) && P.preventDefault(), y.ignoreEmulatedMouseEvents) {
          P.stopPropagation();
          return;
        }
        y.isPressed = !0, y.isOverTarget = !0, y.target = P.currentTarget, y.pointerType = ti(P.nativeEvent) ? "virtual" : "mouse", !i && !l && Lt(P.currentTarget), h(P, y.pointerType) && P.stopPropagation(), v(He(P.currentTarget), "mouseup", $, !1);
      }, F.onMouseEnter = (P) => {
        if (!P.currentTarget.contains(P.target)) return;
        let S = !0;
        y.isPressed && !y.ignoreEmulatedMouseEvents && y.pointerType != null && (y.isOverTarget = !0, S = h(P, y.pointerType)), S && P.stopPropagation();
      }, F.onMouseLeave = (P) => {
        if (!P.currentTarget.contains(P.target)) return;
        let S = !0;
        y.isPressed && !y.ignoreEmulatedMouseEvents && y.pointerType != null && (y.isOverTarget = !1, S = D(P, y.pointerType, !1), O(P)), S && P.stopPropagation();
      }, F.onMouseUp = (P) => {
        P.currentTarget.contains(P.target) && !y.ignoreEmulatedMouseEvents && P.button === 0 && x(P, y.pointerType || "mouse");
      };
      let $ = (P) => {
        if (P.button === 0) {
          if (y.isPressed = !1, C(), y.ignoreEmulatedMouseEvents) {
            y.ignoreEmulatedMouseEvents = !1;
            return;
          }
          y.target && _n(P, y.target) && y.pointerType != null ? D(It(y.target, P), y.pointerType) : y.target && y.isOverTarget && y.pointerType != null && D(It(y.target, P), y.pointerType, !1), y.isOverTarget = !1;
        }
      };
      F.onTouchStart = (P) => {
        if (!P.currentTarget.contains(P.target)) return;
        let S = j3(P.nativeEvent);
        if (!S) return;
        y.activePointerId = S.identifier, y.ignoreEmulatedMouseEvents = !0, y.isOverTarget = !0, y.isPressed = !0, y.target = P.currentTarget, y.pointerType = "touch", !i && !l && Lt(P.currentTarget), c || Xl(y.target), h(Bt(y.target, P), y.pointerType) && P.stopPropagation(), v(mn(P.currentTarget), "scroll", R, !0);
      }, F.onTouchMove = (P) => {
        if (!P.currentTarget.contains(P.target)) return;
        if (!y.isPressed) {
          P.stopPropagation();
          return;
        }
        let S = ts(P.nativeEvent, y.activePointerId), V = !0;
        S && _n(S, P.currentTarget) ? !y.isOverTarget && y.pointerType != null && (y.isOverTarget = !0, V = h(Bt(y.target, P), y.pointerType)) : y.isOverTarget && y.pointerType != null && (y.isOverTarget = !1, V = D(Bt(y.target, P), y.pointerType, !1), O(Bt(y.target, P))), V && P.stopPropagation();
      }, F.onTouchEnd = (P) => {
        if (!P.currentTarget.contains(P.target)) return;
        if (!y.isPressed) {
          P.stopPropagation();
          return;
        }
        let S = ts(P.nativeEvent, y.activePointerId), V = !0;
        S && _n(S, P.currentTarget) && y.pointerType != null ? (x(Bt(y.target, P), y.pointerType), V = D(Bt(y.target, P), y.pointerType)) : y.isOverTarget && y.pointerType != null && (V = D(Bt(y.target, P), y.pointerType, !1)), V && P.stopPropagation(), y.isPressed = !1, y.activePointerId = null, y.isOverTarget = !1, y.ignoreEmulatedMouseEvents = !0, y.target && !c && Mr(y.target), C();
      }, F.onTouchCancel = (P) => {
        P.currentTarget.contains(P.target) && (P.stopPropagation(), y.isPressed && _(Bt(y.target, P)));
      };
      let R = (P) => {
        y.isPressed && P.target.contains(y.target) && _({
          currentTarget: y.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      F.onDragStart = (P) => {
        P.currentTarget.contains(P.target) && _(P);
      };
    }
    return F;
  }, [
    v,
    i,
    l,
    C,
    c,
    _,
    O,
    D,
    h,
    x
  ]);
  return te(() => () => {
    var y;
    c || Mr((y = b.current.target) !== null && y !== void 0 ? y : void 0);
  }, [
    c
  ]), {
    isPressed: u || d,
    pressProps: Me(p, L)
  };
}
function Zi(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function vo(e, t) {
  const { key: n, code: r } = e, a = t, o = a.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(a instanceof mn(a).HTMLInputElement && !Vf(a, n) || a instanceof mn(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((o === "link" || !o && Zi(a)) && n !== "Enter");
}
function j3(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function ts(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const a = n[r];
    if (a.identifier === t) return a;
  }
  return null;
}
function Bt(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function It(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function L3(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function H3(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function _n(e, t) {
  let n = t.getBoundingClientRect(), r = L3(e);
  return H3(n, r);
}
function yo(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function ns(e, t) {
  return e instanceof HTMLInputElement ? !Vf(e, t) : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Zi(e);
}
const K3 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Vf(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : K3.has(e.type);
}
class z3 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, n) {
    this.nativeEvent = n, this.target = n.target, this.currentTarget = n.currentTarget, this.relatedTarget = n.relatedTarget, this.bubbles = n.bubbles, this.cancelable = n.cancelable, this.defaultPrevented = n.defaultPrevented, this.eventPhase = n.eventPhase, this.isTrusted = n.isTrusted, this.timeStamp = n.timeStamp, this.type = t;
  }
}
function Nf(e) {
  let t = q({
    isFocused: !1,
    observer: null
  });
  st(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = Ge((r) => {
    e == null || e(r);
  });
  return ae((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = r.target, o = (i) => {
        t.current.isFocused = !1, a.disabled && n(new z3("blur", i)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", o, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var i;
          (i = t.current.observer) === null || i === void 0 || i.disconnect();
          let u = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: u
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: u
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
function U3(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: a } = e;
  const o = ae((l) => {
    if (l.target === l.currentTarget)
      return r && r(l), a && a(!1), !0;
  }, [
    r,
    a
  ]), i = Nf(o), u = ae((l) => {
    const s = He(l.target);
    l.target === l.currentTarget && s.activeElement === l.target && (n && n(l), a && a(!0), i(l));
  }, [
    a,
    n,
    i
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || a || r) ? u : void 0,
      onBlur: !t && (r || a) ? o : void 0
    }
  };
}
let gn = null, W3 = /* @__PURE__ */ new Set(), tr = /* @__PURE__ */ new Map(), pn = !1, ri = !1;
function Ma(e, t) {
  for (let n of W3) n(e, t);
}
function G3(e) {
  return !(e.metaKey || !Mn() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function fa(e) {
  pn = !0, G3(e) && (gn = "keyboard", Ma("keyboard", e));
}
function ot(e) {
  gn = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (pn = !0, Ma("pointer", e));
}
function jf(e) {
  ti(e) && (pn = !0, gn = "virtual");
}
function Lf(e) {
  e.target === window || e.target === document || (!pn && !ri && (gn = "virtual", Ma("virtual", e)), pn = !1, ri = !1);
}
function Hf() {
  pn = !1, ri = !0;
}
function rs(e) {
  if (typeof window > "u" || tr.get(mn(e))) return;
  const t = mn(e), n = He(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    pn = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", fa, !0), n.addEventListener("keyup", fa, !0), n.addEventListener("click", jf, !0), t.addEventListener("focus", Lf, !0), t.addEventListener("blur", Hf, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", ot, !0), n.addEventListener("pointermove", ot, !0), n.addEventListener("pointerup", ot, !0)) : (n.addEventListener("mousedown", ot, !0), n.addEventListener("mousemove", ot, !0), n.addEventListener("mouseup", ot, !0)), t.addEventListener("beforeunload", () => {
    Kf(e);
  }, {
    once: !0
  }), tr.set(t, {
    focus: r
  });
}
const Kf = (e, t) => {
  const n = mn(e), r = He(e);
  t && r.removeEventListener("DOMContentLoaded", t), tr.has(n) && (n.HTMLElement.prototype.focus = tr.get(n).focus, r.removeEventListener("keydown", fa, !0), r.removeEventListener("keyup", fa, !0), r.removeEventListener("click", jf, !0), n.removeEventListener("focus", Lf, !0), n.removeEventListener("blur", Hf, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", ot, !0), r.removeEventListener("pointermove", ot, !0), r.removeEventListener("pointerup", ot, !0)) : (r.removeEventListener("mousedown", ot, !0), r.removeEventListener("mousemove", ot, !0), r.removeEventListener("mouseup", ot, !0)), tr.delete(n));
};
function Y3(e) {
  const t = He(e);
  let n;
  return t.readyState !== "loading" ? rs(e) : (n = () => {
    rs(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => Kf(e, n);
}
typeof document < "u" && Y3();
function q3() {
  return gn !== "pointer";
}
function Ji() {
  return gn;
}
function Z3(e) {
  gn = e, Ma(e, null);
}
function Xi(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = e, o = q({
    isFocusWithin: !1
  }), i = ae((s) => {
    o.current.isFocusWithin && !s.currentTarget.contains(s.relatedTarget) && (o.current.isFocusWithin = !1, n && n(s), a && a(!1));
  }, [
    n,
    a,
    o
  ]), u = Nf(i), l = ae((s) => {
    !o.current.isFocusWithin && document.activeElement === s.target && (r && r(s), a && a(!0), o.current.isFocusWithin = !0, u(s));
  }, [
    r,
    a,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: l,
      onBlur: i
    }
  };
}
let ma = !1, bo = 0;
function ai() {
  ma = !0, setTimeout(() => {
    ma = !1;
  }, 50);
}
function as(e) {
  e.pointerType === "touch" && ai();
}
function J3() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", as) : document.addEventListener("touchend", ai), bo++, () => {
      bo--, !(bo > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", as) : document.removeEventListener("touchend", ai));
    };
}
function zf(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: a } = e, [o, i] = re(!1), u = q({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  te(J3, []);
  let { hoverProps: l, triggerHoverEnd: s } = J(() => {
    let c = (d, g) => {
      if (u.pointerType = g, a || g === "touch" || u.isHovered || !d.currentTarget.contains(d.target)) return;
      u.isHovered = !0;
      let b = d.currentTarget;
      u.target = b, t && t({
        type: "hoverstart",
        target: b,
        pointerType: g
      }), n && n(!0), i(!0);
    }, f = (d, g) => {
      if (u.pointerType = "", u.target = null, g === "touch" || !u.isHovered) return;
      u.isHovered = !1;
      let b = d.currentTarget;
      r && r({
        type: "hoverend",
        target: b,
        pointerType: g
      }), n && n(!1), i(!1);
    }, p = {};
    return typeof PointerEvent < "u" ? (p.onPointerEnter = (d) => {
      ma && d.pointerType === "mouse" || c(d, d.pointerType);
    }, p.onPointerLeave = (d) => {
      !a && d.currentTarget.contains(d.target) && f(d, d.pointerType);
    }) : (p.onTouchStart = () => {
      u.ignoreEmulatedMouseEvents = !0;
    }, p.onMouseEnter = (d) => {
      !u.ignoreEmulatedMouseEvents && !ma && c(d, "mouse"), u.ignoreEmulatedMouseEvents = !1;
    }, p.onMouseLeave = (d) => {
      !a && d.currentTarget.contains(d.target) && f(d, "mouse");
    }), {
      hoverProps: p,
      triggerHoverEnd: f
    };
  }, [
    t,
    n,
    r,
    a,
    u
  ]);
  return te(() => {
    a && s({
      currentTarget: u.target
    }, u.pointerType);
  }, [
    a
  ]), {
    hoverProps: l,
    isHovered: o
  };
}
function os(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function X3(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: os(e.onKeyDown),
      onKeyUp: os(e.onKeyUp)
    }
  };
}
function Uf(e) {
  const t = He(e);
  if (Ji() === "virtual") {
    let n = t.activeElement;
    Pf(() => {
      t.activeElement === n && e.isConnected && Lt(e);
    });
  } else Lt(e);
}
function Q3(e) {
  const t = mn(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: n, visibility: r } = e.style, a = n !== "none" && r !== "hidden" && r !== "collapse";
  if (a) {
    const { getComputedStyle: o } = e.ownerDocument.defaultView;
    let { display: i, visibility: u } = o(e);
    a = i !== "none" && u !== "hidden" && u !== "collapse";
  }
  return a;
}
function ey(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function Wf(e, t) {
  return e.nodeName !== "#comment" && Q3(e) && ey(e, t) && (!e.parentElement || Wf(e.parentElement, e));
}
const Qi = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], ty = Qi.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
Qi.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const ny = Qi.join(':not([hidden]):not([tabindex="-1"]),');
function Gf(e, t) {
  return !e || !t ? !1 : t.some((n) => n.contains(e));
}
function Yn(e, t = !1) {
  if (e != null && !t) try {
    Uf(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function Jn(e, t, n) {
  let r = t != null && t.tabbable ? ny : ty, a = He(e).createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode(o) {
      var i;
      return !(t == null || (i = t.from) === null || i === void 0) && i.contains(o) ? NodeFilter.FILTER_REJECT : o.matches(r) && Wf(o) && (!n || Gf(o, n)) && (!(t != null && t.accept) || t.accept(o)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t != null && t.from && (a.currentNode = t.from), a;
}
function ka(e, t = {}) {
  return {
    focusNext(n = {}) {
      let r = e.current;
      if (!r) return null;
      let { from: a, tabbable: o = t.tabbable, wrap: i = t.wrap, accept: u = t.accept } = n, l = a || He(r).activeElement, s = Jn(r, {
        tabbable: o,
        accept: u
      });
      r.contains(l) && (s.currentNode = l);
      let c = s.nextNode();
      return !c && i && (s.currentNode = r, c = s.nextNode()), c && Yn(c, !0), c;
    },
    focusPrevious(n = t) {
      let r = e.current;
      if (!r) return null;
      let { from: a, tabbable: o = t.tabbable, wrap: i = t.wrap, accept: u = t.accept } = n, l = a || He(r).activeElement, s = Jn(r, {
        tabbable: o,
        accept: u
      });
      if (r.contains(l)) s.currentNode = l;
      else {
        let f = Do(s);
        return f && Yn(f, !0), f ?? null;
      }
      let c = s.previousNode();
      if (!c && i) {
        s.currentNode = r;
        let f = Do(s);
        if (!f)
          return null;
        c = f;
      }
      return c && Yn(c, !0), c ?? null;
    },
    focusFirst(n = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: a = t.tabbable, accept: o = t.accept } = n, u = Jn(r, {
        tabbable: a,
        accept: o
      }).nextNode();
      return u && Yn(u, !0), u;
    },
    focusLast(n = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: a = t.tabbable, accept: o = t.accept } = n, i = Jn(r, {
        tabbable: a,
        accept: o
      }), u = Do(i);
      return u && Yn(u, !0), u ?? null;
    }
  };
}
function Do(e) {
  let t, n;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
class eu {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let a = this.fastMap.get(n ?? null);
    if (!a) return;
    let o = new is({
      scopeRef: t
    });
    a.addChild(o), o.parent = a, this.fastMap.set(t, o), r && (o.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let n = this.fastMap.get(t);
    if (!n) return;
    let r = n.parent;
    for (let o of this.traverse()) o !== n && n.nodeToRestore && o.nodeToRestore && n.scopeRef && n.scopeRef.current && Gf(o.nodeToRestore, n.scopeRef.current) && (o.nodeToRestore = n.nodeToRestore);
    let a = n.children;
    r && (r.removeChild(n), a.size > 0 && a.forEach((o) => r && r.addChild(o))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let n of t.children) yield* this.traverse(n);
  }
  clone() {
    var t;
    let n = new eu();
    var r;
    for (let a of this.traverse()) n.addTreeNode(a.scopeRef, (r = (t = a.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && r !== void 0 ? r : null, a.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new is({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class is {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
new eu();
let ry = /* @__PURE__ */ fe.createContext(null);
function ay(e) {
  let t = yt(ry) || {};
  Ff(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function oy(e, t) {
  let { focusProps: n } = U3(e), { keyboardProps: r } = X3(e), a = Me(n, r), o = ay(t), i = e.isDisabled ? {} : o, u = q(e.autoFocus);
  return te(() => {
    u.current && t.current && Uf(t.current), u.current = !1;
  }, [
    t
  ]), {
    focusableProps: Me({
      ...a,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, i)
  };
}
const iy = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), uy = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Yf(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return iy.has(n.script);
  }
  let t = e.split("-")[0];
  return uy.has(t);
}
const ly = Symbol.for("react-aria.i18n.locale");
function qf() {
  let e = typeof window < "u" && window[ly] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Yf(e) ? "rtl" : "ltr"
  };
}
let oi = qf(), Xn = /* @__PURE__ */ new Set();
function us() {
  oi = qf();
  for (let e of Xn) e(oi);
}
function Zf() {
  let e = xf(), [t, n] = re(oi);
  return te(() => (Xn.size === 0 && window.addEventListener("languagechange", us), Xn.add(n), () => {
    Xn.delete(n), Xn.size === 0 && window.removeEventListener("languagechange", us);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const Jf = /* @__PURE__ */ fe.createContext(null);
function sy(e) {
  let { locale: t, children: n } = e, r = Zf(), a = fe.useMemo(() => t ? {
    locale: t,
    direction: Yf(t) ? "rtl" : "ltr"
  } : r, [
    r,
    t
  ]);
  return /* @__PURE__ */ fe.createElement(Jf.Provider, {
    value: a
  }, n);
}
function Ze() {
  let e = Zf();
  return yt(Jf) || e;
}
var kn = function() {
  return kn = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, kn.apply(this, arguments);
};
const ls = /* @__PURE__ */ new WeakMap();
function cy(e) {
  let t = ls.get(e);
  return t || (t = new zt(e), ls.set(e, t)), t;
}
function Xf(e, t) {
  return t && zt.getGlobalDictionaryForPackage(t) || cy(e);
}
function Wt(e, t) {
  let { locale: n } = Ze(), r = Xf(e, t);
  return J(() => new Md(n, r), [
    n,
    r
  ]);
}
function lt(e) {
  e = Of(e ?? {}, dy);
  let { locale: t } = Ze();
  return J(() => new ut(t, e), [
    t,
    e
  ]);
}
function dy(e, t) {
  if (e === t) return !0;
  let n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let a of n)
    if (t[a] !== e[a]) return !1;
  return !0;
}
let _o = /* @__PURE__ */ new Map(), ii = !1;
try {
  ii = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let pa = !1;
try {
  pa = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Qf = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class fy {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let n = "";
    if (!ii && this.options.signDisplay != null ? n = py(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !pa) {
      var r;
      let { unit: a, unitDisplay: o = "short", locale: i } = this.resolvedOptions();
      if (!a) return n;
      let u = (r = Qf[a]) === null || r === void 0 ? void 0 : r[o];
      n += u[i] || u.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function")
      return this.numberFormatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function")
      return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), a = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((o) => ({
        ...o,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((o) => ({
        ...o,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !ii && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !pa && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, n = {}) {
    this.numberFormatter = my(t, n), this.options = n;
  }
}
function my(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !pa) {
    var r;
    let { unit: i, unitDisplay: u = "short" } = t;
    if (!i) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = Qf[i]) === null || r === void 0) && r[u])) throw new Error(`Unsupported unit ${i} with unitDisplay = ${u}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let a = e + (t ? Object.entries(t).sort((i, u) => i[0] < u[0] ? -1 : 1).join() : "");
  if (_o.has(a)) return _o.get(a);
  let o = new Intl.NumberFormat(e, t);
  return _o.set(a, o), o;
}
function py(e, t, n) {
  if (t === "auto") return e.format(n);
  if (t === "never") return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let a = e.format(-n), o = e.format(n), i = a.replace(o, "").replace(/\u200e|\u061C/, "");
      return [
        ...i
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), a.replace(o, "!!!").replace(i, "+").replace("!!!", o);
    } else return e.format(n);
  }
}
const gy = new RegExp("^.*\\(.*\\).*$"), hy = [
  "latn",
  "arab",
  "hanidec"
];
class em {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(t) {
    return $o(this.locale, this.options, t).parse(t);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(t, n, r) {
    return $o(this.locale, this.options, t).isValidPartialNumber(t, n, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(t) {
    return $o(this.locale, this.options, t).options.numberingSystem;
  }
  constructor(t, n = {}) {
    this.locale = t, this.options = n;
  }
}
const ss = /* @__PURE__ */ new Map();
function $o(e, t, n) {
  let r = cs(e, t);
  if (!e.includes("-nu-") && !r.isValidPartialNumber(n)) {
    for (let a of hy) if (a !== r.options.numberingSystem) {
      let o = cs(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + a, t);
      if (o.isValidPartialNumber(n)) return o;
    }
  }
  return r;
}
function cs(e, t) {
  let n = e + (t ? Object.entries(t).sort((a, o) => a[0] < o[0] ? -1 : 1).join() : ""), r = ss.get(n);
  return r || (r = new vy(e, t), ss.set(n, r)), r;
}
class vy {
  parse(t) {
    let n = this.sanitize(t);
    if (this.symbols.group && (n = Nr(n, this.symbols.group, "")), this.symbols.decimal && (n = n.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (n = n.replace(this.symbols.minusSign, "-")), n = n.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let i = n.indexOf("-");
      n = n.replace("-", "");
      let u = n.indexOf(".");
      u === -1 && (u = n.length), n = n.replace(".", ""), u - 2 === 0 ? n = `0.${n}` : u - 2 === -1 ? n = `0.0${n}` : u - 2 === -2 ? n = "0.00" : n = `${n.slice(0, u - 2)}.${n.slice(u - 2)}`, i > -1 && (n = `-${n}`);
    }
    let r = n ? +n : NaN;
    if (isNaN(r)) return NaN;
    if (this.options.style === "percent") {
      var a, o;
      let i = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(((a = this.options.minimumFractionDigits) !== null && a !== void 0 ? a : 0) + 2, 20),
        maximumFractionDigits: Math.min(((o = this.options.maximumFractionDigits) !== null && o !== void 0 ? o : 0) + 2, 20)
      };
      return new em(this.locale, i).parse(new fy(this.locale, i).format(r));
    }
    return this.options.currencySign === "accounting" && gy.test(t) && (r = -1 * r), r;
  }
  sanitize(t) {
    return t = t.replace(this.symbols.literals, ""), this.symbols.minusSign && (t = t.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (t = t.replace(",", this.symbols.decimal), t = t.replace("،", this.symbols.decimal)), this.symbols.group && (t = Nr(t, ".", this.symbols.group))), this.options.locale === "fr-FR" && (t = Nr(t, ".", " ")), t;
  }
  isValidPartialNumber(t, n = -1 / 0, r = 1 / 0) {
    return t = this.sanitize(t), this.symbols.minusSign && t.startsWith(this.symbols.minusSign) && n < 0 ? t = t.slice(this.symbols.minusSign.length) : this.symbols.plusSign && t.startsWith(this.symbols.plusSign) && r > 0 && (t = t.slice(this.symbols.plusSign.length)), this.symbols.group && t.startsWith(this.symbols.group) || this.symbols.decimal && t.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && (t = Nr(t, this.symbols.group, "")), t = t.replace(this.symbols.numeral, ""), this.symbols.decimal && (t = t.replace(this.symbols.decimal, "")), t.length === 0);
  }
  constructor(t, n = {}) {
    this.locale = t, this.formatter = new Intl.NumberFormat(t, n), this.options = this.formatter.resolvedOptions(), this.symbols = by(t, this.formatter, this.options, n);
    var r, a;
    this.options.style === "percent" && (((r = this.options.minimumFractionDigits) !== null && r !== void 0 ? r : 0) > 18 || ((a = this.options.maximumFractionDigits) !== null && a !== void 0 ? a : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const ds = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), yy = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function by(e, t, n, r) {
  var a, o, i, u;
  let l = new Intl.NumberFormat(e, {
    ...n,
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21
  }), s = l.formatToParts(-10000.111), c = l.formatToParts(10000.111), f = yy.map((T) => l.formatToParts(T));
  var p;
  let d = (p = (a = s.find((T) => T.type === "minusSign")) === null || a === void 0 ? void 0 : a.value) !== null && p !== void 0 ? p : "-", g = (o = c.find((T) => T.type === "plusSign")) === null || o === void 0 ? void 0 : o.value;
  !g && ((r == null ? void 0 : r.signDisplay) === "exceptZero" || (r == null ? void 0 : r.signDisplay) === "always") && (g = "+");
  let v = (i = new Intl.NumberFormat(e, {
    ...n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((T) => T.type === "decimal")) === null || i === void 0 ? void 0 : i.value, C = (u = s.find((T) => T.type === "group")) === null || u === void 0 ? void 0 : u.value, h = s.filter((T) => !ds.has(T.type)).map((T) => fs(T.value)), D = f.flatMap((T) => T.filter(($) => !ds.has($.type)).map(($) => fs($.value))), x = [
    .../* @__PURE__ */ new Set([
      ...h,
      ...D
    ])
  ].sort((T, $) => $.length - T.length), _ = x.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${x.join("|")}|[\\p{White_Space}]`, "gu"), O = [
    ...new Intl.NumberFormat(n.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), L = new Map(O.map((T, $) => [
    T,
    $
  ])), y = new RegExp(`[${O.join("")}]`, "g");
  return {
    minusSign: d,
    plusSign: g,
    decimal: v,
    group: C,
    literals: _,
    numeral: y,
    index: (T) => String(L.get(T))
  };
}
function Nr(e, t, n) {
  return e.replaceAll ? e.replaceAll(t, n) : e.split(t).join(n);
}
function fs(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
let xo = /* @__PURE__ */ new Map();
function Dy(e) {
  let { locale: t } = Ze(), n = t + (e ? Object.entries(e).sort((a, o) => a[0] < o[0] ? -1 : 1).join() : "");
  if (xo.has(n)) return xo.get(n);
  let r = new Intl.Collator(t, e);
  return xo.set(n, r), r;
}
function _y(e) {
  let t = Dy({
    usage: "search",
    ...e
  }), n = ae((o, i) => i.length === 0 ? !0 : (o = o.normalize("NFC"), i = i.normalize("NFC"), t.compare(o.slice(0, i.length), i) === 0), [
    t
  ]), r = ae((o, i) => i.length === 0 ? !0 : (o = o.normalize("NFC"), i = i.normalize("NFC"), t.compare(o.slice(-i.length), i) === 0), [
    t
  ]), a = ae((o, i) => {
    if (i.length === 0) return !0;
    o = o.normalize("NFC"), i = i.normalize("NFC");
    let u = 0, l = i.length;
    for (; u + l <= o.length; u++) {
      let s = o.slice(u, u + l);
      if (t.compare(i, s) === 0) return !0;
    }
    return !1;
  }, [
    t
  ]);
  return J(() => ({
    startsWith: n,
    endsWith: r,
    contains: a
  }), [
    n,
    r,
    a
  ]);
}
function tu(e, t, n) {
  let { direction: r } = Ze(), a = J(() => ka(t), [
    t
  ]), o = (l) => {
    if (l.currentTarget.contains(l.target) && (l.altKey && (l.key === "ArrowDown" || l.key === "ArrowUp") && "setOpen" in e && (l.preventDefault(), l.stopPropagation(), e.setOpen(!0)), !n))
      switch (l.key) {
        case "ArrowLeft":
          l.preventDefault(), l.stopPropagation(), r === "rtl" ? a.focusNext() : a.focusPrevious();
          break;
        case "ArrowRight":
          l.preventDefault(), l.stopPropagation(), r === "rtl" ? a.focusPrevious() : a.focusNext();
          break;
      }
  }, i = () => {
    var l;
    let s = (l = window.event) === null || l === void 0 ? void 0 : l.target, c = Jn(t.current, {
      tabbable: !0
    });
    if (s && (c.currentNode = s, s = c.previousNode()), !s) {
      let f;
      do
        f = c.lastChild(), f && (s = f);
      while (f);
    }
    for (; s != null && s.hasAttribute("data-placeholder"); ) {
      let f = c.previousNode();
      if (f && f.hasAttribute("data-placeholder")) s = f;
      else break;
    }
    s && s.focus();
  }, { pressProps: u } = kf({
    preventFocusOnPress: !0,
    allowTextSelectionOnPress: !0,
    onPressStart(l) {
      l.pointerType === "mouse" && i();
    },
    onPress(l) {
      l.pointerType !== "mouse" && i();
    }
  });
  return Me(u, {
    onKeyDown: o
  });
}
function $y(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": a, labelElementType: o = "label" } = e;
  t = vt(t);
  let i = vt(), u = {};
  n ? (r = r ? `${i} ${r}` : i, u = {
    id: i,
    htmlFor: o === "label" ? t : void 0
  }) : !r && !a && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let l = Oa({
    id: t,
    "aria-label": a,
    "aria-labelledby": r
  });
  return {
    labelProps: u,
    fieldProps: l
  };
}
function nu(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: a } = e, { labelProps: o, fieldProps: i } = $y(e), u = Xo([
    !!t,
    !!n,
    r,
    a
  ]), l = Xo([
    !!t,
    !!n,
    r,
    a
  ]);
  return i = Me(i, {
    "aria-describedby": [
      u,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      l,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: o,
    fieldProps: i,
    descriptionProps: {
      id: u
    },
    errorMessageProps: {
      id: l
    }
  };
}
function xy(e, t, n) {
  let { validationBehavior: r, focus: a } = e;
  st(() => {
    if (r === "native" && (n != null && n.current)) {
      let l = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(l), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(Cy(n.current));
    }
  });
  let o = Ge(() => {
    t.resetValidation();
  }), i = Ge((l) => {
    var s;
    t.displayValidation.isInvalid || t.commitValidation();
    let c = n == null || (s = n.current) === null || s === void 0 ? void 0 : s.form;
    if (!l.defaultPrevented && n && c && wy(c) === n.current) {
      var f;
      a ? a() : (f = n.current) === null || f === void 0 || f.focus(), Z3("keyboard");
    }
    l.preventDefault();
  }), u = Ge(() => {
    t.commitValidation();
  });
  te(() => {
    let l = n == null ? void 0 : n.current;
    if (!l) return;
    let s = l.form;
    return l.addEventListener("invalid", i), l.addEventListener("change", u), s == null || s.addEventListener("reset", o), () => {
      l.removeEventListener("invalid", i), l.removeEventListener("change", u), s == null || s.removeEventListener("reset", o);
    };
  }, [
    n,
    i,
    u,
    o,
    r
  ]);
}
function Ey(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function Cy(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: Ey(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function wy(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (!n.validity.valid) return n;
  }
  return null;
}
function Sy(e) {
  return e && e.__esModule ? e.default : e;
}
const tm = /* @__PURE__ */ new WeakMap(), nr = "__role_" + Date.now(), nm = "__focusManager_" + Date.now();
function Iy(e, t, n) {
  var r;
  let { isInvalid: a, validationErrors: o, validationDetails: i } = t.displayValidation, { labelProps: u, fieldProps: l, descriptionProps: s, errorMessageProps: c } = nu({
    ...e,
    labelElementType: "span",
    isInvalid: a,
    errorMessage: e.errorMessage || o
  }), f = q(null), { focusWithinProps: p } = Xi({
    ...e,
    onFocusWithin(T) {
      var $;
      f.current = t.value, ($ = e.onFocus) === null || $ === void 0 || $.call(e, T);
    },
    onBlurWithin: (T) => {
      var $;
      t.confirmPlaceholder(), t.value !== f.current && t.commitValidation(), ($ = e.onBlur) === null || $ === void 0 || $.call(e, T);
    },
    onFocusWithinChange: e.onFocusChange
  }), d = Wt(Sy(Dr), "@react-aria/datepicker"), g = t.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription", b = t.maxGranularity === "hour" ? "time" : "date", v = t.value ? d.format(g, {
    [b]: t.formatValue({
      month: "long"
    })
  }) : "", C = Ba(v), h = e[nr] === "presentation" ? l["aria-describedby"] : [
    C["aria-describedby"],
    l["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, D = e[nm], x = J(() => D || ka(n), [
    D,
    n
  ]), _ = tu(t, n, e[nr] === "presentation");
  tm.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: [
      u.id,
      e["aria-labelledby"]
    ].filter(Boolean).join(" ") || void 0,
    ariaDescribedBy: h,
    focusManager: x
  });
  let O = q(e.autoFocus), L;
  e[nr] === "presentation" ? L = {
    role: "presentation"
  } : L = Me(l, {
    role: "group",
    "aria-disabled": e.isDisabled || void 0,
    "aria-describedby": h
  }), te(() => {
    O.current && x.focusFirst(), O.current = !1;
  }, [
    x
  ]), B3(e.inputRef, t.value, t.setValue), xy({
    ...e,
    focus() {
      x.focusFirst();
    }
  }, t, e.inputRef);
  let y = {
    type: "hidden",
    name: e.name,
    value: ((r = t.value) === null || r === void 0 ? void 0 : r.toString()) || "",
    disabled: e.isDisabled
  };
  e.validationBehavior === "native" && (y.type = "text", y.hidden = !0, y.required = e.isRequired, y.onChange = () => {
  });
  let F = _r(e);
  return {
    labelProps: {
      ...u,
      onClick: () => {
        x.focusFirst();
      }
    },
    fieldProps: Me(F, L, _, p, {
      onKeyDown(T) {
        e.onKeyDown && e.onKeyDown(T);
      },
      onKeyUp(T) {
        e.onKeyUp && e.onKeyUp(T);
      }
    }),
    inputProps: y,
    descriptionProps: s,
    errorMessageProps: c,
    isInvalid: a,
    validationErrors: o,
    validationDetails: i
  };
}
function Py(e) {
  return e && e.__esModule ? e.default : e;
}
function Ry(e, t, n) {
  let r = vt(), a = vt(), o = vt(), i = Wt(Py(Dr), "@react-aria/datepicker"), { isInvalid: u, validationErrors: l, validationDetails: s } = t.displayValidation, { labelProps: c, fieldProps: f, descriptionProps: p, errorMessageProps: d } = nu({
    ...e,
    labelElementType: "span",
    isInvalid: u,
    errorMessage: e.errorMessage || l
  }), g = tu(t, n), b = f["aria-labelledby"] || f.id, { locale: v } = Ze(), C = t.formatValue(v, {
    month: "long"
  }), h = C ? i.format("selectedDateDescription", {
    date: C
  }) : "", D = Ba(h), x = [
    D["aria-describedby"],
    f["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, _ = _r(e), O = J(() => ka(n), [
    n
  ]), { focusWithinProps: L } = Xi({
    ...e,
    isDisabled: t.isOpen,
    onBlurWithin: e.onBlur,
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  });
  return {
    groupProps: Me(_, g, f, D, L, {
      role: "group",
      "aria-disabled": e.isDisabled || null,
      "aria-labelledby": b,
      "aria-describedby": x,
      onKeyDown(y) {
        t.isOpen || e.onKeyDown && e.onKeyDown(y);
      },
      onKeyUp(y) {
        t.isOpen || e.onKeyUp && e.onKeyUp(y);
      }
    }),
    labelProps: {
      ...c,
      onClick: () => {
        O.focusFirst();
      }
    },
    fieldProps: {
      ...f,
      id: o,
      [nr]: "presentation",
      "aria-describedby": x,
      value: t.value,
      onChange: t.setValue,
      placeholderValue: e.placeholderValue,
      hideTimeZone: e.hideTimeZone,
      hourCycle: e.hourCycle,
      shouldForceLeadingZeros: e.shouldForceLeadingZeros,
      granularity: e.granularity,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isRequired: e.isRequired,
      validationBehavior: e.validationBehavior,
      // DatePicker owns the validation state for the date field.
      [lr]: t,
      autoFocus: e.autoFocus,
      name: e.name
    },
    descriptionProps: p,
    errorMessageProps: d,
    buttonProps: {
      ...D,
      id: r,
      "aria-haspopup": "dialog",
      "aria-label": i.format("calendar"),
      "aria-labelledby": `${r} ${b}`,
      "aria-describedby": x,
      "aria-expanded": t.isOpen,
      isDisabled: e.isDisabled || e.isReadOnly,
      onPress: () => t.setOpen(!0)
    },
    dialogProps: {
      id: a,
      "aria-labelledby": `${r} ${b}`
    },
    calendarProps: {
      autoFocus: !0,
      value: t.dateValue,
      onChange: t.setDateValue,
      minValue: e.minValue,
      maxValue: e.maxValue,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isDateUnavailable: e.isDateUnavailable,
      defaultFocusedValue: t.dateValue ? void 0 : e.placeholderValue,
      isInvalid: t.isInvalid,
      errorMessage: typeof e.errorMessage == "function" ? e.errorMessage(t.displayValidation) : e.errorMessage || t.displayValidation.validationErrors.join(" ")
    },
    isInvalid: u,
    validationErrors: l,
    validationDetails: s
  };
}
function Fy(e) {
  return e && e.__esModule ? e.default : e;
}
function Ay() {
  let { locale: e } = Ze(), t = Xf(Fy(Dr), "@react-aria/datepicker");
  return J(() => {
    try {
      return new Intl.DisplayNames(e, {
        type: "dateTimeField"
      });
    } catch {
      return new Ty(e, t);
    }
  }, [
    e,
    t
  ]);
}
class Ty {
  of(t) {
    return this.dictionary.getStringForLocale(t, this.locale);
  }
  constructor(t, n) {
    this.locale = t, this.dictionary = n;
  }
}
var rm = {};
rm = {
  Empty: "فارغ"
};
var am = {};
am = {
  Empty: "Изпразни"
};
var om = {};
om = {
  Empty: "Prázdné"
};
var im = {};
im = {
  Empty: "Tom"
};
var um = {};
um = {
  Empty: "Leer"
};
var lm = {};
lm = {
  Empty: "Άδειο"
};
var sm = {};
sm = {
  Empty: "Empty"
};
var cm = {};
cm = {
  Empty: "Vacío"
};
var dm = {};
dm = {
  Empty: "Tühjenda"
};
var fm = {};
fm = {
  Empty: "Tyhjä"
};
var mm = {};
mm = {
  Empty: "Vide"
};
var pm = {};
pm = {
  Empty: "ריק"
};
var gm = {};
gm = {
  Empty: "Prazno"
};
var hm = {};
hm = {
  Empty: "Üres"
};
var vm = {};
vm = {
  Empty: "Vuoto"
};
var ym = {};
ym = {
  Empty: "空"
};
var bm = {};
bm = {
  Empty: "비어 있음"
};
var Dm = {};
Dm = {
  Empty: "Tuščias"
};
var _m = {};
_m = {
  Empty: "Tukšs"
};
var $m = {};
$m = {
  Empty: "Tom"
};
var xm = {};
xm = {
  Empty: "Leeg"
};
var Em = {};
Em = {
  Empty: "Pusty"
};
var Cm = {};
Cm = {
  Empty: "Vazio"
};
var wm = {};
wm = {
  Empty: "Vazio"
};
var Sm = {};
Sm = {
  Empty: "Gol"
};
var Im = {};
Im = {
  Empty: "Не заполнено"
};
var Pm = {};
Pm = {
  Empty: "Prázdne"
};
var Rm = {};
Rm = {
  Empty: "Prazen"
};
var Fm = {};
Fm = {
  Empty: "Prazno"
};
var Am = {};
Am = {
  Empty: "Tomt"
};
var Tm = {};
Tm = {
  Empty: "Boş"
};
var Om = {};
Om = {
  Empty: "Пусто"
};
var Bm = {};
Bm = {
  Empty: "空"
};
var Mm = {};
Mm = {
  Empty: "空白"
};
var km = {};
km = {
  "ar-AE": rm,
  "bg-BG": am,
  "cs-CZ": om,
  "da-DK": im,
  "de-DE": um,
  "el-GR": lm,
  "en-US": sm,
  "es-ES": cm,
  "et-EE": dm,
  "fi-FI": fm,
  "fr-FR": mm,
  "he-IL": pm,
  "hr-HR": gm,
  "hu-HU": hm,
  "it-IT": vm,
  "ja-JP": ym,
  "ko-KR": bm,
  "lt-LT": Dm,
  "lv-LV": _m,
  "nb-NO": $m,
  "nl-NL": xm,
  "pl-PL": Em,
  "pt-BR": Cm,
  "pt-PT": wm,
  "ro-RO": Sm,
  "ru-RU": Im,
  "sk-SK": Pm,
  "sl-SI": Rm,
  "sr-SP": Fm,
  "sv-SE": Am,
  "tr-TR": Tm,
  "uk-UA": Om,
  "zh-CN": Bm,
  "zh-TW": Mm
};
const Vm = 7e3;
let rr = null;
function ui(e, t = "assertive", n = Vm) {
  rr || (rr = new By()), rr.announce(e, t, n);
}
function Oy(e) {
  rr && rr.clear(e);
}
class By {
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = Vm) {
    if (!this.node) return;
    let a = document.createElement("div");
    a.textContent = t, n === "assertive" ? this.assertiveLog.appendChild(a) : this.politeLog.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node);
  }
}
function My(e) {
  return e && e.__esModule ? e.default : e;
}
function ky(e) {
  const t = q(void 0);
  let { value: n, textValue: r, minValue: a, maxValue: o, isDisabled: i, isReadOnly: u, isRequired: l, onIncrement: s, onIncrementPage: c, onDecrement: f, onDecrementPage: p, onDecrementToMin: d, onIncrementToMax: g } = e;
  const b = Wt(My(km), "@react-aria/spinbutton"), v = () => clearTimeout(t.current);
  te(() => () => v(), []);
  let C = ($) => {
    if (!($.ctrlKey || $.metaKey || $.shiftKey || $.altKey || u))
      switch ($.key) {
        case "PageUp":
          if (c) {
            $.preventDefault(), c == null || c();
            break;
          }
        case "ArrowUp":
        case "Up":
          s && ($.preventDefault(), s == null || s());
          break;
        case "PageDown":
          if (p) {
            $.preventDefault(), p == null || p();
            break;
          }
        case "ArrowDown":
        case "Down":
          f && ($.preventDefault(), f == null || f());
          break;
        case "Home":
          d && ($.preventDefault(), d == null || d());
          break;
        case "End":
          g && ($.preventDefault(), g == null || g());
          break;
      }
  }, h = q(!1), D = () => {
    h.current = !0;
  }, x = () => {
    h.current = !1;
  }, _ = r === "" ? b.format("Empty") : (r || `${n}`).replace("-", "−");
  te(() => {
    h.current && (Oy("assertive"), ui(_, "assertive"));
  }, [
    _
  ]);
  const O = Ge(($) => {
    v(), s == null || s(), t.current = window.setTimeout(() => {
      (o === void 0 || isNaN(o) || n === void 0 || isNaN(n) || n < o) && O(60);
    }, $);
  }), L = Ge(($) => {
    v(), f == null || f(), t.current = window.setTimeout(() => {
      (a === void 0 || isNaN(a) || n === void 0 || isNaN(n) || n > a) && L(60);
    }, $);
  });
  let y = ($) => {
    $.preventDefault();
  }, { addGlobalListener: F, removeAllGlobalListeners: T } = Rf();
  return {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": n !== void 0 && !isNaN(n) ? n : void 0,
      "aria-valuetext": _,
      "aria-valuemin": a,
      "aria-valuemax": o,
      "aria-disabled": i || void 0,
      "aria-readonly": u || void 0,
      "aria-required": l || void 0,
      onKeyDown: C,
      onFocus: D,
      onBlur: x
    },
    incrementButtonProps: {
      onPressStart: () => {
        O(400), F(window, "contextmenu", y);
      },
      onPressEnd: () => {
        v(), T();
      },
      onFocus: D,
      onBlur: x
    },
    decrementButtonProps: {
      onPressStart: () => {
        L(400), F(window, "contextmenu", y);
      },
      onPressEnd: () => {
        v(), T();
      },
      onFocus: D,
      onBlur: x
    }
  };
}
function Vy(e, t, n) {
  let r = q(""), { locale: a } = Ze(), o = Ay(), { ariaLabel: i, ariaLabelledBy: u, ariaDescribedBy: l, focusManager: s } = tm.get(t), c = e.isPlaceholder ? "" : e.text, f = J(() => t.dateFormatter.resolvedOptions(), [
    t.dateFormatter
  ]), p = lt({
    month: "long",
    timeZone: f.timeZone
  }), d = lt({
    hour: "numeric",
    hour12: f.hour12,
    timeZone: f.timeZone
  });
  if (e.type === "month" && !e.isPlaceholder) {
    let A = p.format(t.dateValue);
    c = A !== c ? `${c} – ${A}` : A;
  } else e.type === "hour" && !e.isPlaceholder && (c = d.format(t.dateValue));
  let { spinButtonProps: g } = ky({
    // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
    // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
    // https://github.com/dequelabs/axe-core/issues/3505
    value: e.value,
    textValue: c,
    minValue: e.minValue,
    maxValue: e.maxValue,
    isDisabled: t.isDisabled,
    isReadOnly: t.isReadOnly || !e.isEditable,
    isRequired: t.isRequired,
    onIncrement: () => {
      r.current = "", t.increment(e.type);
    },
    onDecrement: () => {
      r.current = "", t.decrement(e.type);
    },
    onIncrementPage: () => {
      r.current = "", t.incrementPage(e.type);
    },
    onDecrementPage: () => {
      r.current = "", t.decrementPage(e.type);
    },
    onIncrementToMax: () => {
      r.current = "", t.setSegment(e.type, e.maxValue);
    },
    onDecrementToMin: () => {
      r.current = "", t.setSegment(e.type, e.minValue);
    }
  }), b = J(() => new em(a, {
    maximumFractionDigits: 0
  }), [
    a
  ]), v = () => {
    if (e.text === e.placeholder && s.focusPrevious(), b.isValidPartialNumber(e.text) && !t.isReadOnly && !e.isPlaceholder) {
      let A = e.text.slice(0, -1), K = b.parse(A);
      A = K === 0 ? "" : A, A.length === 0 || K === 0 ? t.clearSegment(e.type) : t.setSegment(e.type, K), r.current = A;
    } else e.type === "dayPeriod" && t.clearSegment(e.type);
  }, C = (A) => {
    if (A.key === "a" && (Mn() ? A.metaKey : A.ctrlKey) && A.preventDefault(), !(A.ctrlKey || A.metaKey || A.shiftKey || A.altKey))
      switch (A.key) {
        case "Backspace":
        case "Delete":
          A.preventDefault(), A.stopPropagation(), v();
          break;
      }
  }, { startsWith: h } = _y({
    sensitivity: "base"
  }), D = lt({
    hour: "numeric",
    hour12: !0
  }), x = J(() => {
    let A = /* @__PURE__ */ new Date();
    return A.setHours(0), D.formatToParts(A).find((K) => K.type === "dayPeriod").value;
  }, [
    D
  ]), _ = J(() => {
    let A = /* @__PURE__ */ new Date();
    return A.setHours(12), D.formatToParts(A).find((K) => K.type === "dayPeriod").value;
  }, [
    D
  ]), O = lt({
    year: "numeric",
    era: "narrow",
    timeZone: "UTC"
  }), L = J(() => {
    if (e.type !== "era") return [];
    let A = Ce(new Se(1, 1, 1), t.calendar), K = t.calendar.getEras().map((B) => {
      let j = A.set({
        year: 1,
        month: 1,
        day: 1,
        era: B
      }).toDate("UTC"), H = O.formatToParts(j).find((W) => W.type === "era").value;
      return {
        era: B,
        formatted: H
      };
    }), E = Ny(K.map((B) => B.formatted));
    if (E) for (let B of K) B.formatted = B.formatted.slice(E);
    return K;
  }, [
    O,
    t.calendar,
    e.type
  ]), y = (A) => {
    if (t.isDisabled || t.isReadOnly) return;
    let K = r.current + A;
    switch (e.type) {
      case "dayPeriod":
        if (h(x, A)) t.setSegment("dayPeriod", 0);
        else if (h(_, A)) t.setSegment("dayPeriod", 12);
        else break;
        s.focusNext();
        break;
      case "era": {
        let E = L.find((B) => h(B.formatted, A));
        E && (t.setSegment("era", E.era), s.focusNext());
        break;
      }
      case "day":
      case "hour":
      case "minute":
      case "second":
      case "month":
      case "year": {
        if (!b.isValidPartialNumber(K)) return;
        let E = b.parse(K), B = E, j = e.minValue === 0;
        if (e.type === "hour" && t.dateFormatter.resolvedOptions().hour12) {
          switch (t.dateFormatter.resolvedOptions().hourCycle) {
            case "h11":
              E > 11 && (B = b.parse(A));
              break;
            case "h12":
              j = !1, E > 12 && (B = b.parse(A));
              break;
          }
          e.value >= 12 && E > 1 && (E += 12);
        } else E > e.maxValue && (B = b.parse(A));
        if (isNaN(E)) return;
        let N = B !== 0 || j;
        N && t.setSegment(e.type, B), +(E + "0") > e.maxValue || K.length >= String(e.maxValue).length ? (r.current = "", N && s.focusNext()) : r.current = K;
        break;
      }
    }
  }, F = () => {
    r.current = "", Tf(n.current, {
      containingElement: Af(n.current)
    }), window.getSelection().collapse(n.current);
  }, T = q(typeof document < "u" ? document : null);
  Pn(T, "selectionchange", () => {
    let A = window.getSelection();
    n.current.contains(A.anchorNode) && A.collapse(n.current);
  });
  let $ = q("");
  Pn(n, "beforeinput", (A) => {
    switch (A.preventDefault(), A.inputType) {
      case "deleteContentBackward":
      case "deleteContentForward":
        b.isValidPartialNumber(e.text) && !t.isReadOnly && v();
        break;
      case "insertCompositionText":
        $.current = n.current.textContent, n.current.textContent = n.current.textContent;
        break;
      default:
        A.data != null && y(A.data);
        break;
    }
  }), Pn(n, "input", (A) => {
    let { inputType: K, data: E } = A;
    switch (K) {
      case "insertCompositionText":
        n.current.textContent = $.current, (h(x, E) || h(_, E)) && y(E);
        break;
    }
  }), st(() => {
    let A = n.current;
    return () => {
      document.activeElement === A && (s.focusPrevious() || s.focusNext());
    };
  }, [
    n,
    s
  ]);
  let R = qi() || e.type === "timeZoneName" ? {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuetext": null,
    "aria-valuenow": null
  } : {}, P = J(() => t.segments.find((A) => A.isEditable), [
    t.segments
  ]);
  e !== P && !t.isInvalid && (l = void 0);
  let S = vt(), V = !t.isDisabled && !t.isReadOnly && e.isEditable, k = e.type === "literal" ? "" : o.of(e.type), w = Oa({
    "aria-label": `${k}${i ? `, ${i}` : ""}${u ? ", " : ""}`,
    "aria-labelledby": u
  });
  return e.type === "literal" ? {
    segmentProps: {
      "aria-hidden": !0
    }
  } : {
    segmentProps: Me(g, w, {
      id: S,
      ...R,
      "aria-invalid": t.isInvalid ? "true" : void 0,
      "aria-describedby": l,
      "aria-readonly": t.isReadOnly || !e.isEditable ? "true" : void 0,
      "data-placeholder": e.isPlaceholder || void 0,
      contentEditable: V,
      suppressContentEditableWarning: V,
      spellCheck: V ? "false" : void 0,
      autoCorrect: V ? "off" : void 0,
      // Capitalization was changed in React 17...
      [parseInt(fe.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: V ? "next" : void 0,
      inputMode: t.isDisabled || e.type === "dayPeriod" || e.type === "era" || !V ? void 0 : "numeric",
      tabIndex: t.isDisabled ? void 0 : 0,
      onKeyDown: C,
      onFocus: F,
      style: {
        caretColor: "transparent"
      },
      // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
      onPointerDown(A) {
        A.stopPropagation();
      },
      onMouseDown(A) {
        A.stopPropagation();
      }
    })
  };
}
function Ny(e) {
  e.sort();
  let t = e[0], n = e[e.length - 1];
  for (let r = 0; r < t.length; r++)
    if (t[r] !== n[r]) return r;
  return 0;
}
function jy(e) {
  return e && e.__esModule ? e.default : e;
}
function Ly(e, t, n) {
  var r, a;
  let o = Wt(jy(Dr), "@react-aria/datepicker"), { isInvalid: i, validationErrors: u, validationDetails: l } = t.displayValidation, { labelProps: s, fieldProps: c, descriptionProps: f, errorMessageProps: p } = nu({
    ...e,
    labelElementType: "span",
    isInvalid: i,
    errorMessage: e.errorMessage || u
  }), d = c["aria-labelledby"] || c.id, { locale: g } = Ze(), b = t.formatValue(g, {
    month: "long"
  }), v = b ? o.format("selectedRangeDescription", {
    startDate: b.start,
    endDate: b.end
  }) : "", C = Ba(v), h = {
    "aria-label": o.format("startDate"),
    "aria-labelledby": d
  }, D = {
    "aria-label": o.format("endDate"),
    "aria-labelledby": d
  }, x = vt(), _ = vt(), O = tu(t, n), L = [
    C["aria-describedby"],
    c["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, y = J(() => ka(n, {
    // Exclude the button from the focus manager.
    accept: (S) => S.id !== x
  }), [
    n,
    x
  ]), F = {
    [nm]: y,
    [nr]: "presentation",
    "aria-describedby": L,
    placeholderValue: e.placeholderValue,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    granularity: e.granularity,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    isDisabled: e.isDisabled,
    isReadOnly: e.isReadOnly,
    isRequired: e.isRequired,
    validationBehavior: e.validationBehavior
  }, T = _r(e), { focusWithinProps: $ } = Xi({
    ...e,
    isDisabled: t.isOpen,
    onBlurWithin: e.onBlur,
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  }), R = q(en), P = q(en);
  return {
    groupProps: Me(T, O, c, C, $, {
      role: "group",
      "aria-disabled": e.isDisabled || null,
      "aria-describedby": L,
      onKeyDown(S) {
        t.isOpen || e.onKeyDown && e.onKeyDown(S);
      },
      onKeyUp(S) {
        t.isOpen || e.onKeyUp && e.onKeyUp(S);
      }
    }),
    labelProps: {
      ...s,
      onClick: () => {
        y.focusFirst();
      }
    },
    buttonProps: {
      ...C,
      id: x,
      "aria-haspopup": "dialog",
      "aria-label": o.format("calendar"),
      "aria-labelledby": `${x} ${d}`,
      "aria-describedby": L,
      "aria-expanded": t.isOpen,
      isDisabled: e.isDisabled || e.isReadOnly,
      onPress: () => t.setOpen(!0)
    },
    dialogProps: {
      id: _,
      "aria-labelledby": `${x} ${d}`
    },
    startFieldProps: {
      ...h,
      ...F,
      value: (r = t.value) === null || r === void 0 ? void 0 : r.start,
      onChange: (S) => t.setDateTime("start", S),
      autoFocus: e.autoFocus,
      name: e.startName,
      [lr]: {
        realtimeValidation: t.realtimeValidation,
        displayValidation: t.displayValidation,
        updateValidation(S) {
          R.current = S, t.updateValidation(la(S, P.current));
        },
        resetValidation: t.resetValidation,
        commitValidation: t.commitValidation
      }
    },
    endFieldProps: {
      ...D,
      ...F,
      value: (a = t.value) === null || a === void 0 ? void 0 : a.end,
      onChange: (S) => t.setDateTime("end", S),
      name: e.endName,
      [lr]: {
        realtimeValidation: t.realtimeValidation,
        displayValidation: t.displayValidation,
        updateValidation(S) {
          P.current = S, t.updateValidation(la(R.current, S));
        },
        resetValidation: t.resetValidation,
        commitValidation: t.commitValidation
      }
    },
    descriptionProps: f,
    errorMessageProps: p,
    calendarProps: {
      autoFocus: !0,
      value: t.dateRange,
      onChange: t.setDateRange,
      minValue: e.minValue,
      maxValue: e.maxValue,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isDateUnavailable: e.isDateUnavailable,
      allowsNonContiguousRanges: e.allowsNonContiguousRanges,
      defaultFocusedValue: t.dateRange ? void 0 : e.placeholderValue,
      isInvalid: t.isInvalid,
      errorMessage: typeof e.errorMessage == "function" ? e.errorMessage(t.displayValidation) : e.errorMessage || t.displayValidation.validationErrors.join(" ")
    },
    isInvalid: i,
    validationErrors: u,
    validationDetails: l
  };
}
const Hy = (e, t) => {
  te(() => {
    const n = (r) => {
      !e.current || e.current.contains(r.target) || t();
    };
    return document.addEventListener("click", n, !0), () => document.removeEventListener("click", n, !0);
  }, []);
}, Ky = ({
  parentRef: e,
  children: t,
  onClickOutside: n,
  borderless: r = !1
}) => {
  const a = q(null);
  Hy(e, n);
  const o = q(), [i, u] = re();
  return js(() => {
    const l = () => {
      if (!e.current || !a.current) return;
      const c = e.current.getBoundingClientRect(), f = a.current.getBoundingClientRect(), p = window.innerHeight - c.bottom < f.height, d = c.top >= f.height;
      u(p && d ? -f.height : void 0);
    }, s = () => {
      o.current && clearTimeout(o.current), o.current = setTimeout(l, 33.333333333333336);
    };
    return window.addEventListener("resize", s), l(), () => {
      window.removeEventListener("resize", s), o.current && clearTimeout(o.current);
    };
  }, []), /* @__PURE__ */ m.jsx(
    "div",
    {
      ref: a,
      className: se("c__popover", {
        "c__popover--borderless": r
      }),
      style: {
        top: i
      },
      role: "dialog",
      children: t
    }
  );
}, Nm = (e) => {
  try {
    if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone)
      throw new Error("Time zones are not available in this environment");
    return Intl.DateTimeFormat(void 0, { timeZone: e }), !0;
  } catch {
    return !1;
  }
}, Vn = (e, t) => {
  if (e)
    try {
      if (t && !Nm(t))
        throw new Error("Invalid timezone provided.");
      return t ? xd(e, t) : s4(e);
    } catch (n) {
      const r = n instanceof Error ? ": " + n.message : ".";
      throw new Error("Failed to parse date value" + r);
    }
}, ms = (e, t) => {
  if (!(!e || !e[0] || !e[1]))
    return {
      start: Vn(e[0], t),
      end: Vn(e[1], t)
    };
}, Rn = (e, t) => {
  try {
    if (!e)
      return "";
    const n = t || vr();
    if (!Nm(n))
      throw new Error("Invalid timezone provided.");
    return gd(e, n).toAbsoluteString();
  } catch (n) {
    const r = n instanceof Error ? ": " + n.message : ".";
    throw new Error("Failed to convert date value to string" + r);
  }
}, jm = (e) => ({
  minValue: Vn(e.minValue, e.timezone),
  maxValue: Vn(e.maxValue, e.timezone),
  shouldCloseOnSelect: !0,
  granularity: "day",
  isDisabled: e.disabled,
  label: e.label
}), Lm = Re(
  ({
    className: e,
    pickerState: t,
    pickerProps: n,
    onClear: r,
    isFocused: a,
    labelAsPlaceholder: o,
    calendar: i,
    children: u,
    name: l,
    locale: s,
    disabled: c = !1,
    optionalClassName: f,
    isRange: p,
    ...d
  }, g) => {
    var D, x;
    const { t: b, currentLocale: v } = Oe(), C = q(null), h = J(
      () => t.validationState === "invalid" || d.state === "error",
      [t.validationState, d.state]
    );
    return /* @__PURE__ */ m.jsx(sy, { locale: s || v, children: /* @__PURE__ */ m.jsx(
      _t,
      {
        ...d,
        className: se(e, {
          "c__date-picker__range__container": p
        }),
        children: /* @__PURE__ */ m.jsxs(
          "div",
          {
            ref: C,
            className: se(["c__date-picker", f], {
              "c__date-picker--disabled": c,
              "c__date-picker--invalid": h,
              "c__date-picker--success": d.state === "success",
              "c__date-picker--focused": !h && !c && (t.isOpen || a)
            }),
            children: [
              /* @__PURE__ */ m.jsxs(
                "div",
                {
                  className: se("c__date-picker__wrapper", {
                    "c__date-picker__wrapper--clickable": o
                  }),
                  ref: g,
                  ...n.groupProps,
                  role: "button",
                  tabIndex: 0,
                  onClick: () => !t.isOpen && t.open(),
                  children: [
                    "dateRange" in t ? /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
                      /* @__PURE__ */ m.jsx(
                        "input",
                        {
                          type: "hidden",
                          name: l && `${l}_start`,
                          value: Rn(
                            ((D = t.value) == null ? void 0 : D.start) ?? null,
                            d.timezone
                          )
                        }
                      ),
                      /* @__PURE__ */ m.jsx(
                        "input",
                        {
                          type: "hidden",
                          name: l && `${l}_end`,
                          value: Rn(
                            ((x = t.value) == null ? void 0 : x.end) ?? null,
                            d.timezone
                          )
                        }
                      )
                    ] }) : /* @__PURE__ */ m.jsx(
                      "input",
                      {
                        type: "hidden",
                        name: l,
                        value: Rn(
                          t.value,
                          d.timezone
                        )
                      }
                    ),
                    /* @__PURE__ */ m.jsx("div", { className: "c__date-picker__wrapper__icon", children: /* @__PURE__ */ m.jsx(
                      ge,
                      {
                        type: "button",
                        onKeyDown: (_) => {
                          _.key === "Enter" && t.toggle();
                        },
                        onClick: t.toggle,
                        "aria-label": b(
                          t.isOpen ? "components.forms.date_picker.toggle_button_aria_label_close" : "components.forms.date_picker.toggle_button_aria_label_open"
                        ),
                        color: "tertiary-text",
                        size: "small",
                        className: "c__date-picker__wrapper__toggle",
                        icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons icon", children: "calendar_today" }),
                        disabled: c
                      }
                    ) }),
                    u,
                    /* @__PURE__ */ m.jsx(
                      ge,
                      {
                        className: se("c__date-picker__inner__action", {
                          "c__date-picker__inner__action--empty": !t.value,
                          "c__date-picker__inner__action--hidden": o || c
                        }),
                        color: "tertiary-text",
                        size: "nano",
                        icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "close" }),
                        onClick: r,
                        onKeyDown: (_) => {
                          _.key === "Enter" && r();
                        },
                        "aria-label": b(
                          "components.forms.date_picker.clear_button_aria_label"
                        ),
                        disabled: c,
                        type: "button"
                      }
                    )
                  ]
                }
              ),
              t.isOpen && /* @__PURE__ */ m.jsx(
                Ky,
                {
                  parentRef: C,
                  onClickOutside: t.close,
                  borderless: !0,
                  children: i
                }
              )
            ]
          }
        )
      }
    ) });
  }
);
function Fn(e, t, n) {
  return t != null && e.compare(t) < 0 || n != null && e.compare(n) > 0;
}
function li(e, t, n, r, a) {
  let o = {};
  for (let u in t)
    o[u] = Math.floor(t[u] / 2), o[u] > 0 && t[u] % 2 === 0 && o[u]--;
  let i = nn(e, t, n).subtract(o);
  return cr(e, i, t, n, r, a);
}
function nn(e, t, n, r, a) {
  let o = e;
  return t.years ? o = Wv(e) : t.months ? o = yr(e) : t.weeks && (o = Tn(e, n)), cr(e, o, t, n, r, a);
}
function si(e, t, n, r, a) {
  let o = {
    ...t
  };
  o.days ? o.days-- : o.weeks ? o.weeks-- : o.months ? o.months-- : o.years && o.years--;
  let i = nn(e, t, n).subtract(o);
  return cr(e, i, t, n, r, a);
}
function cr(e, t, n, r, a, o) {
  if (a && e.compare(a) >= 0) {
    let i = Bi(t, nn(qe(a), n, r));
    i && (t = i);
  }
  if (o && e.compare(o) <= 0) {
    let i = Oi(t, si(qe(o), n, r));
    i && (t = i);
  }
  return t;
}
function Mt(e, t, n) {
  if (t) {
    let r = Bi(e, qe(t));
    r && (e = r);
  }
  if (n) {
    let r = Oi(e, qe(n));
    r && (e = r);
  }
  return e;
}
function Hm(e, t, n) {
  if (!n) return e;
  for (; e.compare(t) >= 0 && n(e); ) e = e.subtract({
    days: 1
  });
  return e.compare(t) >= 0 ? e : null;
}
function Km(e) {
  let t = J(() => new ut(e.locale), [
    e.locale
  ]), n = J(() => t.resolvedOptions(), [
    t
  ]), { locale: r, createCalendar: a, visibleDuration: o = {
    months: 1
  }, minValue: i, maxValue: u, selectionAlignment: l, isDateUnavailable: s, pageBehavior: c = "visible" } = e, f = J(() => a(n.calendar), [
    a,
    n.calendar
  ]);
  var p;
  let [d, g] = fn(e.value, (p = e.defaultValue) !== null && p !== void 0 ? p : null, e.onChange), b = J(() => d ? Ce(qe(d), f) : null, [
    d,
    f
  ]), v = J(() => d && "timeZone" in d ? d.timeZone : n.timeZone, [
    d,
    n.timeZone
  ]), C = J(() => e.focusedValue ? Mt(Ce(qe(e.focusedValue), f), i, u) : void 0, [
    e.focusedValue,
    f,
    i,
    u
  ]), h = J(() => Mt(e.defaultFocusedValue ? Ce(qe(e.defaultFocusedValue), f) : b || Ce(Pa(v), f), i, u), [
    e.defaultFocusedValue,
    b,
    v,
    f,
    i,
    u
  ]), [D, x] = fn(C, h, e.onFocusChange), [_, O] = re(() => {
    switch (l) {
      case "start":
        return nn(D, o, r, i, u);
      case "end":
        return si(D, o, r, i, u);
      case "center":
      default:
        return li(D, o, r, i, u);
    }
  }), [L, y] = re(e.autoFocus || !1), F = J(() => {
    let E = {
      ...o
    };
    return E.days ? E.days-- : E.days = -1, _.add(E);
  }, [
    _,
    o
  ]), [T, $] = re(f.identifier);
  if (f.identifier !== T) {
    let E = Ce(D, f);
    O(li(E, o, r, i, u)), x(E), $(f.identifier);
  }
  Fn(D, i, u) ? x(Mt(D, i, u)) : D.compare(_) < 0 ? O(si(D, o, r, i, u)) : D.compare(F) > 0 && O(nn(D, o, r, i, u));
  function R(E) {
    E = Mt(E, i, u), x(E);
  }
  function P(E) {
    if (!e.isDisabled && !e.isReadOnly) {
      let B = E;
      if (B === null) {
        g(null);
        return;
      }
      if (B = Mt(B, i, u), B = Hm(B, _, s), !B) return;
      B = Ce(B, (d == null ? void 0 : d.calendar) || new Ke()), d && "hour" in d ? g(d.set(B)) : g(B);
    }
  }
  let S = J(() => b ? s && s(b) ? !0 : Fn(b, i, u) : !1, [
    b,
    s,
    i,
    u
  ]), V = e.isInvalid || e.validationState === "invalid" || S, k = V ? "invalid" : null, w = J(() => c === "visible" ? o : Eo(o), [
    c,
    o
  ]);
  var A, K;
  return {
    isDisabled: (A = e.isDisabled) !== null && A !== void 0 ? A : !1,
    isReadOnly: (K = e.isReadOnly) !== null && K !== void 0 ? K : !1,
    value: b,
    setValue: P,
    visibleRange: {
      start: _,
      end: F
    },
    minValue: i,
    maxValue: u,
    focusedDate: D,
    timeZone: v,
    validationState: k,
    isValueInvalid: V,
    setFocusedDate(E) {
      R(E), y(!0);
    },
    focusNextDay() {
      R(D.add({
        days: 1
      }));
    },
    focusPreviousDay() {
      R(D.subtract({
        days: 1
      }));
    },
    focusNextRow() {
      o.days ? this.focusNextPage() : (o.weeks || o.months || o.years) && R(D.add({
        weeks: 1
      }));
    },
    focusPreviousRow() {
      o.days ? this.focusPreviousPage() : (o.weeks || o.months || o.years) && R(D.subtract({
        weeks: 1
      }));
    },
    focusNextPage() {
      let E = _.add(w);
      x(Mt(D.add(w), i, u)), O(nn(cr(D, E, w, r, i, u), w, r));
    },
    focusPreviousPage() {
      let E = _.subtract(w);
      x(Mt(D.subtract(w), i, u)), O(nn(cr(D, E, w, r, i, u), w, r));
    },
    focusSectionStart() {
      o.days ? R(_) : o.weeks ? R(Tn(D, r)) : (o.months || o.years) && R(yr(D));
    },
    focusSectionEnd() {
      o.days ? R(F) : o.weeks ? R(qv(D, r)) : (o.months || o.years) && R(na(D));
    },
    focusNextSection(E) {
      if (!E && !o.days) {
        R(D.add(Eo(o)));
        return;
      }
      o.days ? this.focusNextPage() : o.weeks ? R(D.add({
        months: 1
      })) : (o.months || o.years) && R(D.add({
        years: 1
      }));
    },
    focusPreviousSection(E) {
      if (!E && !o.days) {
        R(D.subtract(Eo(o)));
        return;
      }
      o.days ? this.focusPreviousPage() : o.weeks ? R(D.subtract({
        months: 1
      })) : (o.months || o.years) && R(D.subtract({
        years: 1
      }));
    },
    selectFocusedDate() {
      P(D);
    },
    selectDate(E) {
      P(E);
    },
    isFocused: L,
    setFocused: y,
    isInvalid(E) {
      return Fn(E, i, u);
    },
    isSelected(E) {
      return b != null && Ae(E, b) && !this.isCellDisabled(E) && !this.isCellUnavailable(E);
    },
    isCellFocused(E) {
      return L && D && Ae(E, D);
    },
    isCellDisabled(E) {
      return e.isDisabled || E.compare(_) < 0 || E.compare(F) > 0 || this.isInvalid(E);
    },
    isCellUnavailable(E) {
      return e.isDateUnavailable ? e.isDateUnavailable(E) : !1;
    },
    isPreviousVisibleRangeInvalid() {
      let E = _.subtract({
        days: 1
      });
      return Ae(E, _) || this.isInvalid(E);
    },
    isNextVisibleRangeInvalid() {
      let E = F.add({
        days: 1
      });
      return Ae(E, F) || this.isInvalid(E);
    },
    getDatesInWeek(E, B = _) {
      let j = B.add({
        weeks: E
      }), N = [];
      j = Tn(j, r);
      let H = Ti(j, r);
      for (let W = 0; W < H; W++) N.push(null);
      for (; N.length < 7; ) {
        N.push(j);
        let W = j.add({
          days: 1
        });
        if (Ae(j, W)) break;
        j = W;
      }
      for (; N.length < 7; ) N.push(null);
      return N;
    }
  };
}
function Eo(e) {
  let t = {
    ...e
  };
  for (let n in e) t[n] = 1;
  return t;
}
function zy(e) {
  let { value: t, defaultValue: n, onChange: r, createCalendar: a, locale: o, visibleDuration: i = {
    months: 1
  }, minValue: u, maxValue: l, ...s } = e, [c, f] = fn(t, n || null, r), [p, d] = re(null), g = "center";
  if (c && c.start && c.end) {
    let A = li(qe(c.start), i, o, u, l).add(i).subtract({
      days: 1
    });
    c.end.compare(A) > 0 && (g = "start");
  }
  let b = q(null), [v, C] = re(null), h = J(() => Bi(u, v == null ? void 0 : v.start), [
    u,
    v
  ]), D = J(() => Oi(l, v == null ? void 0 : v.end), [
    l,
    v
  ]), x = Km({
    ...s,
    value: c && c.start,
    createCalendar: a,
    locale: o,
    visibleDuration: i,
    minValue: h,
    maxValue: D,
    selectionAlignment: g
  }), _ = (w) => {
    if (w && e.isDateUnavailable && !e.allowsNonContiguousRanges) {
      const A = gs(w, x, -1), K = gs(w, x, 1);
      b.current = {
        start: A,
        end: K
      }, C(b.current);
    } else
      b.current = null, C(null);
  }, [O, L] = re(x.visibleRange);
  (!Ko(x.visibleRange.start, O.start) || !Ko(x.visibleRange.end, O.end)) && (_(p), L(x.visibleRange));
  let y = (w) => {
    w ? (d(w), _(w)) : (d(null), _(null));
  }, F = p ? Co(p, x.focusedDate) : c && Co(c.start, c.end), T = (w) => {
    if (e.isReadOnly) return;
    const A = Mt(w, h, D), K = Hm(A, x.visibleRange.start, e.isDateUnavailable);
    if (K)
      if (!p) y(K);
      else {
        let E = Co(p, K);
        E && f({
          start: ps(E.start, c == null ? void 0 : c.start),
          end: ps(E.end, c == null ? void 0 : c.end)
        }), y(null);
      }
  }, [$, R] = re(!1), { isDateUnavailable: P } = e, S = J(() => !c || p ? !1 : P && (P(c.start) || P(c.end)) ? !0 : Fn(c.start, u, l) || Fn(c.end, u, l), [
    P,
    c,
    p,
    u,
    l
  ]), V = e.isInvalid || e.validationState === "invalid" || S;
  return {
    ...x,
    value: c,
    setValue: f,
    anchorDate: p,
    setAnchorDate: y,
    highlightedRange: F,
    validationState: V ? "invalid" : null,
    isValueInvalid: V,
    selectFocusedDate() {
      T(x.focusedDate);
    },
    selectDate: T,
    highlightDate(w) {
      p && x.setFocusedDate(w);
    },
    isSelected(w) {
      return !!(F && w.compare(F.start) >= 0 && w.compare(F.end) <= 0 && !x.isCellDisabled(w) && !x.isCellUnavailable(w));
    },
    isInvalid(w) {
      var A, K;
      return x.isInvalid(w) || Fn(w, (A = b.current) === null || A === void 0 ? void 0 : A.start, (K = b.current) === null || K === void 0 ? void 0 : K.end);
    },
    isDragging: $,
    setDragging: R
  };
}
function Co(e, t) {
  return !e || !t ? null : (t.compare(e) < 0 && ([e, t] = [
    t,
    e
  ]), {
    start: qe(e),
    end: qe(t)
  });
}
function ps(e, t) {
  return e = Ce(e, (t == null ? void 0 : t.calendar) || new Ke()), t && "hour" in t ? t.set(e) : e;
}
function gs(e, t, n) {
  let r = e.add({
    days: n
  });
  for (; (n < 0 ? r.compare(t.visibleRange.start) >= 0 : r.compare(t.visibleRange.end) <= 0) && !t.isCellUnavailable(r); ) r = r.add({
    days: n
  });
  if (t.isCellUnavailable(r)) return r.add({
    days: -n
  });
}
var zm = {};
zm = {
  dateRange: (e) => `${e.startDate} إلى ${e.endDate}`,
  dateSelected: (e) => `${e.date} المحدد`,
  finishRangeSelectionPrompt: "انقر لإنهاء عملية تحديد نطاق التاريخ",
  maximumDate: "آخر تاريخ متاح",
  minimumDate: "أول تاريخ متاح",
  next: "التالي",
  previous: "السابق",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.dateRange}`,
  startRangeSelectionPrompt: "انقر لبدء عملية تحديد نطاق التاريخ",
  todayDate: (e) => `اليوم، ${e.date}`,
  todayDateSelected: (e) => `اليوم، ${e.date} محدد`
};
var Um = {};
Um = {
  dateRange: (e) => `${e.startDate} до ${e.endDate}`,
  dateSelected: (e) => `Избрано е ${e.date}`,
  finishRangeSelectionPrompt: "Натиснете, за да довършите избора на времеви интервал",
  maximumDate: "Последна налична дата",
  minimumDate: "Първа налична дата",
  next: "Напред",
  previous: "Назад",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натиснете, за да пристъпите към избора на времеви интервал",
  todayDate: (e) => `Днес, ${e.date}`,
  todayDateSelected: (e) => `Днес, ${e.date} са избрани`
};
var Wm = {};
Wm = {
  dateRange: (e) => `${e.startDate} až ${e.endDate}`,
  dateSelected: (e) => `Vybráno ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výběr rozsahu dat",
  maximumDate: "Poslední dostupné datum",
  minimumDate: "První dostupné datum",
  next: "Další",
  previous: "Předchozí",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím zahájíte výběr rozsahu dat",
  todayDate: (e) => `Dnes, ${e.date}`,
  todayDateSelected: (e) => `Dnes, vybráno ${e.date}`
};
var Gm = {};
Gm = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klik for at fuldføre valg af datoområde",
  maximumDate: "Sidste ledige dato",
  minimumDate: "Første ledige dato",
  next: "Næste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik for at starte valg af datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var Ym = {};
Ym = {
  dateRange: (e) => `${e.startDate} bis ${e.endDate}`,
  dateSelected: (e) => `${e.date} ausgewählt`,
  finishRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beenden",
  maximumDate: "Letztes verfügbares Datum",
  minimumDate: "Erstes verfügbares Datum",
  next: "Weiter",
  previous: "Zurück",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
  todayDate: (e) => `Heute, ${e.date}`,
  todayDateSelected: (e) => `Heute, ${e.date} ausgewählt`
};
var qm = {};
qm = {
  dateRange: (e) => `${e.startDate} έως ${e.endDate}`,
  dateSelected: (e) => `Επιλέχθηκε ${e.date}`,
  finishRangeSelectionPrompt: "Κάντε κλικ για να ολοκληρώσετε την επιλογή εύρους ημερομηνιών",
  maximumDate: "Τελευταία διαθέσιμη ημερομηνία",
  minimumDate: "Πρώτη διαθέσιμη ημερομηνία",
  next: "Επόμενο",
  previous: "Προηγούμενο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.dateRange}`,
  startRangeSelectionPrompt: "Κάντε κλικ για να ξεκινήσετε την επιλογή εύρους ημερομηνιών",
  todayDate: (e) => `Σήμερα, ${e.date}`,
  todayDateSelected: (e) => `Σήμερα, επιλέχτηκε ${e.date}`
};
var Zm = {};
Zm = {
  previous: "Previous",
  next: "Next",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.dateRange}`,
  todayDate: (e) => `Today, ${e.date}`,
  todayDateSelected: (e) => `Today, ${e.date} selected`,
  dateSelected: (e) => `${e.date} selected`,
  startRangeSelectionPrompt: "Click to start selecting date range",
  finishRangeSelectionPrompt: "Click to finish selecting date range",
  minimumDate: "First available date",
  maximumDate: "Last available date",
  dateRange: (e) => `${e.startDate} to ${e.endDate}`
};
var Jm = {};
Jm = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} seleccionado`,
  finishRangeSelectionPrompt: "Haga clic para terminar de seleccionar rango de fechas",
  maximumDate: "Última fecha disponible",
  minimumDate: "Primera fecha disponible",
  next: "Siguiente",
  previous: "Anterior",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo seleccionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Haga clic para comenzar a seleccionar un rango de fechas",
  todayDate: (e) => `Hoy, ${e.date}`,
  todayDateSelected: (e) => `Hoy, ${e.date} seleccionado`
};
var Xm = {};
Xm = {
  dateRange: (e) => `${e.startDate} kuni ${e.endDate}`,
  dateSelected: (e) => `${e.date} valitud`,
  finishRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimise lõpetamiseks",
  maximumDate: "Viimane saadaolev kuupäev",
  minimumDate: "Esimene saadaolev kuupäev",
  next: "Järgmine",
  previous: "Eelmine",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimiseks",
  todayDate: (e) => `Täna, ${e.date}`,
  todayDateSelected: (e) => `Täna, ${e.date} valitud`
};
var Qm = {};
Qm = {
  dateRange: (e) => `${e.startDate} – ${e.endDate}`,
  dateSelected: (e) => `${e.date} valittu`,
  finishRangeSelectionPrompt: "Lopeta päivämääräalueen valinta napsauttamalla tätä.",
  maximumDate: "Viimeinen varattavissa oleva päivämäärä",
  minimumDate: "Ensimmäinen varattavissa oleva päivämäärä",
  next: "Seuraava",
  previous: "Edellinen",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.dateRange}`,
  startRangeSelectionPrompt: "Aloita päivämääräalueen valinta napsauttamalla tätä.",
  todayDate: (e) => `Tänään, ${e.date}`,
  todayDateSelected: (e) => `Tänään, ${e.date} valittu`
};
var ep = {};
ep = {
  dateRange: (e) => `${e.startDate} à ${e.endDate}`,
  dateSelected: (e) => `${e.date} sélectionné`,
  finishRangeSelectionPrompt: "Cliquer pour finir de sélectionner la plage de dates",
  maximumDate: "Dernière date disponible",
  minimumDate: "Première date disponible",
  next: "Suivant",
  previous: "Précédent",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.dateRange}`,
  startRangeSelectionPrompt: "Cliquer pour commencer à sélectionner la plage de dates",
  todayDate: (e) => `Aujourd'hui, ${e.date}`,
  todayDateSelected: (e) => `Aujourd’hui, ${e.date} sélectionné`
};
var tp = {};
tp = {
  dateRange: (e) => `${e.startDate} עד ${e.endDate}`,
  dateSelected: (e) => `${e.date} נבחר`,
  finishRangeSelectionPrompt: "חץ כדי לסיים את בחירת טווח התאריכים",
  maximumDate: "תאריך פנוי אחרון",
  minimumDate: "תאריך פנוי ראשון",
  next: "הבא",
  previous: "הקודם",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.dateRange}`,
  startRangeSelectionPrompt: "לחץ כדי להתחיל בבחירת טווח התאריכים",
  todayDate: (e) => `היום, ${e.date}`,
  todayDateSelected: (e) => `היום, ${e.date} נבחר`
};
var np = {};
np = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} odabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite raspon odabranih datuma",
  maximumDate: "Posljednji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sljedeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete raspon odabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, odabran ${e.date}`
};
var rp = {};
rp = {
  dateRange: (e) => `${e.startDate}–${e.endDate}`,
  dateSelected: (e) => `${e.date} kiválasztva`,
  finishRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének befejezéséhez",
  maximumDate: "Utolsó elérhető dátum",
  minimumDate: "Az első elérhető dátum",
  next: "Következő",
  previous: "Előző",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének indításához",
  todayDate: (e) => `Ma, ${e.date}`,
  todayDateSelected: (e) => `Ma, ${e.date} kijelölve`
};
var ap = {};
ap = {
  dateRange: (e) => `Da ${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selezionata`,
  finishRangeSelectionPrompt: "Fai clic per completare la selezione dell’intervallo di date",
  maximumDate: "Ultima data disponibile",
  minimumDate: "Prima data disponibile",
  next: "Successivo",
  previous: "Precedente",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: ${e.dateRange}`,
  startRangeSelectionPrompt: "Fai clic per selezionare l’intervallo di date",
  todayDate: (e) => `Oggi, ${e.date}`,
  todayDateSelected: (e) => `Oggi, ${e.date} selezionata`
};
var op = {};
op = {
  dateRange: (e) => `${e.startDate} から ${e.endDate}`,
  dateSelected: (e) => `${e.date} を選択`,
  finishRangeSelectionPrompt: "クリックして日付範囲の選択を終了",
  maximumDate: "最終利用可能日",
  minimumDate: "最初の利用可能日",
  next: "次へ",
  previous: "前へ",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.dateRange}`,
  startRangeSelectionPrompt: "クリックして日付範囲の選択を開始",
  todayDate: (e) => `本日、${e.date}`,
  todayDateSelected: (e) => `本日、${e.date} を選択`
};
var ip = {};
ip = {
  dateRange: (e) => `${e.startDate} ~ ${e.endDate}`,
  dateSelected: (e) => `${e.date} 선택됨`,
  finishRangeSelectionPrompt: "날짜 범위 선택을 완료하려면 클릭하십시오.",
  maximumDate: "마지막으로 사용 가능한 일자",
  minimumDate: "처음으로 사용 가능한 일자",
  next: "다음",
  previous: "이전",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.dateRange}`,
  startRangeSelectionPrompt: "날짜 범위 선택을 시작하려면 클릭하십시오.",
  todayDate: (e) => `오늘, ${e.date}`,
  todayDateSelected: (e) => `오늘, ${e.date} 선택됨`
};
var up = {};
up = {
  dateRange: (e) => `Nuo ${e.startDate} iki ${e.endDate}`,
  dateSelected: (e) => `Pasirinkta ${e.date}`,
  finishRangeSelectionPrompt: "Spustelėkite, kad baigtumėte pasirinkti datų intervalą",
  maximumDate: "Paskutinė galima data",
  minimumDate: "Pirmoji galima data",
  next: "Paskesnis",
  previous: "Ankstesnis",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: ${e.dateRange}`,
  startRangeSelectionPrompt: "Spustelėkite, kad pradėtumėte pasirinkti datų intervalą",
  todayDate: (e) => `Šiandien, ${e.date}`,
  todayDateSelected: (e) => `Šiandien, pasirinkta ${e.date}`
};
var lp = {};
lp = {
  dateRange: (e) => `No ${e.startDate} līdz ${e.endDate}`,
  dateSelected: (e) => `Atlasīts: ${e.date}`,
  finishRangeSelectionPrompt: "Noklikšķiniet, lai pabeigtu datumu diapazona atlasi",
  maximumDate: "Pēdējais pieejamais datums",
  minimumDate: "Pirmais pieejamais datums",
  next: "Tālāk",
  previous: "Atpakaļ",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: ${e.dateRange}`,
  startRangeSelectionPrompt: "Noklikšķiniet, lai sāktu datumu diapazona atlasi",
  todayDate: (e) => `Šodien, ${e.date}`,
  todayDateSelected: (e) => `Atlasīta šodiena, ${e.date}`
};
var sp = {};
sp = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klikk for å fullføre valg av datoområde",
  maximumDate: "Siste tilgjengelige dato",
  minimumDate: "Første tilgjengelige dato",
  next: "Neste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klikk for å starte valg av datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var cp = {};
cp = {
  dateRange: (e) => `${e.startDate} tot ${e.endDate}`,
  dateSelected: (e) => `${e.date} geselecteerd`,
  finishRangeSelectionPrompt: "Klik om de selectie van het datumbereik te voltooien",
  maximumDate: "Laatste beschikbare datum",
  minimumDate: "Eerste beschikbare datum",
  next: "Volgende",
  previous: "Vorige",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik om het datumbereik te selecteren",
  todayDate: (e) => `Vandaag, ${e.date}`,
  todayDateSelected: (e) => `Vandaag, ${e.date} geselecteerd`
};
var dp = {};
dp = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Wybrano ${e.date}`,
  finishRangeSelectionPrompt: "Kliknij, aby zakończyć wybór zakresu dat",
  maximumDate: "Ostatnia dostępna data",
  minimumDate: "Pierwsza dostępna data",
  next: "Dalej",
  previous: "Wstecz",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknij, aby rozpocząć wybór zakresu dat",
  todayDate: (e) => `Dzisiaj, ${e.date}`,
  todayDateSelected: (e) => `Dzisiaj wybrano ${e.date}`
};
var fp = {};
fp = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para concluir a seleção do intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para iniciar a seleção do intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var mp = {};
mp = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para terminar de selecionar o intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para começar a selecionar o intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var pp = {};
pp = {
  dateRange: (e) => `De la ${e.startDate} până la ${e.endDate}`,
  dateSelected: (e) => `${e.date} selectată`,
  finishRangeSelectionPrompt: "Apăsaţi pentru a finaliza selecţia razei pentru dată",
  maximumDate: "Ultima dată disponibilă",
  minimumDate: "Prima dată disponibilă",
  next: "Următorul",
  previous: "Înainte",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: ${e.dateRange}`,
  startRangeSelectionPrompt: "Apăsaţi pentru a începe selecţia razei pentru dată",
  todayDate: (e) => `Astăzi, ${e.date}`,
  todayDateSelected: (e) => `Azi, ${e.date} selectată`
};
var gp = {};
gp = {
  dateRange: (e) => `С ${e.startDate} по ${e.endDate}`,
  dateSelected: (e) => `Выбрано ${e.date}`,
  finishRangeSelectionPrompt: "Щелкните, чтобы завершить выбор диапазона дат",
  maximumDate: "Последняя доступная дата",
  minimumDate: "Первая доступная дата",
  next: "Далее",
  previous: "Назад",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Щелкните, чтобы начать выбор диапазона дат",
  todayDate: (e) => `Сегодня, ${e.date}`,
  todayDateSelected: (e) => `Сегодня, выбрано ${e.date}`
};
var hp = {};
hp = {
  dateRange: (e) => `Od ${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Vybratý dátum ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výber rozsahu dátumov",
  maximumDate: "Posledný dostupný dátum",
  minimumDate: "Prvý dostupný dátum",
  next: "Nasledujúce",
  previous: "Predchádzajúce",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím spustíte výber rozsahu dátumov",
  todayDate: (e) => `Dnes ${e.date}`,
  todayDateSelected: (e) => `Vybratý dnešný dátum ${e.date}`
};
var vp = {};
vp = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izbrano`,
  finishRangeSelectionPrompt: "Kliknite za dokončanje izbire datumskega obsega",
  maximumDate: "Zadnji razpoložljivi datum",
  minimumDate: "Prvi razpoložljivi datum",
  next: "Naprej",
  previous: "Nazaj",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite za začetek izbire datumskega obsega",
  todayDate: (e) => `Danes, ${e.date}`,
  todayDateSelected: (e) => `Danes, ${e.date} izbrano`
};
var yp = {};
yp = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite opseg izabranih datuma",
  maximumDate: "Zadnji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sledeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani period: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete opseg izabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, izabran ${e.date}`
};
var bp = {};
bp = {
  dateRange: (e) => `${e.startDate} till ${e.endDate}`,
  dateSelected: (e) => `${e.date} har valts`,
  finishRangeSelectionPrompt: "Klicka för att avsluta val av datumintervall",
  maximumDate: "Sista tillgängliga datum",
  minimumDate: "Första tillgängliga datum",
  next: "Nästa",
  previous: "Föregående",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicka för att välja datumintervall",
  todayDate: (e) => `Idag, ${e.date}`,
  todayDateSelected: (e) => `Idag, ${e.date} har valts`
};
var Dp = {};
Dp = {
  dateRange: (e) => `${e.startDate} - ${e.endDate}`,
  dateSelected: (e) => `${e.date} seçildi`,
  finishRangeSelectionPrompt: "Tarih aralığı seçimini tamamlamak için tıklayın",
  maximumDate: "Son müsait tarih",
  minimumDate: "İlk müsait tarih",
  next: "Sonraki",
  previous: "Önceki",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.dateRange}`,
  startRangeSelectionPrompt: "Tarih aralığı seçimini başlatmak için tıklayın",
  todayDate: (e) => `Bugün, ${e.date}`,
  todayDateSelected: (e) => `Bugün, ${e.date} seçildi`
};
var _p = {};
_p = {
  dateRange: (e) => `${e.startDate} — ${e.endDate}`,
  dateSelected: (e) => `Вибрано ${e.date}`,
  finishRangeSelectionPrompt: "Натисніть, щоб завершити вибір діапазону дат",
  maximumDate: "Остання доступна дата",
  minimumDate: "Перша доступна дата",
  next: "Наступний",
  previous: "Попередній",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натисніть, щоб почати вибір діапазону дат",
  todayDate: (e) => `Сьогодні, ${e.date}`,
  todayDateSelected: (e) => `Сьогодні, вибрано ${e.date}`
};
var $p = {};
$p = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已选择 ${e.date}`,
  finishRangeSelectionPrompt: "单击以完成选择日期范围",
  maximumDate: "最后一个可用日期",
  minimumDate: "第一个可用日期",
  next: "下一页",
  previous: "上一页",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.dateRange}`,
  startRangeSelectionPrompt: "单击以开始选择日期范围",
  todayDate: (e) => `今天，即 ${e.date}`,
  todayDateSelected: (e) => `已选择今天，即 ${e.date}`
};
var xp = {};
xp = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已選取 ${e.date}`,
  finishRangeSelectionPrompt: "按一下以完成選取日期範圍",
  maximumDate: "最後一個可用日期",
  minimumDate: "第一個可用日期",
  next: "下一頁",
  previous: "上一頁",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.dateRange}`,
  startRangeSelectionPrompt: "按一下以開始選取日期範圍",
  todayDate: (e) => `今天，${e.date}`,
  todayDateSelected: (e) => `已選取今天，${e.date}`
};
var $r = {};
$r = {
  "ar-AE": zm,
  "bg-BG": Um,
  "cs-CZ": Wm,
  "da-DK": Gm,
  "de-DE": Ym,
  "el-GR": qm,
  "en-US": Zm,
  "es-ES": Jm,
  "et-EE": Xm,
  "fi-FI": Qm,
  "fr-FR": ep,
  "he-IL": tp,
  "hr-HR": np,
  "hu-HU": rp,
  "it-IT": ap,
  "ja-JP": op,
  "ko-KR": ip,
  "lt-LT": up,
  "lv-LV": lp,
  "nb-NO": sp,
  "nl-NL": cp,
  "pl-PL": dp,
  "pt-BR": fp,
  "pt-PT": mp,
  "ro-RO": pp,
  "ru-RU": gp,
  "sk-SK": hp,
  "sl-SI": vp,
  "sr-SP": yp,
  "sv-SE": bp,
  "tr-TR": Dp,
  "uk-UA": _p,
  "zh-CN": $p,
  "zh-TW": xp
};
function Ep(e) {
  return e && e.__esModule ? e.default : e;
}
const ru = /* @__PURE__ */ new WeakMap();
function dr(e) {
  return (e == null ? void 0 : e.calendar.identifier) === "gregory" && e.era === "BC" ? "short" : void 0;
}
function Uy(e) {
  let t = Wt(Ep($r), "@react-aria/calendar"), n, r;
  "highlightedRange" in e ? { start: n, end: r } = e.highlightedRange || {} : n = r = e.value;
  let a = lt({
    weekday: "long",
    month: "long",
    year: "numeric",
    day: "numeric",
    era: dr(n) || dr(r),
    timeZone: e.timeZone
  }), o = "anchorDate" in e ? e.anchorDate : null;
  return J(() => {
    if (!o && n && r)
      if (Ae(n, r)) {
        let i = a.format(n.toDate(e.timeZone));
        return t.format("selectedDateDescription", {
          date: i
        });
      } else {
        let i = di(a, t, n, r, e.timeZone);
        return t.format("selectedRangeDescription", {
          dateRange: i
        });
      }
    return "";
  }, [
    n,
    r,
    o,
    e.timeZone,
    t,
    a
  ]);
}
function ci(e, t, n, r) {
  let a = Wt(Ep($r), "@react-aria/calendar"), o = dr(e) || dr(t), i = lt({
    month: "long",
    year: "numeric",
    era: o,
    calendar: e.calendar.identifier,
    timeZone: n
  }), u = lt({
    month: "long",
    year: "numeric",
    day: "numeric",
    era: o,
    calendar: e.calendar.identifier,
    timeZone: n
  });
  return J(() => {
    if (Ae(e, yr(e))) {
      if (Ae(t, na(e))) return i.format(e.toDate(n));
      if (Ae(t, na(t))) return r ? di(i, a, e, t, n) : i.formatRange(e.toDate(n), t.toDate(n));
    }
    return r ? di(u, a, e, t, n) : u.formatRange(e.toDate(n), t.toDate(n));
  }, [
    e,
    t,
    i,
    u,
    a,
    n,
    r
  ]);
}
function di(e, t, n, r, a) {
  let o = e.formatRangeToParts(n.toDate(a), r.toDate(a)), i = -1;
  for (let s = 0; s < o.length; s++) {
    let c = o[s];
    if (c.source === "shared" && c.type === "literal") i = s;
    else if (c.source === "endRange") break;
  }
  let u = "", l = "";
  for (let s = 0; s < o.length; s++)
    s < i ? u += o[s].value : s > i && (l += o[s].value);
  return t.format("dateRange", {
    startDate: u,
    endDate: l
  });
}
function Wy(e) {
  return e && e.__esModule ? e.default : e;
}
function Cp(e, t) {
  let n = Wt(Wy($r), "@react-aria/calendar"), r = _r(e), a = ci(t.visibleRange.start, t.visibleRange.end, t.timeZone, !1), o = ci(t.visibleRange.start, t.visibleRange.end, t.timeZone, !0);
  ql(() => {
    t.isFocused || ui(o);
  }, [
    o
  ]);
  let i = Uy(t);
  ql(() => {
    i && ui(i, "polite", 4e3);
  }, [
    i
  ]);
  let u = Xo([
    !!e.errorMessage,
    e.isInvalid,
    e.validationState
  ]);
  ru.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: e["aria-labelledby"],
    errorMessageId: u,
    selectedDateDescription: i
  });
  let [l, s] = re(!1), c = e.isDisabled || t.isNextVisibleRangeInvalid();
  c && l && (s(!1), t.setFocused(!0));
  let [f, p] = re(!1), d = e.isDisabled || t.isPreviousVisibleRangeInvalid();
  d && f && (p(!1), t.setFocused(!0));
  let g = Oa({
    id: e.id,
    "aria-label": [
      e["aria-label"],
      o
    ].filter(Boolean).join(", "),
    "aria-labelledby": e["aria-labelledby"]
  });
  return {
    calendarProps: Me(r, g, {
      role: "application",
      "aria-describedby": e["aria-describedby"] || void 0
    }),
    nextButtonProps: {
      onPress: () => t.focusNextPage(),
      "aria-label": n.format("next"),
      isDisabled: c,
      onFocusChange: s
    },
    prevButtonProps: {
      onPress: () => t.focusPreviousPage(),
      "aria-label": n.format("previous"),
      isDisabled: d,
      onFocusChange: p
    },
    errorMessageProps: {
      id: u
    },
    title: a
  };
}
function Gy(e, t) {
  return Cp(e, t);
}
function Yy(e, t, n) {
  let r = Cp(e, t), a = q(!1), o = q(typeof window < "u" ? window : null);
  return Pn(o, "pointerdown", (u) => {
    a.current = u.width === 0 && u.height === 0;
  }), Pn(o, "pointerup", (u) => {
    if (a.current) {
      a.current = !1;
      return;
    }
    if (t.setDragging(!1), !t.anchorDate) return;
    let l = u.target;
    n.current && n.current.contains(document.activeElement) && (!n.current.contains(l) || !l.closest('button, [role="button"]')) && t.selectFocusedDate();
  }), r.calendarProps.onBlur = (u) => {
    n.current && (!u.relatedTarget || !n.current.contains(u.relatedTarget)) && t.anchorDate && t.selectFocusedDate();
  }, Pn(n, "touchmove", (u) => {
    t.isDragging && u.preventDefault();
  }, {
    passive: !1,
    capture: !0
  }), r;
}
function qy(e, t) {
  let { startDate: n = t.visibleRange.start, endDate: r = t.visibleRange.end } = e, { direction: a } = Ze(), o = (d) => {
    switch (d.key) {
      case "Enter":
      case " ":
        d.preventDefault(), t.selectFocusedDate();
        break;
      case "PageUp":
        d.preventDefault(), d.stopPropagation(), t.focusPreviousSection(d.shiftKey);
        break;
      case "PageDown":
        d.preventDefault(), d.stopPropagation(), t.focusNextSection(d.shiftKey);
        break;
      case "End":
        d.preventDefault(), d.stopPropagation(), t.focusSectionEnd();
        break;
      case "Home":
        d.preventDefault(), d.stopPropagation(), t.focusSectionStart();
        break;
      case "ArrowLeft":
        d.preventDefault(), d.stopPropagation(), a === "rtl" ? t.focusNextDay() : t.focusPreviousDay();
        break;
      case "ArrowUp":
        d.preventDefault(), d.stopPropagation(), t.focusPreviousRow();
        break;
      case "ArrowRight":
        d.preventDefault(), d.stopPropagation(), a === "rtl" ? t.focusPreviousDay() : t.focusNextDay();
        break;
      case "ArrowDown":
        d.preventDefault(), d.stopPropagation(), t.focusNextRow();
        break;
      case "Escape":
        "setAnchorDate" in t && (d.preventDefault(), t.setAnchorDate(null));
        break;
    }
  }, i = ci(n, r, t.timeZone, !0), { ariaLabel: u, ariaLabelledBy: l } = ru.get(t), s = Oa({
    "aria-label": [
      u,
      i
    ].filter(Boolean).join(", "),
    "aria-labelledby": l
  }), c = lt({
    weekday: e.weekdayStyle || "narrow",
    timeZone: t.timeZone
  }), { locale: f } = Ze(), p = J(() => {
    let d = Tn(Pa(t.timeZone), f);
    return [
      ...new Array(7).keys()
    ].map((g) => {
      let v = d.add({
        days: g
      }).toDate(t.timeZone);
      return c.format(v);
    });
  }, [
    f,
    t.timeZone,
    c
  ]);
  return {
    gridProps: Me(s, {
      role: "grid",
      "aria-readonly": t.isReadOnly || null,
      "aria-disabled": t.isDisabled || null,
      "aria-multiselectable": "highlightedRange" in t || void 0,
      onKeyDown: o,
      onFocus: () => t.setFocused(!0),
      onBlur: () => t.setFocused(!1)
    }),
    headerProps: {
      // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
      // The day names are already included in the label of each cell, so there's no need to announce them twice.
      "aria-hidden": !0
    },
    weekDays: p
  };
}
function Zy(e) {
  return e && e.__esModule ? e.default : e;
}
function Jy(e, t, n) {
  let { date: r, isDisabled: a } = e, { errorMessageId: o, selectedDateDescription: i } = ru.get(t), u = Wt(Zy($r), "@react-aria/calendar"), l = lt({
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    era: dr(r),
    timeZone: t.timeZone
  }), s = t.isSelected(r), c = t.isCellFocused(r);
  a = a || t.isCellDisabled(r);
  let f = t.isCellUnavailable(r), p = !a && !f, d = t.isValueInvalid && ("highlightedRange" in t ? !t.anchorDate && t.highlightedRange && r.compare(t.highlightedRange.start) >= 0 && r.compare(t.highlightedRange.end) <= 0 : t.value && Ae(t.value, r));
  d && (s = !0), r = Of(r, Ko);
  let g = J(() => r.toDate(t.timeZone), [
    r,
    t.timeZone
  ]), b = ld(r, t.timeZone), v = J(() => {
    let $ = "";
    return "highlightedRange" in t && t.value && !t.anchorDate && (Ae(r, t.value.start) || Ae(r, t.value.end)) && ($ = i + ", "), $ += l.format(g), b ? $ = u.format(s ? "todayDateSelected" : "todayDate", {
      date: $
    }) : s && ($ = u.format("dateSelected", {
      date: $
    })), t.minValue && Ae(r, t.minValue) ? $ += ", " + u.format("minimumDate") : t.maxValue && Ae(r, t.maxValue) && ($ += ", " + u.format("maximumDate")), $;
  }, [
    l,
    g,
    u,
    s,
    b,
    r,
    t,
    i
  ]), C = "";
  "anchorDate" in t && c && !t.isReadOnly && p && (t.anchorDate ? C = u.format("finishRangeSelectionPrompt") : C = u.format("startRangeSelectionPrompt"));
  let h = Ba(C), D = q(!1), x = q(!1), _ = q(null), { pressProps: O, isPressed: L } = kf({
    // When dragging to select a range, we don't want dragging over the original anchor
    // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
    shouldCancelOnPointerExit: "anchorDate" in t && !!t.anchorDate,
    preventFocusOnPress: !0,
    isDisabled: !p || t.isReadOnly,
    onPressStart($) {
      if (t.isReadOnly) {
        t.setFocusedDate(r);
        return;
      }
      if ("highlightedRange" in t && !t.anchorDate && ($.pointerType === "mouse" || $.pointerType === "touch")) {
        if (t.highlightedRange && !d) {
          if (Ae(r, t.highlightedRange.start)) {
            t.setAnchorDate(t.highlightedRange.end), t.setFocusedDate(r), t.setDragging(!0), x.current = !0;
            return;
          } else if (Ae(r, t.highlightedRange.end)) {
            t.setAnchorDate(t.highlightedRange.start), t.setFocusedDate(r), t.setDragging(!0), x.current = !0;
            return;
          }
        }
        let R = () => {
          t.setDragging(!0), _.current = null, t.selectDate(r), t.setFocusedDate(r), D.current = !0;
        };
        $.pointerType === "touch" ? _.current = setTimeout(R, 200) : R();
      }
    },
    onPressEnd() {
      x.current = !1, D.current = !1, clearTimeout(_.current), _.current = null;
    },
    onPress() {
      !("anchorDate" in t) && !t.isReadOnly && (t.selectDate(r), t.setFocusedDate(r));
    },
    onPressUp($) {
      if (!t.isReadOnly && ("anchorDate" in t && _.current && (t.selectDate(r), t.setFocusedDate(r)), "anchorDate" in t))
        if (x.current)
          t.setAnchorDate(r);
        else if (t.anchorDate && !D.current)
          t.selectDate(r), t.setFocusedDate(r);
        else if ($.pointerType === "keyboard" && !t.anchorDate) {
          t.selectDate(r);
          let R = r.add({
            days: 1
          });
          t.isInvalid(R) && (R = r.subtract({
            days: 1
          })), t.isInvalid(R) || t.setFocusedDate(R);
        } else $.pointerType === "virtual" && (t.selectDate(r), t.setFocusedDate(r));
    }
  }), y = null;
  a || (y = Ae(r, t.focusedDate) ? 0 : -1), te(() => {
    c && n.current && (Lt(n.current), Ji() !== "pointer" && document.activeElement === n.current && Tf(n.current, {
      containingElement: Af(n.current)
    }));
  }, [
    c,
    n
  ]);
  let F = lt({
    day: "numeric",
    timeZone: t.timeZone,
    calendar: r.calendar.identifier
  }), T = J(() => F.formatToParts(g).find(($) => $.type === "day").value, [
    F,
    g
  ]);
  return {
    cellProps: {
      role: "gridcell",
      "aria-disabled": !p || null,
      "aria-selected": s || null,
      "aria-invalid": d || null
    },
    buttonProps: Me(O, {
      onFocus() {
        a || t.setFocusedDate(r);
      },
      tabIndex: y,
      role: "button",
      "aria-disabled": !p || null,
      "aria-label": v,
      "aria-invalid": d || null,
      "aria-describedby": [
        d ? o : null,
        h["aria-describedby"]
      ].filter(Boolean).join(" ") || void 0,
      onPointerEnter($) {
        "highlightDate" in t && ($.pointerType !== "touch" || t.isDragging) && p && t.highlightDate(r);
      },
      onPointerDown($) {
        "releasePointerCapture" in $.target && $.target.releasePointerCapture($.pointerId);
      },
      onContextMenu($) {
        $.preventDefault();
      }
    }),
    isPressed: L,
    isFocused: c,
    isSelected: s,
    isDisabled: a,
    isUnavailable: f,
    isOutsideVisibleRange: r.compare(t.visibleRange.start) < 0 || r.compare(t.visibleRange.end) > 0,
    isInvalid: d,
    formattedDate: T
  };
}
function Ye(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function ie() {
  return ie = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ie.apply(this, arguments);
}
function fi(e, t) {
  return fi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, fi(e, t);
}
function Xy(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, fi(e, t);
}
var mi = { exports: {} }, _e = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hs;
function Qy() {
  if (hs) return _e;
  hs = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), i = Symbol.for("react.context"), u = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function b(v) {
    if (typeof v == "object" && v !== null) {
      var C = v.$$typeof;
      switch (C) {
        case e:
          switch (v = v.type, v) {
            case n:
            case a:
            case r:
            case s:
            case c:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case u:
                case i:
                case l:
                case p:
                case f:
                case o:
                  return v;
                default:
                  return C;
              }
          }
        case t:
          return C;
      }
    }
  }
  return _e.ContextConsumer = i, _e.ContextProvider = o, _e.Element = e, _e.ForwardRef = l, _e.Fragment = n, _e.Lazy = p, _e.Memo = f, _e.Portal = t, _e.Profiler = a, _e.StrictMode = r, _e.Suspense = s, _e.SuspenseList = c, _e.isAsyncMode = function() {
    return !1;
  }, _e.isConcurrentMode = function() {
    return !1;
  }, _e.isContextConsumer = function(v) {
    return b(v) === i;
  }, _e.isContextProvider = function(v) {
    return b(v) === o;
  }, _e.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, _e.isForwardRef = function(v) {
    return b(v) === l;
  }, _e.isFragment = function(v) {
    return b(v) === n;
  }, _e.isLazy = function(v) {
    return b(v) === p;
  }, _e.isMemo = function(v) {
    return b(v) === f;
  }, _e.isPortal = function(v) {
    return b(v) === t;
  }, _e.isProfiler = function(v) {
    return b(v) === a;
  }, _e.isStrictMode = function(v) {
    return b(v) === r;
  }, _e.isSuspense = function(v) {
    return b(v) === s;
  }, _e.isSuspenseList = function(v) {
    return b(v) === c;
  }, _e.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === a || v === r || v === s || v === c || v === d || typeof v == "object" && v !== null && (v.$$typeof === p || v.$$typeof === f || v.$$typeof === o || v.$$typeof === i || v.$$typeof === l || v.$$typeof === g || v.getModuleId !== void 0);
  }, _e.typeOf = b, _e;
}
var $e = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vs;
function e1() {
  return vs || (vs = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), i = Symbol.for("react.context"), u = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g = !1, b = !1, v = !1, C = !1, h = !1, D;
    D = Symbol.for("react.module.reference");
    function x(ee) {
      return !!(typeof ee == "string" || typeof ee == "function" || ee === n || ee === a || h || ee === r || ee === s || ee === c || C || ee === d || g || b || v || typeof ee == "object" && ee !== null && (ee.$$typeof === p || ee.$$typeof === f || ee.$$typeof === o || ee.$$typeof === i || ee.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ee.$$typeof === D || ee.getModuleId !== void 0));
    }
    function _(ee) {
      if (typeof ee == "object" && ee !== null) {
        var we = ee.$$typeof;
        switch (we) {
          case e:
            var ve = ee.type;
            switch (ve) {
              case n:
              case a:
              case r:
              case s:
              case c:
                return ve;
              default:
                var Te = ve && ve.$$typeof;
                switch (Te) {
                  case u:
                  case i:
                  case l:
                  case p:
                  case f:
                  case o:
                    return Te;
                  default:
                    return we;
                }
            }
          case t:
            return we;
        }
      }
    }
    var O = i, L = o, y = e, F = l, T = n, $ = p, R = f, P = t, S = a, V = r, k = s, w = c, A = !1, K = !1;
    function E(ee) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(ee) {
      return K || (K = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(ee) {
      return _(ee) === i;
    }
    function N(ee) {
      return _(ee) === o;
    }
    function H(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === e;
    }
    function W(ee) {
      return _(ee) === l;
    }
    function Z(ee) {
      return _(ee) === n;
    }
    function M(ee) {
      return _(ee) === p;
    }
    function U(ee) {
      return _(ee) === f;
    }
    function X(ee) {
      return _(ee) === t;
    }
    function Q(ee) {
      return _(ee) === a;
    }
    function oe(ee) {
      return _(ee) === r;
    }
    function z(ee) {
      return _(ee) === s;
    }
    function xe(ee) {
      return _(ee) === c;
    }
    $e.ContextConsumer = O, $e.ContextProvider = L, $e.Element = y, $e.ForwardRef = F, $e.Fragment = T, $e.Lazy = $, $e.Memo = R, $e.Portal = P, $e.Profiler = S, $e.StrictMode = V, $e.Suspense = k, $e.SuspenseList = w, $e.isAsyncMode = E, $e.isConcurrentMode = B, $e.isContextConsumer = j, $e.isContextProvider = N, $e.isElement = H, $e.isForwardRef = W, $e.isFragment = Z, $e.isLazy = M, $e.isMemo = U, $e.isPortal = X, $e.isProfiler = Q, $e.isStrictMode = oe, $e.isSuspense = z, $e.isSuspenseList = xe, $e.isValidElementType = x, $e.typeOf = _;
  }()), $e;
}
process.env.NODE_ENV === "production" ? mi.exports = Qy() : mi.exports = e1();
var ys = mi.exports;
const bs = (e) => typeof e == "object" && e != null && e.nodeType === 1, Ds = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", wo = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return Ds(n.overflowY, t) || Ds(n.overflowX, t) || ((r) => {
      const a = ((o) => {
        if (!o.ownerDocument || !o.ownerDocument.defaultView) return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!a && (a.clientHeight < r.scrollHeight || a.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, jr = (e, t, n, r, a, o, i, u) => o < e && i > t || o > e && i < t ? 0 : o <= e && u <= n || i >= t && u >= n ? o - e - r : i > t && u < n || o < e && u > n ? i - t + a : 0, t1 = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, n1 = (e, t) => {
  var n, r, a, o;
  if (typeof document > "u") return [];
  const { scrollMode: i, block: u, inline: l, boundary: s, skipOverflowHiddenElements: c } = t, f = typeof s == "function" ? s : (k) => k !== s;
  if (!bs(e)) throw new TypeError("Invalid target");
  const p = document.scrollingElement || document.documentElement, d = [];
  let g = e;
  for (; bs(g) && f(g); ) {
    if (g = t1(g), g === p) {
      d.push(g);
      break;
    }
    g != null && g === document.body && wo(g) && !wo(document.documentElement) || g != null && wo(g, c) && d.push(g);
  }
  const b = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, v = (o = (a = window.visualViewport) == null ? void 0 : a.height) != null ? o : innerHeight, { scrollX: C, scrollY: h } = window, { height: D, width: x, top: _, right: O, bottom: L, left: y } = e.getBoundingClientRect(), { top: F, right: T, bottom: $, left: R } = ((k) => {
    const w = window.getComputedStyle(k);
    return { top: parseFloat(w.scrollMarginTop) || 0, right: parseFloat(w.scrollMarginRight) || 0, bottom: parseFloat(w.scrollMarginBottom) || 0, left: parseFloat(w.scrollMarginLeft) || 0 };
  })(e);
  let P = u === "start" || u === "nearest" ? _ - F : u === "end" ? L + $ : _ + D / 2 - F + $, S = l === "center" ? y + x / 2 - R + T : l === "end" ? O + T : y - R;
  const V = [];
  for (let k = 0; k < d.length; k++) {
    const w = d[k], { height: A, width: K, top: E, right: B, bottom: j, left: N } = w.getBoundingClientRect();
    if (i === "if-needed" && _ >= 0 && y >= 0 && L <= v && O <= b && _ >= E && L <= j && y >= N && O <= B) return V;
    const H = getComputedStyle(w), W = parseInt(H.borderLeftWidth, 10), Z = parseInt(H.borderTopWidth, 10), M = parseInt(H.borderRightWidth, 10), U = parseInt(H.borderBottomWidth, 10);
    let X = 0, Q = 0;
    const oe = "offsetWidth" in w ? w.offsetWidth - w.clientWidth - W - M : 0, z = "offsetHeight" in w ? w.offsetHeight - w.clientHeight - Z - U : 0, xe = "offsetWidth" in w ? w.offsetWidth === 0 ? 0 : K / w.offsetWidth : 0, ee = "offsetHeight" in w ? w.offsetHeight === 0 ? 0 : A / w.offsetHeight : 0;
    if (p === w) X = u === "start" ? P : u === "end" ? P - v : u === "nearest" ? jr(h, h + v, v, Z, U, h + P, h + P + D, D) : P - v / 2, Q = l === "start" ? S : l === "center" ? S - b / 2 : l === "end" ? S - b : jr(C, C + b, b, W, M, C + S, C + S + x, x), X = Math.max(0, X + h), Q = Math.max(0, Q + C);
    else {
      X = u === "start" ? P - E - Z : u === "end" ? P - j + U + z : u === "nearest" ? jr(E, j, A, Z, U + z, P, P + D, D) : P - (E + A / 2) + z / 2, Q = l === "start" ? S - N - W : l === "center" ? S - (N + K / 2) + oe / 2 : l === "end" ? S - B + M + oe : jr(N, B, K, W, M + oe, S, S + x, x);
      const { scrollLeft: we, scrollTop: ve } = w;
      X = ee === 0 ? 0 : Math.max(0, Math.min(ve + X / ee, w.scrollHeight - A / ee + z)), Q = xe === 0 ? 0 : Math.max(0, Math.min(we + Q / xe, w.scrollWidth - K / xe + oe)), P += ve - X, S += we - Q;
    }
    V.push({ el: w, top: X, left: Q });
  }
  return V;
};
var r1 = 0;
function _s(e) {
  return typeof e == "function" ? e : We;
}
function We() {
}
function wp(e, t) {
  if (e) {
    var n = n1(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var a = r.el, o = r.top, i = r.left;
      a.scrollTop = o, a.scrollLeft = i;
    });
  }
}
function $s(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function Va(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function a() {
    for (var o = arguments.length, i = new Array(o), u = 0; u < o; u++)
      i[u] = arguments[u];
    r(), n = setTimeout(function() {
      n = null, e.apply(void 0, i);
    }, t);
  }
  return a.cancel = r, a;
}
function he() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
      o[i - 1] = arguments[i];
    return t.some(function(u) {
      return u && u.apply(void 0, [r].concat(o)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function mt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    t.forEach(function(a) {
      typeof a == "function" ? a(r) : a && (a.current = r);
    });
  };
}
function Sp() {
  return String(r1++);
}
function a1(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function xs(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function Ip(e) {
  return typeof e.type == "string";
}
function Pp(e) {
  return e.props;
}
function o1(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var i1 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Lr(e) {
  e === void 0 && (e = {});
  var t = {};
  return i1.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function fr(e, t) {
  return !e || !t ? e : Object.keys(e).reduce(function(n, r) {
    return n[r] = ga(t, r) ? t[r] : e[r], n;
  }, {});
}
function ga(e, t) {
  return e[t] !== void 0;
}
function Nn(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function u1(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function pt(e, t, n, r, a) {
  a === void 0 && (a = !1);
  var o = n.length;
  if (o === 0)
    return -1;
  var i = o - 1;
  (typeof e != "number" || e < 0 || e > i) && (e = t > 0 ? -1 : i + 1);
  var u = e + t;
  u < 0 ? u = a ? i : 0 : u > i && (u = a ? 0 : i);
  var l = Kt(u, t < 0, n, r, a);
  return l === -1 ? e >= o ? -1 : e : l;
}
function Kt(e, t, n, r, a) {
  a === void 0 && (a = !1);
  var o = n.length;
  if (t) {
    for (var i = e; i >= 0; i--)
      if (!r(n[i], i))
        return i;
  } else
    for (var u = e; u < o; u++)
      if (!r(n[u], u))
        return u;
  return a ? Kt(t ? o - 1 : 0, t, n, r) : -1;
}
function ha(e, t, n, r) {
  return r === void 0 && (r = !0), n && t.some(function(a) {
    return a && ($s(a, e, n) || r && $s(a, n.document.activeElement, n));
  });
}
var au = We;
process.env.NODE_ENV !== "production" && (au = function(t, n, r) {
  var a = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(o) {
    n[o] !== void 0 && r[o] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + o + '" to be uncontrolled. ' + a) : n[o] === void 0 && r[o] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + o + '" to be controlled. ' + a);
  });
});
var l1 = Va(function(e) {
  Rp(e).textContent = "";
}, 500);
function Rp(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function Fp(e, t) {
  if (!(!e || !t)) {
    var n = Rp(t);
    n.textContent = e, l1(t);
  }
}
function s1(e) {
  var t = e == null ? void 0 : e.getElementById("a11y-status-message");
  t && t.remove();
}
var Ap = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Tp = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Op = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Yr = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, qr = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Bp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Mp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, kp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, Vp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Np = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, jp = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Lp = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Hp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, pi = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Kp = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, zp = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Up = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, c1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: Kp,
  blurInput: jp,
  changeInput: Lp,
  clickButton: pi,
  clickItem: Np,
  controlledPropUpdatedSelectedItem: zp,
  itemMouseEnter: Op,
  keyDownArrowDown: qr,
  keyDownArrowUp: Yr,
  keyDownEnd: Vp,
  keyDownEnter: Mp,
  keyDownEscape: Bp,
  keyDownHome: kp,
  keyDownSpaceButton: Hp,
  mouseUp: Tp,
  touchEnd: Up,
  unknown: Ap
}), d1 = ["refKey", "ref"], f1 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], m1 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], p1 = ["refKey", "ref"], g1 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], h1 = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    function n(a) {
      var o;
      o = t.call(this, a) || this, o.id = o.props.id || "downshift-" + Sp(), o.menuId = o.props.menuId || o.id + "-menu", o.labelId = o.props.labelId || o.id + "-label", o.inputId = o.props.inputId || o.id + "-input", o.getItemId = o.props.getItemId || function(h) {
        return o.id + "-item-" + h;
      }, o.items = [], o.itemCount = null, o.previousResultCount = 0, o.timeoutIds = [], o.internalSetTimeout = function(h, D) {
        var x = setTimeout(function() {
          o.timeoutIds = o.timeoutIds.filter(function(_) {
            return _ !== x;
          }), h();
        }, D);
        o.timeoutIds.push(x);
      }, o.setItemCount = function(h) {
        o.itemCount = h;
      }, o.unsetItemCount = function() {
        o.itemCount = null;
      }, o.isItemDisabled = function(h, D) {
        var x = o.getItemNodeFromIndex(D);
        return x && x.hasAttribute("disabled");
      }, o.setHighlightedIndex = function(h, D) {
        h === void 0 && (h = o.props.defaultHighlightedIndex), D === void 0 && (D = {}), D = Lr(D), o.internalSetState(ie({
          highlightedIndex: h
        }, D));
      }, o.clearSelection = function(h) {
        o.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: o.props.defaultHighlightedIndex,
          isOpen: o.props.defaultIsOpen
        }, h);
      }, o.selectItem = function(h, D, x) {
        D = Lr(D), o.internalSetState(ie({
          isOpen: o.props.defaultIsOpen,
          highlightedIndex: o.props.defaultHighlightedIndex,
          selectedItem: h,
          inputValue: o.props.itemToString(h)
        }, D), x);
      }, o.selectItemAtIndex = function(h, D, x) {
        var _ = o.items[h];
        _ != null && o.selectItem(_, D, x);
      }, o.selectHighlightedItem = function(h, D) {
        return o.selectItemAtIndex(o.getState().highlightedIndex, h, D);
      }, o.internalSetState = function(h, D) {
        var x, _, O = {}, L = typeof h == "function";
        return !L && h.hasOwnProperty("inputValue") && o.props.onInputValueChange(h.inputValue, ie({}, o.getStateAndHelpers(), h)), o.setState(function(y) {
          var F;
          y = o.getState(y);
          var T = L ? h(y) : h;
          T = o.props.stateReducer(y, T), x = T.hasOwnProperty("selectedItem");
          var $ = {};
          return x && T.selectedItem !== y.selectedItem && (_ = T.selectedItem), (F = T).type || (F.type = Ap), Object.keys(T).forEach(function(R) {
            y[R] !== T[R] && (O[R] = T[R]), R !== "type" && (T[R], ga(o.props, R) || ($[R] = T[R]));
          }), L && T.hasOwnProperty("inputValue") && o.props.onInputValueChange(T.inputValue, ie({}, o.getStateAndHelpers(), T)), $;
        }, function() {
          _s(D)();
          var y = Object.keys(O).length > 1;
          y && o.props.onStateChange(O, o.getStateAndHelpers()), x && o.props.onSelect(h.selectedItem, o.getStateAndHelpers()), _ !== void 0 && o.props.onChange(_, o.getStateAndHelpers()), o.props.onUserAction(O, o.getStateAndHelpers());
        });
      }, o.rootRef = function(h) {
        return o._rootNode = h;
      }, o.getRootProps = function(h, D) {
        var x, _ = h === void 0 ? {} : h, O = _.refKey, L = O === void 0 ? "ref" : O, y = _.ref, F = Ye(_, d1), T = D === void 0 ? {} : D, $ = T.suppressRefError, R = $ === void 0 ? !1 : $;
        o.getRootProps.called = !0, o.getRootProps.refKey = L, o.getRootProps.suppressRefError = R;
        var P = o.getState(), S = P.isOpen;
        return ie((x = {}, x[L] = mt(y, o.rootRef), x.role = "combobox", x["aria-expanded"] = S, x["aria-haspopup"] = "listbox", x["aria-owns"] = S ? o.menuId : void 0, x["aria-labelledby"] = o.labelId, x), F);
      }, o.keyDownHandlers = {
        ArrowDown: function(D) {
          var x = this;
          if (D.preventDefault(), this.getState().isOpen) {
            var _ = D.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(_, {
              type: qr
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: qr
            }, function() {
              var O = x.getItemCount();
              if (O > 0) {
                var L = x.getState(), y = L.highlightedIndex, F = pt(y, 1, {
                  length: O
                }, x.isItemDisabled, !0);
                x.setHighlightedIndex(F, {
                  type: qr
                });
              }
            });
        },
        ArrowUp: function(D) {
          var x = this;
          if (D.preventDefault(), this.getState().isOpen) {
            var _ = D.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(_, {
              type: Yr
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Yr
            }, function() {
              var O = x.getItemCount();
              if (O > 0) {
                var L = x.getState(), y = L.highlightedIndex, F = pt(y, -1, {
                  length: O
                }, x.isItemDisabled, !0);
                x.setHighlightedIndex(F, {
                  type: Yr
                });
              }
            });
        },
        Enter: function(D) {
          if (D.which !== 229) {
            var x = this.getState(), _ = x.isOpen, O = x.highlightedIndex;
            if (_ && O != null) {
              D.preventDefault();
              var L = this.items[O], y = this.getItemNodeFromIndex(O);
              if (L == null || y && y.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Mp
              });
            }
          }
        },
        Escape: function(D) {
          D.preventDefault(), this.reset(ie({
            type: Bp
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, o.buttonKeyDownHandlers = ie({}, o.keyDownHandlers, {
        " ": function(D) {
          D.preventDefault(), this.toggleMenu({
            type: Hp
          });
        }
      }), o.inputKeyDownHandlers = ie({}, o.keyDownHandlers, {
        Home: function(D) {
          var x = this.getState(), _ = x.isOpen;
          if (_) {
            D.preventDefault();
            var O = this.getItemCount();
            if (!(O <= 0 || !_)) {
              var L = Kt(0, !1, {
                length: O
              }, this.isItemDisabled);
              this.setHighlightedIndex(L, {
                type: kp
              });
            }
          }
        },
        End: function(D) {
          var x = this.getState(), _ = x.isOpen;
          if (_) {
            D.preventDefault();
            var O = this.getItemCount();
            if (!(O <= 0 || !_)) {
              var L = Kt(O - 1, !0, {
                length: O
              }, this.isItemDisabled);
              this.setHighlightedIndex(L, {
                type: Vp
              });
            }
          }
        }
      }), o.getToggleButtonProps = function(h) {
        var D = h === void 0 ? {} : h, x = D.onClick;
        D.onPress;
        var _ = D.onKeyDown, O = D.onKeyUp, L = D.onBlur, y = Ye(D, f1), F = o.getState(), T = F.isOpen, $ = {
          onClick: he(x, o.buttonHandleClick),
          onKeyDown: he(_, o.buttonHandleKeyDown),
          onKeyUp: he(O, o.buttonHandleKeyUp),
          onBlur: he(L, o.buttonHandleBlur)
        }, R = y.disabled ? {} : $;
        return ie({
          type: "button",
          role: "button",
          "aria-label": T ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, R, y);
      }, o.buttonHandleKeyUp = function(h) {
        h.preventDefault();
      }, o.buttonHandleKeyDown = function(h) {
        var D = Nn(h);
        o.buttonKeyDownHandlers[D] && o.buttonKeyDownHandlers[D].call(o, h);
      }, o.buttonHandleClick = function(h) {
        if (h.preventDefault(), o.props.environment) {
          var D = o.props.environment.document, x = D.body, _ = D.activeElement;
          x && x === _ && h.target.focus();
        }
        process.env.NODE_ENV === "test" ? o.toggleMenu({
          type: pi
        }) : o.internalSetTimeout(function() {
          return o.toggleMenu({
            type: pi
          });
        });
      }, o.buttonHandleBlur = function(h) {
        var D = h.target;
        o.internalSetTimeout(function() {
          if (!(o.isMouseDown || !o.props.environment)) {
            var x = o.props.environment.document.activeElement;
            (x == null || x.id !== o.inputId) && x !== D && o.reset({
              type: Kp
            });
          }
        });
      }, o.getLabelProps = function(h) {
        return ie({
          htmlFor: o.inputId,
          id: o.labelId
        }, h);
      }, o.getInputProps = function(h) {
        var D = h === void 0 ? {} : h, x = D.onKeyDown, _ = D.onBlur, O = D.onChange, L = D.onInput;
        D.onChangeText;
        var y = Ye(D, m1), F, T = {};
        F = "onChange";
        var $ = o.getState(), R = $.inputValue, P = $.isOpen, S = $.highlightedIndex;
        if (!y.disabled) {
          var V;
          T = (V = {}, V[F] = he(O, L, o.inputHandleChange), V.onKeyDown = he(x, o.inputHandleKeyDown), V.onBlur = he(_, o.inputHandleBlur), V);
        }
        return ie({
          "aria-autocomplete": "list",
          "aria-activedescendant": P && typeof S == "number" && S >= 0 ? o.getItemId(S) : void 0,
          "aria-controls": P ? o.menuId : void 0,
          "aria-labelledby": y && y["aria-label"] ? void 0 : o.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: R,
          id: o.inputId
        }, T, y);
      }, o.inputHandleKeyDown = function(h) {
        var D = Nn(h);
        D && o.inputKeyDownHandlers[D] && o.inputKeyDownHandlers[D].call(o, h);
      }, o.inputHandleChange = function(h) {
        o.internalSetState({
          type: Lp,
          isOpen: !0,
          inputValue: h.target.value,
          highlightedIndex: o.props.defaultHighlightedIndex
        });
      }, o.inputHandleBlur = function() {
        o.internalSetTimeout(function() {
          var h;
          if (!(o.isMouseDown || !o.props.environment)) {
            var D = o.props.environment.document.activeElement, x = (D == null || (h = D.dataset) == null ? void 0 : h.toggle) && o._rootNode && o._rootNode.contains(D);
            x || o.reset({
              type: jp
            });
          }
        });
      }, o.menuRef = function(h) {
        o._menuNode = h;
      }, o.getMenuProps = function(h, D) {
        var x, _ = h === void 0 ? {} : h, O = _.refKey, L = O === void 0 ? "ref" : O, y = _.ref, F = Ye(_, p1), T = D === void 0 ? {} : D, $ = T.suppressRefError, R = $ === void 0 ? !1 : $;
        return o.getMenuProps.called = !0, o.getMenuProps.refKey = L, o.getMenuProps.suppressRefError = R, ie((x = {}, x[L] = mt(y, o.menuRef), x.role = "listbox", x["aria-labelledby"] = F && F["aria-label"] ? void 0 : o.labelId, x.id = o.menuId, x), F);
      }, o.getItemProps = function(h) {
        var D, x = h === void 0 ? {} : h, _ = x.onMouseMove, O = x.onMouseDown, L = x.onClick;
        x.onPress;
        var y = x.index, F = x.item, T = F === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : o1("getItemProps", "item") : F, $ = Ye(x, g1);
        y === void 0 ? (o.items.push(T), y = o.items.indexOf(T)) : o.items[y] = T;
        var R = "onClick", P = L, S = (D = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: he(_, function() {
            y !== o.getState().highlightedIndex && (o.setHighlightedIndex(y, {
              type: Op
            }), o.avoidScrolling = !0, o.internalSetTimeout(function() {
              return o.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: he(O, function(k) {
            k.preventDefault();
          })
        }, D[R] = he(P, function() {
          o.selectItemAtIndex(y, {
            type: Np
          });
        }), D), V = $.disabled ? {
          onMouseDown: S.onMouseDown
        } : S;
        return ie({
          id: o.getItemId(y),
          role: "option",
          "aria-selected": o.getState().highlightedIndex === y
        }, V, $);
      }, o.clearItems = function() {
        o.items = [];
      }, o.reset = function(h, D) {
        h === void 0 && (h = {}), h = Lr(h), o.internalSetState(function(x) {
          var _ = x.selectedItem;
          return ie({
            isOpen: o.props.defaultIsOpen,
            highlightedIndex: o.props.defaultHighlightedIndex,
            inputValue: o.props.itemToString(_)
          }, h);
        }, D);
      }, o.toggleMenu = function(h, D) {
        h === void 0 && (h = {}), h = Lr(h), o.internalSetState(function(x) {
          var _ = x.isOpen;
          return ie({
            isOpen: !_
          }, _ && {
            highlightedIndex: o.props.defaultHighlightedIndex
          }, h);
        }, function() {
          var x = o.getState(), _ = x.isOpen, O = x.highlightedIndex;
          _ && o.getItemCount() > 0 && typeof O == "number" && o.setHighlightedIndex(O, h), _s(D)();
        });
      }, o.openMenu = function(h) {
        o.internalSetState({
          isOpen: !0
        }, h);
      }, o.closeMenu = function(h) {
        o.internalSetState({
          isOpen: !1
        }, h);
      }, o.updateStatus = Va(function() {
        var h;
        if ((h = o.props) != null && (h = h.environment) != null && h.document) {
          var D = o.getState(), x = o.items[D.highlightedIndex], _ = o.getItemCount(), O = o.props.getA11yStatusMessage(ie({
            itemToString: o.props.itemToString,
            previousResultCount: o.previousResultCount,
            resultCount: _,
            highlightedItem: x
          }, D));
          o.previousResultCount = _, Fp(O, o.props.environment.document);
        }
      }, 200);
      var i = o.props, u = i.defaultHighlightedIndex, l = i.initialHighlightedIndex, s = l === void 0 ? u : l, c = i.defaultIsOpen, f = i.initialIsOpen, p = f === void 0 ? c : f, d = i.initialInputValue, g = d === void 0 ? "" : d, b = i.initialSelectedItem, v = b === void 0 ? null : b, C = o.getState({
        highlightedIndex: s,
        isOpen: p,
        inputValue: g,
        selectedItem: v
      });
      return C.selectedItem != null && o.props.initialInputValue === void 0 && (C.inputValue = o.props.itemToString(C.selectedItem)), o.state = C, o;
    }
    Xy(n, t);
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(o) {
        clearTimeout(o);
      }), this.timeoutIds = [];
    }, r.getState = function(o) {
      return o === void 0 && (o = this.state), fr(o, this.props);
    }, r.getItemCount = function() {
      var o = this.items.length;
      return this.itemCount != null ? o = this.itemCount : this.props.itemCount !== void 0 && (o = this.props.itemCount), o;
    }, r.getItemNodeFromIndex = function(o) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(o)) : null;
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var o = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(o, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(o, i) {
      var u = this.getItemCount(), l = this.getState(), s = l.highlightedIndex;
      if (u > 0) {
        var c = pt(s, o, {
          length: u
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(c, i);
      }
    }, r.getStateAndHelpers = function() {
      var o = this.getState(), i = o.highlightedIndex, u = o.inputValue, l = o.selectedItem, s = o.isOpen, c = this.props.itemToString, f = this.id, p = this.getRootProps, d = this.getToggleButtonProps, g = this.getLabelProps, b = this.getMenuProps, v = this.getInputProps, C = this.getItemProps, h = this.openMenu, D = this.closeMenu, x = this.toggleMenu, _ = this.selectItem, O = this.selectItemAtIndex, L = this.selectHighlightedItem, y = this.setHighlightedIndex, F = this.clearSelection, T = this.clearItems, $ = this.reset, R = this.setItemCount, P = this.unsetItemCount, S = this.internalSetState;
      return {
        // prop getters
        getRootProps: p,
        getToggleButtonProps: d,
        getLabelProps: g,
        getMenuProps: b,
        getInputProps: v,
        getItemProps: C,
        // actions
        reset: $,
        openMenu: h,
        closeMenu: D,
        toggleMenu: x,
        selectItem: _,
        selectItemAtIndex: O,
        selectHighlightedItem: L,
        setHighlightedIndex: y,
        clearSelection: F,
        clearItems: T,
        setItemCount: R,
        unsetItemCount: P,
        setState: S,
        // props
        itemToString: c,
        // derived
        id: f,
        // state
        highlightedIndex: i,
        inputValue: u,
        isOpen: s,
        selectedItem: l
      };
    }, r.componentDidMount = function() {
      var o = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Es(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          o.internalClearTimeouts();
        };
      else {
        var i = function() {
          o.isMouseDown = !0;
        }, u = function(d) {
          o.isMouseDown = !1;
          var g = ha(d.target, [o._rootNode, o._menuNode], o.props.environment);
          !g && o.getState().isOpen && o.reset({
            type: Tp
          }, function() {
            return o.props.onOuterClick(o.getStateAndHelpers());
          });
        }, l = function() {
          o.isTouchMove = !1;
        }, s = function() {
          o.isTouchMove = !0;
        }, c = function(d) {
          var g = ha(d.target, [o._rootNode, o._menuNode], o.props.environment, !1);
          !o.isTouchMove && !g && o.getState().isOpen && o.reset({
            type: Up
          }, function() {
            return o.props.onOuterClick(o.getStateAndHelpers());
          });
        }, f = this.props.environment;
        f.addEventListener("mousedown", i), f.addEventListener("mouseup", u), f.addEventListener("touchstart", l), f.addEventListener("touchmove", s), f.addEventListener("touchend", c), this.cleanup = function() {
          o.internalClearTimeouts(), o.updateStatus.cancel(), f.removeEventListener("mousedown", i), f.removeEventListener("mouseup", u), f.removeEventListener("touchstart", l), f.removeEventListener("touchmove", s), f.removeEventListener("touchend", c);
        };
      }
    }, r.shouldScroll = function(o, i) {
      var u = this.props.highlightedIndex === void 0 ? this.getState() : this.props, l = u.highlightedIndex, s = i.highlightedIndex === void 0 ? o : i, c = s.highlightedIndex, f = l && this.getState().isOpen && !o.isOpen, p = l !== c;
      return f || p;
    }, r.componentDidUpdate = function(o, i) {
      process.env.NODE_ENV !== "production" && (au(this.state, o, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Es(this._menuNode, this.getMenuProps)), ga(this.props, "selectedItem") && this.props.selectedItemChanged(o.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: zp,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(i, o) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var o = xs(this.props.children, We);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var i = xs(o(this.getStateAndHelpers()));
      if (!i)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && v1(i, this.getRootProps), i;
      if (Ip(i))
        return /* @__PURE__ */ Jg(i, this.getRootProps(Pp(i)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(Xg);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: a1,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && u1(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: We,
    onInputValueChange: We,
    onUserAction: We,
    onChange: We,
    onSelect: We,
    onOuterClick: We,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: wp
  }, e.stateChangeTypes = c1, e;
}();
process.env.NODE_ENV !== "production" && (h1.propTypes = {
  children: Y.func,
  defaultHighlightedIndex: Y.number,
  defaultIsOpen: Y.bool,
  initialHighlightedIndex: Y.number,
  initialSelectedItem: Y.any,
  initialInputValue: Y.string,
  initialIsOpen: Y.bool,
  getA11yStatusMessage: Y.func,
  itemToString: Y.func,
  onChange: Y.func,
  onSelect: Y.func,
  onStateChange: Y.func,
  onInputValueChange: Y.func,
  onUserAction: Y.func,
  onOuterClick: Y.func,
  selectedItemChanged: Y.func,
  stateReducer: Y.func,
  itemCount: Y.number,
  id: Y.string,
  environment: Y.shape({
    addEventListener: Y.func.isRequired,
    removeEventListener: Y.func.isRequired,
    document: Y.shape({
      createElement: Y.func.isRequired,
      getElementById: Y.func.isRequired,
      activeElement: Y.any.isRequired,
      body: Y.any.isRequired
    }).isRequired,
    Node: Y.func.isRequired
  }),
  suppressRefError: Y.bool,
  scrollIntoView: Y.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: Y.any,
  isOpen: Y.bool,
  inputValue: Y.string,
  highlightedIndex: Y.number,
  labelId: Y.string,
  inputId: Y.string,
  menuId: Y.string,
  getItemId: Y.func
  /* eslint-enable react/no-unused-prop-types */
});
function Es(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function v1(e, t) {
  var n = t.refKey, r = n !== "ref", a = !Ip(e);
  a && !r && !ys.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !a && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !ys.isForwardRef(e) && !Pp(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var Wp = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function y1(e, t, n) {
  var r = e.props, a = e.type, o = {};
  Object.keys(t).forEach(function(i) {
    b1(i, e, t, n), n[i] !== t[i] && (o[i] = n[i]);
  }), r.onStateChange && Object.keys(o).length && r.onStateChange(ie({
    type: a
  }, o));
}
function b1(e, t, n, r) {
  var a = t.props, o = t.type, i = "on" + iu(e) + "Change";
  a[i] && r[e] !== void 0 && r[e] !== n[e] && a[i](ie({
    type: o
  }, r));
}
function D1(e, t) {
  return t.changes;
}
var Cs = Va(function(e, t) {
  Fp(e, t);
}, 200), _1 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? js : te, Gp = "useId" in fe ? function(t) {
  var n = t.id, r = t.labelId, a = t.menuId, o = t.getItemId, i = t.toggleButtonId, u = t.inputId, l = "downshift-" + fe.useId();
  n || (n = l);
  var s = q({
    labelId: r || n + "-label",
    menuId: a || n + "-menu",
    getItemId: o || function(c) {
      return n + "-item-" + c;
    },
    toggleButtonId: i || n + "-toggle-button",
    inputId: u || n + "-input"
  });
  return s.current;
} : function(t) {
  var n = t.id, r = n === void 0 ? "downshift-" + Sp() : n, a = t.labelId, o = t.menuId, i = t.getItemId, u = t.toggleButtonId, l = t.inputId, s = q({
    labelId: a || r + "-label",
    menuId: o || r + "-menu",
    getItemId: i || function(c) {
      return r + "-item-" + c;
    },
    toggleButtonId: u || r + "-toggle-button",
    inputId: l || r + "-input"
  });
  return s.current;
};
function ou(e, t, n, r) {
  var a, o;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(r);
    a = n[t], o = t;
  } else
    o = t === void 0 ? n.indexOf(e) : t, a = e;
  return [a, o];
}
function $1(e) {
  return /^\S{1}$/.test(e);
}
function iu(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function Na(e) {
  var t = q(e);
  return t.current = e, t;
}
function Yp(e, t, n, r) {
  var a = q(), o = q(), i = ae(function(d, g) {
    o.current = g, d = fr(d, g.props);
    var b = e(d, g), v = g.props.stateReducer(d, ie({}, g, {
      changes: b
    }));
    return v;
  }, [e]), u = Qg(i, t, n), l = u[0], s = u[1], c = Na(t), f = ae(function(d) {
    return s(ie({
      props: c.current
    }, d));
  }, [c]), p = o.current;
  return te(function() {
    var d = fr(a.current, p == null ? void 0 : p.props), g = p && a.current && !r(d, l);
    g && y1(p, d, l), a.current = l;
  }, [l, p, r]), [l, f];
}
function qp(e, t, n, r) {
  var a = Yp(e, t, n, r), o = a[0], i = a[1];
  return [fr(o, t), i];
}
var ar = {
  itemToString: function(t) {
    return t ? String(t) : "";
  },
  itemToKey: function(t) {
    return t;
  },
  stateReducer: D1,
  scrollIntoView: wp,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Ct(e, t, n) {
  n === void 0 && (n = Wp);
  var r = e["default" + iu(t)];
  return r !== void 0 ? r : n[t];
}
function un(e, t, n) {
  n === void 0 && (n = Wp);
  var r = e[t];
  if (r !== void 0)
    return r;
  var a = e["initial" + iu(t)];
  return a !== void 0 ? a : Ct(e, t, n);
}
function Zp(e) {
  var t = un(e, "selectedItem"), n = un(e, "isOpen"), r = x1(e), a = un(e, "inputValue");
  return {
    highlightedIndex: r < 0 && t && n ? e.items.findIndex(function(o) {
      return e.itemToKey(o) === e.itemToKey(t);
    }) : r,
    isOpen: n,
    selectedItem: t,
    inputValue: a
  };
}
function ln(e, t, n) {
  var r = e.items, a = e.initialHighlightedIndex, o = e.defaultHighlightedIndex, i = e.isItemDisabled, u = e.itemToKey, l = t.selectedItem, s = t.highlightedIndex;
  return r.length === 0 ? -1 : a !== void 0 && s === a && !i(r[a], a) ? a : o !== void 0 && !i(r[o], o) ? o : l ? r.findIndex(function(c) {
    return u(l) === u(c);
  }) : n < 0 && !i(r[r.length - 1], r.length - 1) ? r.length - 1 : n > 0 && !i(r[0], 0) ? 0 : -1;
}
function Jp(e, t, n) {
  var r = q({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return te(function() {
    if (!e)
      return We;
    var a = n.map(function(c) {
      return c.current;
    });
    function o() {
      r.current.isTouchEnd = !1, r.current.isMouseDown = !0;
    }
    function i(c) {
      r.current.isMouseDown = !1, ha(c.target, a, e) || t();
    }
    function u() {
      r.current.isTouchEnd = !1, r.current.isTouchMove = !1;
    }
    function l() {
      r.current.isTouchMove = !0;
    }
    function s(c) {
      r.current.isTouchEnd = !0, !r.current.isTouchMove && !ha(c.target, a, e, !1) && t();
    }
    return e.addEventListener("mousedown", o), e.addEventListener("mouseup", i), e.addEventListener("touchstart", u), e.addEventListener("touchmove", l), e.addEventListener("touchend", s), function() {
      e.removeEventListener("mousedown", o), e.removeEventListener("mouseup", i), e.removeEventListener("touchstart", u), e.removeEventListener("touchmove", l), e.removeEventListener("touchend", s);
    };
  }, [n, e, t]), r.current;
}
var ja = function() {
  return We;
};
process.env.NODE_ENV !== "production" && (ja = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var a = q(n.reduce(function(i, u) {
    return i[u] = {}, i;
  }, {}));
  te(function() {
    Object.keys(a.current).forEach(function(i) {
      var u = a.current[i];
      if (!Object.keys(u).length) {
        console.error("downshift: You forgot to call the " + i + " getter function on your component / element.");
        return;
      }
      var l = u.suppressRefError, s = u.refKey, c = u.elementRef;
      l || c != null && c.current || console.error('downshift: The ref prop "' + s + '" from ' + i + " was not applied correctly on your element.");
    });
  }, []);
  var o = ae(function(i, u, l, s) {
    a.current[i] = {
      suppressRefError: u,
      refKey: l,
      elementRef: s
    };
  }, []);
  return o;
});
function uu(e, t, n, r) {
  r === void 0 && (r = {});
  var a = r.document, o = xr();
  te(function() {
    if (!(!e || o || !a)) {
      var i = e(t);
      Cs(i, a);
    }
  }, n), te(function() {
    return function() {
      Cs.cancel(), s1(a);
    };
  }, [a]);
}
function Xp(e) {
  var t = e.highlightedIndex, n = e.isOpen, r = e.itemRefs, a = e.getItemNodeFromIndex, o = e.menuElement, i = e.scrollIntoView, u = q(!0);
  return _1(function() {
    t < 0 || !n || !Object.keys(r.current).length || (u.current === !1 ? u.current = !0 : i(a(t), o));
  }, [t]), u;
}
var La = We;
process.env.NODE_ENV !== "production" && (La = function(t) {
  var n = t.props, r = t.state, a = q(n), o = xr();
  te(function() {
    o || (au(r, a.current, n), a.current = n);
  }, [r, n, o]);
});
function va(e, t, n) {
  var r;
  n === void 0 && (n = !0);
  var a = ((r = e.items) == null ? void 0 : r.length) && t >= 0;
  return ie({
    isOpen: !1,
    highlightedIndex: -1
  }, a && ie({
    selectedItem: e.items[t],
    isOpen: Ct(e, "isOpen"),
    highlightedIndex: Ct(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function Qp(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
function xr() {
  var e = fe.useRef(!0);
  return fe.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
function ya(e) {
  var t = Ct(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
function x1(e) {
  var t = un(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
var Zr = {
  environment: Y.shape({
    addEventListener: Y.func.isRequired,
    removeEventListener: Y.func.isRequired,
    document: Y.shape({
      createElement: Y.func.isRequired,
      getElementById: Y.func.isRequired,
      activeElement: Y.any.isRequired,
      body: Y.any.isRequired
    }).isRequired,
    Node: Y.func.isRequired
  }),
  itemToString: Y.func,
  itemToKey: Y.func,
  stateReducer: Y.func
}, eg = ie({}, Zr, {
  getA11yStatusMessage: Y.func,
  highlightedIndex: Y.number,
  defaultHighlightedIndex: Y.number,
  initialHighlightedIndex: Y.number,
  isOpen: Y.bool,
  defaultIsOpen: Y.bool,
  initialIsOpen: Y.bool,
  selectedItem: Y.any,
  initialSelectedItem: Y.any,
  defaultSelectedItem: Y.any,
  id: Y.string,
  labelId: Y.string,
  menuId: Y.string,
  getItemId: Y.func,
  toggleButtonId: Y.string,
  onSelectedItemChange: Y.func,
  onHighlightedIndexChange: Y.func,
  onStateChange: Y.func,
  onIsOpenChange: Y.func,
  scrollIntoView: Y.func
});
function tg(e, t, n) {
  var r = t.type, a = t.props, o;
  switch (r) {
    case n.ItemMouseMove:
      o = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      o = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      o = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : ln(a, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      o = {
        isOpen: !0,
        highlightedIndex: ln(a, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      o = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      o = {
        highlightedIndex: a.isItemDisabled(a.items[t.highlightedIndex], t.highlightedIndex) ? -1 : t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      o = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      o = {
        highlightedIndex: ya(a),
        isOpen: Ct(a, "isOpen"),
        selectedItem: Ct(a, "selectedItem"),
        inputValue: Ct(a, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return ie({}, e, o);
}
function E1(e) {
  for (var t = e.keysSoFar, n = e.highlightedIndex, r = e.items, a = e.itemToString, o = e.isItemDisabled, i = t.toLowerCase(), u = 0; u < r.length; u++) {
    var l = (u + n + (t.length < 2 ? 1 : 0)) % r.length, s = r[l];
    if (s !== void 0 && a(s).toLowerCase().startsWith(i) && !o(s, l))
      return l;
  }
  return n;
}
var C1 = kn(kn({}, eg), { items: Y.array.isRequired, isItemDisabled: Y.func }), w1 = kn(kn({}, ar), { isItemDisabled: function() {
  return !1;
} }), ng = We;
process.env.NODE_ENV !== "production" && (ng = function(e, t) {
  Y.checkPropTypes(C1, e, "prop", t.name);
});
var Jr = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0, lu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1, su = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2, ba = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3, cu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4, du = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5, fu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6, mu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7, pu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8, gu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9, hu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10, Da = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11, rg = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12, ag = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13, vu = process.env.NODE_ENV !== "production" ? "__item_click__" : 14, og = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, ig = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, ug = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, lg = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, yu = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, gi = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, sg = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, cg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  FunctionCloseMenu: ug,
  FunctionOpenMenu: ig,
  FunctionReset: sg,
  FunctionSelectItem: yu,
  FunctionSetHighlightedIndex: lg,
  FunctionSetInputValue: gi,
  FunctionToggleMenu: og,
  ItemClick: vu,
  ItemMouseMove: ag,
  MenuMouseLeave: rg,
  ToggleButtonBlur: Da,
  ToggleButtonClick: Jr,
  ToggleButtonKeyDownArrowDown: lu,
  ToggleButtonKeyDownArrowUp: su,
  ToggleButtonKeyDownCharacter: ba,
  ToggleButtonKeyDownEnd: fu,
  ToggleButtonKeyDownEnter: mu,
  ToggleButtonKeyDownEscape: cu,
  ToggleButtonKeyDownHome: du,
  ToggleButtonKeyDownPageDown: hu,
  ToggleButtonKeyDownPageUp: gu,
  ToggleButtonKeyDownSpaceButton: pu
});
function S1(e, t) {
  var n, r = t.type, a = t.props, o = t.altKey, i;
  switch (r) {
    case vu:
      i = {
        isOpen: Ct(a, "isOpen"),
        highlightedIndex: ya(a),
        selectedItem: a.items[t.index]
      };
      break;
    case ba:
      {
        var u = t.key, l = "" + e.inputValue + u, s = !e.isOpen && e.selectedItem ? a.items.findIndex(function(d) {
          return a.itemToKey(d) === a.itemToKey(e.selectedItem);
        }) : e.highlightedIndex, c = E1({
          keysSoFar: l,
          highlightedIndex: s,
          items: a.items,
          itemToString: a.itemToString,
          isItemDisabled: a.isItemDisabled
        });
        i = {
          inputValue: l,
          highlightedIndex: c,
          isOpen: !0
        };
      }
      break;
    case lu:
      {
        var f = e.isOpen ? pt(e.highlightedIndex, 1, a.items, a.isItemDisabled) : o && e.selectedItem == null ? -1 : ln(a, e, 1);
        i = {
          highlightedIndex: f,
          isOpen: !0
        };
      }
      break;
    case su:
      if (e.isOpen && o)
        i = va(a, e.highlightedIndex, !1);
      else {
        var p = e.isOpen ? pt(e.highlightedIndex, -1, a.items, a.isItemDisabled) : ln(a, e, -1);
        i = {
          highlightedIndex: p,
          isOpen: !0
        };
      }
      break;
    case mu:
    case pu:
      i = va(a, e.highlightedIndex, !1);
      break;
    case du:
      i = {
        highlightedIndex: Kt(0, !1, a.items, a.isItemDisabled),
        isOpen: !0
      };
      break;
    case fu:
      i = {
        highlightedIndex: Kt(a.items.length - 1, !0, a.items, a.isItemDisabled),
        isOpen: !0
      };
      break;
    case gu:
      i = {
        highlightedIndex: pt(e.highlightedIndex, -10, a.items, a.isItemDisabled)
      };
      break;
    case hu:
      i = {
        highlightedIndex: pt(e.highlightedIndex, 10, a.items, a.isItemDisabled)
      };
      break;
    case cu:
      i = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case Da:
      i = ie({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = a.items) == null ? void 0 : n.length) && {
        selectedItem: a.items[e.highlightedIndex]
      });
      break;
    case yu:
      i = {
        selectedItem: t.selectedItem
      };
      break;
    default:
      return tg(e, t, cg);
  }
  return ie({}, e, i);
}
var I1 = ["onClick"], P1 = ["onMouseLeave", "refKey", "ref"], R1 = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"], F1 = ["item", "index", "onMouseMove", "onClick", "onMouseDown", "onPress", "refKey", "disabled", "ref"];
ft.stateChangeTypes = cg;
function ft(e) {
  e === void 0 && (e = {}), ng(e, ft);
  var t = ie({}, w1, e), n = t.scrollIntoView, r = t.environment, a = t.getA11yStatusMessage, o = qp(S1, t, Zp, Qp), i = o[0], u = o[1], l = i.isOpen, s = i.highlightedIndex, c = i.selectedItem, f = i.inputValue, p = q(null), d = q(null), g = q({}), b = q(null), v = Gp(t), C = Na({
    state: i,
    props: t
  }), h = ae(function(A) {
    return g.current[v.getItemId(A)];
  }, [v]);
  uu(a, i, [l, s, c, f], r);
  var D = Xp({
    menuElement: d.current,
    highlightedIndex: s,
    isOpen: l,
    itemRefs: g,
    scrollIntoView: n,
    getItemNodeFromIndex: h
  });
  te(function() {
    return b.current = Va(function(A) {
      A({
        type: gi,
        inputValue: ""
      });
    }, 500), function() {
      b.current.cancel();
    };
  }, []), te(function() {
    f && b.current(u);
  }, [u, f]), La({
    props: t,
    state: i
  }), te(function() {
    var A = un(t, "isOpen");
    A && p.current && p.current.focus();
  }, []);
  var x = Jp(r, ae(function() {
    C.current.state.isOpen && u({
      type: Da
    });
  }, [u, C]), J(function() {
    return [d, p];
  }, [d.current, p.current])), _ = ja("getMenuProps", "getToggleButtonProps");
  te(function() {
    l || (g.current = {});
  }, [l]);
  var O = J(function() {
    return {
      ArrowDown: function(K) {
        K.preventDefault(), u({
          type: lu,
          altKey: K.altKey
        });
      },
      ArrowUp: function(K) {
        K.preventDefault(), u({
          type: su,
          altKey: K.altKey
        });
      },
      Home: function(K) {
        K.preventDefault(), u({
          type: du
        });
      },
      End: function(K) {
        K.preventDefault(), u({
          type: fu
        });
      },
      Escape: function() {
        C.current.state.isOpen && u({
          type: cu
        });
      },
      Enter: function(K) {
        K.preventDefault(), u({
          type: C.current.state.isOpen ? mu : Jr
        });
      },
      PageUp: function(K) {
        C.current.state.isOpen && (K.preventDefault(), u({
          type: gu
        }));
      },
      PageDown: function(K) {
        C.current.state.isOpen && (K.preventDefault(), u({
          type: hu
        }));
      },
      " ": function(K) {
        K.preventDefault();
        var E = C.current.state;
        if (!E.isOpen) {
          u({
            type: Jr
          });
          return;
        }
        E.inputValue ? u({
          type: ba,
          key: " "
        }) : u({
          type: pu
        });
      }
    };
  }, [u, C]), L = ae(function() {
    u({
      type: og
    });
  }, [u]), y = ae(function() {
    u({
      type: ug
    });
  }, [u]), F = ae(function() {
    u({
      type: ig
    });
  }, [u]), T = ae(function(A) {
    u({
      type: lg,
      highlightedIndex: A
    });
  }, [u]), $ = ae(function(A) {
    u({
      type: yu,
      selectedItem: A
    });
  }, [u]), R = ae(function() {
    u({
      type: sg
    });
  }, [u]), P = ae(function(A) {
    u({
      type: gi,
      inputValue: A
    });
  }, [u]), S = ae(function(A) {
    var K = A === void 0 ? {} : A, E = K.onClick, B = Ye(K, I1), j = function() {
      var H;
      (H = p.current) == null || H.focus();
    };
    return ie({
      id: v.labelId,
      htmlFor: v.toggleButtonId,
      onClick: he(E, j)
    }, B);
  }, [v]), V = ae(function(A, K) {
    var E, B = A === void 0 ? {} : A, j = B.onMouseLeave, N = B.refKey, H = N === void 0 ? "ref" : N, W = B.ref, Z = Ye(B, P1), M = K === void 0 ? {} : K, U = M.suppressRefError, X = U === void 0 ? !1 : U, Q = function() {
      u({
        type: rg
      });
    };
    return _("getMenuProps", X, H, d), ie((E = {}, E[H] = mt(W, function(oe) {
      d.current = oe;
    }), E.id = v.menuId, E.role = "listbox", E["aria-labelledby"] = Z && Z["aria-label"] ? void 0 : "" + v.labelId, E.onMouseLeave = he(j, Q), E), Z);
  }, [u, _, v]), k = ae(function(A, K) {
    var E, B = A === void 0 ? {} : A, j = B.onBlur, N = B.onClick;
    B.onPress;
    var H = B.onKeyDown, W = B.refKey, Z = W === void 0 ? "ref" : W, M = B.ref, U = Ye(B, R1), X = K === void 0 ? {} : K, Q = X.suppressRefError, oe = Q === void 0 ? !1 : Q, z = C.current.state, xe = function() {
      u({
        type: Jr
      });
    }, ee = function() {
      z.isOpen && !x.isMouseDown && u({
        type: Da
      });
    }, we = function(ke) {
      var Ve = Nn(ke);
      Ve && O[Ve] ? O[Ve](ke) : $1(Ve) && u({
        type: ba,
        key: Ve
      });
    }, ve = ie((E = {}, E[Z] = mt(M, function(Te) {
      p.current = Te;
    }), E["aria-activedescendant"] = z.isOpen && z.highlightedIndex > -1 ? v.getItemId(z.highlightedIndex) : "", E["aria-controls"] = v.menuId, E["aria-expanded"] = C.current.state.isOpen, E["aria-haspopup"] = "listbox", E["aria-labelledby"] = U && U["aria-label"] ? void 0 : "" + v.labelId, E.id = v.toggleButtonId, E.role = "combobox", E.tabIndex = 0, E.onBlur = he(j, ee), E), U);
    return U.disabled || (ve.onClick = he(N, xe), ve.onKeyDown = he(H, we)), _("getToggleButtonProps", oe, Z, p), ve;
  }, [u, v, C, x, _, O]), w = ae(function(A) {
    var K, E = A === void 0 ? {} : A, B = E.item, j = E.index, N = E.onMouseMove, H = E.onClick, W = E.onMouseDown;
    E.onPress;
    var Z = E.refKey, M = Z === void 0 ? "ref" : Z, U = E.disabled, X = E.ref, Q = Ye(E, F1);
    U !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
    var oe = C.current, z = oe.state, xe = oe.props, ee = ou(B, j, xe.items, "Pass either item or index to getItemProps!"), we = ee[0], ve = ee[1], Te = xe.isItemDisabled(we, ve), ke = function() {
      x.isTouchEnd || ve === z.highlightedIndex || (D.current = !1, u({
        type: ag,
        index: ve,
        disabled: Te
      }));
    }, Ve = function() {
      u({
        type: vu,
        index: ve
      });
    }, Gt = function(Yt) {
      return Yt.preventDefault();
    }, Ne = ie((K = {}, K[M] = mt(X, function(ze) {
      ze && (g.current[v.getItemId(ve)] = ze);
    }), K["aria-disabled"] = Te, K["aria-selected"] = we === z.selectedItem, K.id = v.getItemId(ve), K.role = "option", K), Q);
    return Te || (Ne.onClick = he(H, Ve)), Ne.onMouseMove = he(N, ke), Ne.onMouseDown = he(W, Gt), Ne;
  }, [C, v, x, D, u]);
  return {
    // prop getters.
    getToggleButtonProps: k,
    getLabelProps: S,
    getMenuProps: V,
    getItemProps: w,
    // actions.
    toggleMenu: L,
    openMenu: F,
    closeMenu: y,
    setHighlightedIndex: T,
    selectItem: $,
    reset: R,
    setInputValue: P,
    // state.
    highlightedIndex: s,
    isOpen: l,
    selectedItem: c,
    inputValue: f
  };
}
var bu = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Du = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, _u = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, $u = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, xu = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Eu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Cu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, wu = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Su = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, _a = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Iu = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, dg = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, fg = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Pu = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, mg = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, pg = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, gg = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, hg = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, vg = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Ru = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, yg = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, bg = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, Fu = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, Dg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: Fu,
  FunctionCloseMenu: hg,
  FunctionOpenMenu: gg,
  FunctionReset: bg,
  FunctionSelectItem: Ru,
  FunctionSetHighlightedIndex: vg,
  FunctionSetInputValue: yg,
  FunctionToggleMenu: pg,
  InputBlur: _a,
  InputChange: Su,
  InputClick: Iu,
  InputKeyDownArrowDown: bu,
  InputKeyDownArrowUp: Du,
  InputKeyDownEnd: xu,
  InputKeyDownEnter: wu,
  InputKeyDownEscape: _u,
  InputKeyDownHome: $u,
  InputKeyDownPageDown: Cu,
  InputKeyDownPageUp: Eu,
  ItemClick: Pu,
  ItemMouseMove: fg,
  MenuMouseLeave: dg,
  ToggleButtonClick: mg
});
function A1(e) {
  var t = Zp(e), n = t.selectedItem, r = t.inputValue;
  return r === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(n)), ie({}, t, {
    inputValue: r
  });
}
var T1 = ie({}, eg, {
  items: Y.array.isRequired,
  isItemDisabled: Y.func,
  inputValue: Y.string,
  defaultInputValue: Y.string,
  initialInputValue: Y.string,
  inputId: Y.string,
  onInputValueChange: Y.func
});
function O1(e, t, n, r) {
  var a = q(), o = Yp(e, t, n, r), i = o[0], u = o[1], l = xr();
  return te(function() {
    if (ga(t, "selectedItem")) {
      if (!l) {
        var s = t.itemToKey(t.selectedItem) !== t.itemToKey(a.current);
        s && u({
          type: Fu,
          inputValue: t.itemToString(t.selectedItem)
        });
      }
      a.current = i.selectedItem === a.current ? t.selectedItem : i.selectedItem;
    }
  }, [i.selectedItem, t.selectedItem]), [fr(i, t), u];
}
var _g = We;
process.env.NODE_ENV !== "production" && (_g = function(t, n) {
  Y.checkPropTypes(T1, t, "prop", n.name);
});
var B1 = ie({}, ar, {
  isItemDisabled: function() {
    return !1;
  }
});
function M1(e, t) {
  var n, r = t.type, a = t.props, o = t.altKey, i;
  switch (r) {
    case Pu:
      i = {
        isOpen: Ct(a, "isOpen"),
        highlightedIndex: ya(a),
        selectedItem: a.items[t.index],
        inputValue: a.itemToString(a.items[t.index])
      };
      break;
    case bu:
      e.isOpen ? i = {
        highlightedIndex: pt(e.highlightedIndex, 1, a.items, a.isItemDisabled, !0)
      } : i = {
        highlightedIndex: o && e.selectedItem == null ? -1 : ln(a, e, 1),
        isOpen: a.items.length >= 0
      };
      break;
    case Du:
      e.isOpen ? o ? i = va(a, e.highlightedIndex) : i = {
        highlightedIndex: pt(e.highlightedIndex, -1, a.items, a.isItemDisabled, !0)
      } : i = {
        highlightedIndex: ln(a, e, -1),
        isOpen: a.items.length >= 0
      };
      break;
    case wu:
      i = va(a, e.highlightedIndex);
      break;
    case _u:
      i = ie({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Eu:
      i = {
        highlightedIndex: pt(e.highlightedIndex, -10, a.items, a.isItemDisabled, !0)
      };
      break;
    case Cu:
      i = {
        highlightedIndex: pt(e.highlightedIndex, 10, a.items, a.isItemDisabled, !0)
      };
      break;
    case $u:
      i = {
        highlightedIndex: Kt(0, !1, a.items, a.isItemDisabled)
      };
      break;
    case xu:
      i = {
        highlightedIndex: Kt(a.items.length - 1, !0, a.items, a.isItemDisabled)
      };
      break;
    case _a:
      i = ie({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = a.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: a.items[e.highlightedIndex],
        inputValue: a.itemToString(a.items[e.highlightedIndex])
      });
      break;
    case Su:
      i = {
        isOpen: !0,
        highlightedIndex: ya(a),
        inputValue: t.inputValue
      };
      break;
    case Iu:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : ln(a, e, 0)
      };
      break;
    case Ru:
      i = {
        selectedItem: t.selectedItem,
        inputValue: a.itemToString(t.selectedItem)
      };
      break;
    case Fu:
      i = {
        inputValue: t.inputValue
      };
      break;
    default:
      return tg(e, t, Dg);
  }
  return ie({}, e, i);
}
var k1 = ["onMouseLeave", "refKey", "ref"], V1 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], N1 = ["onClick", "onPress", "refKey", "ref"], j1 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
xt.stateChangeTypes = Dg;
function xt(e) {
  e === void 0 && (e = {}), _g(e, xt);
  var t = ie({}, B1, e), n = t.items, r = t.scrollIntoView, a = t.environment, o = t.getA11yStatusMessage, i = O1(M1, t, A1, Qp), u = i[0], l = i[1], s = u.isOpen, c = u.highlightedIndex, f = u.selectedItem, p = u.inputValue, d = q(null), g = q({}), b = q(null), v = q(null), C = xr(), h = Gp(t), D = q(), x = Na({
    state: u,
    props: t
  }), _ = ae(function(j) {
    return g.current[h.getItemId(j)];
  }, [h]);
  uu(o, u, [s, c, f, p], a);
  var O = Xp({
    menuElement: d.current,
    highlightedIndex: c,
    isOpen: s,
    itemRefs: g,
    scrollIntoView: r,
    getItemNodeFromIndex: _
  });
  La({
    props: t,
    state: u
  }), te(function() {
    var j = un(t, "isOpen");
    j && b.current && b.current.focus();
  }, []), te(function() {
    C || (D.current = n.length);
  });
  var L = Jp(a, ae(function() {
    x.current.state.isOpen && l({
      type: _a,
      selectItem: !1
    });
  }, [l, x]), J(function() {
    return [d, v, b];
  }, [d.current, v.current, b.current])), y = ja("getInputProps", "getMenuProps");
  te(function() {
    s || (g.current = {});
  }, [s]), te(function() {
    var j;
    !s || !(a != null && a.document) || !(b != null && (j = b.current) != null && j.focus) || a.document.activeElement !== b.current && b.current.focus();
  }, [s, a]);
  var F = J(function() {
    return {
      ArrowDown: function(N) {
        N.preventDefault(), l({
          type: bu,
          altKey: N.altKey
        });
      },
      ArrowUp: function(N) {
        N.preventDefault(), l({
          type: Du,
          altKey: N.altKey
        });
      },
      Home: function(N) {
        x.current.state.isOpen && (N.preventDefault(), l({
          type: $u
        }));
      },
      End: function(N) {
        x.current.state.isOpen && (N.preventDefault(), l({
          type: xu
        }));
      },
      Escape: function(N) {
        var H = x.current.state;
        (H.isOpen || H.inputValue || H.selectedItem || H.highlightedIndex > -1) && (N.preventDefault(), l({
          type: _u
        }));
      },
      Enter: function(N) {
        var H = x.current.state;
        !H.isOpen || N.which === 229 || (N.preventDefault(), l({
          type: wu
        }));
      },
      PageUp: function(N) {
        x.current.state.isOpen && (N.preventDefault(), l({
          type: Eu
        }));
      },
      PageDown: function(N) {
        x.current.state.isOpen && (N.preventDefault(), l({
          type: Cu
        }));
      }
    };
  }, [l, x]), T = ae(function(j) {
    return ie({
      id: h.labelId,
      htmlFor: h.inputId
    }, j);
  }, [h]), $ = ae(function(j, N) {
    var H, W = j === void 0 ? {} : j, Z = W.onMouseLeave, M = W.refKey, U = M === void 0 ? "ref" : M, X = W.ref, Q = Ye(W, k1), oe = N === void 0 ? {} : N, z = oe.suppressRefError, xe = z === void 0 ? !1 : z;
    return y("getMenuProps", xe, U, d), ie((H = {}, H[U] = mt(X, function(ee) {
      d.current = ee;
    }), H.id = h.menuId, H.role = "listbox", H["aria-labelledby"] = Q && Q["aria-label"] ? void 0 : "" + h.labelId, H.onMouseLeave = he(Z, function() {
      l({
        type: dg
      });
    }), H), Q);
  }, [l, y, h]), R = ae(function(j) {
    var N, H, W = j === void 0 ? {} : j, Z = W.item, M = W.index, U = W.refKey, X = U === void 0 ? "ref" : U, Q = W.ref, oe = W.onMouseMove, z = W.onMouseDown, xe = W.onClick;
    W.onPress;
    var ee = W.disabled, we = Ye(W, V1);
    ee !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var ve = x.current, Te = ve.props, ke = ve.state, Ve = ou(Z, M, Te.items, "Pass either item or index to getItemProps!"), Gt = Ve[0], Ne = Ve[1], ze = Te.isItemDisabled(Gt, Ne), Yt = "onClick", hn = xe, ct = function() {
      L.isTouchEnd || Ne === ke.highlightedIndex || (O.current = !1, l({
        type: fg,
        index: Ne,
        disabled: ze
      }));
    }, $t = function() {
      l({
        type: Pu,
        index: Ne
      });
    }, Je = function(Cr) {
      return Cr.preventDefault();
    };
    return ie((N = {}, N[X] = mt(Q, function(et) {
      et && (g.current[h.getItemId(Ne)] = et);
    }), N["aria-disabled"] = ze, N["aria-selected"] = Ne === ke.highlightedIndex, N.id = h.getItemId(Ne), N.role = "option", N), !ze && (H = {}, H[Yt] = he(hn, $t), H), {
      onMouseMove: he(oe, ct),
      onMouseDown: he(z, Je)
    }, we);
  }, [l, h, x, L, O]), P = ae(function(j) {
    var N, H = j === void 0 ? {} : j, W = H.onClick;
    H.onPress;
    var Z = H.refKey, M = Z === void 0 ? "ref" : Z, U = H.ref, X = Ye(H, N1), Q = x.current.state, oe = function() {
      l({
        type: mg
      });
    };
    return ie((N = {}, N[M] = mt(U, function(z) {
      v.current = z;
    }), N["aria-controls"] = h.menuId, N["aria-expanded"] = Q.isOpen, N.id = h.toggleButtonId, N.tabIndex = -1, N), !X.disabled && ie({}, {
      onClick: he(W, oe)
    }), X);
  }, [l, x, h]), S = ae(function(j, N) {
    var H, W = j === void 0 ? {} : j, Z = W.onKeyDown, M = W.onChange, U = W.onInput, X = W.onBlur;
    W.onChangeText;
    var Q = W.onClick, oe = W.refKey, z = oe === void 0 ? "ref" : oe, xe = W.ref, ee = Ye(W, j1), we = N === void 0 ? {} : N, ve = we.suppressRefError, Te = ve === void 0 ? !1 : ve;
    y("getInputProps", Te, z, b);
    var ke = x.current.state, Ve = function(Je) {
      var et = Nn(Je);
      et && F[et] && F[et](Je);
    }, Gt = function(Je) {
      l({
        type: Su,
        inputValue: Je.target.value
      });
    }, Ne = function(Je) {
      if (a != null && a.document && ke.isOpen && !L.isMouseDown) {
        var et = Je.relatedTarget === null && a.document.activeElement !== a.document.body;
        l({
          type: _a,
          selectItem: !et
        });
      }
    }, ze = function() {
      l({
        type: Iu
      });
    }, Yt = "onChange", hn = {};
    if (!ee.disabled) {
      var ct;
      hn = (ct = {}, ct[Yt] = he(M, U, Gt), ct.onKeyDown = he(Z, Ve), ct.onBlur = he(X, Ne), ct.onClick = he(Q, ze), ct);
    }
    return ie((H = {}, H[z] = mt(xe, function($t) {
      b.current = $t;
    }), H["aria-activedescendant"] = ke.isOpen && ke.highlightedIndex > -1 ? h.getItemId(ke.highlightedIndex) : "", H["aria-autocomplete"] = "list", H["aria-controls"] = h.menuId, H["aria-expanded"] = ke.isOpen, H["aria-labelledby"] = ee && ee["aria-label"] ? void 0 : h.labelId, H.autoComplete = "off", H.id = h.inputId, H.role = "combobox", H.value = ke.inputValue, H), hn, ee);
  }, [l, h, a, F, x, L, y]), V = ae(function() {
    l({
      type: pg
    });
  }, [l]), k = ae(function() {
    l({
      type: hg
    });
  }, [l]), w = ae(function() {
    l({
      type: gg
    });
  }, [l]), A = ae(function(j) {
    l({
      type: vg,
      highlightedIndex: j
    });
  }, [l]), K = ae(function(j) {
    l({
      type: Ru,
      selectedItem: j
    });
  }, [l]), E = ae(function(j) {
    l({
      type: yg,
      inputValue: j
    });
  }, [l]), B = ae(function() {
    l({
      type: bg
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: R,
    getLabelProps: T,
    getMenuProps: $,
    getInputProps: S,
    getToggleButtonProps: P,
    // actions.
    toggleMenu: V,
    openMenu: w,
    closeMenu: k,
    setHighlightedIndex: A,
    setInputValue: E,
    selectItem: K,
    reset: B,
    // state.
    highlightedIndex: c,
    isOpen: s,
    selectedItem: f,
    inputValue: p
  };
}
var $g = {
  activeIndex: -1,
  selectedItems: []
};
function ws(e, t) {
  return un(e, t, $g);
}
function Ss(e, t) {
  return Ct(e, t, $g);
}
function L1(e) {
  var t = ws(e, "activeIndex"), n = ws(e, "selectedItems");
  return {
    activeIndex: t,
    selectedItems: n
  };
}
function Is(e) {
  if (e.shiftKey || e.metaKey || e.ctrlKey || e.altKey)
    return !1;
  var t = e.target;
  return !(t instanceof HTMLInputElement && // if element is a text input
  t.value !== "" && // and we have text in it
  // and cursor is either not at the start or is currently highlighting text.
  (t.selectionStart !== 0 || t.selectionEnd !== 0));
}
function H1(e, t) {
  return e.selectedItems === t.selectedItems && e.activeIndex === t.activeIndex;
}
var K1 = {
  stateReducer: Zr.stateReducer,
  itemToKey: Zr.itemToKey,
  environment: Zr.environment,
  selectedItems: Y.array,
  initialSelectedItems: Y.array,
  defaultSelectedItems: Y.array,
  getA11yStatusMessage: Y.func,
  activeIndex: Y.number,
  initialActiveIndex: Y.number,
  defaultActiveIndex: Y.number,
  onActiveIndexChange: Y.func,
  onSelectedItemsChange: Y.func,
  keyNavigationNext: Y.string,
  keyNavigationPrevious: Y.string
}, z1 = {
  itemToKey: ar.itemToKey,
  stateReducer: ar.stateReducer,
  environment: ar.environment,
  keyNavigationNext: "ArrowRight",
  keyNavigationPrevious: "ArrowLeft"
}, xg = We;
process.env.NODE_ENV !== "production" && (xg = function(t, n) {
  Y.checkPropTypes(K1, t, "prop", n.name);
});
var Au = process.env.NODE_ENV !== "production" ? "__selected_item_click__" : 0, Tu = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_delete__" : 1, Ou = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_backspace__" : 2, Bu = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_next__" : 3, Mu = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_previous__" : 4, ku = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_navigation_previous__" : 5, Vu = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_backspace__" : 6, Nu = process.env.NODE_ENV !== "production" ? "__dropdown_click__" : 7, ju = process.env.NODE_ENV !== "production" ? "__function_add_selected_item__" : 8, Lu = process.env.NODE_ENV !== "production" ? "__function_remove_selected_item__" : 9, Hu = process.env.NODE_ENV !== "production" ? "__function_set_selected_items__" : 10, Ku = process.env.NODE_ENV !== "production" ? "__function_set_active_index__" : 11, zu = process.env.NODE_ENV !== "production" ? "__function_reset__" : 12, U1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DropdownClick: Nu,
  DropdownKeyDownBackspace: Vu,
  DropdownKeyDownNavigationPrevious: ku,
  FunctionAddSelectedItem: ju,
  FunctionRemoveSelectedItem: Lu,
  FunctionReset: zu,
  FunctionSetActiveIndex: Ku,
  FunctionSetSelectedItems: Hu,
  SelectedItemClick: Au,
  SelectedItemKeyDownBackspace: Ou,
  SelectedItemKeyDownDelete: Tu,
  SelectedItemKeyDownNavigationNext: Bu,
  SelectedItemKeyDownNavigationPrevious: Mu
});
function W1(e, t) {
  var n = t.type, r = t.index, a = t.props, o = t.selectedItem, i = e.activeIndex, u = e.selectedItems, l;
  switch (n) {
    case Au:
      l = {
        activeIndex: r
      };
      break;
    case Mu:
      l = {
        activeIndex: i - 1 < 0 ? 0 : i - 1
      };
      break;
    case Bu:
      l = {
        activeIndex: i + 1 >= u.length ? -1 : i + 1
      };
      break;
    case Ou:
    case Tu: {
      if (i < 0)
        break;
      var s = i;
      u.length === 1 ? s = -1 : i === u.length - 1 && (s = u.length - 2), l = ie({
        selectedItems: [].concat(u.slice(0, i), u.slice(i + 1))
      }, {
        activeIndex: s
      });
      break;
    }
    case ku:
      l = {
        activeIndex: u.length - 1
      };
      break;
    case Vu:
      l = {
        selectedItems: u.slice(0, u.length - 1)
      };
      break;
    case ju:
      l = {
        selectedItems: [].concat(u, [o])
      };
      break;
    case Nu:
      l = {
        activeIndex: -1
      };
      break;
    case Lu: {
      var c = i, f = u.findIndex(function(g) {
        return a.itemToKey(g) === a.itemToKey(o);
      });
      if (f < 0)
        break;
      u.length === 1 ? c = -1 : f === u.length - 1 && (c = u.length - 2), l = {
        selectedItems: [].concat(u.slice(0, f), u.slice(f + 1)),
        activeIndex: c
      };
      break;
    }
    case Hu: {
      var p = t.selectedItems;
      l = {
        selectedItems: p
      };
      break;
    }
    case Ku: {
      var d = t.activeIndex;
      l = {
        activeIndex: d
      };
      break;
    }
    case zu:
      l = {
        activeIndex: Ss(a, "activeIndex"),
        selectedItems: Ss(a, "selectedItems")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return ie({}, e, l);
}
var G1 = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"], Y1 = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
it.stateChangeTypes = U1;
function it(e) {
  e === void 0 && (e = {}), xg(e, it);
  var t = ie({}, z1, e), n = t.getA11yStatusMessage, r = t.environment, a = t.keyNavigationNext, o = t.keyNavigationPrevious, i = qp(W1, t, L1, H1), u = i[0], l = i[1], s = u.activeIndex, c = u.selectedItems, f = xr(), p = q(null), d = q();
  d.current = [];
  var g = Na({
    state: u,
    props: t
  });
  uu(n, u, [s, c], r), te(function() {
    f || (s === -1 && p.current ? p.current.focus() : d.current[s] && d.current[s].focus());
  }, [s]), La({
    props: t,
    state: u
  });
  var b = ja("getDropdownProps"), v = J(function() {
    var F;
    return F = {}, F[o] = function() {
      l({
        type: Mu
      });
    }, F[a] = function() {
      l({
        type: Bu
      });
    }, F.Delete = function() {
      l({
        type: Tu
      });
    }, F.Backspace = function() {
      l({
        type: Ou
      });
    }, F;
  }, [l, a, o]), C = J(function() {
    var F;
    return F = {}, F[o] = function(T) {
      Is(T) && l({
        type: ku
      });
    }, F.Backspace = function($) {
      Is($) && l({
        type: Vu
      });
    }, F;
  }, [l, o]), h = ae(function(F) {
    var T, $ = F === void 0 ? {} : F, R = $.refKey, P = R === void 0 ? "ref" : R, S = $.ref, V = $.onClick, k = $.onKeyDown, w = $.selectedItem, A = $.index, K = Ye($, G1), E = g.current.state, B = ou(w, A, E.selectedItems, "Pass either item or index to getSelectedItemProps!"), j = B[1], N = j > -1 && j === E.activeIndex, H = function() {
      l({
        type: Au,
        index: j
      });
    }, W = function(M) {
      var U = Nn(M);
      U && v[U] && v[U](M);
    };
    return ie((T = {}, T[P] = mt(S, function(Z) {
      Z && d.current.push(Z);
    }), T.tabIndex = N ? 0 : -1, T.onClick = he(V, H), T.onKeyDown = he(k, W), T), K);
  }, [l, g, v]), D = ae(function(F, T) {
    var $, R = F === void 0 ? {} : F, P = R.refKey, S = P === void 0 ? "ref" : P, V = R.ref, k = R.onKeyDown, w = R.onClick, A = R.preventKeyAction, K = A === void 0 ? !1 : A, E = Ye(R, Y1), B = T === void 0 ? {} : T, j = B.suppressRefError, N = j === void 0 ? !1 : j;
    b("getDropdownProps", N, S, p);
    var H = function(M) {
      var U = Nn(M);
      U && C[U] && C[U](M);
    }, W = function() {
      l({
        type: Nu
      });
    };
    return ie(($ = {}, $[S] = mt(V, function(Z) {
      Z && (p.current = Z);
    }), $), !K && {
      onKeyDown: he(k, H),
      onClick: he(w, W)
    }, E);
  }, [l, C, b]), x = ae(function(F) {
    l({
      type: ju,
      selectedItem: F
    });
  }, [l]), _ = ae(function(F) {
    l({
      type: Lu,
      selectedItem: F
    });
  }, [l]), O = ae(function(F) {
    l({
      type: Hu,
      selectedItems: F
    });
  }, [l]), L = ae(function(F) {
    l({
      type: Ku,
      activeIndex: F
    });
  }, [l]), y = ae(function() {
    l({
      type: zu
    });
  }, [l]);
  return {
    getSelectedItemProps: h,
    getDropdownProps: D,
    addSelectedItem: x,
    removeSelectedItem: _,
    setSelectedItems: O,
    setActiveIndex: L,
    reset: y,
    selectedItems: c,
    activeIndex: s
  };
}
const Et = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, $a = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, q1 = {
  top: "left",
  left: "top"
}, hi = {
  top: "height",
  left: "width"
}, Eg = {
  width: "totalWidth",
  height: "totalHeight"
}, Hr = {};
let Qe = typeof document < "u" && window.visualViewport;
function Ps(e) {
  let t = 0, n = 0, r = 0, a = 0, o = 0, i = 0, u = {}, l = (Qe == null ? void 0 : Qe.scale) > 1;
  if (e.tagName === "BODY") {
    let f = document.documentElement;
    r = f.clientWidth, a = f.clientHeight;
    var s;
    t = (s = Qe == null ? void 0 : Qe.width) !== null && s !== void 0 ? s : r;
    var c;
    n = (c = Qe == null ? void 0 : Qe.height) !== null && c !== void 0 ? c : a, u.top = f.scrollTop || e.scrollTop, u.left = f.scrollLeft || e.scrollLeft, Qe && (o = Qe.offsetTop, i = Qe.offsetLeft);
  } else
    ({ width: t, height: n, top: o, left: i } = An(e)), u.top = e.scrollTop, u.left = e.scrollLeft, r = t, a = n;
  return Sf() && (e.tagName === "BODY" || e.tagName === "HTML") && l && (u.top = 0, u.left = 0, o = Qe.pageTop, i = Qe.pageLeft), {
    width: t,
    height: n,
    totalWidth: r,
    totalHeight: a,
    scroll: u,
    top: o,
    left: i
  };
}
function Z1(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function Rs(e, t, n, r, a, o, i) {
  let u = a.scroll[e], l = r[hi[e]], s = r.scroll[Et[e]] + o, c = l + r.scroll[Et[e]] - o, f = t - u + i[e] - r[Et[e]], p = t - u + n + i[e] - r[Et[e]];
  return f < s ? s - f : p > c ? Math.max(c - p, s - f) : 0;
}
function J1(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function Fs(e) {
  if (Hr[e]) return Hr[e];
  let [t, n] = e.split(" "), r = Et[t] || "right", a = q1[r];
  Et[n] || (n = "center");
  let o = hi[r], i = hi[a];
  return Hr[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: a,
    size: o,
    crossSize: i
  }, Hr[e];
}
function So(e, t, n, r, a, o, i, u, l, s) {
  let { placement: c, crossPlacement: f, axis: p, crossAxis: d, size: g, crossSize: b } = r, v = {};
  v[d] = e[d], f === "center" ? v[d] += (e[b] - n[b]) / 2 : f !== d && (v[d] += e[b] - n[b]), v[d] += o;
  const C = e[d] - n[b] + l + s, h = e[d] + e[b] - l - s;
  if (v[d] = Jo(v[d], C, h), c === p) {
    const D = u ? i[g] : t[Eg[g]];
    v[$a[p]] = Math.floor(D - e[p] + a);
  } else v[p] = Math.floor(e[p] + e[g] + a);
  return v;
}
function X1(e, t, n, r, a, o, i, u) {
  const l = r ? n.height : t[Eg.height];
  let s = e.top != null ? n.top + e.top : n.top + (l - e.bottom - i), c = u !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, t.height + t.top + t.scroll.top - s - (a.top + a.bottom + o))
  ) : Math.max(0, s + i - (t.top + t.scroll.top) - (a.top + a.bottom + o));
  return Math.min(t.height - o * 2, c);
}
function As(e, t, n, r, a, o) {
  let { placement: i, axis: u, size: l } = o;
  return i === u ? Math.max(0, n[u] - e[u] - e.scroll[u] + t[u] - r[u] - r[$a[u]] - a) : Math.max(0, e[l] + e[u] + e.scroll[u] - t[u] - n[u] - n[l] - r[u] - r[$a[u]] - a);
}
function Q1(e, t, n, r, a, o, i, u, l, s, c, f, p, d, g, b) {
  let v = Fs(e), { size: C, crossAxis: h, crossSize: D, placement: x, crossPlacement: _ } = v, O = So(t, u, n, v, c, f, s, p, g, b), L = c, y = As(u, s, t, a, o + c, v);
  if (i && r[C] > y) {
    let E = Fs(`${$a[x]} ${_}`), B = So(t, u, n, E, c, f, s, p, g, b);
    As(u, s, t, a, o + c, E) > y && (v = E, O = B, L = c);
  }
  let F = "bottom";
  v.axis === "top" ? v.placement === "top" ? F = "top" : v.placement === "bottom" && (F = "bottom") : v.crossAxis === "top" && (v.crossPlacement === "top" ? F = "bottom" : v.crossPlacement === "bottom" && (F = "top"));
  let T = Rs(h, O[h], n[D], u, l, o, s);
  O[h] += T;
  let $ = X1(O, u, s, p, a, o, n.height, F);
  d && d < $ && ($ = d), n.height = Math.min(n.height, $), O = So(t, u, n, v, L, f, s, p, g, b), T = Rs(h, O[h], n[D], u, l, o, s), O[h] += T;
  let R = {}, P = t[h] + 0.5 * t[D] - O[h] - a[Et[h]];
  const S = g / 2 + b, V = Et[h] === "left" ? a.left + a.right : a.top + a.bottom, k = n[D] - V - g / 2 - b, w = t[h] + g / 2 - (O[h] + a[Et[h]]), A = t[h] + t[D] - g / 2 - (O[h] + a[Et[h]]), K = Jo(P, w, A);
  return R[h] = Jo(K, S, k), {
    position: O,
    maxHeight: $,
    arrowOffsetLeft: R.left,
    arrowOffsetTop: R.top,
    placement: v.placement
  };
}
function eb(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: a, padding: o, shouldFlip: i, boundaryElement: u, offset: l, crossOffset: s, maxHeight: c, arrowSize: f = 0, arrowBoundaryOffset: p = 0 } = e, d = r instanceof HTMLElement ? tb(r) : document.documentElement, g = d === document.documentElement;
  const b = window.getComputedStyle(d).position;
  let v = !!b && b !== "static", C = g ? An(n) : Ts(n, d);
  if (!g) {
    let { marginTop: y, marginLeft: F } = window.getComputedStyle(n);
    C.top += parseInt(y, 10) || 0, C.left += parseInt(F, 10) || 0;
  }
  let h = An(r), D = J1(r);
  h.width += D.left + D.right, h.height += D.top + D.bottom;
  let x = Z1(a), _ = Ps(u), O = Ps(d), L = u.tagName === "BODY" ? An(d) : Ts(d, u);
  return d.tagName === "HTML" && u.tagName === "BODY" && (O.scroll.top = 0, O.scroll.left = 0), Q1(t, C, h, x, D, o, i, _, O, L, l, s, v, c, f, p);
}
function An(e) {
  let { top: t, left: n, width: r, height: a } = e.getBoundingClientRect(), { scrollTop: o, scrollLeft: i, clientTop: u, clientLeft: l } = document.documentElement;
  return {
    top: t + o - u,
    left: n + i - l,
    width: r,
    height: a
  };
}
function Ts(e, t) {
  let n = window.getComputedStyle(e), r;
  if (n.position === "fixed") {
    let { top: a, left: o, width: i, height: u } = e.getBoundingClientRect();
    r = {
      top: a,
      left: o,
      width: i,
      height: u
    };
  } else {
    r = An(e);
    let a = An(t), o = window.getComputedStyle(t);
    a.top += (parseInt(o.borderTopWidth, 10) || 0) - t.scrollTop, a.left += (parseInt(o.borderLeftWidth, 10) || 0) - t.scrollLeft, r.top -= a.top, r.left -= a.left;
  }
  return r.top -= parseInt(n.marginTop, 10) || 0, r.left -= parseInt(n.marginLeft, 10) || 0, r;
}
function tb(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !Os(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !Os(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function Os(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || // @ts-ignore
  "backdropFilter" in t && t.backdropFilter !== "none" || // @ts-ignore
  "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const nb = /* @__PURE__ */ new WeakMap();
function rb(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  te(() => {
    if (!n || r === null) return;
    let a = (o) => {
      let i = o.target;
      if (!t.current || i instanceof Node && !i.contains(t.current) || o.target instanceof HTMLInputElement || o.target instanceof HTMLTextAreaElement) return;
      let u = r || nb.get(t.current);
      u && u();
    };
    return window.addEventListener("scroll", a, !0), () => {
      window.removeEventListener("scroll", a, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
let Pe = typeof document < "u" && window.visualViewport;
function Cg(e) {
  let { direction: t } = Ze(), { arrowSize: n = 0, targetRef: r, overlayRef: a, scrollRef: o = a, placement: i = "bottom", containerPadding: u = 12, shouldFlip: l = !0, boundaryElement: s = typeof document < "u" ? document.body : null, offset: c = 0, crossOffset: f = 0, shouldUpdatePosition: p = !0, isOpen: d = !0, onClose: g, maxHeight: b, arrowBoundaryOffset: v = 0 } = e, [C, h] = re({
    position: {},
    arrowOffsetLeft: void 0,
    arrowOffsetTop: void 0,
    maxHeight: void 0,
    placement: void 0
  }), D = [
    p,
    i,
    a.current,
    r.current,
    o.current,
    u,
    l,
    s,
    c,
    f,
    d,
    t,
    b,
    v,
    n
  ], x = q(Pe == null ? void 0 : Pe.scale);
  te(() => {
    d && (x.current = Pe == null ? void 0 : Pe.scale);
  }, [
    d
  ]);
  let _ = ae(() => {
    if (p === !1 || !d || !a.current || !r.current || !s || (Pe == null ? void 0 : Pe.scale) !== x.current) return;
    let F = null;
    if (o.current && o.current.contains(document.activeElement)) {
      let S = document.activeElement.getBoundingClientRect(), V = o.current.getBoundingClientRect();
      F = {
        type: "top",
        offset: S.top - V.top
      }, F.offset > V.height / 2 && (F.type = "bottom", F.offset = S.bottom - V.bottom);
    }
    let T = a.current;
    if (!b && a.current) {
      var $;
      T.style.top = "0px", T.style.bottom = "";
      var R;
      T.style.maxHeight = ((R = ($ = window.visualViewport) === null || $ === void 0 ? void 0 : $.height) !== null && R !== void 0 ? R : window.innerHeight) + "px";
    }
    let P = eb({
      placement: ob(i, t),
      overlayNode: a.current,
      targetNode: r.current,
      scrollNode: o.current || a.current,
      padding: u,
      shouldFlip: l,
      boundaryElement: s,
      offset: c,
      crossOffset: f,
      maxHeight: b,
      arrowSize: n,
      arrowBoundaryOffset: v
    });
    if (T.style.top = "", T.style.bottom = "", T.style.left = "", T.style.right = "", Object.keys(P.position).forEach((S) => T.style[S] = P.position[S] + "px"), T.style.maxHeight = P.maxHeight != null ? P.maxHeight + "px" : void 0, F) {
      let S = document.activeElement.getBoundingClientRect(), V = o.current.getBoundingClientRect(), k = S[F.type] - V[F.type];
      o.current.scrollTop += k - F.offset;
    }
    h(P);
  }, D);
  st(_, D), ab(_), Zl({
    ref: a,
    onResize: _
  }), Zl({
    ref: r,
    onResize: _
  });
  let O = q(!1);
  st(() => {
    let F, T = () => {
      O.current = !0, clearTimeout(F), F = setTimeout(() => {
        O.current = !1;
      }, 500), _();
    }, $ = () => {
      O.current && T();
    };
    return Pe == null || Pe.addEventListener("resize", T), Pe == null || Pe.addEventListener("scroll", $), () => {
      Pe == null || Pe.removeEventListener("resize", T), Pe == null || Pe.removeEventListener("scroll", $);
    };
  }, [
    _
  ]);
  let L = ae(() => {
    O.current || g();
  }, [
    g,
    O
  ]);
  rb({
    triggerRef: r,
    isOpen: d,
    onClose: g && L
  });
  var y;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...C.position,
        maxHeight: (y = C.maxHeight) !== null && y !== void 0 ? y : "100vh"
      }
    },
    placement: C.placement,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: C.arrowOffsetLeft,
        top: C.arrowOffsetTop
      }
    },
    updatePosition: _
  };
}
function ab(e) {
  st(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function ob(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
function ib(e, t) {
  let n = _r(e, {
    labelable: !0
  }), { hoverProps: r } = zf({
    onHoverStart: () => t == null ? void 0 : t.open(!0),
    onHoverEnd: () => t == null ? void 0 : t.close()
  });
  return {
    tooltipProps: Me(n, r, {
      role: "tooltip"
    })
  };
}
function ub(e, t, n) {
  let { isDisabled: r, trigger: a } = e, o = vt(), i = q(!1), u = q(!1), l = () => {
    (i.current || u.current) && t.open(u.current);
  }, s = (C) => {
    !i.current && !u.current && t.close(C);
  };
  te(() => {
    let C = (h) => {
      n && n.current && h.key === "Escape" && (h.stopPropagation(), t.close(!0));
    };
    if (t.isOpen)
      return document.addEventListener("keydown", C, !0), () => {
        document.removeEventListener("keydown", C, !0);
      };
  }, [
    n,
    t
  ]);
  let c = () => {
    a !== "focus" && (Ji() === "pointer" ? i.current = !0 : i.current = !1, l());
  }, f = () => {
    a !== "focus" && (u.current = !1, i.current = !1, s());
  }, p = () => {
    u.current = !1, i.current = !1, s(!0);
  }, d = () => {
    q3() && (u.current = !0, l());
  }, g = () => {
    u.current = !1, i.current = !1, s(!0);
  }, { hoverProps: b } = zf({
    isDisabled: r,
    onHoverStart: c,
    onHoverEnd: f
  }), { focusableProps: v } = oy({
    isDisabled: r,
    onFocus: d,
    onBlur: g
  }, n);
  return {
    triggerProps: {
      "aria-describedby": t.isOpen ? o : void 0,
      ...Me(v, b, {
        onPointerDown: p,
        onKeyDown: p
      })
    },
    tooltipProps: {
      id: o
    }
  };
}
const Kr = (e) => !!(e != null && e.highlightedRange), lb = ({ state: e, date: t }) => {
  const n = q(null), {
    cellProps: r,
    buttonProps: a,
    isSelected: o,
    formattedDate: i,
    isOutsideVisibleRange: u,
    isDisabled: l
  } = Jy({ date: t }, e, n), s = Kr(e) && Ae(t, e.highlightedRange.end), c = Kr(e) && Ae(t, e == null ? void 0 : e.highlightedRange.start), f = Kr(e) && (e == null ? void 0 : e.highlightedRange.start) <= t && (e == null ? void 0 : e.highlightedRange.end) >= t;
  return /* @__PURE__ */ m.jsx("td", { ...r, children: /* @__PURE__ */ m.jsx(
    "div",
    {
      hidden: u,
      className: se({
        "c__calendar__wrapper__grid__week-row__background--range--disabled": f && l,
        "c__calendar__wrapper__grid__week-row__background--range": f,
        "c__calendar__wrapper__grid__week-row__background--range--end": s,
        "c__calendar__wrapper__grid__week-row__background--range--start": c
      }),
      children: /* @__PURE__ */ m.jsx(
        ge,
        {
          size: "small",
          color: (Kr(e) ? c || s : o) ? "primary" : "tertiary-text",
          className: se(
            "c__calendar__wrapper__grid__week-row__button",
            {
              "c__calendar__wrapper__grid__week-row__button--selected": o,
              "c__calendar__wrapper__grid__week-row__button--today": ld(
                t,
                vr()
              )
            }
          ),
          type: "button",
          disabled: l,
          ...a,
          onKeyDown: (p) => p.preventDefault(),
          onKeyUp: (p) => p.preventDefault(),
          ref: n,
          children: i
        }
      )
    }
  ) });
}, sb = ({
  state: e,
  defaultDaysInWeek: t = 7
}) => {
  const { locale: n } = Ze(), r = Xv(e.visibleRange.start, n), { gridProps: a, headerProps: o } = qy(
    {
      startDate: e.visibleRange.start,
      endDate: na(e.visibleRange.start)
    },
    e
  ), i = lt({
    weekday: "short",
    timeZone: e.timeZone
  }), u = J(() => {
    const l = Tn(Pa(e.timeZone), n);
    return ta(0, t - 1).map((s) => {
      const c = l.add({ days: s }).toDate(e.timeZone);
      return i.format(c);
    });
  }, [n, e.timeZone, i]);
  return /* @__PURE__ */ m.jsxs("table", { ...a, className: "c__calendar__wrapper__grid", children: [
    /* @__PURE__ */ m.jsx("thead", { ...o, children: /* @__PURE__ */ m.jsx("tr", { className: "c__calendar__wrapper__grid__header-row", children: u.map((l, s) => /* @__PURE__ */ m.jsx("th", { children: l }, `${l}${s}`)) }) }),
    /* @__PURE__ */ m.jsx("tbody", { children: ta(0, r - 1).map((l) => /* @__PURE__ */ m.jsx("tr", { className: "c__calendar__wrapper__grid__week-row", children: e.getDatesInWeek(l).map(
      (s, c) => s && /* @__PURE__ */ m.jsx(lb, { state: e, date: s }, c)
    ) }, l)) })
  ] });
}, cb = (e) => e ? e.label : "", Bs = ({ options: e, downShift: t }) => /* @__PURE__ */ m.jsx(
  "div",
  {
    className: se("c__calendar__menu", {
      "c__calendar__menu--opened": t.isOpen
    }),
    ...t.getMenuProps(),
    children: /* @__PURE__ */ m.jsx("ul", { children: t.isOpen && e.map((n, r) => {
      var a;
      return /* @__PURE__ */ m.jsx(
        "li",
        {
          ...t.getItemProps({
            item: n,
            index: r
          }),
          className: se("c__calendar__menu__item", {
            "c__calendar__menu__item--highlight": t.highlightedIndex === r,
            "c__calendar__menu__item--selected": ((a = t.selectedItem) == null ? void 0 : a.label) === n.label,
            "c__calendar__menu__item--disabled": n.disabled
          }),
          children: /* @__PURE__ */ m.jsx("span", { children: n.label })
        },
        `${n.value}${r}`
      );
    }) })
  }
), wg = Re(
  ({
    state: e,
    minYear: t = 1900,
    // in gregorian calendar.
    maxYear: n = 2050,
    // in gregorian calendar.
    prevButtonProps: r,
    nextButtonProps: a,
    calendarProps: o
  }, i) => {
    const { t: u } = Oe(), l = (R) => lt({
      ...R,
      timeZone: e.timeZone
    }), s = l({ month: "long" }), c = l({ month: "short" }), f = l({ year: "numeric" }), [p, d] = re(!0), g = J(() => {
      const R = e.focusedDate.calendar.getMonthsInYear(
        e.focusedDate
      );
      return ta(1, R).map((P) => {
        const S = e.focusedDate.set({ month: P });
        return {
          value: P,
          label: s.format(S.toDate(e.timeZone)),
          disabled: !!e.minValue && e.minValue.month > P || !!e.maxValue && e.maxValue.month < P
        };
      });
    }, [e.maxValue, e.minValue, e.focusedDate.year]), b = J(() => {
      const R = Fa(
        new Intl.DateTimeFormat().resolvedOptions().calendar
      ), P = Ce(
        new Se(new Ke(), t, 1, 1),
        R
      ), S = Ce(
        new Se(new Ke(), n, 12, 31),
        R
      );
      return ta(P.year, S.year).map((V) => {
        const k = e.focusedDate.set({ year: V });
        return {
          value: V,
          label: f.format(k.toDate(e.timeZone)),
          disabled: !!e.minValue && e.minValue.year > V || !!e.maxValue && e.maxValue.year < V
        };
      });
    }, [e.focusedDate, e.timeZone, e.maxValue, e.minValue]), v = (R, P) => ft({
      items: P,
      itemToString: cb,
      onSelectedItemChange: (S) => {
        var k;
        const V = e.focusedDate.set({
          [R]: (k = S == null ? void 0 : S.selectedItem) == null ? void 0 : k.value
        });
        d(!1), setTimeout(() => {
          e.setFocusedDate(V), setTimeout(() => {
            d(!0);
          });
        });
      }
    }), C = v("month", g), h = v("year", b), {
      isDisabled: D,
      onPress: x,
      onFocusChange: _,
      ...O
    } = r, {
      isDisabled: L,
      onPress: y,
      onFocusChange: F,
      ...T
    } = a, $ = (R, P, S) => ({
      ...S.getToggleButtonProps(),
      onClick: () => {
        const V = P.find(
          (k) => k.value === e.focusedDate[R]
        );
        V && S.selectItem(V), S.toggleMenu();
      },
      "aria-label": u(
        `components.forms.date_picker.${R}_select_button_aria_label`
      )
    });
    return /* @__PURE__ */ m.jsxs("div", { className: "c__calendar", children: [
      /* @__PURE__ */ m.jsxs(
        "div",
        {
          ref: i,
          ...o,
          id: !C.isOpen && !h.isOpen ? o.id : "",
          className: se("c__calendar__wrapper", {
            "c__calendar__wrapper--opened": !C.isOpen && !h.isOpen
          }),
          children: [
            /* @__PURE__ */ m.jsxs("div", { className: "c__calendar__wrapper__header", children: [
              /* @__PURE__ */ m.jsxs("div", { className: "c__calendar__wrapper__header__actions", children: [
                /* @__PURE__ */ m.jsx(
                  ge,
                  {
                    color: "tertiary-text",
                    size: "small",
                    icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "navigate_before" }),
                    ...O,
                    "aria-label": u(
                      "components.forms.date_picker.previous_month_button_aria_label"
                    ),
                    disabled: D,
                    onClick: () => e.focusPreviousSection(),
                    type: "button"
                  }
                ),
                /* @__PURE__ */ m.jsx(
                  ge,
                  {
                    className: "c__calendar__wrapper__header__actions__dropdown",
                    color: "tertiary-text",
                    size: "small",
                    iconPosition: "right",
                    icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "arrow_drop_down" }),
                    type: "button",
                    ...$("month", g, C),
                    children: c.format(
                      e.focusedDate.toDate(e.timeZone)
                    )
                  }
                ),
                /* @__PURE__ */ m.jsx(
                  ge,
                  {
                    color: "tertiary-text",
                    size: "small",
                    icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "navigate_next" }),
                    type: "button",
                    ...T,
                    "aria-label": u(
                      "components.forms.date_picker.next_month_button_aria_label"
                    ),
                    disabled: L,
                    onClick: () => e.focusNextSection()
                  }
                )
              ] }),
              /* @__PURE__ */ m.jsxs("div", { className: "c__calendar__wrapper__header__actions", children: [
                /* @__PURE__ */ m.jsx(
                  ge,
                  {
                    color: "tertiary-text",
                    size: "small",
                    icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "navigate_before" }),
                    onClick: () => e.focusPreviousSection(!0),
                    disabled: !!e.minValue && e.minValue.year > e.focusedDate.add({ years: -1 }).year,
                    "aria-label": u(
                      "components.forms.date_picker.previous_year_button_aria_label"
                    ),
                    type: "button"
                  }
                ),
                /* @__PURE__ */ m.jsx(
                  ge,
                  {
                    className: "c__calendar__wrapper__header__actions__dropdown",
                    color: "tertiary-text",
                    size: "small",
                    iconPosition: "right",
                    icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "arrow_drop_down" }),
                    type: "button",
                    ...$("year", b, h),
                    children: f.format(
                      e.focusedDate.toDate(e.timeZone)
                    )
                  }
                ),
                /* @__PURE__ */ m.jsx(
                  ge,
                  {
                    color: "tertiary-text",
                    size: "small",
                    icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "navigate_next" }),
                    onClick: () => e.focusNextSection(!0),
                    disabled: !!e.maxValue && e.maxValue.year < e.focusedDate.add({ years: 1 }).year,
                    "aria-label": u(
                      "components.forms.date_picker.next_year_button_aria_label"
                    ),
                    type: "button"
                  }
                )
              ] })
            ] }),
            !C.isOpen && !h.isOpen && p && /* @__PURE__ */ m.jsx(sb, { state: e })
          ]
        }
      ),
      /* @__PURE__ */ m.jsx(Bs, { options: g, downShift: C }),
      /* @__PURE__ */ m.jsx(Bs, { options: b, downShift: h })
    ] });
  }
), db = (e) => {
  const { locale: t } = Ze(), n = q(null), r = Km({
    ...e,
    locale: t,
    createCalendar: Fa
  }), a = Gy(e, r);
  return /* @__PURE__ */ m.jsx(wg, { ...a, state: r, ref: n });
}, fb = (e) => {
  const { locale: t } = Ze(), n = q(null), r = zy({
    ...e,
    locale: t,
    createCalendar: Fa
  }), a = Yy(e, r, n);
  return /* @__PURE__ */ m.jsx(wg, { ...a, state: r, ref: n });
}, mb = ({
  currentSegment: e,
  previousSegment: t,
  state: n
}) => {
  var o;
  const r = q(null), { segmentProps: a } = Vy(e, n, r);
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      ref: r,
      ...a,
      className: se("c__date-picker__inner__value__segment", {
        "c__date-picker__inner__value__segment--empty": e.isPlaceholder || e.type === "literal" && (t == null ? void 0 : t.isPlaceholder)
      }),
      children: (o = e.text) == null ? void 0 : o.toUpperCase()
    }
  );
}, pb = (e) => {
  const { locale: t } = Ze(), n = e3({
    ...e,
    locale: t,
    createCalendar: Fa
  }), r = q(null), { fieldProps: a } = Iy(e, n, r);
  return /* @__PURE__ */ m.jsx("div", { className: "c__date-picker__inner__value", ...a, ref: r, children: n.segments.map((o, i, u) => /* @__PURE__ */ m.jsx(
    mb,
    {
      currentSegment: o,
      previousSegment: u[i - 1],
      state: n
    },
    i
  )) });
}, vi = ({ ...e }) => /* @__PURE__ */ m.jsx(gr, { ...e, children: /* @__PURE__ */ m.jsx(
  "div",
  {
    className: se("c__date-picker__inner", {
      "c__date-picker__inner--collapsed": e.labelAsPlaceholder
    }),
    children: /* @__PURE__ */ m.jsx(pb, { ...e })
  }
) }), Jb = (e) => {
  if (e.defaultValue && e.value)
    throw new Error(
      "You cannot use both defaultValue and value props on DatePicker component"
    );
  const t = q(null), [n, r] = re(!1), a = {
    ...jm(e),
    value: (
      // Force clear the component's value when passing null or an empty string.
      e.value === "" || e.value === null ? null : Vn(e.value, e.timezone)
    ),
    defaultValue: Vn(e.defaultValue, e.timezone),
    onChange: (f) => {
      var p;
      (p = e.onChange) == null || p.call(e, Rn(f, e.timezone));
    }
  }, o = Z4(a), { fieldProps: i, calendarProps: u, ...l } = Ry(
    a,
    o,
    t
  ), s = J(
    () => !n && !o.isOpen && !o.value,
    [o.value, o.isOpen, n]
  ), c = /* @__PURE__ */ m.jsx(db, { ...u });
  return /* @__PURE__ */ m.jsx(
    Lm,
    {
      ...e,
      labelAsPlaceholder: s,
      isFocused: n,
      pickerState: o,
      pickerProps: l,
      calendar: c,
      onClear: () => o.setValue(null),
      ref: t,
      children: /* @__PURE__ */ m.jsx(
        vi,
        {
          ...i,
          label: e.label,
          labelAsPlaceholder: s,
          onFocusChange: r,
          disabled: e.disabled
        }
      )
    }
  );
}, Xb = ({
  startLabel: e,
  endLabel: t,
  ...n
}) => {
  if (n.defaultValue && n.value)
    throw new Error(
      "You cannot use both defaultValue and value props on DateRangePicker component"
    );
  const r = q(null), [a, o] = re(!1), i = {
    ...jm(n),
    value: n.value === null ? null : ms(n.value, n.timezone),
    defaultValue: ms(n.defaultValue, n.timezone),
    onChange: (g) => {
      var b;
      (b = n.onChange) == null || b.call(
        n,
        g != null && g.start && g.end ? [
          Rn(g.start, n.timezone),
          Rn(g.end, n.timezone)
        ] : null
      );
    }
  }, u = a3(i), { startFieldProps: l, endFieldProps: s, calendarProps: c, ...f } = Ly(i, u, r), p = J(
    () => {
      var g, b;
      return !a && !u.isOpen && !((g = u.value) != null && g.start) && !((b = u.value) != null && b.end);
    },
    [u.value, u.isOpen, a]
  ), d = /* @__PURE__ */ m.jsx(fb, { ...c });
  return /* @__PURE__ */ m.jsxs(
    Lm,
    {
      ...n,
      labelAsPlaceholder: p,
      isFocused: a,
      pickerState: u,
      pickerProps: f,
      optionalClassName: "c__date-picker__range",
      isRange: !0,
      onClear: () => {
        u.setValue({
          start: null,
          end: null
        });
      },
      calendar: d,
      ref: r,
      children: [
        /* @__PURE__ */ m.jsx(
          vi,
          {
            ...l,
            label: e,
            labelAsPlaceholder: p,
            onFocusChange: o,
            disabled: n.disabled
          }
        ),
        /* @__PURE__ */ m.jsx("div", { className: "c__date-picker__range__separator" }),
        /* @__PURE__ */ m.jsx(
          vi,
          {
            ...s,
            label: t,
            labelAsPlaceholder: p,
            onFocusChange: o,
            disabled: n.disabled
          }
        )
      ]
    }
  );
};
function gb(e, t = 2) {
  if (e === 0) return "0 Bytes";
  const n = 1024, r = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], a = Math.floor(Math.log(e) / Math.log(n));
  return parseFloat((e / n ** a).toFixed(t)) + " " + r[a];
}
const hb = (e, t) => {
  const n = new DataTransfer();
  t.forEach((r) => {
    n.items.add(r);
  }), e.files = n.files;
}, Sg = Re(
  ({
    multiple: e,
    name: t,
    state: n,
    icon: r,
    animateIcon: a,
    successIcon: o,
    uploadingIcon: i,
    text: u,
    bigText: l,
    files: s,
    onFilesChange: c,
    children: f,
    ...p
  }, d) => {
    const [g, b] = re(!1), v = q(null), C = q(null), { t: h } = Oe();
    mr(d, () => ({
      get input() {
        return C.current;
      },
      reset() {
        c == null || c({ target: { value: [] } });
      }
    })), te(() => {
      C.current && hb(C.current, s);
    }, [s]), te(() => {
      c == null || c({ target: { value: s ?? [] } });
    }, [s]);
    const D = () => n === "success" ? o ?? /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "done" }) : n === "uploading" ? fe.cloneElement(i ?? /* @__PURE__ */ m.jsx(Ec, { size: "small" }), {
      "aria-label": h("components.forms.file_uploader.uploading")
    }) : r ?? /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "upload" }), x = () => n === "uploading" ? h("components.forms.file_uploader.uploading") : l || /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
      h("components.forms.file_uploader.caption"),
      /* @__PURE__ */ m.jsx("span", { children: h("components.forms.file_uploader.browse_files") })
    ] });
    return /* @__PURE__ */ m.jsx(
      "label",
      {
        className: se(
          "c__file-uploader",
          "c__file-uploader--" + n,
          {
            "c__file-uploader--active": g,
            "c__file-uploader--animate-icon": a
          }
        ),
        onDragEnter: () => {
          b(!0);
        },
        onDragLeave: (_) => {
          v.current.contains(_.relatedTarget) || b(!1);
        },
        onDragOver: (_) => {
          _.preventDefault();
        },
        onDrop: (_) => {
          _.preventDefault();
          const O = Array.from(_.dataTransfer.files);
          C.current && (C.current.files = _.dataTransfer.files, c == null || c({ target: { value: [...O] } })), b(!1);
        },
        ref: v,
        children: /* @__PURE__ */ m.jsxs("div", { className: "c__file-uploader__inner", children: [
          /* @__PURE__ */ m.jsx("div", { className: "c__file-uploader__inner__icon", children: D() }),
          f ?? /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
            /* @__PURE__ */ m.jsx("div", { className: "c__file-uploader__inner__caption", children: x() }),
            u && /* @__PURE__ */ m.jsx("div", { className: "c__file-uploader__inner__text", children: u })
          ] }),
          /* @__PURE__ */ m.jsx(
            "input",
            {
              type: "file",
              name: t,
              ref: C,
              onChange: (_) => {
                _.target.files ? c == null || c({ target: { value: [..._.target.files] } }) : c == null || c({ target: { value: [] } });
              },
              multiple: e,
              ...p
            }
          )
        ] })
      }
    );
  }
), vb = Re(({ fullWidth: e, fakeDefaultFiles: t, ...n }, r) => {
  const { t: a } = Oe(), [o, i] = re(t || []);
  return te(() => {
    var u;
    (u = n.onFilesChange) == null || u.call(n, { target: { value: o } });
  }, [o]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(
      Sg,
      {
        ...n,
        files: o,
        onFilesChange: (u) => i(u.target.value),
        animateIcon: !0,
        ref: r
      }
    ),
    o.length > 0 && /* @__PURE__ */ m.jsx("div", { className: "c__file-uploader__files", children: o.map((u) => /* @__PURE__ */ m.jsxs(
      "div",
      {
        className: "c__file-uploader__file",
        children: [
          /* @__PURE__ */ m.jsx("div", { className: "c__file-uploader__file__name", children: u.name }),
          /* @__PURE__ */ m.jsxs("div", { className: "c__file-uploader__file__specs", children: [
            /* @__PURE__ */ m.jsx("span", { children: gb(u.size) }),
            /* @__PURE__ */ m.jsx(
              ge,
              {
                color: "tertiary-text",
                size: "nano",
                "aria-label": a(
                  "components.forms.file_uploader.delete_file_name",
                  {
                    name: u.name
                  }
                ),
                onClick: () => {
                  i(o.filter((l) => l !== u));
                },
                icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "close" })
              }
            )
          ] })
        ]
      },
      "" + u.name + u.size + u.type + u.lastModified
    )) })
  ] });
}), yb = Re(({ fakeDefaultFiles: e, ...t }, n) => {
  const { t: r } = Oe(), [a, o] = re(
    e && e.length > 0 ? e[0] : void 0
  ), i = J(() => a ? [a] : [], [a]), [u, l] = re(!1), [s, c] = J(() => u ? [
    t.deleteIcon ?? /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "delete" }),
    !0
  ] : a ? [
    t.fileSelectedIcon ?? /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "download" }),
    !1
  ] : [t.icon, !0], [a, u]), f = (p) => {
    o(void 0), p.preventDefault(), l(!1);
  };
  return te(() => {
    var p;
    (p = t.onFilesChange) == null || p.call(t, { target: { value: a ? [a] : [] } });
  }, [a]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(
      Sg,
      {
        ...t,
        files: i,
        onFilesChange: (p) => o(p.target.value[0]),
        icon: s,
        animateIcon: c,
        ref: n,
        children: a && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
          /* @__PURE__ */ m.jsx("div", { className: "c__file-uploader__inner__filename", children: a.name }),
          /* @__PURE__ */ m.jsx(
            "div",
            {
              className: "c__file-uploader__inner__actions",
              onClick: f,
              onMouseEnter: () => {
                l(!0);
              },
              onMouseLeave: () => l(!1),
              children: r("components.forms.file_uploader.delete_file")
            }
          )
        ] })
      }
    ),
    a && /* @__PURE__ */ m.jsx(m.Fragment, { children: /* @__PURE__ */ m.jsx(ge, { onClick: f, className: "c__offscreen", children: r("components.forms.file_uploader.delete_file") }) })
  ] });
}), Qb = Re(
  ({ fullWidth: e, ...t }, n) => /* @__PURE__ */ m.jsx(_t, { fullWidth: e, className: t.className, children: t.multiple ? /* @__PURE__ */ m.jsx(vb, { ...t, ref: n }) : /* @__PURE__ */ m.jsx(yb, { ...t, ref: n }) })
), e2 = Re((e, t) => {
  const [n, r] = fe.useState(!1), { className: a, ...o } = e, i = "c__input--password", { t: u } = Oe();
  return /* @__PURE__ */ m.jsx(
    xc,
    {
      ...o,
      ref: t,
      className: a + " " + i,
      type: n ? "text" : "password",
      rightIcon: n ? /* @__PURE__ */ m.jsx(
        ge,
        {
          onClick: () => r(!1),
          icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "visibility_off" }),
          color: "tertiary-text",
          size: "small",
          "aria-label": u("components.forms.input.password.hide_password")
        }
      ) : /* @__PURE__ */ m.jsx(
        ge,
        {
          onClick: () => r(!0),
          icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "visibility" }),
          color: "tertiary-text",
          size: "small",
          "aria-label": u("components.forms.input.password.show_password")
        }
      )
    }
  );
}), t2 = Re(
  ({ className: e, label: t, ...n }, r) => {
    const {
      compact: a,
      fullWidth: o,
      rightText: i,
      state: u,
      text: l,
      textItems: s,
      ...c
    } = n;
    return /* @__PURE__ */ m.jsx(
      "label",
      {
        className: se("c__checkbox", "c__radio", e, {
          "c__checkbox--disabled": n.disabled,
          "c__checkbox--full-width": n.fullWidth
        }),
        children: /* @__PURE__ */ m.jsx(_t, { compact: !0, ...n, children: /* @__PURE__ */ m.jsxs("div", { className: "c__checkbox__container", children: [
          /* @__PURE__ */ m.jsx("input", { type: "radio", ...c, ref: r }),
          t && /* @__PURE__ */ m.jsx("div", { className: "c__checkbox__label", children: t })
        ] }) })
      }
    );
  }
), n2 = ({
  className: e,
  children: t,
  style: n,
  ...r
}) => /* @__PURE__ */ m.jsx(
  _t,
  {
    className: se("c__radio__group c__checkbox__group", e),
    compact: !0,
    ...r,
    children: /* @__PURE__ */ m.jsx("div", { className: "c__checkbox__group__list", style: n, children: t })
  }
), Uu = (e) => e.render !== void 0, Ig = ({
  option: e,
  showLabelWhenSelected: t = !0
}) => e ? Uu(e) && !t ? e.render() : /* @__PURE__ */ m.jsx("span", { children: e.label }) : null, Pg = ({
  isOpen: e,
  selectRef: t,
  downshiftReturn: n,
  menuOptionsStyle: r,
  children: a
}) => {
  const o = fe.useRef(null), i = Cg({
    targetRef: t,
    overlayRef: o,
    placement: "bottom",
    isOpen: e,
    maxHeight: 160,
    shouldUpdatePosition: !0
  }), u = n.getMenuProps({
    ref: o
  });
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      className: se(
        "c__select__menu",
        r ? "c__select__menu--" + r : "",
        {
          "c__select__menu--opened": e
        }
      ),
      ...u,
      style: {
        marginLeft: "-4px",
        width: t.current ? t.current.getBoundingClientRect().width - 4 : 0,
        ...i.overlayProps.style
      },
      children: e && a
    }
  );
};
function Rg(e) {
  return (t) => {
    var n;
    return !e || t.label.toLowerCase().includes(e.toLowerCase()) || ((n = t.value) == null ? void 0 : n.toLowerCase().includes(e.toLowerCase()));
  };
}
const Er = (e) => e ? e.label : "", Be = (e) => e.value ?? e.label, yi = (e, t) => Be(e) === Be(t), Wu = (e) => Uu(e) ? e.render() : e.label, Fg = ({
  children: e,
  state: t = "default",
  options: n,
  name: r,
  label: a,
  hideLabel: o,
  labelAsPlaceholder: i,
  downshiftProps: u,
  downshiftReturn: l,
  value: s,
  disabled: c,
  clearable: f = !0,
  onBlur: p,
  ...d
}) => {
  const { t: g } = Oe(), b = l.getLabelProps(), v = q(null);
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(_t, { state: t, ...d, children: /* @__PURE__ */ m.jsx(
      "div",
      {
        ref: v,
        className: se(
          "c__select",
          "c__select--mono",
          "c__select--" + t,
          {
            "c__select--disabled": c
          }
        ),
        onBlur: () => {
          var C;
          return p == null ? void 0 : p({ target: { value: (C = l.selectedItem) == null ? void 0 : C.value } });
        },
        children: /* @__PURE__ */ m.jsxs(
          "div",
          {
            className: se("c__select__wrapper", {
              "c__select__wrapper--focus": l.isOpen && !c
            }),
            ...l.wrapperProps,
            children: [
              l.selectedItem && /* @__PURE__ */ m.jsx(
                "input",
                {
                  type: "hidden",
                  name: r,
                  value: Be(l.selectedItem)
                }
              ),
              /* @__PURE__ */ m.jsx(
                gr,
                {
                  label: a,
                  hideLabel: o,
                  labelAsPlaceholder: i,
                  htmlFor: b.htmlFor,
                  labelId: b.id,
                  disabled: c,
                  children: /* @__PURE__ */ m.jsxs("div", { className: "c__select__inner", children: [
                    /* @__PURE__ */ m.jsx("div", { className: "c__select__inner__value", children: e }),
                    /* @__PURE__ */ m.jsxs("div", { className: "c__select__inner__actions", children: [
                      f && !c && l.selectedItem && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
                        /* @__PURE__ */ m.jsx(
                          ge,
                          {
                            color: "tertiary-text",
                            size: "nano",
                            "aria-label": g(
                              "components.forms.select.clear_button_aria_label"
                            ),
                            className: "c__select__inner__actions__clear",
                            onClick: (C) => {
                              l.selectItem(null), C.stopPropagation();
                            },
                            icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "close" }),
                            type: "button"
                          }
                        ),
                        /* @__PURE__ */ m.jsx("div", { className: "c__select__inner__actions__separator" })
                      ] }),
                      /* @__PURE__ */ m.jsx(
                        ge,
                        {
                          color: "tertiary-text",
                          size: "nano",
                          className: "c__select__inner__actions__open",
                          icon: /* @__PURE__ */ m.jsx(
                            "span",
                            {
                              className: se("material-icons", {
                                opened: l.isOpen
                              }),
                              children: "arrow_drop_down"
                            }
                          ),
                          disabled: c,
                          type: "button",
                          ...l.toggleButtonProps
                        }
                      )
                    ] })
                  ] })
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ m.jsx(
      Pg,
      {
        isOpen: l.isOpen,
        selectRef: v,
        downshiftReturn: l,
        children: /* @__PURE__ */ m.jsxs("ul", { children: [
          n.map((C, h) => {
            const D = h === l.highlightedIndex;
            return /* @__PURE__ */ m.jsx(
              "li",
              {
                className: se("c__select__menu__item", {
                  "c__select__menu__item--highlight": D,
                  "c__select__menu__item--selected": l.selectedItem && yi(l.selectedItem, C),
                  "c__select__menu__item--disabled": C.disabled
                }),
                ...l.getItemProps({
                  item: C,
                  index: h
                }),
                children: /* @__PURE__ */ m.jsx("span", { children: Wu(C) })
              },
              `${Be(C)}${h.toString()}`
            );
          }),
          n.length === 0 && /* @__PURE__ */ m.jsx("li", { className: "c__select__menu__item c__select__menu__empty-placeholder", children: g("components.forms.select.menu_empty_placeholder") })
        ] })
      }
    )
  ] });
}, bb = (e) => {
  if (e.selectedItemsStyle === "pills")
    return /* @__PURE__ */ m.jsx(Db, { ...e });
  if (e.selectedItemsStyle === "text")
    return /* @__PURE__ */ m.jsx(_b, { ...e });
  throw new Error("Unknown selectedItemsStyle");
}, Db = ({
  selectedItems: e,
  selectedItemsStyle: t,
  disabled: n,
  useMultipleSelectionReturn: r,
  ...a
}) => {
  const { t: o } = Oe();
  return e.map((i, u) => /* @__PURE__ */ m.jsxs(
    "div",
    {
      className: "c__select__inner__value__pill",
      ...r.getSelectedItemProps({
        selectedItem: i,
        index: u
      }),
      children: [
        /* @__PURE__ */ m.jsx(Ig, { option: i, ...a }),
        /* @__PURE__ */ m.jsx(
          ge,
          {
            tabIndex: -1,
            color: "tertiary-text",
            disabled: n,
            size: "small",
            "aria-label": o("components.forms.select.clear_button_aria_label"),
            type: "button",
            className: "c__select__inner__value__pill__clear",
            onClick: (l) => {
              l.stopPropagation(), r.removeSelectedItem(
                i
              );
            },
            icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "close" })
          }
        )
      ]
    },
    `${Be(i)}${u.toString()}`
  ));
}, _b = ({ selectedItems: e }) => e.map((t) => Er(t)).join(", "), $b = (e) => {
  const { t } = Oe();
  return /* @__PURE__ */ m.jsx(
    Pg,
    {
      isOpen: e.downshiftReturn.isOpen,
      selectRef: e.selectRef,
      downshiftReturn: e.downshiftReturn,
      menuOptionsStyle: e.menuOptionsStyle,
      children: /* @__PURE__ */ m.jsx("ul", { children: e.downshiftReturn.isOpen && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
        e.options.map((n, r) => /* @__PURE__ */ bi(
          xb,
          {
            ...e,
            option: n,
            index: r,
            key: Be(n)
          }
        )),
        e.options.length === 0 && /* @__PURE__ */ m.jsx("li", { className: "c__select__menu__item c__select__menu__empty-placeholder", children: t("components.forms.select.menu_empty_placeholder") })
      ] }) })
    }
  );
}, xb = (e) => {
  if (e.menuOptionsStyle === "plain")
    return /* @__PURE__ */ m.jsx(Eb, { ...e });
  if (e.menuOptionsStyle === "checkbox")
    return /* @__PURE__ */ m.jsx(Cb, { ...e });
  throw new Error("Unknown menuOptionsStyle");
}, Eb = ({ option: e, index: t, ...n }) => {
  const r = t === n.downshiftReturn.highlightedIndex || e.highlighted;
  return /* @__PURE__ */ m.jsx(
    "li",
    {
      className: se("c__select__menu__item", {
        "c__select__menu__item--highlight": r,
        "c__select__menu__item--disabled": e.disabled
      }),
      ...n.downshiftReturn.getItemProps({
        item: e,
        index: t
      }),
      children: /* @__PURE__ */ m.jsx("span", { children: Wu(e) })
    }
  );
}, Cb = ({ option: e, index: t, ...n }) => /* @__PURE__ */ m.jsx(
  "li",
  {
    className: se("c__select__menu__item", {
      "c__select__menu__item--highlight": t === n.downshiftReturn.highlightedIndex,
      "c__select__menu__item--disabled": e.disabled
    }),
    ...n.downshiftReturn.getItemProps({
      item: e,
      index: t
    }),
    children: /* @__PURE__ */ m.jsx(
      Ai,
      {
        label: Wu(e),
        checked: e.highlighted,
        fullWidth: !0
      }
    )
  }
);
function Ag(e, t) {
  const n = Rg(t);
  return (r) => !e.find(
    (a) => Be(a) === Be(r)
  ) && n(r);
}
const Tg = ({ children: e, ...t }) => {
  const { t: n } = Oe(), r = t.downshiftReturn.getLabelProps(), a = q(null), { onBlur: o, ...i } = t.downshiftReturn.toggleButtonProps;
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(_t, { ...t, children: /* @__PURE__ */ m.jsx(
      "div",
      {
        ref: a,
        className: se(
          "c__select",
          "c__select--multi",
          "c__select--" + t.state,
          "c__select--" + t.selectedItemsStyle,
          {
            "c__select--disabled": t.disabled,
            "c__select--populated": t.selectedItems.length > 0,
            "c__select--monoline": t.monoline,
            "c__select--multiline": !t.monoline
          }
        ),
        children: /* @__PURE__ */ m.jsxs(
          "div",
          {
            className: se("c__select__wrapper", {
              "c__select__wrapper--focus": t.downshiftReturn.isOpen && !t.disabled
            }),
            ...t.downshiftReturn.wrapperProps,
            ...i,
            children: [
              t.selectedItems.map((u, l) => /* @__PURE__ */ m.jsx(
                "input",
                {
                  type: "hidden",
                  name: t.name,
                  value: Be(u)
                },
                `${Be(u)}${l.toString()}`
              )),
              /* @__PURE__ */ m.jsx(
                gr,
                {
                  label: t.label,
                  labelAsPlaceholder: t.labelAsPlaceholder,
                  htmlFor: r.htmlFor,
                  labelId: r.id,
                  hideLabel: t.hideLabel,
                  disabled: t.disabled,
                  children: /* @__PURE__ */ m.jsxs("div", { className: "c__select__inner", children: [
                    /* @__PURE__ */ m.jsxs("div", { className: "c__select__inner__actions", children: [
                      t.clearable && !t.disabled && t.selectedItems.length > 0 && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
                        /* @__PURE__ */ m.jsx(
                          ge,
                          {
                            color: "tertiary-text",
                            size: "nano",
                            "aria-label": n(
                              "components.forms.select.clear_all_button_aria_label"
                            ),
                            className: "c__select__inner__actions__clear",
                            onClick: (u) => {
                              u.stopPropagation(), t.onSelectedItemsChange([]);
                            },
                            icon: /* @__PURE__ */ m.jsx("span", { className: "material-icons", children: "close" }),
                            type: "button"
                          }
                        ),
                        /* @__PURE__ */ m.jsx("div", { className: "c__select__inner__actions__separator" })
                      ] }),
                      /* @__PURE__ */ m.jsx(
                        ge,
                        {
                          color: "tertiary-text",
                          size: "nano",
                          className: "c__select__inner__actions__open",
                          icon: /* @__PURE__ */ m.jsx(
                            "span",
                            {
                              className: se("material-icons", {
                                opened: t.downshiftReturn.isOpen
                              }),
                              children: "arrow_drop_down"
                            }
                          ),
                          disabled: t.disabled,
                          type: "button"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ m.jsxs("div", { className: "c__select__inner__value", children: [
                      /* @__PURE__ */ m.jsx(bb, { ...t }),
                      e
                    ] })
                  ] })
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ m.jsx($b, { ...t, selectRef: a })
  ] });
}, wb = Re(
  (e, t) => {
    const [n, r] = fe.useState(), a = q(null), o = fe.useMemo(
      () => e.options.filter(
        Ag(e.selectedItems, n)
      ),
      [e.selectedItems, n]
    ), [i, u] = re(!1), l = it({
      selectedItems: e.selectedItems,
      onStateChange({ selectedItems: g, type: b }) {
        switch (b) {
          case it.stateChangeTypes.SelectedItemKeyDownBackspace:
          case it.stateChangeTypes.SelectedItemKeyDownDelete:
          case it.stateChangeTypes.DropdownKeyDownBackspace:
          case it.stateChangeTypes.FunctionRemoveSelectedItem:
            e.onSelectedItemsChange(g ?? []);
            break;
        }
      }
    }), s = xt({
      items: o,
      itemToString: Er,
      defaultHighlightedIndex: 0,
      // after selection, highlight the first item.
      selectedItem: null,
      // Important, without this we are not able to re-select the last removed option.
      stateReducer: (g, b) => {
        const { changes: v, type: C } = b;
        switch (C) {
          case xt.stateChangeTypes.InputKeyDownEnter:
          case xt.stateChangeTypes.ItemClick:
            return {
              ...v,
              isOpen: !0,
              // keep the menu open after selection.
              highlightedIndex: 0
              // with the first option highlighted.
            };
          default:
            return v;
        }
      },
      onStateChange: ({
        inputValue: g,
        type: b,
        selectedItem: v
      }) => {
        switch (b) {
          case xt.stateChangeTypes.InputKeyDownEnter:
          case xt.stateChangeTypes.ItemClick:
          case xt.stateChangeTypes.InputBlur:
            v && !v.disabled && (e.onSelectedItemsChange([
              ...e.selectedItems,
              v
            ]), r(void 0));
            break;
          case xt.stateChangeTypes.InputChange:
            r(g);
            break;
        }
      },
      isItemDisabled: (g) => !!g.disabled
    }), c = s.getInputProps({
      ...l.getDropdownProps({
        preventKeyAction: s.isOpen,
        ref: a,
        disabled: e.disabled
      }),
      value: n
    }), { onKeyDown: f } = c;
    c.onKeyDown = (g) => {
      switch (g.code) {
        case "Backspace":
          n || e.onSelectedItemsChange(e.selectedItems.slice(0, -1));
      }
      f == null || f(g);
    };
    const [p, d] = re(!0);
    return te(() => {
      if (i || n) {
        d(!1);
        return;
      }
      d(e.selectedItems.length === 0);
    }, [e.selectedItems, i, n]), mr(t, () => ({
      blur: () => {
        var g;
        s.closeMenu(), (g = a.current) == null || g.blur();
      }
    })), te(() => {
      var g;
      (g = e.onSearchInputChange) == null || g.call(e, { target: { value: n } });
    }, [n]), /* @__PURE__ */ m.jsx(
      Tg,
      {
        ...e,
        monoline: !1,
        options: o,
        labelAsPlaceholder: p,
        selectedItems: e.selectedItems,
        downshiftReturn: {
          ...s,
          wrapperProps: {
            onClick: () => {
              var g;
              (g = a.current) == null || g.focus(), s.isOpen || s.openMenu();
            }
          },
          toggleButtonProps: s.getToggleButtonProps()
        },
        useMultipleSelectionReturn: l,
        children: /* @__PURE__ */ m.jsx(
          "span",
          {
            className: "c__select__inner__value__input",
            "data-value": n,
            children: /* @__PURE__ */ m.jsx(
              "input",
              {
                ...c,
                onFocus: () => {
                  u(!0), s.openMenu();
                },
                onBlur: () => {
                  u(!1);
                },
                size: 4
              }
            )
          }
        )
      }
    );
  }
), Sb = Re(
  (e, t) => {
    const n = (u) => !!e.selectedItems.find(
      (l) => yi(l, u)
    ), r = fe.useMemo(() => e.monoline ? e.options.map((u) => ({
      ...u,
      highlighted: n(u)
    })) : e.options.filter(
      Ag(e.selectedItems, "")
    ), [e.selectedItems]), a = it({
      selectedItems: e.selectedItems,
      onStateChange({ selectedItems: u, type: l }) {
        switch (l) {
          case it.stateChangeTypes.SelectedItemKeyDownBackspace:
          case it.stateChangeTypes.SelectedItemKeyDownDelete:
          case it.stateChangeTypes.DropdownKeyDownBackspace:
          case it.stateChangeTypes.FunctionRemoveSelectedItem:
            e.onSelectedItemsChange(u ?? []);
            break;
        }
      }
    }), o = ft({
      items: r,
      itemToString: Er,
      selectedItem: null,
      // Important, without this we are not able to re-select the last removed option.
      defaultHighlightedIndex: 0,
      // after selection, highlight the first item.
      stateReducer: (u, l) => {
        const { changes: s, type: c } = l;
        switch (c) {
          case ft.stateChangeTypes.ToggleButtonKeyDownEnter:
          case ft.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
          case ft.stateChangeTypes.ItemClick:
            return {
              ...s,
              isOpen: !0,
              // keep the menu open after selection.
              highlightedIndex: u.highlightedIndex
              // avoid automatic scroll up on click.
            };
        }
        return s;
      },
      onStateChange: ({ type: u, selectedItem: l }) => {
        switch (u) {
          case ft.stateChangeTypes.ToggleButtonKeyDownEnter:
          case ft.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
          case ft.stateChangeTypes.ItemClick:
            if (!l)
              break;
            n(l) ? e.onSelectedItemsChange(
              e.selectedItems.filter(
                (s) => !yi(s, l)
              )
            ) : e.onSelectedItemsChange([
              ...e.selectedItems,
              l
            ]);
            break;
        }
      },
      isItemDisabled: (u) => !!u.disabled
    }), i = q(null);
    return mr(t, () => ({
      blur: () => {
        var u;
        o.closeMenu(), (u = i.current) == null || u.blur();
      }
    })), /* @__PURE__ */ m.jsx(
      Tg,
      {
        ...e,
        options: r,
        labelAsPlaceholder: e.selectedItems.length === 0,
        selectedItems: e.selectedItems,
        selectedItemsStyle: e.monoline ? "text" : "pills",
        menuOptionsStyle: e.monoline ? "checkbox" : "plain",
        downshiftReturn: {
          ...o,
          toggleButtonProps: o.getToggleButtonProps({
            ...a.getDropdownProps({
              preventKeyAction: o.isOpen,
              ref: i
            }),
            disabled: e.disabled,
            onClick: (u) => {
              u.stopPropagation();
            }
          })
        },
        useMultipleSelectionReturn: a
      }
    );
  }
), Ib = Re(
  (e, t) => {
    const n = () => {
      const u = e.defaultValue ?? e.value ?? [];
      return e.options.filter(
        (l) => u.includes(Be(l))
      );
    }, [r, a] = fe.useState(
      n()
    );
    te(() => {
      e.defaultValue === void 0 && a(n());
    }, [JSON.stringify(e.value)]), te(() => {
      var u;
      (u = e.onChange) == null || u.call(e, { target: { value: r.map(Be) } });
    }, [JSON.stringify(r)]);
    const o = (u) => {
      a(u);
    }, i = {
      selectedItemsStyle: "pills",
      menuOptionsStyle: "plain",
      clearable: !0
    };
    return e.searchable ? /* @__PURE__ */ m.jsx(
      wb,
      {
        ...i,
        ...e,
        selectedItems: r,
        onSelectedItemsChange: o,
        ref: t
      }
    ) : /* @__PURE__ */ m.jsx(
      Sb,
      {
        ...i,
        ...e,
        selectedItems: r,
        onSelectedItemsChange: o,
        ref: t
      }
    );
  }
), Pb = Re(
  ({ showLabelWhenSelected: e = !0, ...t }, n) => {
    const { t: r } = Oe(), [a, o] = re(t.options), [i, u] = re(!1), [l, s] = re(), c = q(null), f = xt({
      ...t.downshiftProps,
      items: a,
      itemToString: Er,
      onInputValueChange: (C) => {
        s(C.inputValue), C.inputValue || f.selectItem(null);
      }
    }), [p, d] = re(
      !f.selectedItem
    );
    te(() => {
      if (i || f.inputValue) {
        d(!1);
        return;
      }
      d(!f.selectedItem);
    }, [
      f.selectedItem,
      i,
      f.inputValue
    ]), te(() => {
      if (l)
        return;
      const C = t.options.find(
        (h) => Be(h) === t.value
      );
      f.selectItem(C ?? null);
    }, [t.value, t.options, l]), te(() => {
      f.isOpen ? o(
        l ? t.options.filter(Rg(l)) : t.options
      ) : s(void 0);
    }, [f.isOpen, t.options, l]), mr(n, () => ({
      blur: () => {
        var C;
        f.closeMenu(), (C = c.current) == null || C.blur();
      }
    })), te(() => {
      var C;
      (C = t.onSearchInputChange) == null || C.call(t, { target: { value: l } });
    }, [l]);
    const g = () => {
      u(!1), f.selectedItem ? f.selectItem(f.selectedItem) : f.setInputValue("");
    }, b = f.getInputProps({
      ref: c,
      disabled: t.disabled
    }), v = !e;
    return /* @__PURE__ */ m.jsxs(
      Fg,
      {
        ...t,
        downshiftReturn: {
          ...f,
          wrapperProps: {
            onClick: () => {
              var C;
              (C = c.current) == null || C.focus(), f.isOpen || f.openMenu();
            }
          },
          toggleButtonProps: f.getToggleButtonProps({
            disabled: t.disabled,
            "aria-label": r("components.forms.select.toggle_button_aria_label")
          })
        },
        labelAsPlaceholder: p,
        options: a,
        children: [
          /* @__PURE__ */ m.jsx(
            "input",
            {
              ...b,
              className: se({
                "c__select__inner__value__input--hidden": v && !i
              }),
              onFocus: () => {
                u(!0);
              },
              onBlur: () => {
                g();
              }
            }
          ),
          v && !i && f.selectedItem && Uu(f.selectedItem) && f.selectedItem.render()
        ]
      }
    );
  }
), Rb = (e, t) => {
  te(() => {
    const n = t.options.find(
      (r) => Be(r) === t.value
    );
    e.selectItem(n ?? null);
  }, [t.value, t.options]);
}, Fb = Re(
  (e, t) => {
    const n = ft({
      ...e.downshiftProps,
      items: e.options,
      itemToString: Er
    });
    Rb(n, e);
    const r = q(null);
    return mr(t, () => ({
      blur: () => {
        var a;
        n.closeMenu(), (a = r.current) == null || a.blur();
      }
    })), /* @__PURE__ */ m.jsx(
      Fg,
      {
        ...e,
        downshiftReturn: {
          ...n,
          wrapperProps: n.getToggleButtonProps({
            disabled: e.disabled,
            ref: r
          }),
          toggleButtonProps: {}
        },
        labelAsPlaceholder: !n.selectedItem,
        children: /* @__PURE__ */ m.jsx(Ig, { option: n.selectedItem, ...e })
      }
    );
  }
), Ab = Re(
  (e, t) => {
    const n = e.defaultValue ? e.options.find(
      (i) => Be(i) === e.defaultValue
    ) : void 0, [r, a] = re(
      n ? Be(n) : e.value
    );
    te(() => {
      e.defaultValue || a(e.value);
    }, [e.value, e.defaultValue]);
    const o = {
      initialSelectedItem: n,
      onSelectedItemChange: (i) => {
        var s;
        const u = i.selectedItem ? Be(i.selectedItem) : null;
        u !== (r ?? null) && (a(u || void 0), (s = e.onChange) == null || s.call(e, {
          target: {
            value: i.selectedItem ? Be(i.selectedItem) : void 0
          }
        }));
      },
      isItemDisabled: (i) => !!i.disabled
    };
    return e.searchable ? /* @__PURE__ */ m.jsx(
      Pb,
      {
        ...e,
        downshiftProps: o,
        value: r,
        ref: t
      }
    ) : /* @__PURE__ */ m.jsx(
      Fb,
      {
        ...e,
        downshiftProps: o,
        value: r,
        ref: t
      }
    );
  }
), r2 = Re((e, t) => {
  if (e.defaultValue && e.value)
    throw new Error(
      "You cannot use both defaultValue and value props on Select component"
    );
  return e.multi ? /* @__PURE__ */ m.jsx(Ib, { ...e, ref: t }) : /* @__PURE__ */ m.jsx(Ab, { ...e, ref: t });
}), a2 = Re(
  ({ label: e, labelSide: t = "left", ...n }, r) => {
    const {
      compact: a,
      className: o,
      fullWidth: i,
      rightText: u,
      state: l,
      text: s,
      textItems: c,
      ...f
    } = n, { className: p, ...d } = n;
    return /* @__PURE__ */ m.jsx(
      "label",
      {
        className: se(
          "c__checkbox",
          "c__switch",
          "c__switch--" + t,
          o,
          {
            "c__checkbox--disabled": n.disabled,
            "c__switch--full-width": n.fullWidth
          }
        ),
        children: /* @__PURE__ */ m.jsx(_t, { compact: !0, ...d, children: /* @__PURE__ */ m.jsxs("div", { className: "c__checkbox__container", children: [
          e && /* @__PURE__ */ m.jsx("div", { className: "c__checkbox__label", children: e }),
          /* @__PURE__ */ m.jsxs("div", { className: "c__switch__rail__wrapper", children: [
            /* @__PURE__ */ m.jsx("input", { type: "checkbox", ...f, ref: r }),
            /* @__PURE__ */ m.jsx("div", { className: "c__switch__rail" })
          ] })
        ] }) })
      }
    );
  }
), o2 = Re(
  ({ label: e, id: t, defaultValue: n, charCounter: r, charCounterMax: a, ...o }, i) => {
    const u = q(null), [l, s] = re(!1), [c, f] = re(n || o.value || ""), [p, d] = re(!c), g = q(t || Ii()), b = r ? `${c.toString().length}/${a}` : o.rightText;
    te(() => {
      if (l) {
        d(!1);
        return;
      }
      d(!c);
    }, [l, c]), te(() => {
      n === void 0 && f(o.value || "");
    }, [o.value]);
    const { fullWidth: v, rightText: C, text: h, textItems: D, className: x, ..._ } = o;
    return /* @__PURE__ */ m.jsx(
      _t,
      {
        ...o,
        className: se("c__field--textarea", x),
        rightText: b,
        children: /* @__PURE__ */ m.jsx(
          "div",
          {
            className: se("c__textarea__wrapper", {
              "c__textarea__wrapper--disabled": o.disabled
            }),
            onClick: () => {
              var O;
              return (O = u.current) == null ? void 0 : O.focus();
            },
            children: /* @__PURE__ */ m.jsx(
              gr,
              {
                label: e,
                htmlFor: g.current,
                labelAsPlaceholder: p,
                disabled: o.disabled,
                children: /* @__PURE__ */ m.jsx(
                  "textarea",
                  {
                    className: "c__textarea",
                    ..._,
                    id: g.current,
                    onFocus: (O) => {
                      var L;
                      s(!0), (L = o.onFocus) == null || L.call(o, O);
                    },
                    onBlur: (O) => {
                      var L;
                      s(!1), (L = o.onBlur) == null || L.call(o, O);
                    },
                    value: c,
                    onChange: (O) => {
                      var L;
                      f(O.target.value), (L = o.onChange) == null || L.call(o, O);
                    },
                    ref: (O) => {
                      i && (typeof i == "function" ? i(O) : i.current = O), u.current = O;
                    }
                  }
                )
              }
            )
          }
        )
      }
    );
  }
), Ms = Symbol("default");
function Tb(e) {
  let { className: t, style: n, children: r, defaultClassName: a, defaultChildren: o, defaultStyle: i, values: u } = e;
  return J(() => {
    let l, s, c;
    return typeof t == "function" ? l = t({
      ...u,
      defaultClassName: a
    }) : l = t, typeof n == "function" ? s = n({
      ...u,
      defaultStyle: i || {}
    }) : s = n, typeof r == "function" ? c = r({
      ...u,
      defaultChildren: o
    }) : r == null ? c = o : c = r, {
      className: l ?? a,
      style: s || i ? {
        ...i,
        ...s
      } : void 0,
      children: c ?? o,
      "data-rac": ""
    };
  }, [
    t,
    n,
    r,
    a,
    o,
    i,
    u
  ]);
}
function Ob(e, t) {
  let n = yt(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = new Intl.ListFormat().format(Object.keys(n.slots).map((o) => `"${o}"`));
    if (!t && !n.slots[Ms]) throw new Error(`A slot prop is required. Valid slot names are ${r}.`);
    let a = t || Ms;
    if (!n.slots[a])
      throw new Error(`Invalid slot "${t}". Valid slot names are ${r}.`);
    return n.slots[a];
  }
  return n;
}
function Bb(e, t, n) {
  let r = Ob(n, e.slot) || {}, { ref: a, ...o } = r, i = P3(J(() => y3(t, a), [
    t,
    a
  ])), u = Me(o, e);
  return "style" in o && o.style && "style" in e && e.style && (typeof o.style == "function" || typeof e.style == "function" ? u.style = (l) => {
    let s = typeof o.style == "function" ? o.style(l) : o.style, c = {
      ...l.defaultStyle,
      ...s
    }, f = typeof e.style == "function" ? e.style({
      ...l,
      defaultStyle: c
    }) : e.style;
    return {
      ...c,
      ...f
    };
  } : u.style = {
    ...o.style,
    ...e.style
  }), [
    u,
    i
  ];
}
const Mb = 1500, ks = 500;
let Zt = {}, kb = 0, qn = !1, Pt = null, Jt = null;
function Vb(e = {}) {
  let { delay: t = Mb, closeDelay: n = ks } = e, { isOpen: r, open: a, close: o } = Gi(e), i = J(() => `${++kb}`, []), u = q(void 0), l = q(o), s = () => {
    Zt[i] = p;
  }, c = () => {
    for (let g in Zt) g !== i && (Zt[g](!0), delete Zt[g]);
  }, f = () => {
    clearTimeout(u.current), u.current = null, c(), s(), qn = !0, a(), Pt && (clearTimeout(Pt), Pt = null), Jt && (clearTimeout(Jt), Jt = null);
  }, p = (g) => {
    g || n <= 0 ? (clearTimeout(u.current), u.current = null, l.current()) : u.current || (u.current = setTimeout(() => {
      u.current = null, l.current();
    }, n)), Pt && (clearTimeout(Pt), Pt = null), qn && (Jt && clearTimeout(Jt), Jt = setTimeout(() => {
      delete Zt[i], Jt = null, qn = !1;
    }, Math.max(ks, n)));
  }, d = () => {
    c(), s(), !r && !Pt && !qn ? Pt = setTimeout(() => {
      Pt = null, qn = !0, f();
    }, t) : r || f();
  };
  return te(() => {
    l.current = o;
  }, [
    o
  ]), te(() => () => {
    clearTimeout(u.current), Zt[i] && delete Zt[i];
  }, [
    i
  ]), {
    isOpen: r,
    open: (g) => {
      !g && t > 0 && !u.current ? d() : f();
    },
    close: p
  };
}
const Nb = /* @__PURE__ */ xa({
  placement: "bottom"
});
function jb(e, t) {
  [e, t] = Bb(e, t, Nb);
  let n = e.placement, r = {
    position: "absolute",
    [n]: "100%",
    transform: n === "top" || n === "bottom" ? "translateX(-50%)" : "translateY(-50%)"
  }, a = Tb({
    ...e,
    defaultClassName: "react-aria-OverlayArrow",
    values: {
      placement: n
    }
  });
  return a.style && Object.keys(a.style).forEach((o) => a.style[o] === void 0 && delete a.style[o]), /* @__PURE__ */ fe.createElement("div", {
    ...e,
    ...a,
    style: {
      ...r,
      ...a.style
    },
    ref: t,
    "data-placement": n
  });
}
const Lb = /* @__PURE__ */ Re(jb), Vs = 200, i2 = ({
  placement: e = "bottom",
  content: t,
  closeDelay: n = 150,
  className: r,
  ...a
}) => {
  const o = fe.useRef(null), i = fe.useRef(null), [u, l] = fe.useState(!1), [s, c] = fe.useState(!1), f = Vb({
    delay: 0,
    closeDelay: n,
    onOpenChange: (C) => {
      C ? (c(!0), setTimeout(() => {
        c(!1);
      }, Vs)) : (l(!0), setTimeout(() => {
        l(!1);
      }, Vs));
    }
  }), p = ub({}, f, o), d = Cg({
    targetRef: o,
    overlayRef: i,
    placement: e,
    isOpen: f.isOpen
  }), { tooltipProps: g } = ib(
    p.tooltipProps,
    f
  ), b = {
    placement: d.placement
  }, v = f.isOpen || u;
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    fe.cloneElement(
      fe.Children.toArray(a.children)[0],
      {
        ref: o,
        ...p.triggerProps
      }
    ),
    v && /* @__PURE__ */ m.jsxs(
      "span",
      {
        className: se(
          "c__tooltip",
          {
            "c__tooltip--exiting": u,
            "c__tooltip--entering": s
          },
          r
        ),
        "data-placement": d.placement,
        ref: i,
        style: {
          ...d.overlayProps.style
        },
        ...Me(a, g),
        children: [
          /* @__PURE__ */ m.jsx(Lb, { ...b, children: /* @__PURE__ */ m.jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", children: /* @__PURE__ */ m.jsx("path", { d: "M0 0 L8 8 L16 0" }) }) }),
          /* @__PURE__ */ m.jsx("span", { className: "c__tooltip__content", children: t })
        ]
      }
    )
  ] });
}, u2 = Ls.themes.default;
export {
  Gb as Alert,
  ge as Button,
  Ai as Checkbox,
  Yb as CheckboxGroup,
  B0 as ConfirmationModal,
  Wb as CunninghamProvider,
  Ir as DEFAULT_LOCALE,
  L0 as DEFAULT_THEME,
  Cc as DataGrid,
  qb as DataList,
  Jb as DatePicker,
  Xb as DateRangePicker,
  O0 as DeleteConfirmationModal,
  _t as Field,
  Qb as FileUploader,
  xc as Input,
  e2 as InputPassword,
  Ec as Loader,
  Dl as MODAL_CLASS,
  M0 as MessageModal,
  Si as Modal,
  A0 as ModalInner,
  j0 as ModalProvider,
  wa as ModalSize,
  k0 as NOSCROLL_CLASS,
  Mv as Pagination,
  Ky as Popover,
  fh as ProgressBar,
  t2 as Radio,
  n2 as RadioGroup,
  Ub as SUPPORTED_LOCALES,
  r2 as Select,
  Ab as SelectMono,
  Ib as SelectMulti,
  Zb as SimpleDataGrid,
  a2 as Switch,
  o2 as TextArea,
  ch as Toast,
  dh as ToastIcon,
  gh as ToastProvider,
  i2 as Tooltip,
  Ea as VariantType,
  sh as colorFromType,
  Rn as convertDateValueToString,
  u2 as defaultTokens,
  jm as getDefaultPickerOptions,
  $i as iconFromType,
  Nm as isValidTimeZone,
  Vn as parseDateValue,
  ms as parseRangeDateValue,
  Oe as useCunningham,
  F0 as useModal,
  V0 as useModals,
  Bv as usePagination,
  zb as useToastProvider
};
//# sourceMappingURL=index.mjs.map
